import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Coordinates: any;
  Date: any;
  JSON: any;
  Upload: any;
};

export type ApiPriceResponse = {
  __typename?: 'APIPriceResponse';
  _id: Scalars['String'];
  dates: HomadatEvolutionDates;
  id: Scalars['String'];
};

export type AcceptGalleryInvitationResult = MutationResult & {
  __typename?: 'AcceptGalleryInvitationResult';
  invitation?: Maybe<GalleryInvitation>;
  problem?: Maybe<ProblemDetail>;
  success: Scalars['Boolean'];
};

export type Activity = {
  __typename?: 'Activity';
  activityCategories: Array<Maybe<ActivityCategory>>;
  featuredOrder?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  labelKey: Scalars['String'];
};

export type ActivityCategory = {
  __typename?: 'ActivityCategory';
  activities?: Maybe<Array<Activity>>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  labelKey: Scalars['String'];
  parentActivityCategory?: Maybe<ActivityCategory>;
  parentActivityCategoryId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['Date'];
};

export type Ad = {
  __typename?: 'Ad';
  address: Address;
  assets?: Maybe<Array<Maybe<Scalars['String']>>>;
  assignedTo?: Maybe<User>;
  assignedToId?: Maybe<Scalars['String']>;
  availableDate?: Maybe<Scalars['Int']>;
  bedroomNumber?: Maybe<Scalars['Int']>;
  coOwnership?: Maybe<Scalars['Boolean']>;
  coOwnershipNumberOfLots?: Maybe<Scalars['Int']>;
  coOwnershipOngoing?: Maybe<YesNoOptions>;
  coOwnershipYearlyCharge?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
  commonAreasState?: Maybe<CommonAreasState>;
  constructibleLand?: Maybe<YesNoNaOptions>;
  constructionYear?: Maybe<Scalars['Int']>;
  consumption?: Maybe<Scalars['String']>;
  contactConsent?: Maybe<Scalars['Boolean']>;
  contactEmail?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  crmCreatedAt?: Maybe<Scalars['Date']>;
  crmUpdatedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  dimensionHeight?: Maybe<Scalars['Float']>;
  dimensionLength?: Maybe<Scalars['Float']>;
  dimensionWidth?: Maybe<Scalars['Float']>;
  emissions?: Maybe<Scalars['String']>;
  fees?: Maybe<Scalars['Int']>;
  floorNumber?: Maybe<Scalars['Int']>;
  floorPosition?: Maybe<Scalars['Int']>;
  furnished?: Maybe<Scalars['Boolean']>;
  guarantees?: Maybe<Scalars['String']>;
  heatInformations?: Maybe<Scalars['String']>;
  heatType?: Maybe<HeatTypes>;
  homadataEvaluation?: Maybe<HomadataEvaluation>;
  iHaveOwnership: Scalars['Boolean'];
  id: Scalars['ID'];
  inclusions?: Maybe<Scalars['String']>;
  interOffice: Scalars['Boolean'];
  inventory?: Maybe<Scalars['Float']>;
  isHiddingCompleteAddress: Scalars['Boolean'];
  isInaccurateAddress: Scalars['Boolean'];
  isNew: Scalars['Boolean'];
  isPriceDecreasing: Scalars['Boolean'];
  isRentChargesIncluded?: Maybe<Scalars['Boolean']>;
  isUserAffiliatedCompanyFavorite: Scalars['Boolean'];
  isUserFavorite: Scalars['Boolean'];
  landArea?: Maybe<Scalars['Float']>;
  lastAdHistory?: Maybe<AdHistory>;
  livingArea?: Maybe<Scalars['Float']>;
  mainMedium?: Maybe<Medium>;
  mainPublisher?: Maybe<Publisher>;
  media: Array<Maybe<Medium>>;
  monthlyCharges?: Maybe<Scalars['Float']>;
  newProperty?: Maybe<Scalars['Boolean']>;
  numberOfVehicles?: Maybe<Scalars['Int']>;
  owner?: Maybe<Owner>;
  price?: Maybe<Scalars['Int']>;
  /** @deprecated Use lastAdHistory instead (added 20211005) */
  priceHistory?: Maybe<Array<Maybe<AdHistory>>>;
  priceSold?: Maybe<Scalars['Int']>;
  priceWithoutSaleFee?: Maybe<Scalars['Int']>;
  propertyPurposeEstimation?: Maybe<PropertyPurposeEstimation>;
  propertyResidenceType?: Maybe<PropertyResidenceType>;
  propertyState?: Maybe<PropertyState>;
  propertyType: Scalars['String'];
  proxyLat: Scalars['Float'];
  proxyLng: Scalars['Float'];
  reasonWhyAdArchived?: Maybe<ReasonWhyAdArchived>;
  reasonWhyAdDeleted?: Maybe<ReasonWhyAdDeleted>;
  rent?: Maybe<Scalars['Int']>;
  roomNumber?: Maybe<Scalars['Int']>;
  rooms?: Maybe<Scalars['String']>;
  saleFeeBuyerPrice?: Maybe<Scalars['Float']>;
  saleFeeBuyerRate?: Maybe<Scalars['Float']>;
  saleFeeType?: Maybe<SaleFeeType>;
  servicedLand?: Maybe<YesNoNaOptions>;
  sharableUrl: Scalars['String'];
  showSaleFeeBuyerPrice?: Maybe<Scalars['Boolean']>;
  standardLoanAmount?: Maybe<LoanAmount>;
  stats: Stats;
  status?: Maybe<AdStatuses>;
  surfaceArea?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  totalPublisher?: Maybe<Scalars['Int']>;
  type: AdTypes;
  updatedAt: Scalars['Date'];
  userIsOwner?: Maybe<Scalars['Boolean']>;
};

export type AdHistory = {
  __typename?: 'AdHistory';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  status?: Maybe<AdStatuses>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  value: Scalars['Int'];
};

export enum AdPublisherSortField {
  CreatedAt = 'createdAt',
  Price = 'price',
  PublisherName = 'publisherName'
}

export type AdPublisherSortInput = {
  direction: SortDirection;
  field: AdPublisherSortField;
};

export enum AdStatuses {
  Archived = 'archived',
  Available = 'available',
  Draft = 'draft',
  Ended = 'ended'
}

export enum AdTypes {
  Rent = 'rent',
  Sell = 'sell'
}

export type Address = {
  __typename?: 'Address';
  city?: Maybe<City>;
  cityName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  description: Scalars['String'];
  id: Scalars['ID'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  placeId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  zipCode?: Maybe<Scalars['String']>;
};

export type AddressParam = {
  /** @deprecated Use cityName 20231103 */
  city?: InputMaybe<Scalars['String']>;
  cityName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  googlePlaceId?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  /** @deprecated Use googlePlaceId 20231103 */
  placeId?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type AdminRequestsResponse = {
  __typename?: 'AdminRequestsResponse';
  items: Array<RequestAdmin>;
  total: Scalars['Int'];
};

export type AdsSearch = {
  __typename?: 'AdsSearch';
  items?: Maybe<Array<Ad>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AgoraResponse = {
  __typename?: 'AgoraResponse';
  channel?: Maybe<Scalars['String']>;
  receiverToken?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type AppLink = {
  __typename?: 'AppLink';
  fullUrl: Scalars['String'];
  shortUrl: Scalars['String'];
  type: AppLinkType;
};

export type AppLinkParamsInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export enum AppLinkType {
  Ad = 'ad',
  Ads = 'ads',
  Company = 'company',
  CompanyPagesJaunes = 'companyPagesJaunes',
  Gallery = 'gallery',
  JobOffer = 'jobOffer',
  Login = 'login',
  NewsFeedPost = 'newsFeedPost',
  NewsFeedStory = 'newsFeedStory',
  NewsPost = 'newsPost',
  ProfileNotificationSubscriptions = 'profileNotificationSubscriptions',
  StartEstimate = 'startEstimate',
  User = 'user',
  ViewEstimate = 'viewEstimate'
}

export type BlockedUser = {
  __typename?: 'BlockedUser';
  blockedUser: User;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  user: User;
};

export type CancelGalleryInvitationResult = MutationResult & {
  __typename?: 'CancelGalleryInvitationResult';
  invitation?: Maybe<GalleryInvitation>;
  problem?: Maybe<ProblemDetail>;
  success: Scalars['Boolean'];
};

export type Chat = {
  __typename?: 'Chat';
  company?: Maybe<Company>;
  fallbackInititals?: Maybe<Scalars['String']>;
  fallbackNameEn?: Maybe<Scalars['String']>;
  fallbackNameFr?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Medium>;
  initials?: Maybe<Scalars['String']>;
  isStoryReaction?: Maybe<Scalars['Boolean']>;
  job?: Maybe<Scalars['String']>;
  lastChatVisualizationTime?: Maybe<Scalars['Int']>;
  lastMessage: Scalars['String'];
  lastMessageEmitterId?: Maybe<Scalars['String']>;
  lastMessageTargetId?: Maybe<Scalars['String']>;
  lastMessageTime: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
};

export type ChatNotificationData = {
  data?: InputMaybe<Scalars['JSON']>;
  notificationType: ChatNotificationType;
};

export enum ChatNotificationType {
  AddUsers = 'addUsers',
  ChannelCreation = 'channelCreation',
  LeaveChannel = 'leaveChannel',
  RemoveUser = 'removeUser',
  UpdateGroupName = 'updateGroupName',
  UpdateGroupPicture = 'updateGroupPicture'
}

export type City = {
  __typename?: 'City';
  code: Scalars['String'];
  country: Scalars['String'];
  countryShort: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  name: Scalars['String'];
  zipCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClosedGalleryInvitationInput = {
  invitee: GalleryInviteeInput;
  role: GalleryRole;
};

export type Comment = {
  __typename?: 'Comment';
  content: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy: User;
  iHaveOwnership: Scalars['Boolean'];
  id: Scalars['ID'];
  likedByCurrentUser: Scalars['Boolean'];
  owner: Owner;
  post: Post;
  updatedAt: Scalars['Date'];
  usersWhoLikes?: Maybe<Array<Maybe<User>>>;
};

export enum CommonAreasState {
  CommonAreaRecentRestoration = 'common_area_recent_restoration',
  Nothing = 'nothing',
  RecentRestoration = 'recent_restoration'
}

export type CommunityByNameSearchResult = Company | PagesJaunesProSearchResult | QuickSignupCompany | User;

export enum CommunityEntityType {
  Company = 'company',
  NonPro = 'nonPro',
  PagesJaunesPro = 'pagesJaunesPro',
  Pro = 'pro'
}

export type CommunitySearchResponse = {
  __typename?: 'CommunitySearchResponse';
  results: Array<CommunitySearchResult>;
  total: Scalars['Int'];
};

export type CommunitySearchResult = Company | PagesJaunesProSearchResult | User;

export type CompaniesResponseWithTotal = {
  __typename?: 'CompaniesResponseWithTotal';
  results?: Maybe<Array<Maybe<Company>>>;
  total?: Maybe<Scalars['Int']>;
};

export type Company = {
  __typename?: 'Company';
  activities?: Maybe<Array<Activity>>;
  address?: Maybe<Address>;
  adminRequest?: Maybe<RequestAdmin>;
  averageRating: Scalars['Float'];
  capabilities?: Maybe<CompanyCapatibilities>;
  companyAndMembersRecommendationsCount: Scalars['Int'];
  companyMembersWhoAreInMyContactsCount?: Maybe<Scalars['Int']>;
  /** @deprecated Use new label property 20230111 */
  companyType?: Maybe<CompanyType>;
  contactUrl?: Maybe<Scalars['String']>;
  contactUser?: Maybe<User>;
  coverImage?: Maybe<Medium>;
  createdAt: Scalars['Date'];
  crmSyncs?: Maybe<Array<Maybe<CrmSync>>>;
  currentUserAffiliatedCompanyIsAbleToJoin?: Maybe<Scalars['Boolean']>;
  currentUserIsAbleToJoin?: Maybe<Scalars['Boolean']>;
  customActivity?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  director?: Maybe<User>;
  feeScaleFile?: Maybe<Scalars['String']>;
  feeScaleFileName?: Maybe<Scalars['String']>;
  foundationYear?: Maybe<Scalars['Int']>;
  galleries: GalleryPage;
  group?: Maybe<Company>;
  groupInvitationStatus?: Maybe<InvitationStatus>;
  hasUnreadStory: Scalars['Boolean'];
  id: Scalars['ID'];
  image?: Maybe<Medium>;
  initials?: Maybe<Scalars['String']>;
  invitationStatus?: Maybe<InvitationStatus>;
  /** @deprecated Use new capabilities and/or type properties 20230111 */
  isAgency: Scalars['Boolean'];
  isFollowingCompany: Scalars['Boolean'];
  /** @deprecated Use new capabilities and/or type properties 20230111 */
  isPrivate: Scalars['Boolean'];
  label?: Maybe<CompanyLabel>;
  members: Array<User>;
  membersRecommendationsCount: Scalars['Int'];
  mission?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numberOfAdminRequests: Scalars['Int'];
  numberOfAds: Scalars['Int'];
  numberOfCompanies?: Maybe<Scalars['Int']>;
  numberOfDisplayedRatings: Scalars['Int'];
  numberOfFollowers: Scalars['Int'];
  numberOfGalleries: Scalars['Int'];
  numberOfJobOffers: Scalars['Int'];
  numberOfMembers: Scalars['Int'];
  numberOfMembersRecursively: Scalars['Int'];
  /** @deprecated Use recommendationsReceivedCount 20230111 */
  numberOfNotUniqueRecommendations: Scalars['Int'];
  numberOfPosts: Scalars['Int'];
  numberOfProjects: Scalars['Int'];
  numberOfRatings: Scalars['Int'];
  numberOfStories: Scalars['Int'];
  pagesJaunesId?: Maybe<Scalars['String']>;
  pagesJaunesUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<PhoneNumber>;
  ratingGivenByCurrentUser?: Maybe<Rating>;
  ratings: Array<Maybe<Rating>>;
  recommendationFromMe?: Maybe<Recommendation>;
  recommendationsReceivedCount: Scalars['Int'];
  showcase?: Maybe<Array<Maybe<Medium>>>;
  siretNumber?: Maybe<Scalars['String']>;
  type: CompanyEntityType;
  updatedAt?: Maybe<Scalars['Date']>;
  video?: Maybe<Medium>;
  website?: Maybe<Scalars['String']>;
};


export type CompanyGalleriesArgs = {
  pageRequest?: InputMaybe<PageRequest>;
  policy?: InputMaybe<GalleryAccessPolicy>;
  sort?: InputMaybe<GallerySort>;
};


export type CompanyNumberOfAdminRequestsArgs = {
  status?: InputMaybe<RequestAdminStatus>;
};


export type CompanyNumberOfAdsArgs = {
  statuses?: InputMaybe<Array<AdStatuses>>;
  type?: InputMaybe<AdTypes>;
};


export type CompanyNumberOfMembersArgs = {
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isDirector?: InputMaybe<Scalars['Boolean']>;
};


export type CompanyRecommendationsReceivedCountArgs = {
  statuses?: InputMaybe<Array<InputMaybe<RecommendationStatus>>>;
};


export type CompanyShowcaseArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type CompanyCapatibilities = {
  __typename?: 'CompanyCapatibilities';
  allowedContentTypesToDisplay?: Maybe<Array<Maybe<ContentType>>>;
  allowedContentTypesToManage?: Maybe<Array<Maybe<ContentType>>>;
  allowedLabels?: Maybe<Array<Maybe<CompanyLabel>>>;
  hasPublicPage: Scalars['Boolean'];
  isAbleToHaveDirectors: Scalars['Boolean'];
  isAbleToHaveEstateCompanies: Scalars['Boolean'];
  isAbleToSyncCrm: Scalars['Boolean'];
};

export enum CompanyEntityType {
  CraftCompany = 'CraftCompany',
  EstateCompany = 'EstateCompany',
  EstateGroup = 'EstateGroup',
  PrivateCompany = 'PrivateCompany'
}

export enum CompanyLabel {
  Company = 'company',
  Group = 'group',
  NotaryOffice = 'notary_office',
  RealEstateAgency = 'real_estate_agency',
  RealEstateAgencyNetwork = 'real_estate_agency_network'
}

export type CompanyMembership = {
  __typename?: 'CompanyMembership';
  company: Company;
  createdAt: Scalars['Date'];
  deletedAt: Scalars['Date'];
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  isDirector: Scalars['Boolean'];
  user: User;
};

export type CompanyOrPagesJaunesProSearchResponse = {
  __typename?: 'CompanyOrPagesJaunesProSearchResponse';
  results: Array<CompanyOrPagesJaunesProSearchResult>;
  total: Scalars['Int'];
};

export type CompanyOrPagesJaunesProSearchResult = Company | PagesJaunesProSearchResult;

export enum CompanyType {
  Company = 'company',
  NotaryOffice = 'notary_office',
  RealEstateAgency = 'real_estate_agency',
  RealEstateAgencyNetwork = 'real_estate_agency_network'
}

export type Contact = {
  __typename?: 'Contact';
  contactedUser: User;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  status: Scalars['String'];
  updatedAt: Scalars['Date'];
  user: User;
  viewed: Scalars['Boolean'];
};

export enum ContactStatus {
  Accepted = 'accepted',
  Pending = 'pending',
  Refused = 'refused',
  ToRespond = 'to_respond',
  Uninvited = 'uninvited'
}

export enum ContentType {
  Ad = 'ad',
  Company = 'company',
  Gallery = 'gallery',
  JobOffer = 'job_offer',
  Post = 'post',
  Project = 'project',
  Story = 'story'
}

export type CountsForSitemapResponse = {
  __typename?: 'CountsForSitemapResponse';
  ads: Scalars['Int'];
  companies: Scalars['Int'];
  users: Scalars['Int'];
};

export type CountsResponse = {
  __typename?: 'CountsResponse';
  numberOfPendingAdminRequests: Scalars['Int'];
  /** @deprecated Use numberOfPendingInvitations 20221108 */
  numberOfPendingAgencyInvitations: Scalars['Int'];
  numberOfPendingInvitations: Scalars['Int'];
  numberOfPendingRecommendationRequests: Scalars['Int'];
  numberOfReceivedPendingContactInvitations: Scalars['Int'];
  numberOfUnreadNotifications: Scalars['Int'];
  totalPendingNotifications: Scalars['Int'];
  unreadMessages: Scalars['Int'];
};


export type CountsResponseNumberOfPendingInvitationsArgs = {
  side?: InputMaybe<PendingInvitationSide>;
  type?: InputMaybe<PendingInvitationType>;
};

export type CreateCityInput = {
  departmentId: Scalars['ID'];
  name: Scalars['String'];
};

export type CreateCityResult = {
  __typename?: 'CreateCityResult';
  city?: Maybe<City>;
};

export type CreateGalleryInvitationResult = MutationResult & {
  __typename?: 'CreateGalleryInvitationResult';
  invitation?: Maybe<GalleryInvitation>;
  problem?: Maybe<ProblemDetail>;
  success: Scalars['Boolean'];
};

export type CreateRatingResponse = {
  __typename?: 'CreateRatingResponse';
  averageRating: Scalars['Float'];
  id: Scalars['String'];
  numberOfRatings: Scalars['Int'];
};

export type CreateRecommendationResponse = {
  __typename?: 'CreateRecommendationResponse';
  id: Scalars['String'];
};

export type CrmSource = {
  __typename?: 'CrmSource';
  emailAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  requestEmailBody?: Maybe<Scalars['String']>;
  requestEmailSubject?: Maybe<Scalars['String']>;
};

export type CrmSync = {
  __typename?: 'CrmSync';
  createdAt: Scalars['Date'];
  createdBy: User;
  crmAgencyId?: Maybe<Scalars['String']>;
  crmSource?: Maybe<CrmSource>;
  crmSourceId?: Maybe<Scalars['String']>;
  crmUserId?: Maybe<Scalars['String']>;
  forceRefresh?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  owner?: Maybe<Owner>;
  polirisUser?: Maybe<PolirisUser>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type CrmUserTemp = {
  __typename?: 'CrmUserTemp';
  apimoAgencyId: Scalars['String'];
  apimoUserId?: Maybe<Scalars['String']>;
  crmSource: Scalars['String'];
};

export type DataForSitemapResponse = {
  __typename?: 'DataForSitemapResponse';
  ads: Array<Ad>;
  companies: Array<Company>;
  users: Array<User>;
};

export enum DataType {
  Ad = 'ad',
  Company = 'company',
  CompanyPagesJaunes = 'companyPagesJaunes',
  Estimation = 'estimation',
  File = 'file',
  MissedVideoCall = 'missedVideoCall',
  NewsPost = 'newsPost',
  Notification = 'notification',
  Post = 'post',
  Story = 'story',
  User = 'user'
}

export type DeclineGalleryInvitationResult = MutationResult & {
  __typename?: 'DeclineGalleryInvitationResult';
  invitation?: Maybe<GalleryInvitation>;
  problem?: Maybe<ProblemDetail>;
  success: Scalars['Boolean'];
};

export enum DeletedReason {
  DeletedByAdmin = 'deletedByAdmin',
  DeletedByUser = 'deletedByUser'
}

export enum EsOrderByTypes {
  Distance = 'distance',
  MutualContacts = 'mutualContacts',
  Recommendation = 'recommendation'
}

export type EmailGalleryInviteeValue = {
  __typename?: 'EmailGalleryInviteeValue';
  emailAddress: Scalars['String'];
};

export enum EmbedSource {
  Youtube = 'youtube'
}

export type EventData = {
  companyId?: InputMaybe<Scalars['String']>;
  eventType: Scalars['String'];
  pagesJaunesMerchantId?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  quickSignupCompanyId?: InputMaybe<Scalars['String']>;
  quickSignupUserId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  viewedUserId?: InputMaybe<Scalars['String']>;
};

export type FeeItemsResponse = {
  __typename?: 'FeeItemsResponse';
  newsPostsCount: Scalars['Int'];
  postsCount: Scalars['Int'];
  results: Array<FeedItem>;
};

export type FeedItem = NewsPost | Post;

export type FirstConnectionResponse = {
  __typename?: 'FirstConnectionResponse';
  me: User;
  nbPendingInvitations: Scalars['Int'];
};

export type Follow = {
  __typename?: 'Follow';
  followedOwner: Owner;
  followingUser: User;
  id: Scalars['ID'];
};

export type FollowsWithTotal = {
  __typename?: 'FollowsWithTotal';
  results: Array<Follow>;
  total: Scalars['Int'];
};

export enum FurnishedStatus {
  Furnished = 'furnished',
  Unfurnished = 'unfurnished'
}

export type Gallery = {
  __typename?: 'Gallery';
  collaborators: GalleryCollaboratorPage;
  contentItems: GalleryContentItemPage;
  contentLastUpdatedAt: Scalars['Date'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<User>;
  id: Scalars['String'];
  invitations: GalleryInvitationPage;
  isSecret: Scalars['Boolean'];
  name: Scalars['String'];
  numberOfAds: Scalars['Int'];
  numberOfContents: Scalars['Int'];
  numberOfNewsPosts: Scalars['Int'];
  numberOfPosts: Scalars['Int'];
  owner?: Maybe<Owner>;
  previewMedia?: Maybe<Array<Maybe<Medium>>>;
  searchUsers: GalleryUserPage;
  viewerPermissions: GalleryViewerPermissions;
  viewerProperties: GalleryViewerProperties;
};


export type GalleryCollaboratorsArgs = {
  pageRequest?: InputMaybe<PageRequest>;
  sort?: InputMaybe<GalleryCollaboratorSort>;
  types?: InputMaybe<Array<GalleryCollaboratorType>>;
};


export type GalleryContentItemsArgs = {
  pageRequest?: InputMaybe<PageRequest>;
  sort?: InputMaybe<GalleryContentItemSort>;
  types?: InputMaybe<Array<GalleryContentReferenceType>>;
};


export type GalleryInvitationsArgs = {
  includeExpired?: InputMaybe<Scalars['Boolean']>;
  pageRequest?: InputMaybe<PageRequest>;
  sort?: InputMaybe<GalleryInvitationSort>;
  statuses?: InputMaybe<Array<GalleryInvitationStatus>>;
  types?: InputMaybe<Array<GalleryInvitationType>>;
};


export type GallerySearchUsersArgs = {
  pageRequest?: InputMaybe<PageRequest>;
  searchString: Scalars['String'];
};

export enum GalleryAccessPolicy {
  EditContent = 'editContent',
  Public = 'public',
  Read = 'read'
}

export type GalleryCollaborator = {
  __typename?: 'GalleryCollaborator';
  company?: Maybe<Company>;
  createdAt: Scalars['Date'];
  invitedBy?: Maybe<User>;
  role: GalleryRole;
  type: GalleryCollaboratorType;
  user?: Maybe<User>;
};

export type GalleryCollaboratorPage = Page & {
  __typename?: 'GalleryCollaboratorPage';
  items: Array<GalleryCollaborator>;
  totalCount: Scalars['Int'];
};

export type GalleryCollaboratorRefInput = {
  id: Scalars['ID'];
  type: GalleryCollaboratorType;
};

export type GalleryCollaboratorSort = {
  direction?: InputMaybe<SortDirection>;
  field: GalleryCollaboratorSortField;
};

export enum GalleryCollaboratorSortField {
  CreatedAt = 'createdAt'
}

export enum GalleryCollaboratorType {
  Company = 'company',
  CompanyAdmin = 'companyAdmin',
  CompanyDirector = 'companyDirector',
  User = 'user'
}

export type GalleryContent = Ad | NewsPost | Post;

export type GalleryContentItem = {
  __typename?: 'GalleryContentItem';
  createdAt: Scalars['Date'];
  createdBy: User;
  id: Scalars['ID'];
  reference: GalleryContentReference;
  updatedAt: Scalars['Date'];
  updatedBy: User;
};

export type GalleryContentItemPage = Page & {
  __typename?: 'GalleryContentItemPage';
  items: Array<GalleryContentItem>;
  totalCount: Scalars['Int'];
};

export type GalleryContentItemSort = {
  direction?: InputMaybe<SortDirection>;
  field: GalleryContentItemSortField;
};

export enum GalleryContentItemSortField {
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

export type GalleryContentReference = {
  __typename?: 'GalleryContentReference';
  type: GalleryContentReferenceType;
  value: GalleryContentReferenceValue;
};

export enum GalleryContentReferenceType {
  Ad = 'ad',
  NewsPost = 'newsPost',
  Post = 'post'
}

export type GalleryContentReferenceValue = Ad | NewsPost | Post;

export enum GalleryContentType {
  Ads = 'ads',
  NewsPosts = 'newsPosts',
  Posts = 'posts'
}

export type GalleryDescriptor = {
  __typename?: 'GalleryDescriptor';
  id: Scalars['ID'];
  isSecret: Scalars['Boolean'];
  name: Scalars['String'];
  owner: Owner;
  statistics: GalleryStatistics;
};

export type GalleryInvitation = {
  __typename?: 'GalleryInvitation';
  createdAt: Scalars['Date'];
  createdBy: User;
  expiresAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invitee?: Maybe<GalleryInvitee>;
  role: GalleryRole;
  scope: GalleryDescriptor;
  status: GalleryInvitationStatus;
  type: GalleryInvitationType;
  updatedAt: Scalars['Date'];
};

export type GalleryInvitationPage = Page & {
  __typename?: 'GalleryInvitationPage';
  items: Array<GalleryInvitation>;
  totalCount: Scalars['Int'];
};

export type GalleryInvitationSort = {
  direction?: InputMaybe<SortDirection>;
  field: GalleryInvitationSortField;
};

export enum GalleryInvitationSortField {
  CreatedAt = 'createdAt'
}

export enum GalleryInvitationStatus {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Pending = 'pending'
}

export enum GalleryInvitationType {
  Closed = 'closed',
  Open = 'open'
}

export type GalleryInvitee = {
  __typename?: 'GalleryInvitee';
  type: GalleryInviteeType;
  value: GalleryInviteeValue;
};

export type GalleryInviteeInput = {
  type: GalleryInviteeType;
  value: Scalars['String'];
};

export enum GalleryInviteeType {
  Email = 'email',
  User = 'user'
}

export type GalleryInviteeValue = EmailGalleryInviteeValue | UserGalleryInviteeValue;

export type GalleryPage = Page & {
  __typename?: 'GalleryPage';
  items: Array<Gallery>;
  totalCount: Scalars['Int'];
};

export enum GalleryRole {
  Admin = 'admin',
  Editor = 'editor',
  Viewer = 'viewer'
}

export type GallerySort = {
  direction?: InputMaybe<SortDirection>;
  field: GallerySortField;
};

export enum GallerySortField {
  ContentLastUpdatedAt = 'contentLastUpdatedAt',
  CreatedAt = 'createdAt',
  Name = 'name'
}

export type GalleryStatistics = {
  __typename?: 'GalleryStatistics';
  contentItemCount: Scalars['Int'];
};

export type GalleryUser = {
  __typename?: 'GalleryUser';
  id: Scalars['ID'];
  status: GalleryUserStatus;
  user: User;
};

export type GalleryUserPage = Page & {
  __typename?: 'GalleryUserPage';
  items: Array<GalleryUser>;
  totalCount: Scalars['Int'];
};

export enum GalleryUserStatus {
  Collaborator = 'collaborator',
  Invited = 'invited',
  Unaffiliated = 'unaffiliated'
}

export type GalleryViewerPermissions = {
  __typename?: 'GalleryViewerPermissions';
  canDelete: Scalars['Boolean'];
  canEditContent: Scalars['Boolean'];
  canManage: Scalars['Boolean'];
};

export type GalleryViewerProperties = {
  __typename?: 'GalleryViewerProperties';
  userStatus: GalleryUserStatus;
};

export type GenerateFirebaseDynamicLinkResponse = {
  __typename?: 'GenerateFirebaseDynamicLinkResponse';
  sharedLink?: Maybe<Scalars['String']>;
};

export type Geometry = {
  __typename?: 'Geometry';
  coordinates?: Maybe<Scalars['Coordinates']>;
  type?: Maybe<GeometryType>;
};

export type GeometryInput = {
  coordinates?: InputMaybe<Scalars['Coordinates']>;
  type?: InputMaybe<GeometryType>;
};

export enum GeometrySource {
  Drawing = 'drawing',
  Viewport = 'viewport'
}

export enum GeometryType {
  MultiPolygon = 'MultiPolygon',
  Polygon = 'Polygon'
}

export type GeometryWithSource = {
  __typename?: 'GeometryWithSource';
  coordinates?: Maybe<Scalars['Coordinates']>;
  source: GeometrySource;
  type?: Maybe<GeometryType>;
};

export type GroupCompaniesResponse = {
  __typename?: 'GroupCompaniesResponse';
  results: Array<Maybe<Company>>;
  total: Scalars['Int'];
};

export type GroupInvitation = {
  __typename?: 'GroupInvitation';
  company: Company;
  companyId: Scalars['String'];
  direction: GroupInvitationDirection;
  group: Company;
  groupId: Scalars['String'];
  id: Scalars['ID'];
  status: InvitationStatus;
};

export enum GroupInvitationDirection {
  CompanyToGroup = 'company_to_group',
  GroupToCompany = 'group_to_company'
}

export enum HeatTypes {
  Electricity = 'electricity',
  Fuel = 'fuel',
  Gas = 'gas',
  Geo = 'geo',
  HeatPump = 'heat_pump',
  Other = 'other',
  Solar = 'solar',
  Wood = 'wood'
}

export enum HeatingDevices {
  AirConditioner = 'air_conditioner',
  Central = 'central',
  Convector = 'convector',
  FloorHeating = 'floor_heating',
  Other = 'other',
  Radiator = 'radiator',
  Stove = 'stove',
  WithoutHeating = 'without_heating'
}

export type HomadatEvolutionDates = {
  __typename?: 'HomadatEvolutionDates';
  prices: HomadataEvolutionPrices;
  year: Scalars['String'];
};

export type HomadataEstimationResponse = {
  __typename?: 'HomadataEstimationResponse';
  atypical: Scalars['Int'];
  confidenceIndex: Scalars['Int'];
  confidenceMax: Scalars['Float'];
  confidenceMin: Scalars['Float'];
  fai: Scalars['Float'];
  faiRate: Scalars['Float'];
  nego: Scalars['Float'];
  negoRate: Scalars['Float'];
  predictedPrice: Scalars['Float'];
  priceM2: Scalars['Float'];
  priceMax: Scalars['Float'];
  priceMin: Scalars['Float'];
  virtualPrice: Scalars['Float'];
  virtualPriceAdjustment: Scalars['Int'];
  virtualPriceMax: Scalars['Float'];
  virtualPriceMin: Scalars['Float'];
};

export type HomadataEvaluation = {
  __typename?: 'HomadataEvaluation';
  confidenceIndex?: Maybe<Scalars['Int']>;
  confidenceMax: Scalars['Int'];
  confidenceMin: Scalars['Int'];
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  predictedPrice?: Maybe<Scalars['Int']>;
  requestDate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type HomadataEvolutionPrices = {
  __typename?: 'HomadataEvolutionPrices';
  apartment: HouseOrAppartement;
  house: HouseOrAppartement;
  month: Scalars['String'];
};

export type HomadataEvolutionResponse = {
  __typename?: 'HomadataEvolutionResponse';
  prices: Array<Maybe<PriceResponse>>;
  tendancy: Scalars['Float'];
};

export type HouseOrAppartement = {
  __typename?: 'HouseOrAppartement';
  confidence_index: Scalars['Float'];
  evol: Scalars['Float'];
  max_price: Scalars['Float'];
  min_price: Scalars['Float'];
  price: Scalars['Float'];
};

export type HybridMedium = {
  file?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['String']>;
  tmpUrl?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  company: Company;
  companyId: Scalars['String'];
  direction: InvitationDirection;
  id: Scalars['ID'];
  status: InvitationStatus;
  user: User;
  userId: Scalars['String'];
};

export enum InvitationDirection {
  CompanyToUser = 'company_to_user',
  UserToCompany = 'user_to_company'
}

export enum InvitationStatus {
  Accepted = 'accepted',
  Pending = 'pending',
  Refused = 'refused',
  ToRespond = 'to_respond',
  Uninvited = 'uninvited'
}

export type JobOffer = {
  __typename?: 'JobOffer';
  city: City;
  company: Company;
  companyName: Scalars['String'];
  createdAt: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  hasCurrentUserAlreadyApplied: Scalars['Boolean'];
  id: Scalars['ID'];
  isHidden: Scalars['Boolean'];
  jobOfferApplications?: Maybe<Array<Maybe<JobOfferApplication>>>;
  jobType: JobType;
  numberOfJobOfferApplications: Scalars['Int'];
  profile?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type JobOfferApplication = {
  __typename?: 'JobOfferApplication';
  coverLetter: Scalars['String'];
  createdAt: Scalars['Date'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  jobOffer: JobOffer;
  lastName: Scalars['String'];
  linkedInProfileLink?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<PhoneNumber>;
  resumeFile: Scalars['String'];
  resumeFileName: Scalars['String'];
  updatedAt: Scalars['Date'];
  user: User;
};

export type JobType = {
  __typename?: 'JobType';
  createdAt: Scalars['Date'];
  en?: Maybe<Scalars['String']>;
  fr?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  updatedAt: Scalars['Date'];
};

export type LoanAmount = {
  __typename?: 'LoanAmount';
  intakePercent: Scalars['Float'];
  monthNumber: Scalars['Int'];
  monthlyPayment: Scalars['Int'];
  totalInterestAmount: Scalars['Int'];
  totalInterests: Scalars['Float'];
  totalLoanAmount: Scalars['Int'];
  totalLoanedAmount: Scalars['Float'];
  totalPrice: Scalars['Int'];
};

export type LocalPhoneContactInput = {
  contact?: InputMaybe<Scalars['JSON']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  localPhoneContactId: Scalars['String'];
};

export type LocalPriceEvolutionDataPoint = {
  __typename?: 'LocalPriceEvolutionDataPoint';
  month: Scalars['String'];
  price: Scalars['Float'];
  year: Scalars['String'];
};

export enum LocalPriceEvolutionPropertyType {
  Apartment = 'apartment',
  House = 'house'
}

export type LocalPriceEvolutionResponse = {
  __typename?: 'LocalPriceEvolutionResponse';
  dataPoints: Array<LocalPriceEvolutionDataPoint>;
  tendency: Scalars['Float'];
};

export enum Match {
  Any = 'any',
  End = 'end',
  Exact = 'exact',
  Start = 'start'
}

export type Medium = {
  __typename?: 'Medium';
  ad?: Maybe<Ad>;
  aspectRatio?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Date'];
  duration: Scalars['Float'];
  embedId?: Maybe<Scalars['String']>;
  embedSource?: Maybe<EmbedSource>;
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  isTranscoding?: Maybe<Scalars['Boolean']>;
  post?: Maybe<Post>;
  project?: Maybe<Project>;
  rotation?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  story?: Maybe<Story>;
  type: MediumType;
  updatedAt: Scalars['Date'];
  url: Scalars['String'];
  userImage?: Maybe<User>;
  userShowcase?: Maybe<User>;
  width?: Maybe<Scalars['Int']>;
};

export enum MediumType {
  Audio = 'audio',
  Embed = 'embed',
  Image = 'image',
  Pdf = 'pdf',
  Video = 'video'
}

export type MembershipInvitation = GroupInvitation | Invitation;

export type Message = {
  __typename?: 'Message';
  content?: Maybe<Scalars['String']>;
  emitter?: Maybe<User>;
  emitterId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isStoryReaction?: Maybe<Scalars['Boolean']>;
  reaction?: Maybe<Reaction>;
};

export type MessageData = {
  payload?: InputMaybe<MessageDataPayload>;
  type: DataType;
};

export type MessageDataPayload = {
  id?: InputMaybe<Scalars['String']>;
  reaction?: InputMaybe<Reaction>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptGalleryInvitation: AcceptGalleryInvitationResult;
  /** @deprecated Use updateInvitation instead 20221107 */
  acceptInvitation: Invitation;
  addAdmin: Scalars['Boolean'];
  addBlockedUser: BlockedUser;
  addContactToUser: Contact;
  addContentEvent: Scalars['Boolean'];
  addContentToGallery: Gallery;
  addCrmSync?: Maybe<CrmSync>;
  addDirector: Scalars['Boolean'];
  addEvent: Scalars['Boolean'];
  addEvents: Scalars['Boolean'];
  assignAdsToUser: Scalars['Boolean'];
  assistancePagesJaunes: Scalars['Boolean'];
  cancelGalleryInvitation: CancelGalleryInvitationResult;
  cancelPhoneContactSync: Scalars['Boolean'];
  createAd: Ad;
  createChatToken: SendbirdToken;
  createComment: Comment;
  createCompany: Company;
  /** @deprecated Use createCompany instead 20220908 */
  createCompanyWithNullableAddress: Company;
  createGallery: Gallery;
  createGalleryInvitation: CreateGalleryInvitationResult;
  createGroupInvitation: GroupInvitation;
  createInvitation: Invitation;
  createJobOffer: JobOffer;
  createJobOfferApplication: JobOfferApplication;
  createNewsFeedback: NewsFeedback;
  createPhoneContacts: PhoneContactResponse;
  createPost: Post;
  createProject: Project;
  createQuickSignupAds: Scalars['Boolean'];
  createRating: CreateRatingResponse;
  createRecommendation: CreateRecommendationResponse;
  createSecondaryEmail?: Maybe<SecondaryEmail>;
  createStory: Story;
  declineGalleryInvitation: DeclineGalleryInvitationResult;
  /** @deprecated Use updateAdStatus instead 20220322 */
  deleteAd: Scalars['Boolean'];
  deleteComment: Scalars['Boolean'];
  deleteCompany: Scalars['Boolean'];
  deleteGallery: Scalars['Boolean'];
  deleteGroupInvitation: Scalars['Boolean'];
  deleteInvitation: Scalars['Boolean'];
  deletePhoneContactSync: Scalars['Boolean'];
  deletePhoneContacts: Scalars['Boolean'];
  deletePost: Scalars['Boolean'];
  deleteProject: Scalars['Boolean'];
  deleteSavedSearch: Scalars['Boolean'];
  deleteSecondaryEmail: Scalars['Boolean'];
  deleteStory: Scalars['Boolean'];
  dislikeComment: Scalars['Boolean'];
  dislikeNewsPost: Scalars['Boolean'];
  dislikePost: Scalars['Boolean'];
  follow: Scalars['Int'];
  hideRating: Scalars['Boolean'];
  incrementStatsContactCount: Scalars['Boolean'];
  incrementStatsViewCount: Scalars['Boolean'];
  /** @deprecated Pro can't join freely a company now 20221107 */
  joinCompany: Scalars['Boolean'];
  likeComment: Scalars['Boolean'];
  likeNewsPost: Scalars['Boolean'];
  likePost: Scalars['Boolean'];
  patchViewerNotificationSubscriptions: Array<NotificationSubscription>;
  recoverJobOffer: Scalars['Boolean'];
  recoverUser: Scalars['Boolean'];
  refreshBadgeCount: Scalars['Boolean'];
  /** @deprecated Use updateInvitation instead 20221107 */
  refuseInvitation: Invitation;
  removeAdmin: Scalars['Boolean'];
  removeBlockedUser: Scalars['Boolean'];
  removeCompany: Scalars['Boolean'];
  removeContact: Scalars['Boolean'];
  removeContentFromGalleries: Array<Gallery>;
  removeCrmSync: Scalars['Boolean'];
  removeDirector: Scalars['Boolean'];
  removeGalleryCollaborator: RemoveGalleryCollaboratorResult;
  removeGroupMembership: Scalars['Boolean'];
  removeMember: Scalars['Boolean'];
  removeRecommendation: Scalars['Boolean'];
  reportAd: Scalars['Boolean'];
  reportComment: Scalars['Boolean'];
  reportCompany: Scalars['Boolean'];
  reportConversation: Scalars['Boolean'];
  reportNewsPost: Scalars['Boolean'];
  reportPost: Scalars['Boolean'];
  reportStory: Scalars['Boolean'];
  reportUser: Scalars['Boolean'];
  requestAdminAccess: RequestAdmin;
  requestAgentEmail: Scalars['Boolean'];
  requestCrm: Scalars['Boolean'];
  requestHomadataEvaluation?: Maybe<HomadataEvaluation>;
  requestPermanentDeleteAccount: Scalars['Boolean'];
  requestRecommendation: RequestRecommendationResponse;
  requestVerificationCode: Scalars['Boolean'];
  /** @deprecated Never used I think 20221107 */
  resendInvitation: Invitation;
  saveNewsCategories: Scalars['Boolean'];
  /** @deprecated Use saveSearchByPlace 20231103 */
  saveSearch: Search;
  saveSearchByPlace: Search;
  sendChatNotificationMessage?: Maybe<SendbirdResponse>;
  sendMailVerification?: Maybe<Scalars['Boolean']>;
  sendMessage?: Maybe<SendbirdResponse>;
  sendSharedContentMessage?: Maybe<SendbirdResponse>;
  sendSharedFileMessage?: Maybe<SendbirdResponse>;
  setEmailVerified: Scalars['Boolean'];
  setMessagingData: Scalars['Boolean'];
  setPrimaryEmail: Scalars['Boolean'];
  setUserVersion?: Maybe<Scalars['String']>;
  signUp: User;
  signUpPro: User;
  softDeleteAd: Scalars['Boolean'];
  softDeleteJobOffer: Scalars['Boolean'];
  softDeleteUser: Scalars['Boolean'];
  statsViewCount: Scalars['Boolean'];
  submitInterest: Scalars['Boolean'];
  syncNotifications: Scalars['Boolean'];
  unfollow: Scalars['Int'];
  unsubscribeQuickSignupUser: Scalars['Boolean'];
  updateAd: Ad;
  updateAdStatus: Scalars['Boolean'];
  updateAdminRequest: Scalars['Boolean'];
  updateApimoAgency: User;
  updateApimoUser: User;
  updateChannelName: Scalars['String'];
  updateChannelToSuperChannel: Scalars['Boolean'];
  updateComment: Comment;
  updateCompanyShowcase: Array<Maybe<Medium>>;
  updateCompanyWithNullableAddress: Company;
  updateContact: Scalars['Boolean'];
  updateDeviceToken: Scalars['Boolean'];
  updateGallery: Gallery;
  updateGroupInvitation: Scalars['Boolean'];
  updateInvitation: Scalars['Boolean'];
  updateIosVoipPushToken: Scalars['Boolean'];
  updateJobOffer: JobOffer;
  updateJobOfferIsHidden: JobOffer;
  updateMyProfileImage: User;
  updatePassword: Scalars['Boolean'];
  updatePersonalInfo: User;
  updatePost: Post;
  updateProject: Project;
  updateRating: UpdateRatingResponse;
  updateRecommendation: Recommendation;
  /** @deprecated Use updateSearchByPlace 20231103 */
  updateSearch: Search;
  updateSearchByPlace: Search;
  updateSettings: Scalars['Boolean'];
  updateShowcase: Array<Maybe<Medium>>;
  updateUserLocale: SupportedLocales;
  uploadChannelImage: Scalars['String'];
  uploadMedia: Array<Scalars['String']>;
  validateVerificationCode: ValidateVerificationCodeResponse;
  viewNotification: Scalars['Boolean'];
  viewSavedSearch: Search;
  viewStory: Scalars['Boolean'];
  viewTip?: Maybe<Array<UserTipView>>;
};


export type MutationAcceptGalleryInvitationArgs = {
  invitationId: Scalars['ID'];
};


export type MutationAcceptInvitationArgs = {
  invitationId: Scalars['String'];
};


export type MutationAddAdminArgs = {
  userId: Scalars['String'];
};


export type MutationAddBlockedUserArgs = {
  userId: Scalars['String'];
};


export type MutationAddContactToUserArgs = {
  userId: Scalars['String'];
};


export type MutationAddContentEventArgs = {
  adId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  newsPostId?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['String']>;
  storyId?: InputMaybe<Scalars['String']>;
};


export type MutationAddContentToGalleryArgs = {
  adId?: InputMaybe<Scalars['String']>;
  galleryId: Scalars['String'];
  newsPostId?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['String']>;
};


export type MutationAddCrmSyncArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  crmSourceId: Scalars['String'];
  requestedCrmName?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationAddDirectorArgs = {
  userId: Scalars['String'];
};


export type MutationAddEventArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  eventType: Scalars['String'];
  pagesJaunesMerchantId?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  quickSignupCompanyId?: InputMaybe<Scalars['String']>;
  quickSignupUserId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  viewedUserId?: InputMaybe<Scalars['String']>;
};


export type MutationAddEventsArgs = {
  events: Array<EventData>;
};


export type MutationAssignAdsToUserArgs = {
  adIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId: Scalars['String'];
};


export type MutationAssistancePagesJaunesArgs = {
  description: Scalars['String'];
  email: Scalars['String'];
  pagesJaunesId: Scalars['String'];
  phone: Scalars['String'];
};


export type MutationCancelGalleryInvitationArgs = {
  invitationId: Scalars['ID'];
};


export type MutationCreateAdArgs = {
  address?: InputMaybe<AddressParam>;
  addressDescription?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availableDate?: InputMaybe<Scalars['Int']>;
  bedroomNumber?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  coOwnership?: InputMaybe<Scalars['Boolean']>;
  coOwnershipNumberOfLots?: InputMaybe<Scalars['Int']>;
  coOwnershipOngoing?: InputMaybe<YesNoOptions>;
  coOwnershipYearlyCharge?: InputMaybe<Scalars['Float']>;
  commissionRate?: InputMaybe<Scalars['Float']>;
  commonAreasState?: InputMaybe<CommonAreasState>;
  companyId?: InputMaybe<Scalars['String']>;
  constructibleLand?: InputMaybe<YesNoNaOptions>;
  constructionYear?: InputMaybe<Scalars['Int']>;
  consumption?: InputMaybe<Scalars['String']>;
  contactConsent?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dimensionHeight?: InputMaybe<Scalars['Float']>;
  dimensionLength?: InputMaybe<Scalars['Float']>;
  dimensionWidth?: InputMaybe<Scalars['Float']>;
  email?: InputMaybe<Scalars['String']>;
  emissions?: InputMaybe<Scalars['String']>;
  fees?: InputMaybe<Scalars['Int']>;
  floorNumber?: InputMaybe<Scalars['Int']>;
  floorPosition?: InputMaybe<Scalars['Int']>;
  furnished?: InputMaybe<Scalars['Boolean']>;
  guarantees?: InputMaybe<Scalars['String']>;
  heatInformations?: InputMaybe<Scalars['String']>;
  heatType?: InputMaybe<HeatTypes>;
  heatingDevice?: InputMaybe<HeatingDevices>;
  homadataEvaluation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inclusions?: InputMaybe<Scalars['String']>;
  interOffice: Scalars['Boolean'];
  inventory?: InputMaybe<Scalars['Float']>;
  isHiddingCompleteAddress: Scalars['Boolean'];
  landArea?: InputMaybe<Scalars['Float']>;
  lat?: InputMaybe<Scalars['Float']>;
  livingArea?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  media: Array<InputMaybe<Scalars['Upload']>>;
  monthlyCharges?: InputMaybe<Scalars['Float']>;
  newProperty?: InputMaybe<Scalars['Boolean']>;
  numberOfVehicles?: InputMaybe<Scalars['Int']>;
  placeId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  priceHidden?: InputMaybe<Scalars['Boolean']>;
  priceWithoutSaleFee?: InputMaybe<Scalars['Int']>;
  propertyPurposeEstimation?: InputMaybe<PropertyPurposeEstimation>;
  propertyResidenceType?: InputMaybe<PropertyResidenceType>;
  propertyState?: InputMaybe<PropertyState>;
  propertyType: PropertyTypes;
  rent?: InputMaybe<Scalars['Int']>;
  roomNumber?: InputMaybe<Scalars['Int']>;
  rooms?: InputMaybe<Scalars['String']>;
  saleFeeBuyerRate?: InputMaybe<Scalars['Float']>;
  saleFeeType?: InputMaybe<SaleFeeType>;
  servicedLand?: InputMaybe<YesNoNaOptions>;
  showSaleFeeBuyerPrice?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<AdStatuses>;
  surfaceArea?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  tmpUrls?: InputMaybe<Array<Scalars['String']>>;
  type: AdTypes;
  userId?: InputMaybe<Scalars['String']>;
  userIsOwner?: InputMaybe<Scalars['Boolean']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationCreateCommentArgs = {
  content: Scalars['String'];
  postId: Scalars['String'];
};


export type MutationCreateCompanyArgs = {
  address?: InputMaybe<AddressParam>;
  coverImage?: InputMaybe<Scalars['Upload']>;
  customActivity?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feeScaleFile?: InputMaybe<Scalars['Upload']>;
  feeScaleFileName?: InputMaybe<Scalars['String']>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['Upload']>;
  imageHybridMedium?: InputMaybe<HybridMedium>;
  isPrivate: Scalars['Boolean'];
  label?: InputMaybe<CompanyLabel>;
  mainActivityId?: InputMaybe<Scalars['String']>;
  mainCategoryId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pagesJaunesId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<PhoneParam>;
  showcase?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  siretNumber?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};


export type MutationCreateCompanyWithNullableAddressArgs = {
  address?: InputMaybe<AddressParam>;
  companyType?: InputMaybe<CompanyType>;
  coverImage?: InputMaybe<Scalars['Upload']>;
  description?: InputMaybe<Scalars['String']>;
  feeScaleFile?: InputMaybe<Scalars['Upload']>;
  feeScaleFileName?: InputMaybe<Scalars['String']>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['Upload']>;
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  phoneNumber?: InputMaybe<PhoneParam>;
  showcase?: InputMaybe<Array<InputMaybe<HybridMedium>>>;
  website?: InputMaybe<Scalars['String']>;
};


export type MutationCreateGalleryArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  invitations?: InputMaybe<Array<ClosedGalleryInvitationInput>>;
  isSecret: Scalars['Boolean'];
  name: Scalars['String'];
};


export type MutationCreateGalleryInvitationArgs = {
  galleryId: Scalars['ID'];
  invitee?: InputMaybe<GalleryInviteeInput>;
  role: GalleryRole;
  type: GalleryInvitationType;
};


export type MutationCreateGroupInvitationArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateInvitationArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateJobOfferArgs = {
  cityId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  companyName: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  googlePlaceId?: InputMaybe<Scalars['String']>;
  jobTypeId: Scalars['String'];
  profile?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};


export type MutationCreateJobOfferApplicationArgs = {
  coverLetter: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  jobOfferId: Scalars['String'];
  lastName: Scalars['String'];
  linkedInProfileLink?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  resumeFile: Scalars['Upload'];
  resumeFileName: Scalars['String'];
};


export type MutationCreateNewsFeedbackArgs = {
  newsPostId: Scalars['String'];
  reasonForLess?: InputMaybe<ReasonForLess>;
  userId?: InputMaybe<Scalars['String']>;
  wantToSeeMoreOrLess: WantToSeeMoreOrLess;
};


export type MutationCreatePhoneContactsArgs = {
  contacts: Array<InputMaybe<LocalPhoneContactInput>>;
};


export type MutationCreatePostArgs = {
  adId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  media: Array<InputMaybe<Scalars['Upload']>>;
  message?: InputMaybe<Scalars['String']>;
  newsPostId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateProjectArgs = {
  cityId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  media: Array<InputMaybe<Scalars['Upload']>>;
  name: Scalars['String'];
};


export type MutationCreateQuickSignupAdsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  quickSignupUserId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationCreateRatingArgs = {
  comment?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  value: Scalars['Int'];
};


export type MutationCreateRecommendationArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateSecondaryEmailArgs = {
  email: Scalars['String'];
};


export type MutationCreateStoryArgs = {
  adId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  floatingText?: InputMaybe<Scalars['String']>;
  medium: Scalars['Upload'];
  newsPostId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationDeclineGalleryInvitationArgs = {
  invitationId: Scalars['ID'];
};


export type MutationDeleteAdArgs = {
  id: Scalars['String'];
  reasonWhyDeleted?: InputMaybe<ReasonWhyDeleted>;
};


export type MutationDeleteCommentArgs = {
  commentId: Scalars['String'];
};


export type MutationDeleteCompanyArgs = {
  companyId: Scalars['String'];
};


export type MutationDeleteGalleryArgs = {
  id: Scalars['String'];
};


export type MutationDeleteGroupInvitationArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteInvitationArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  invitationId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationDeletePostArgs = {
  postId: Scalars['String'];
};


export type MutationDeleteProjectArgs = {
  projectId: Scalars['String'];
};


export type MutationDeleteSavedSearchArgs = {
  searchId: Scalars['String'];
};


export type MutationDeleteSecondaryEmailArgs = {
  id: Scalars['String'];
};


export type MutationDeleteStoryArgs = {
  storyId: Scalars['String'];
};


export type MutationDislikeCommentArgs = {
  commentId: Scalars['String'];
};


export type MutationDislikeNewsPostArgs = {
  newsPostId: Scalars['String'];
};


export type MutationDislikePostArgs = {
  postId: Scalars['String'];
};


export type MutationFollowArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationHideRatingArgs = {
  id: Scalars['String'];
  isHidden: Scalars['Boolean'];
};


export type MutationIncrementStatsContactCountArgs = {
  statsId: Scalars['String'];
};


export type MutationIncrementStatsViewCountArgs = {
  adId?: InputMaybe<Scalars['String']>;
  newsPostId?: InputMaybe<Scalars['String']>;
};


export type MutationJoinCompanyArgs = {
  companyId: Scalars['String'];
};


export type MutationLikeCommentArgs = {
  commentId: Scalars['String'];
};


export type MutationLikeNewsPostArgs = {
  newsPostId: Scalars['String'];
};


export type MutationLikePostArgs = {
  postId: Scalars['String'];
};


export type MutationPatchViewerNotificationSubscriptionsArgs = {
  subscriptions: Array<PatchNotificationSubscriptionInput>;
};


export type MutationRecoverJobOfferArgs = {
  jobOfferId: Scalars['String'];
};


export type MutationRefuseInvitationArgs = {
  invitationId: Scalars['String'];
};


export type MutationRemoveAdminArgs = {
  userId: Scalars['String'];
};


export type MutationRemoveBlockedUserArgs = {
  userId: Scalars['String'];
};


export type MutationRemoveCompanyArgs = {
  companyId: Scalars['String'];
};


export type MutationRemoveContactArgs = {
  userId: Scalars['String'];
};


export type MutationRemoveContentFromGalleriesArgs = {
  adId?: InputMaybe<Scalars['String']>;
  isCompanyGallery?: InputMaybe<Scalars['Boolean']>;
  newsPostId?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveCrmSyncArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveDirectorArgs = {
  userId: Scalars['String'];
};


export type MutationRemoveGalleryCollaboratorArgs = {
  collaborator: GalleryCollaboratorRefInput;
  galleryId: Scalars['ID'];
};


export type MutationRemoveGroupMembershipArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveMemberArgs = {
  userId: Scalars['String'];
};


export type MutationRemoveRecommendationArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationReportAdArgs = {
  adId: Scalars['String'];
  reason: Scalars['String'];
};


export type MutationReportCommentArgs = {
  commentId: Scalars['String'];
  reason: Scalars['String'];
};


export type MutationReportCompanyArgs = {
  companyId: Scalars['String'];
  reason: Scalars['String'];
};


export type MutationReportConversationArgs = {
  channelUrl: Scalars['String'];
  reason: Scalars['String'];
};


export type MutationReportNewsPostArgs = {
  newsPostId: Scalars['String'];
  reason: Scalars['String'];
};


export type MutationReportPostArgs = {
  postId: Scalars['String'];
  reason: Scalars['String'];
};


export type MutationReportStoryArgs = {
  reason: Scalars['String'];
  storyId: Scalars['String'];
};


export type MutationReportUserArgs = {
  reason: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationRequestAdminAccessArgs = {
  companyId: Scalars['String'];
};


export type MutationRequestAgentEmailArgs = {
  estimationId: Scalars['String'];
};


export type MutationRequestCrmArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  crmSourceName: Scalars['String'];
  requestedCrmName: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationRequestHomadataEvaluationArgs = {
  adId: Scalars['ID'];
};


export type MutationRequestPermanentDeleteAccountArgs = {
  appleAuthorizationCode?: InputMaybe<Scalars['String']>;
};


export type MutationRequestRecommendationArgs = {
  userId: Scalars['String'];
};


export type MutationRequestVerificationCodeArgs = {
  proId: Scalars['String'];
};


export type MutationResendInvitationArgs = {
  invitationId: Scalars['String'];
};


export type MutationSaveNewsCategoriesArgs = {
  categoryIds: Array<Scalars['String']>;
};


export type MutationSaveSearchArgs = {
  cities?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  parameters: Scalars['String'];
};


export type MutationSaveSearchByPlaceArgs = {
  emailNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parameters: Scalars['String'];
  place: GeometryInput;
  placeSource?: InputMaybe<GeometrySource>;
};


export type MutationSendChatNotificationMessageArgs = {
  channelUrl: Scalars['String'];
  notification: ChatNotificationData;
  requestId?: InputMaybe<Scalars['String']>;
};


export type MutationSendMailVerificationArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type MutationSendMessageArgs = {
  channelUrl: Scalars['String'];
  data?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<Scalars['String']>;
};


export type MutationSendSharedContentMessageArgs = {
  channelUrl: Scalars['String'];
  data?: InputMaybe<MessageData>;
  message?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<Scalars['String']>;
};


export type MutationSendSharedFileMessageArgs = {
  channelUrl: Scalars['String'];
  files: Array<InputMaybe<Scalars['Upload']>>;
  message?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<Scalars['String']>;
};


export type MutationSetEmailVerifiedArgs = {
  isEmailVerified: Scalars['Boolean'];
};


export type MutationSetMessagingDataArgs = {
  deviceToken: Scalars['String'];
  pushNotificationAccepted: Scalars['Boolean'];
};


export type MutationSetPrimaryEmailArgs = {
  secondaryEmail: Scalars['String'];
};


export type MutationSetUserVersionArgs = {
  mobileVersion?: InputMaybe<Scalars['String']>;
};


export type MutationSignUpArgs = {
  firstName?: InputMaybe<Scalars['String']>;
  hasOptedInAt?: InputMaybe<Scalars['Date']>;
  hasOptedInToMarketingCommsAt?: InputMaybe<Scalars['Date']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PlatformSource>;
  quickSignupUserId?: InputMaybe<Scalars['String']>;
};


export type MutationSignUpProArgs = {
  activityId: Scalars['String'];
  customActivity?: InputMaybe<Scalars['String']>;
  hasOptedInAt?: InputMaybe<Scalars['Date']>;
  hasOptedInToMarketingCommsAt?: InputMaybe<Scalars['Date']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  isTheRealEstateOther?: InputMaybe<Scalars['Boolean']>;
  platform?: InputMaybe<PlatformSource>;
  quickSignupUserId?: InputMaybe<Scalars['String']>;
};


export type MutationSoftDeleteAdArgs = {
  id: Scalars['String'];
};


export type MutationSoftDeleteJobOfferArgs = {
  jobOfferId: Scalars['String'];
};


export type MutationStatsViewCountArgs = {
  id: Scalars['String'];
};


export type MutationSubmitInterestArgs = {
  interest: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationUnfollowArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationUnsubscribeQuickSignupUserArgs = {
  quickSignupUserId: Scalars['String'];
};


export type MutationUpdateAdArgs = {
  address?: InputMaybe<AddressParam>;
  addressDescription?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availableDate?: InputMaybe<Scalars['Int']>;
  bedroomNumber?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  coOwnership?: InputMaybe<Scalars['Boolean']>;
  coOwnershipNumberOfLots?: InputMaybe<Scalars['Int']>;
  coOwnershipOngoing?: InputMaybe<YesNoOptions>;
  coOwnershipYearlyCharge?: InputMaybe<Scalars['Float']>;
  commissionRate?: InputMaybe<Scalars['Float']>;
  commonAreasState?: InputMaybe<CommonAreasState>;
  companyId?: InputMaybe<Scalars['String']>;
  constructibleLand?: InputMaybe<YesNoNaOptions>;
  constructionYear?: InputMaybe<Scalars['Int']>;
  consumption?: InputMaybe<Scalars['String']>;
  contactConsent?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  crmId?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dimensionHeight?: InputMaybe<Scalars['Float']>;
  dimensionLength?: InputMaybe<Scalars['Float']>;
  dimensionWidth?: InputMaybe<Scalars['Float']>;
  email?: InputMaybe<Scalars['String']>;
  emissions?: InputMaybe<Scalars['String']>;
  fees?: InputMaybe<Scalars['Int']>;
  floorNumber?: InputMaybe<Scalars['Int']>;
  floorPosition?: InputMaybe<Scalars['Int']>;
  furnished?: InputMaybe<Scalars['Boolean']>;
  guarantees?: InputMaybe<Scalars['String']>;
  heatInformations?: InputMaybe<Scalars['String']>;
  heatType?: InputMaybe<HeatTypes>;
  heatingDevice?: InputMaybe<HeatingDevices>;
  homadataEvaluation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inclusions?: InputMaybe<Scalars['String']>;
  interOffice: Scalars['Boolean'];
  inventory?: InputMaybe<Scalars['Float']>;
  isHiddingCompleteAddress: Scalars['Boolean'];
  isInaccurateAddress?: InputMaybe<Scalars['Boolean']>;
  landArea?: InputMaybe<Scalars['Float']>;
  lat?: InputMaybe<Scalars['Float']>;
  livingArea?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  media: Array<InputMaybe<HybridMedium>>;
  monthlyCharges?: InputMaybe<Scalars['Float']>;
  newProperty?: InputMaybe<Scalars['Boolean']>;
  numberOfVehicles?: InputMaybe<Scalars['Int']>;
  placeId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  priceHidden?: InputMaybe<Scalars['Boolean']>;
  priceWithoutSaleFee?: InputMaybe<Scalars['Int']>;
  propertyPurposeEstimation?: InputMaybe<PropertyPurposeEstimation>;
  propertyResidenceType?: InputMaybe<PropertyResidenceType>;
  propertyState?: InputMaybe<PropertyState>;
  propertyType: PropertyTypes;
  rent?: InputMaybe<Scalars['Int']>;
  roomNumber?: InputMaybe<Scalars['Int']>;
  rooms?: InputMaybe<Scalars['String']>;
  saleFeeBuyerRate?: InputMaybe<Scalars['Float']>;
  saleFeeType?: InputMaybe<SaleFeeType>;
  servicedLand?: InputMaybe<YesNoNaOptions>;
  showSaleFeeBuyerPrice?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<AdStatuses>;
  surfaceArea?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type: AdTypes;
  userId?: InputMaybe<Scalars['String']>;
  userIsOwner?: InputMaybe<Scalars['Boolean']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateAdStatusArgs = {
  id: Scalars['String'];
  priceSold?: InputMaybe<Scalars['Int']>;
  reasonWhyAdArchived?: InputMaybe<ReasonWhyAdArchived>;
  status: AdStatuses;
};


export type MutationUpdateAdminRequestArgs = {
  id: Scalars['String'];
  status: RequestAdminStatus;
};


export type MutationUpdateApimoAgencyArgs = {
  apimoAgencyId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateApimoUserArgs = {
  apimoAgencyId?: InputMaybe<Scalars['String']>;
  apimoUserId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateChannelNameArgs = {
  channelUrl: Scalars['String'];
  name: Scalars['String'];
};


export type MutationUpdateChannelToSuperChannelArgs = {
  channelUrl: Scalars['String'];
};


export type MutationUpdateCommentArgs = {
  commentId: Scalars['String'];
  content: Scalars['String'];
};


export type MutationUpdateCompanyShowcaseArgs = {
  companyId: Scalars['String'];
  media: Array<InputMaybe<HybridMedium>>;
};


export type MutationUpdateCompanyWithNullableAddressArgs = {
  address?: InputMaybe<AddressParam>;
  contactUrl?: InputMaybe<Scalars['String']>;
  contactUserId?: InputMaybe<Scalars['String']>;
  coverImageHybridMedium?: InputMaybe<HybridMedium>;
  customActivity?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feeScaleFileHybridMedium?: InputMaybe<HybridMedium>;
  feeScaleFileName?: InputMaybe<Scalars['String']>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  id: Scalars['String'];
  imageHybridMedium?: InputMaybe<HybridMedium>;
  label?: InputMaybe<CompanyLabel>;
  mainActivityId?: InputMaybe<Scalars['String']>;
  mainCategoryId?: InputMaybe<Scalars['String']>;
  mission?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<PhoneParam>;
  showcase?: InputMaybe<Array<InputMaybe<HybridMedium>>>;
  siretNumber?: InputMaybe<Scalars['String']>;
  videoHybridMedium?: InputMaybe<HybridMedium>;
  website?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateContactArgs = {
  contactedUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDeviceTokenArgs = {
  deviceToken?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateGalleryArgs = {
  id: Scalars['String'];
  isSecret: Scalars['Boolean'];
  name: Scalars['String'];
};


export type MutationUpdateGroupInvitationArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<InvitationStatus>;
};


export type MutationUpdateInvitationArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<InvitationStatus>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateIosVoipPushTokenArgs = {
  iosVoipPushToken?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateJobOfferArgs = {
  cityId?: InputMaybe<Scalars['String']>;
  companyName: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  googlePlaceId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  jobTypeId: Scalars['String'];
  profile?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};


export type MutationUpdateJobOfferIsHiddenArgs = {
  id: Scalars['String'];
  isHidden: Scalars['Boolean'];
};


export type MutationUpdateMyProfileImageArgs = {
  imageHybridMedium?: InputMaybe<HybridMedium>;
};


export type MutationUpdatePasswordArgs = {
  newPassword: Scalars['String'];
};


export type MutationUpdatePersonalInfoArgs = {
  awards?: InputMaybe<Scalars['String']>;
  certificates?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['String']>;
  coverImageHybridMedium?: InputMaybe<HybridMedium>;
  customActivity?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feeScaleFileHybridMedium?: InputMaybe<HybridMedium>;
  feeScaleFileName?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  imageHybridMedium?: InputMaybe<HybridMedium>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  services?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePostArgs = {
  adId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  media: Array<InputMaybe<HybridMedium>>;
  message?: InputMaybe<Scalars['String']>;
  newsPostId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateProjectArgs = {
  cityId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  media: Array<InputMaybe<HybridMedium>>;
  name: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationUpdateRatingArgs = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  value: Scalars['Int'];
};


export type MutationUpdateRecommendationArgs = {
  recommendationId: Scalars['String'];
  status?: InputMaybe<RecommendationStatus>;
};


export type MutationUpdateSearchArgs = {
  cities?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  lastViewedAt?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
  parameters: Scalars['String'];
};


export type MutationUpdateSearchByPlaceArgs = {
  emailNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  lastViewedAt?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  parameters?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<GeometryInput>;
  placeSource?: InputMaybe<GeometrySource>;
};


export type MutationUpdateSettingsArgs = {
  pushNotificationAccepted: Scalars['Boolean'];
};


export type MutationUpdateShowcaseArgs = {
  media: Array<InputMaybe<HybridMedium>>;
};


export type MutationUpdateUserLocaleArgs = {
  locale: SupportedLocales;
};


export type MutationUploadChannelImageArgs = {
  channelUrl: Scalars['String'];
  image: Scalars['Upload'];
};


export type MutationUploadMediaArgs = {
  media: Array<Scalars['Upload']>;
};


export type MutationValidateVerificationCodeArgs = {
  code: Scalars['String'];
  proId: Scalars['String'];
};


export type MutationViewNotificationArgs = {
  id: Scalars['String'];
};


export type MutationViewSavedSearchArgs = {
  searchId: Scalars['String'];
};


export type MutationViewStoryArgs = {
  storyId: Scalars['String'];
};


export type MutationViewTipArgs = {
  tipIdentifier: Scalars['String'];
};

export type MutationResult = {
  problem?: Maybe<ProblemDetail>;
  success: Scalars['Boolean'];
};

export type NewsCategory = {
  __typename?: 'NewsCategory';
  createdAt: Scalars['Date'];
  icon: Scalars['String'];
  id: Scalars['String'];
  nameEn: Scalars['String'];
  nameFr: Scalars['String'];
};

export type NewsFeedResponse = {
  __typename?: 'NewsFeedResponse';
  adsCount: Scalars['Int'];
  hasMore: Scalars['Boolean'];
  newsPostsCount: Scalars['Int'];
  postsCount: Scalars['Int'];
  results: Array<GalleryContent>;
};

export type NewsFeedback = {
  __typename?: 'NewsFeedback';
  id: Scalars['String'];
  newsPostId: Scalars['String'];
  reasonForLess: ReasonForLess;
  userId: Scalars['String'];
  wantToSeeMoreOrLess: WantToSeeMoreOrLess;
};

export type NewsPost = {
  __typename?: 'NewsPost';
  categories?: Maybe<Array<NewsCategory>>;
  createdAt: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  directusId?: Maybe<Scalars['Int']>;
  featuredCategory?: Maybe<NewsCategory>;
  id: Scalars['ID'];
  isUserAffiliatedCompanyFavorite: Scalars['Boolean'];
  isUserFavorite: Scalars['Boolean'];
  likedByCurrentUser: Scalars['Boolean'];
  likes: Array<NewsPostLike>;
  media: Array<Maybe<Medium>>;
  newsPostLink?: Maybe<Scalars['String']>;
  nofollow: Scalars['Boolean'];
  pubDate: Scalars['Date'];
  shortDescription?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceLink?: Maybe<Scalars['String']>;
  stats: Stats;
  status: NewsPostStatus;
  tags?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalLikes: Scalars['Int'];
  updatedAt: Scalars['Date'];
  views: Array<NewsPostView>;
};

export type NewsPostLike = {
  __typename?: 'NewsPostLike';
  createdAt: Scalars['Date'];
  id: Scalars['String'];
  newsPost: NewsPost;
  user: User;
};

export enum NewsPostStatus {
  Archived = 'archived',
  Draft = 'draft',
  Published = 'published',
  Ready = 'ready'
}

export type NewsPostView = {
  __typename?: 'NewsPostView';
  createdAt: Scalars['Date'];
  id: Scalars['String'];
  newsPost: NewsPost;
  user: User;
};

export type NewsPostsResponseWithTotal = {
  __typename?: 'NewsPostsResponseWithTotal';
  results: Array<NewsPost>;
  total: Scalars['Int'];
};

export type Notification = {
  __typename?: 'Notification';
  commentId?: Maybe<Scalars['ID']>;
  companyName?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  count?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  link: Scalars['String'];
  linkedContentId?: Maybe<Scalars['ID']>;
  nameToDisplay?: Maybe<Scalars['String']>;
  notifiedUser: User;
  notifyingUser?: Maybe<User>;
  showAfter?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  viewed: Scalars['Boolean'];
};

export type NotificationSubscription = {
  __typename?: 'NotificationSubscription';
  status: NotificationSubscriptionStatus;
  subject: NotificationSubscriptionSubject;
};

export enum NotificationSubscriptionStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export enum NotificationSubscriptionSubject {
  AdSearchResultsEmail = 'adSearchResultsEmail',
  MarketingCommunicationsEmail = 'marketingCommunicationsEmail'
}

export enum NotificationTypes {
  AcceptedMeContact = 'acceptedMeContact',
  CommentResponse = 'commentResponse'
}

export type NotificationsResponse = {
  __typename?: 'NotificationsResponse';
  nbPendingContacts?: Maybe<Scalars['Int']>;
  nbPendingGalleryInvitations?: Maybe<Scalars['Int']>;
  nbPendingInvitations?: Maybe<Scalars['Int']>;
  nbPendingRecommendations?: Maybe<Scalars['Int']>;
  nbPendingRequestAdmin?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<Notification>>>;
  total?: Maybe<Scalars['Int']>;
};

export type Owner = {
  __typename?: 'Owner';
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  detailDeepLink: Scalars['String'];
  displayName: Scalars['String'];
  email: Scalars['String'];
  feeScaleFile?: Maybe<Scalars['String']>;
  feeScaleFileName?: Maybe<Scalars['String']>;
  hasStoryWithAdLinked?: Maybe<Story>;
  hasUnreadStory: Scalars['Boolean'];
  id: Scalars['ID'];
  image?: Maybe<Medium>;
  initials?: Maybe<Scalars['String']>;
  lastStory?: Maybe<Story>;
  numberOfStories: Scalars['Int'];
  phoneNumber?: Maybe<PhoneNumber>;
  showcase?: Maybe<Array<Maybe<Medium>>>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type Page = {
  totalCount: Scalars['Int'];
};

export type PageRequest = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type PagesJaunesAddress = {
  __typename?: 'PagesJaunesAddress';
  addressDescription?: Maybe<Scalars['String']>;
  cityName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type PagesJaunesImage = {
  __typename?: 'PagesJaunesImage';
  /** @deprecated Use imagePath and download the image from the frontend */
  dataUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated Use imagePath and download the image from the frontend */
  imageAsBase64?: Maybe<Scalars['String']>;
  imagePath?: Maybe<Scalars['String']>;
};

export type PagesJaunesPhoneNumber = {
  __typename?: 'PagesJaunesPhoneNumber';
  countryCode: Scalars['String'];
  number: Scalars['String'];
  phoneCode: Scalars['String'];
};

export type PagesJaunesPro = {
  __typename?: 'PagesJaunesPro';
  activityLabel?: Maybe<Scalars['String']>;
  address?: Maybe<PagesJaunesAddress>;
  averageRating?: Maybe<Scalars['Float']>;
  canBeClaimedByCurrentUser: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  foundationYear?: Maybe<Scalars['String']>;
  imagePath?: Maybe<Scalars['String']>;
  images: Array<PagesJaunesImage>;
  name: Scalars['String'];
  numberOfRatings?: Maybe<Scalars['Int']>;
  pageUrl?: Maybe<Scalars['String']>;
  pagesJaunesProType: PagesJaunesProType;
  phoneNumber?: Maybe<PagesJaunesPhoneNumber>;
  proId: Scalars['String'];
  ratingsPageUrl?: Maybe<Scalars['String']>;
  siret?: Maybe<Scalars['String']>;
  thumbnailPath?: Maybe<Scalars['String']>;
  website?: Maybe<PagesJaunesWebsite>;
  woopenCompanyId?: Maybe<Scalars['String']>;
};

export type PagesJaunesProSearchResult = {
  __typename?: 'PagesJaunesProSearchResult';
  activityLabel?: Maybe<Scalars['String']>;
  address?: Maybe<PagesJaunesAddress>;
  averagePJRating?: Maybe<Scalars['Float']>;
  contactEmail?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imagePath?: Maybe<Scalars['String']>;
  images: Array<PagesJaunesImage>;
  merchantId: Scalars['String'];
  merchantName: Scalars['String'];
  numberOfPJRatings?: Maybe<Scalars['Int']>;
  pageUrl?: Maybe<Scalars['String']>;
  pagesJaunesProType: PagesJaunesProType;
  phoneNumber?: Maybe<PagesJaunesPhoneNumber>;
  ratingsPageUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use thumbnailPath and use the express endpoint to download the image from the frontend */
  thumbnail?: Maybe<PagesJaunesImage>;
  thumbnailPath?: Maybe<Scalars['String']>;
  woopenCompanyId?: Maybe<Scalars['String']>;
};

export enum PagesJaunesProType {
  Craft = 'craft',
  CraftAndRealEstate = 'craftAndRealEstate',
  Other = 'other',
  RealEstate = 'realEstate'
}

export type PagesJaunesWebsite = {
  __typename?: 'PagesJaunesWebsite';
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ParsedLinkResponse = {
  __typename?: 'ParsedLinkResponse';
  image?: Maybe<Scalars['String']>;
  publisher?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PatchNotificationSubscriptionInput = {
  status: NotificationSubscriptionStatus;
  subject: NotificationSubscriptionSubject;
};

export type PendingContact = {
  __typename?: 'PendingContact';
  id: Scalars['ID'];
  numberOfMutualContacts: Scalars['Int'];
  status: Scalars['String'];
  user: User;
};

export enum PendingInvitationSide {
  Received = 'received',
  Sent = 'sent'
}

export enum PendingInvitationType {
  All = 'all',
  CompanyMembership = 'companyMembership',
  GroupMembership = 'groupMembership'
}

export type PhoneContact = {
  __typename?: 'PhoneContact';
  createdAt: Scalars['Date'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importingUser: User;
  initials?: Maybe<Scalars['String']>;
  isSynchronized: Scalars['Boolean'];
  jsonContact?: Maybe<Scalars['JSON']>;
  lastName?: Maybe<Scalars['String']>;
  localPhoneContactId: Scalars['String'];
  updatedAt: Scalars['Date'];
  woopenUser?: Maybe<User>;
};

export type PhoneContactResponse = {
  __typename?: 'PhoneContactResponse';
  numberOfPhoneContacts: Scalars['Int'];
  phoneContacts?: Maybe<Array<PhoneContact>>;
};

export type PhoneContactSync = {
  __typename?: 'PhoneContactSync';
  createdAt: Scalars['Date'];
  currentCount: Scalars['Int'];
  id: Scalars['ID'];
  state: PhoneContactSyncState;
  syncNumber: Scalars['Int'];
  totalCount: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export enum PhoneContactSyncState {
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed'
}

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  countryCode: Scalars['String'];
  id: Scalars['ID'];
  number: Scalars['String'];
  phoneCode: Scalars['String'];
};

export type PhoneParam = {
  countryCode: Scalars['String'];
  number: Scalars['String'];
  phoneCode: Scalars['String'];
};

export enum PlatformSource {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

export type PolirisUser = {
  __typename?: 'PolirisUser';
  createdAt: Scalars['Date'];
  crmAgencyId?: Maybe<Scalars['String']>;
  crmSource?: Maybe<CrmSource>;
  crmSourceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type Post = {
  __typename?: 'Post';
  ad?: Maybe<Ad>;
  city: City;
  comments?: Maybe<Array<Maybe<Comment>>>;
  createdAt: Scalars['Date'];
  createdBy: User;
  createdById?: Maybe<Scalars['String']>;
  hasDeletedAdLinked: Scalars['Boolean'];
  hasDeletedNewsPostLinked: Scalars['Boolean'];
  hasDeletedProjectLinked: Scalars['Boolean'];
  iHaveOwnership: Scalars['Boolean'];
  id: Scalars['ID'];
  isFollowingUser?: Maybe<Scalars['Boolean']>;
  isUserAffiliatedCompanyFavorite: Scalars['Boolean'];
  isUserFavorite: Scalars['Boolean'];
  likedByCurrentUser: Scalars['Boolean'];
  media: Array<Maybe<Medium>>;
  message?: Maybe<Scalars['String']>;
  newsPost?: Maybe<NewsPost>;
  owner?: Maybe<Owner>;
  project?: Maybe<Project>;
  totalComments?: Maybe<Scalars['Int']>;
  totalLikes: Scalars['Int'];
  updatedAt: Scalars['Date'];
  usersWhoLikes?: Maybe<Array<Maybe<User>>>;
};

export type PriceResponse = {
  __typename?: 'PriceResponse';
  _id: Scalars['String'];
  dates: HomadatEvolutionDates;
  id: Scalars['String'];
};

export type ProblemDetail = {
  __typename?: 'ProblemDetail';
  data?: Maybe<Scalars['JSON']>;
  debug?: Maybe<ProblemDetailDebug>;
  detail?: Maybe<Scalars['String']>;
  help?: Maybe<Scalars['String']>;
  instance?: Maybe<Scalars['String']>;
  status: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ProblemDetailDebug = {
  __typename?: 'ProblemDetailDebug';
  message: Scalars['String'];
  name: Scalars['String'];
  stack?: Maybe<Scalars['String']>;
};

export type Project = {
  __typename?: 'Project';
  city: City;
  createdAt: Scalars['Date'];
  createdBy: User;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  media: Array<Maybe<Medium>>;
  name: Scalars['String'];
  owner: Owner;
  updatedAt: Scalars['Date'];
};

export type ProjectResponse = {
  __typename?: 'ProjectResponse';
  isFollowingUser?: Maybe<Scalars['Boolean']>;
  project?: Maybe<Project>;
};

export enum PropertyPurposeEstimation {
  AlreadySelled = 'already_selled',
  AlreadyStartedTheSell = 'already_started_the_sell',
  NoSell = 'no_sell',
  NoSellJustByCuriosity = 'no_sell_just_by_curiosity',
  SellInMoreThan_6Month = 'sell_in_more_than_6_month',
  SellSoon_3Or_6Month = 'sell_soon_3_or_6_month'
}

export enum PropertyResidenceType {
  Main = 'main',
  Other = 'other',
  Rental = 'rental',
  Secondary = 'secondary'
}

export enum PropertyState {
  Nothing = 'nothing',
  Other = 'other',
  RefreshNeeded = 'refresh_needed',
  Restored = 'restored',
  WorkNeeded = 'work_needed'
}

export enum PropertyTypes {
  Apartment = 'apartment',
  House = 'house',
  Land = 'land',
  Loft = 'loft',
  Other = 'other',
  Parking = 'parking'
}

export type Publisher = {
  __typename?: 'Publisher';
  createdAt: Scalars['Date'];
  id: Scalars['String'];
  name: Scalars['String'];
  price?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type PublishersWithTotal = {
  __typename?: 'PublishersWithTotal';
  results: Array<Publisher>;
  total: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  activities?: Maybe<Array<Activity>>;
  activity: Activity;
  activityCategories?: Maybe<Array<ActivityCategory>>;
  activityCategorySubcategories?: Maybe<Array<ActivityCategory>>;
  ad?: Maybe<Ad>;
  adPublishers: PublishersWithTotal;
  adStats?: Maybe<Array<Maybe<Ad>>>;
  adminRequests: AdminRequestsResponse;
  ads?: Maybe<AdsSearch>;
  agents?: Maybe<UsersResponseWithTotal>;
  chatUser?: Maybe<User>;
  /** @deprecated Not used anymore 2023_05_04 */
  chats?: Maybe<Array<Maybe<Chat>>>;
  closestAd?: Maybe<Ad>;
  comments?: Maybe<Array<Comment>>;
  /** @deprecated Use searchCompaniesToJoin instead 2023_05_05 */
  companiesToJoin?: Maybe<Array<Company>>;
  /** @deprecated Use ads query */
  companyAds?: Maybe<Array<Ad>>;
  /** @deprecated Use companyMembersWithTotal instead 2022_12_21 */
  companyMembers: Array<User>;
  /** @deprecated Not used anymore */
  companyMembersAndPendingInvitations?: Maybe<Array<User>>;
  companyMembersWhoAreInMyContacts?: Maybe<UsersResponseWithTotal>;
  companyMembersWithTotal?: Maybe<UsersResponseWithTotal>;
  companyProfile: Company;
  /** @deprecated Use searchProjects */
  companyProjects: Array<Project>;
  /** @deprecated Use recommendingUsers OR recommendations query according to need */
  companyRecommendations?: Maybe<UsersResponseWithTotal>;
  counts: CountsResponse;
  countsForSitemap: CountsForSitemapResponse;
  crmSources?: Maybe<Array<Maybe<CrmSource>>>;
  dataForSitemap: DataForSitemapResponse;
  /** @deprecated Use newsFeed instead */
  feedItems?: Maybe<FeeItemsResponse>;
  findVersion?: Maybe<VersionSupported>;
  firstConnection: FirstConnectionResponse;
  /** @deprecated Use following instead - 03-08-2023 */
  followedUsers?: Maybe<Array<Follow>>;
  followers: FollowsWithTotal;
  following: FollowsWithTotal;
  /** @deprecated Use User.galleries, Company.galleries instead 2024_09_24 */
  galleries?: Maybe<Array<Gallery>>;
  gallery?: Maybe<Gallery>;
  /** @deprecated Use Gallery.contentItems instead 2024_09_30 */
  galleryContent?: Maybe<Array<GalleryContent>>;
  generateAppLink?: Maybe<AppLink>;
  /** @deprecated Use generateAppLink instead 2024_04_26 */
  generateFirebaseDynamicLink: GenerateFirebaseDynamicLinkResponse;
  getTotalNotificationsBadgeCount: Scalars['Int'];
  groupCompanies?: Maybe<GroupCompaniesResponse>;
  homadata?: Maybe<HomadataEstimationResponse>;
  /** @deprecated Use localPriceEvolution instead 2024_02_27 */
  homadataEvolution?: Maybe<HomadataEvolutionResponse>;
  homeLoan?: Maybe<LoanAmount>;
  isAgoraSupported: Scalars['Boolean'];
  isBackwardCompatible?: Maybe<Scalars['Boolean']>;
  jobOffer?: Maybe<JobOffer>;
  jobOffers?: Maybe<Array<JobOffer>>;
  jobTypes?: Maybe<Array<JobType>>;
  localPriceEvolution?: Maybe<LocalPriceEvolutionResponse>;
  locate?: Maybe<City>;
  makeAgoraCall?: Maybe<AgoraResponse>;
  me: User;
  membersAds?: Maybe<Array<Ad>>;
  /** @deprecated Use userContactsV2 instead - 28-07-2023 */
  mutualContacts?: Maybe<UsersResponseWithTotal>;
  myContacts?: Maybe<Array<User>>;
  /** @deprecated Use followers instead - 20-07-2023 */
  myFollowers?: Maybe<Array<Follow>>;
  myGalleryInvitations: GalleryInvitationPage;
  myPendingClosedGalleryInvitation?: Maybe<GalleryInvitation>;
  myPendingContacts?: Maybe<Array<PendingContact>>;
  myPendingInvitations?: Maybe<Array<MembershipInvitation>>;
  /** @deprecated Use myPendingInvitations without ide => default = received */
  myReceivedInvitationsPending?: Maybe<Array<Invitation>>;
  mySettings: SettingsResponse;
  newsCategories: Array<NewsCategory>;
  newsCategoriesRecommendations: Array<NewsCategory>;
  newsFeed?: Maybe<NewsFeedResponse>;
  newsPost?: Maybe<NewsPost>;
  newsPostLikes?: Maybe<Array<Maybe<User>>>;
  newsPosts: Array<NewsPost>;
  notifications?: Maybe<NotificationsResponse>;
  pagesJaunesProWithImagesUrls?: Maybe<PagesJaunesPro>;
  parsedLink?: Maybe<ParsedLinkResponse>;
  pendingOpenGalleryInvitation?: Maybe<GalleryInvitation>;
  phoneContactsSync?: Maybe<PhoneContactSync>;
  phoneContactsWithTotal?: Maybe<PhoneContactResponse>;
  post?: Maybe<Post>;
  postLikes?: Maybe<Array<Maybe<User>>>;
  posts?: Maybe<Array<Post>>;
  project?: Maybe<ProjectResponse>;
  /** @deprecated Use searchProjects */
  projects?: Maybe<Array<Project>>;
  quickSignupCompany: QuickSignupCompany;
  quickSignupUser: QuickSignupUser;
  rating?: Maybe<Rating>;
  ratings?: Maybe<RatingsResponse>;
  recommendations?: Maybe<Array<Recommendation>>;
  recommendingUsers?: Maybe<UsersResponseWithTotal>;
  savedSearches: SavedSearchesResponseWithTotal;
  search?: Maybe<Search>;
  searchAdsCountSinceLastViewed?: Maybe<Scalars['Int']>;
  /** @deprecated Use searchAllUsersWithTotal instead */
  searchAllUsers?: Maybe<Array<User>>;
  searchAllUsersWithTotal?: Maybe<UsersResponseWithTotal>;
  searchCities?: Maybe<Array<City>>;
  searchCommunity?: Maybe<CommunitySearchResponse>;
  /** @deprecated Use searchCommunity instead 2023_05_24 */
  searchCommunityByActivityWithImagesUrls?: Maybe<SearchCommunityByActivityResponse>;
  /** @deprecated Use searchCommunity instead 2023_05_24 */
  searchCommunityByNameWithImagesUrls?: Maybe<Array<CommunityByNameSearchResult>>;
  searchCompaniesForInvitations?: Maybe<CompaniesResponseWithTotal>;
  searchCompaniesToJoin?: Maybe<CompanyOrPagesJaunesProSearchResponse>;
  searchForSIRET?: Maybe<Array<SiretEstablishment>>;
  /** @deprecated Use searchAllUsers instead 2022_11_25 */
  searchMentionableUsers?: Maybe<Array<User>>;
  searchProjects?: Maybe<SearchProjectsResponseWithTotal>;
  searchRecommendedRealEstate?: Maybe<SearchRecommendedRealEstateResponseWithTotal>;
  searchUsersAndCompaniesWithTotal?: Maybe<UsersOrCompaniesResponseWithTotal>;
  searchUsersForInvitations?: Maybe<Array<User>>;
  /** @deprecated Added offset and limit for batched fetching 20231012, use savedSearches instead */
  searches?: Maybe<Array<Search>>;
  secondaryEmail?: Maybe<SecondaryEmail>;
  secondaryEmails?: Maybe<Array<SecondaryEmail>>;
  sharedFiles?: Maybe<Array<Maybe<Medium>>>;
  stories?: Maybe<Array<Story>>;
  storiesGroupedByOwners?: Maybe<Array<Owner>>;
  story?: Maybe<Story>;
  storyReactions?: Maybe<Array<StoryReactions>>;
  /** @deprecated Use storyReactions instead */
  storyReacts?: Maybe<Array<Message>>;
  suggestedContacts?: Maybe<UsersResponseWithTotal>;
  suggestedUsersAndCompanies?: Maybe<UsersOrCompaniesResponseWithTotal>;
  /** @deprecated Not used anymore 2023_05_05 */
  talkWith: TalkWithResponse;
  userAds?: Maybe<Array<Ad>>;
  userContactsV2?: Maybe<UsersResponseWithTotal>;
  userFavoriteNewsPosts?: Maybe<NewsPostsResponseWithTotal>;
  userProfile?: Maybe<User>;
  users?: Maybe<Array<User>>;
  usersToDivert?: Maybe<Array<Scalars['String']>>;
  versionsSupported?: Maybe<Array<Scalars['String']>>;
  woopenParameter?: Maybe<Scalars['String']>;
};


export type QueryActivitiesArgs = {
  companyLabel?: InputMaybe<CompanyLabel>;
  displayOneOtherOnSignUp?: InputMaybe<Scalars['Boolean']>;
};


export type QueryActivityArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryActivityCategoriesArgs = {
  includeOther?: InputMaybe<Scalars['Boolean']>;
  onlyCrafts?: InputMaybe<Scalars['Boolean']>;
};


export type QueryActivityCategorySubcategoriesArgs = {
  parentCategoryId?: InputMaybe<Scalars['String']>;
};


export type QueryAdArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryAdPublishersArgs = {
  adId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<AdPublisherSortInput>;
};


export type QueryAdminRequestsArgs = {
  companyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<RequestAdminStatus>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAdsArgs = {
  apartment?: InputMaybe<Scalars['Boolean']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  assignatedToUserId?: InputMaybe<Scalars['String']>;
  bedrooms?: InputMaybe<Scalars['Int']>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyId?: InputMaybe<Scalars['String']>;
  furnished?: InputMaybe<Array<FurnishedStatus>>;
  house?: InputMaybe<Scalars['Boolean']>;
  interOffice?: InputMaybe<Scalars['Boolean']>;
  isPrivateAdvertiser?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  loft?: InputMaybe<Scalars['Boolean']>;
  maxLandArea?: InputMaybe<Scalars['Int']>;
  maxLivingArea?: InputMaybe<Scalars['Int']>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  minLandArea?: InputMaybe<Scalars['Int']>;
  minLivingArea?: InputMaybe<Scalars['Int']>;
  minPrice?: InputMaybe<Scalars['Int']>;
  newProperty?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  oldProperty?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  parking?: InputMaybe<Scalars['Boolean']>;
  places?: InputMaybe<Array<InputMaybe<GeometryInput>>>;
  realEstateTradesAdvertiser?: InputMaybe<Scalars['Boolean']>;
  rooms?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<InputMaybe<AdStatuses>>>;
  terrain?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  withoutAssignation?: InputMaybe<Scalars['Boolean']>;
  zoom?: InputMaybe<Scalars['Float']>;
};


export type QueryAgentsArgs = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  orderBy?: InputMaybe<EsOrderByTypes>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryChatUserArgs = {
  sendbirdUserId: Scalars['String'];
};


export type QueryChatsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryClosestAdArgs = {
  cityId?: InputMaybe<Scalars['String']>;
};


export type QueryCommentsArgs = {
  order?: InputMaybe<Scalars['JSON']>;
  postId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCompaniesToJoinArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  match?: InputMaybe<Match>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCompanyAdsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  statuses?: InputMaybe<Array<InputMaybe<AdStatuses>>>;
  type?: InputMaybe<AdTypes>;
};


export type QueryCompanyMembersArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isDirector?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  match?: InputMaybe<Match>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withRecursive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCompanyMembersAndPendingInvitationsArgs = {
  companyId: Scalars['String'];
  match?: InputMaybe<Match>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCompanyMembersWhoAreInMyContactsArgs = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyId: Scalars['String'];
  match?: InputMaybe<Match>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCompanyMembersWithTotalArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isDirector?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyWithRecommendations?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  withRecursive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCompanyProfileArgs = {
  companyId: Scalars['String'];
};


export type QueryCompanyProjectsArgs = {
  companyId: Scalars['String'];
  match?: InputMaybe<Match>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCompanyRecommendationsArgs = {
  companyId: Scalars['String'];
  match?: InputMaybe<Match>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCrmSourcesArgs = {
  withOther?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDataForSitemapArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFeedItemsArgs = {
  skipNewsPosts?: InputMaybe<Scalars['Int']>;
  skipPosts?: InputMaybe<Scalars['Int']>;
};


export type QueryFindVersionArgs = {
  versionNumber: Scalars['String'];
};


export type QueryFollowedUsersArgs = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  match?: InputMaybe<Match>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryFollowersArgs = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  match?: InputMaybe<Match>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryFollowingArgs = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  match?: InputMaybe<Match>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryGalleriesArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryGalleryArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryGalleryContentArgs = {
  galleryId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  type: GalleryContentType;
};


export type QueryGenerateAppLinkArgs = {
  params?: InputMaybe<Array<AppLinkParamsInput>>;
  type: AppLinkType;
};


export type QueryGenerateFirebaseDynamicLinkArgs = {
  id: Scalars['String'];
  type: Scalars['String'];
};


export type QueryGroupCompaniesArgs = {
  cityId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['String'];
  lat?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyWithRecommendations?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  radiusKm?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryHomadataArgs = {
  bedroomNumber?: InputMaybe<Scalars['Int']>;
  constructionYear?: InputMaybe<Scalars['Int']>;
  floorNumber?: InputMaybe<Scalars['Int']>;
  floorPosition?: InputMaybe<Scalars['Int']>;
  isOnEstimationFlow?: InputMaybe<Scalars['Boolean']>;
  landArea?: InputMaybe<Scalars['Float']>;
  lat: Scalars['Float'];
  livingArea: Scalars['Float'];
  lng: Scalars['Float'];
  propertyType: PropertyTypes;
  roomNumber?: InputMaybe<Scalars['Int']>;
};


export type QueryHomadataEvolutionArgs = {
  inseeCode: Scalars['Int'];
  type: Scalars['String'];
};


export type QueryHomeLoanArgs = {
  housePrice: Scalars['Float'];
  intakeAmount: Scalars['Float'];
  interestRate: Scalars['Float'];
  yearNumber: Scalars['Int'];
};


export type QueryIsAgoraSupportedArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryJobOfferArgs = {
  id: Scalars['String'];
};


export type QueryJobOffersArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryLocalPriceEvolutionArgs = {
  cityName: Scalars['String'];
  propertyType: LocalPriceEvolutionPropertyType;
  zipCode: Scalars['String'];
};


export type QueryLocateArgs = {
  cityName?: InputMaybe<Scalars['String']>;
  fallbackToParis?: InputMaybe<Scalars['Boolean']>;
};


export type QueryMakeAgoraCallArgs = {
  receiverId: Scalars['String'];
};


export type QueryMembersAdsArgs = {
  companyId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  statuses?: InputMaybe<Array<InputMaybe<AdStatuses>>>;
};


export type QueryMutualContactsArgs = {
  excludeFromResultsUserId?: InputMaybe<Scalars['String']>;
  match?: InputMaybe<Match>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};


export type QueryMyContactsArgs = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  match?: InputMaybe<Match>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statuses?: InputMaybe<Array<InputMaybe<ContactStatus>>>;
};


export type QueryMyFollowersArgs = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  match?: InputMaybe<Match>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryMyGalleryInvitationsArgs = {
  includeExpired?: InputMaybe<Scalars['Boolean']>;
  pageRequest?: InputMaybe<PageRequest>;
  sort?: InputMaybe<GalleryInvitationSort>;
  statuses?: InputMaybe<Array<GalleryInvitationStatus>>;
};


export type QueryMyPendingClosedGalleryInvitationArgs = {
  galleryId: Scalars['ID'];
};


export type QueryMyPendingContactsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryMyPendingInvitationsArgs = {
  side?: InputMaybe<PendingInvitationSide>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<PendingInvitationType>;
};


export type QueryMyReceivedInvitationsPendingArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryNewsFeedArgs = {
  skipAds?: InputMaybe<Scalars['Int']>;
  skipNewsPosts?: InputMaybe<Scalars['Int']>;
  skipPosts?: InputMaybe<Scalars['Int']>;
};


export type QueryNewsPostArgs = {
  newsPostId: Scalars['String'];
};


export type QueryNewsPostLikesArgs = {
  postId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryNotificationsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPagesJaunesProWithImagesUrlsArgs = {
  proId: Scalars['String'];
};


export type QueryParsedLinkArgs = {
  link: Scalars['String'];
};


export type QueryPendingOpenGalleryInvitationArgs = {
  galleryId: Scalars['ID'];
  invitationId: Scalars['ID'];
};


export type QueryPhoneContactsWithTotalArgs = {
  excludedContactStatuses?: InputMaybe<Array<ContactStatus>>;
  isSynchronized?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  match?: InputMaybe<Match>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyNonWoopenContacts?: InputMaybe<Scalars['Boolean']>;
  onlyWoopenContacts?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPostArgs = {
  postId: Scalars['String'];
};


export type QueryPostLikesArgs = {
  postId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPostsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryProjectsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryQuickSignupCompanyArgs = {
  quickSignupCompanyId: Scalars['String'];
};


export type QueryQuickSignupUserArgs = {
  isPro?: InputMaybe<Scalars['Boolean']>;
  quickSignupUserId: Scalars['String'];
};


export type QueryRatingArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  giverId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryRatingsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  includeCurrentUserRatings?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  withHiddenRatings?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRecommendationsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  match?: InputMaybe<Match>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  recommendingUserId?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statuses?: InputMaybe<Array<InputMaybe<RecommendationStatus>>>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryRecommendingUsersArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<UserType>;
};


export type QuerySavedSearchesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchArgs = {
  searchId: Scalars['String'];
};


export type QuerySearchAdsCountSinceLastViewedArgs = {
  searchId?: InputMaybe<Scalars['String']>;
};


export type QuerySearchAllUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchAllUsersWithTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchCitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchCommunityArgs = {
  activityId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['String']>;
  cityRadiusKm?: InputMaybe<Scalars['Int']>;
  communityEntityTypes?: InputMaybe<Array<InputMaybe<CommunityEntityType>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchCommunityByActivityWithImagesUrlsArgs = {
  activityId: Scalars['String'];
  cityId?: InputMaybe<Scalars['String']>;
  radiusKm?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  unlimitedRadius?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySearchCommunityByNameWithImagesUrlsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchCompaniesForInvitationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchCompaniesToJoinArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  search?: InputMaybe<Scalars['String']>;
  shouldIncludePJPros?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySearchForSiretArgs = {
  query: Scalars['String'];
};


export type QuerySearchMentionableUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  match?: InputMaybe<Match>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  postId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySearchProjectsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  search?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QuerySearchRecommendedRealEstateArgs = {
  lat: Scalars['Float'];
  limit?: InputMaybe<Scalars['Int']>;
  lng: Scalars['Float'];
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchUsersAndCompaniesWithTotalArgs = {
  excludeCurrentUser?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchUsersForInvitationsArgs = {
  filterOutUsersWithPendingInvitations?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySecondaryEmailArgs = {
  id: Scalars['String'];
};


export type QuerySecondaryEmailsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySharedFilesArgs = {
  channelUrl: Scalars['String'];
  ids: Array<InputMaybe<Scalars['String']>>;
};


export type QueryStoriesArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryStoriesGroupedByOwnersArgs = {
  lat?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryStoryArgs = {
  storyId: Scalars['String'];
};


export type QueryStoryReactionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  storyId: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryStoryReactsArgs = {
  storyId: Scalars['String'];
};


export type QuerySuggestedContactsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};


export type QuerySuggestedUsersAndCompaniesArgs = {
  includeCompanies?: InputMaybe<Scalars['Boolean']>;
  includeUsers?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryTalkWithArgs = {
  id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryUserAdsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  statuses?: InputMaybe<Array<InputMaybe<AdStatuses>>>;
  type?: InputMaybe<AdTypes>;
  userId: Scalars['String'];
};


export type QueryUserContactsV2Args = {
  excludeFromResultsUserId?: InputMaybe<Scalars['String']>;
  match?: InputMaybe<Match>;
  onlyMutual?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};


export type QueryUserFavoriteNewsPostsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryUserProfileArgs = {
  id: Scalars['String'];
};


export type QueryUsersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryWoopenParameterArgs = {
  key: Scalars['String'];
};

export type QuickSignupAd = {
  __typename?: 'QuickSignupAd';
  addressDescription: Scalars['String'];
  assets?: Maybe<Array<Maybe<Scalars['String']>>>;
  bedroomNumber?: Maybe<Scalars['Int']>;
  city: City;
  cityId: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  description: Scalars['String'];
  floorPosition?: Maybe<Scalars['Int']>;
  furnished?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  images?: Maybe<Scalars['String']>;
  isHiddingCompleteAddress: Scalars['Boolean'];
  isInaccurateAddress: Scalars['Boolean'];
  landArea?: Maybe<Scalars['Float']>;
  livingArea?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Int']>;
  propertyType: Scalars['String'];
  proxyLat: Scalars['Float'];
  proxyLng: Scalars['Float'];
  quickSignupUser: QuickSignupUser;
  quickSignupUserId: Scalars['String'];
  rent?: Maybe<Scalars['Int']>;
  roomNumber?: Maybe<Scalars['Int']>;
  surfaceArea?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  type: AdTypes;
  zipCode: Scalars['String'];
};

export type QuickSignupCompany = {
  __typename?: 'QuickSignupCompany';
  activity?: Maybe<Activity>;
  activityId?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  addressDescription?: Maybe<Scalars['String']>;
  addressLat?: Maybe<Scalars['Float']>;
  addressLng?: Maybe<Scalars['Float']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  foundationYear?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  initials?: Maybe<Scalars['String']>;
  isAgency?: Maybe<Scalars['Boolean']>;
  nafCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<PhoneNumber>;
  phoneNumber?: Maybe<Scalars['String']>;
  siretNumber?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type QuickSignupUser = {
  __typename?: 'QuickSignupUser';
  activity?: Maybe<Activity>;
  activityId?: Maybe<Scalars['String']>;
  agencyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  email: Scalars['String'];
  emailSent: Scalars['Boolean'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  quickSignupAd?: Maybe<QuickSignupAd>;
  quickSignupAdId?: Maybe<Scalars['String']>;
  quickSignupCompany?: Maybe<QuickSignupCompany>;
  quickSignupCompanyId?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type Rating = {
  __typename?: 'Rating';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  giver?: Maybe<User>;
  id: Scalars['ID'];
  isHidden: Scalars['Boolean'];
  owner: Owner;
  updatedAt: Scalars['Date'];
  value: Scalars['Int'];
};

export type RatingsResponse = {
  __typename?: 'RatingsResponse';
  allRatings?: Maybe<Array<Maybe<Rating>>>;
  averageRating?: Maybe<Scalars['Float']>;
  numberOfRatings?: Maybe<Scalars['Int']>;
};

export enum Reaction {
  Applause = 'applause',
  Celebrate = 'celebrate',
  Fire = 'fire',
  HeartEyes = 'heart_eyes',
  Laughing = 'laughing',
  Party = 'party',
  Sad = 'sad',
  StarEyes = 'star_eyes',
  Wow = 'wow'
}

export enum ReasonForLess {
  Default = 'default',
  Enough = 'enough',
  NotInteresting = 'notInteresting',
  Repetitive = 'repetitive'
}

export enum ReasonWhyAdArchived {
  ExpiredMandate = 'expired_mandate',
  SoldRented = 'sold_rented',
  SoldRentedByColleague = 'sold_rented_by_colleague',
  WithdrawnFromSaleRent = 'withdrawn_from_sale_rent'
}

export enum ReasonWhyAdDeleted {
  DeletedByUser = 'deleted_by_user'
}

export enum ReasonWhyDeleted {
  ExpiredMandate = 'expired_mandate',
  SoldRented = 'sold_rented',
  SoldRentedByColleague = 'sold_rented_by_colleague',
  WithdrawnFromSaleRent = 'withdrawn_from_sale_rent'
}

export type Recommendation = {
  __typename?: 'Recommendation';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  recommendedOwner: Owner;
  recommendingUser: User;
  status: RecommendationStatus;
};

export enum RecommendationStatus {
  Accepted = 'accepted',
  Pending = 'pending',
  Refused = 'refused'
}

export type RemoveGalleryCollaboratorResult = MutationResult & {
  __typename?: 'RemoveGalleryCollaboratorResult';
  problem?: Maybe<ProblemDetail>;
  success: Scalars['Boolean'];
};

export type RequestAdmin = {
  __typename?: 'RequestAdmin';
  company: Company;
  companyId: Scalars['String'];
  id: Scalars['ID'];
  status: RequestAdminStatus;
  user: User;
};

export enum RequestAdminStatus {
  Accepted = 'accepted',
  Pending = 'pending',
  Refused = 'refused'
}

export type RequestRecommendationResponse = {
  __typename?: 'RequestRecommendationResponse';
  id: Scalars['String'];
};

export type SiretEstablishment = {
  __typename?: 'SIRETEstablishment';
  activity: Scalars['String'];
  location: Scalars['String'];
  name: Scalars['String'];
  siret: Scalars['String'];
};

export enum SaleFeeType {
  Buyer = 'buyer',
  Seller = 'seller'
}

export type SavedSearchesResponseWithTotal = {
  __typename?: 'SavedSearchesResponseWithTotal';
  results: Array<Search>;
  total: Scalars['Int'];
};

export type Search = {
  __typename?: 'Search';
  /** @deprecated use place 20231103 */
  cities?: Maybe<Array<City>>;
  emailNotificationsEnabled: Scalars['Boolean'];
  id: Scalars['ID'];
  isFirstSavedAdSearch: Scalars['Boolean'];
  lastViewedAt: Scalars['Date'];
  name: Scalars['String'];
  parameters: Scalars['String'];
  placeGeometry?: Maybe<GeometryWithSource>;
};

export type SearchCommunityByActivityResponse = {
  __typename?: 'SearchCommunityByActivityResponse';
  results: Array<UserOrPagesJaunesSearchResult>;
  total: Scalars['Int'];
};

export type SearchProjectsResponseWithTotal = {
  __typename?: 'SearchProjectsResponseWithTotal';
  results: Array<Maybe<Project>>;
  total: Scalars['Int'];
};

export type SearchRecommendedRealEstateResponseWithTotal = {
  __typename?: 'SearchRecommendedRealEstateResponseWithTotal';
  results: Array<Maybe<User>>;
  total: Scalars['Int'];
};

export type SecondaryEmail = {
  __typename?: 'SecondaryEmail';
  email: Scalars['String'];
  id: Scalars['ID'];
  userId: Scalars['String'];
  verified: Scalars['Boolean'];
};

export type SendbirdResponse = {
  __typename?: 'SendbirdResponse';
  data?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type SendbirdToken = {
  __typename?: 'SendbirdToken';
  expireAt?: Maybe<Scalars['Date']>;
  token?: Maybe<Scalars['String']>;
};

export type SettingsResponse = {
  __typename?: 'SettingsResponse';
  pushNotificationAccepted: Scalars['Boolean'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Stats = {
  __typename?: 'Stats';
  contactCount: Scalars['Int'];
  favoriteCount: Scalars['Int'];
  id: Scalars['ID'];
  impressionCount: Scalars['Int'];
  viewCount: Scalars['Int'];
};

export type Story = {
  __typename?: 'Story';
  ad?: Maybe<Ad>;
  createdAt: Scalars['Date'];
  createdBy: User;
  createdById: Scalars['String'];
  floatingText?: Maybe<Scalars['String']>;
  hasDeletedAdLinked: Scalars['Boolean'];
  hasDeletedNewsPostLinked: Scalars['Boolean'];
  iHaveOwnership: Scalars['Boolean'];
  id: Scalars['ID'];
  medium: Medium;
  newsPost?: Maybe<NewsPost>;
  /** @deprecated use numberOfReactions 20221014 */
  numberOfReact: Scalars['Int'];
  numberOfReactions: Scalars['Int'];
  owner: Owner;
  ownerId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  usersWhoViewed?: Maybe<Array<User>>;
  viewed?: Maybe<Scalars['Boolean']>;
};

export type StoryReaction = {
  __typename?: 'StoryReaction';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  reaction?: Maybe<Scalars['String']>;
  sendbirdChannelId: Scalars['String'];
  sendbirdMessageId: Scalars['String'];
  story?: Maybe<Story>;
  storyId: Scalars['String'];
  user?: Maybe<User>;
  userId?: Maybe<User>;
};

export type StoryReactions = {
  __typename?: 'StoryReactions';
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  reaction?: Maybe<Reaction>;
  sendbirdChannelUrl?: Maybe<Scalars['String']>;
  sendbirdMessageId?: Maybe<Scalars['String']>;
  story?: Maybe<Story>;
  user?: Maybe<User>;
};

export enum SupportedLocales {
  En = 'en',
  Fr = 'fr'
}

export type Talk = {
  __typename?: 'Talk';
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  ownerId: Scalars['String'];
  recipientId: Scalars['String'];
};

export type TalkWithResponse = {
  __typename?: 'TalkWithResponse';
  id: Scalars['String'];
  talk: Talk;
  user: User;
};

export type User = {
  __typename?: 'User';
  activity?: Maybe<Activity>;
  affiliatedCompany?: Maybe<Company>;
  /** @deprecated Not sent in resolver 2022_08_30 */
  agencyAdNumber?: Maybe<Scalars['Int']>;
  averageRating: Scalars['Float'];
  awards?: Maybe<Scalars['String']>;
  /** @deprecated Not used 2022_08_30 */
  blockedUser?: Maybe<Array<Maybe<BlockedUser>>>;
  certificates?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  /** @deprecated Not sent in resolver 2022_08_30 */
  commentsLiked?: Maybe<Array<Maybe<Post>>>;
  companyToDisplay?: Maybe<Company>;
  contactCompany?: Maybe<Company>;
  /** @deprecated Use contactStatusV2 instead (added 20220801) */
  contactInvitation?: Maybe<Contact>;
  /** @deprecated Use contactStatusV2 instead (added 20220801) */
  contactStatus?: Maybe<Scalars['String']>;
  contactStatusV2?: Maybe<ContactStatus>;
  /** @deprecated Use userContactsV2 query 2022_08_30 */
  contacts?: Maybe<Array<Maybe<Contact>>>;
  coverImage?: Maybe<Medium>;
  createdAt: Scalars['Date'];
  crmSyncs?: Maybe<Array<Maybe<CrmSync>>>;
  customActivity?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedReason?: Maybe<DeletedReason>;
  description?: Maybe<Scalars['String']>;
  draftAd?: Maybe<Ad>;
  email: Scalars['String'];
  fallbackInititals?: Maybe<Scalars['String']>;
  fallbackNameEn?: Maybe<Scalars['String']>;
  fallbackNameFr?: Maybe<Scalars['String']>;
  featuredAds?: Maybe<Array<Ad>>;
  /** @deprecated Use User.galleries with appropriate parameters 2024_11_18 */
  featuredGalleries?: Maybe<Array<Maybe<Gallery>>>;
  featuredPosts?: Maybe<Array<Maybe<Post>>>;
  featuredRatings?: Maybe<Array<Maybe<Rating>>>;
  featuredRecommendationsReceived?: Maybe<Array<Recommendation>>;
  feeScaleFile?: Maybe<Scalars['String']>;
  feeScaleFileName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated Not used 2022_08_30 */
  followers?: Maybe<Array<Maybe<Follow>>>;
  /** @deprecated Not used 2022_08_30 */
  follows?: Maybe<Array<Maybe<Follow>>>;
  fullName?: Maybe<Scalars['String']>;
  galleries: GalleryPage;
  /** @deprecated Use hasOptedInToMarketingCommsAt instead (added 2024_01_18) */
  hasOptedInAt?: Maybe<Scalars['Date']>;
  hasOptedInToMarketingCommsAt?: Maybe<Scalars['Date']>;
  hasUnreadStory: Scalars['Boolean'];
  id: Scalars['ID'];
  image?: Maybe<Medium>;
  /** @deprecated Use contactStatusV2 instead (added 20220801) */
  inboundContacts?: Maybe<Array<Maybe<Contact>>>;
  initials?: Maybe<Scalars['String']>;
  invitations?: Maybe<Array<Maybe<Invitation>>>;
  /** @deprecated Use isAbleToJoinOrCreateEstateCompany instead (added 2022_08_30) */
  isAbleToJoinOrCreateAgency: Scalars['Boolean'];
  isAbleToJoinOrCreateCompany: Scalars['Boolean'];
  isAbleToJoinOrCreateCraftCompany: Scalars['Boolean'];
  isAbleToJoinOrCreateEstateCompany: Scalars['Boolean'];
  isAdminOfAffiliatedCompany?: Maybe<Scalars['Boolean']>;
  /** @deprecated Not sent in resolver 2022_08_30 */
  isAgency: Scalars['Boolean'];
  isBlocked: Scalars['Boolean'];
  isCrafts: Scalars['Boolean'];
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  isFollowed: Scalars['Boolean'];
  isMandatoryAgentTrade: Scalars['Boolean'];
  isProfessionnal: Scalars['Boolean'];
  isRealEstatesTrades: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  locale?: Maybe<SupportedLocales>;
  mutualContactsCount?: Maybe<Scalars['Int']>;
  newsCategories: Array<NewsCategory>;
  notificationSubscriptions: Array<NotificationSubscription>;
  notificationsLastSyncedAt: Scalars['Date'];
  numberOfAds: Scalars['Int'];
  numberOfContacts: Scalars['Int'];
  numberOfDisplayedRatings: Scalars['Int'];
  numberOfFollowers: Scalars['Int'];
  numberOfFollows: Scalars['Int'];
  numberOfGalleries: Scalars['Int'];
  numberOfNotifications: Scalars['Int'];
  numberOfPendingContacts: Scalars['Int'];
  numberOfPendingInvitations: Scalars['Int'];
  numberOfPhoneContacts: Scalars['Int'];
  numberOfPosts: Scalars['Int'];
  numberOfProjects: Scalars['Int'];
  numberOfRatings: Scalars['Int'];
  numberOfStories: Scalars['Int'];
  numberOfUnsyncedNotifications: Scalars['Int'];
  pendingInvitations?: Maybe<Array<Maybe<Invitation>>>;
  /** @deprecated Use phoneContactsWithTotal query 2022_08_30 */
  phoneContacts?: Maybe<Array<Maybe<PhoneContact>>>;
  phoneNumber?: Maybe<PhoneNumber>;
  /** @deprecated Not sent in resolver 2022_08_30 */
  postsLiked?: Maybe<Array<Maybe<Post>>>;
  privateCompany?: Maybe<Company>;
  ratingGivenByCurrentUser?: Maybe<Rating>;
  /** @deprecated Use ratings query 2022_08_30 */
  ratingsReceived?: Maybe<Array<Maybe<Rating>>>;
  recommendationFromMe?: Maybe<Recommendation>;
  recommendationToMe?: Maybe<Recommendation>;
  /** @deprecated Not used 2022_08_30 */
  recommendationsGiven?: Maybe<Array<Recommendation>>;
  /** @deprecated Not used 2022_08_30 */
  recommendationsGivenCount: Scalars['Int'];
  /** @deprecated Use recommendations query 2022_08_30 */
  recommendationsReceived?: Maybe<Array<Recommendation>>;
  recommendationsReceivedCount: Scalars['Int'];
  sendbirdUserId?: Maybe<Scalars['String']>;
  services?: Maybe<Scalars['String']>;
  showcase?: Maybe<Array<Maybe<Medium>>>;
  tipsViewed?: Maybe<Array<UserTipView>>;
  totalRelations: Scalars['Int'];
  updatedAt: Scalars['Date'];
};


export type UserGalleriesArgs = {
  includeInheritedFromMemberCompanies?: InputMaybe<Scalars['Boolean']>;
  pageRequest?: InputMaybe<PageRequest>;
  policy?: InputMaybe<GalleryAccessPolicy>;
  sort?: InputMaybe<GallerySort>;
};


export type UserNumberOfAdsArgs = {
  statuses?: InputMaybe<Array<AdStatuses>>;
  type?: InputMaybe<AdTypes>;
};


export type UserNumberOfPhoneContactsArgs = {
  excludedContactStatuses?: InputMaybe<Array<ContactStatus>>;
};


export type UserRecommendationsGivenCountArgs = {
  statuses?: InputMaybe<Array<InputMaybe<RecommendationStatus>>>;
};


export type UserRecommendationsReceivedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<InputMaybe<RecommendationStatus>>>;
};


export type UserRecommendationsReceivedCountArgs = {
  statuses?: InputMaybe<Array<InputMaybe<RecommendationStatus>>>;
};


export type UserShowcaseArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type UserGalleryInviteeValue = {
  __typename?: 'UserGalleryInviteeValue';
  user: User;
};

export type UserOrCompany = Company | User;

export type UserOrPagesJaunesSearchResult = PagesJaunesProSearchResult | User;

export type UserTipView = {
  __typename?: 'UserTipView';
  tipIdentifier: Scalars['String'];
};

export enum UserType {
  All = 'all',
  NonPro = 'nonPro',
  Pro = 'pro'
}

export type UsersOrCompaniesResponseWithTotal = {
  __typename?: 'UsersOrCompaniesResponseWithTotal';
  results?: Maybe<Array<UserOrCompany>>;
  total?: Maybe<Scalars['Int']>;
};

export type UsersResponseWithTotal = {
  __typename?: 'UsersResponseWithTotal';
  results?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['Int']>;
};

export enum ValidateVerificationCodeResponse {
  CodeExpired = 'code_expired',
  Success = 'success',
  TooManyAttempts = 'too_many_attempts',
  WrongClaimStatus = 'wrong_claim_status',
  WrongCode = 'wrong_code'
}

export type VersionSupported = {
  __typename?: 'VersionSupported';
  createdAt: Scalars['Date'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  version: Scalars['String'];
};

export enum WantToSeeMoreOrLess {
  Default = 'default',
  Less = 'less',
  More = 'more'
}

export type WoopenParameter = {
  __typename?: 'WoopenParameter';
  id: Scalars['ID'];
  key: Scalars['String'];
  value: Scalars['String'];
};

export enum YesNoNaOptions {
  Na = 'na',
  No = 'no',
  Yes = 'yes'
}

export enum YesNoOptions {
  No = 'no',
  Yes = 'yes'
}

export type UpdateRatingResponse = {
  __typename?: 'updateRatingResponse';
  averageRating: Scalars['Float'];
  id: Scalars['String'];
  numberOfRatings: Scalars['Int'];
};

export type AcceptAdminRequestMutationVariables = Exact<{
  adminRequestId: Scalars['String'];
}>;


export type AcceptAdminRequestMutation = { __typename?: 'Mutation', updateAdminRequest: boolean };

export type AcceptGalleryInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID'];
}>;


export type AcceptGalleryInvitationMutation = { __typename?: 'Mutation', acceptGalleryInvitation: { __typename?: 'AcceptGalleryInvitationResult', success: boolean } };

export type AddAdminMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type AddAdminMutation = { __typename?: 'Mutation', addAdmin: boolean };

export type AddBlockedUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type AddBlockedUserMutation = { __typename?: 'Mutation', addBlockedUser: { __typename?: 'BlockedUser', id: string } };

export type RemoveBlockedUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type RemoveBlockedUserMutation = { __typename?: 'Mutation', removeBlockedUser: boolean };

export type AddContactMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type AddContactMutation = { __typename?: 'Mutation', addContactToUser: { __typename?: 'Contact', id: string } };

export type RemoveContactMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type RemoveContactMutation = { __typename?: 'Mutation', removeContact: boolean };

export type AddContentEventMutationVariables = Exact<{
  newsPostId?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['String']>;
  adId?: InputMaybe<Scalars['String']>;
  storyId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  eventType: Scalars['String'];
}>;


export type AddContentEventMutation = { __typename?: 'Mutation', addContentEvent: boolean };

export type AddContentToGalleryMutationVariables = Exact<{
  galleryId: Scalars['String'];
  adId?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['String']>;
  newsPostId?: InputMaybe<Scalars['String']>;
}>;


export type AddContentToGalleryMutation = { __typename?: 'Mutation', addContentToGallery: { __typename?: 'Gallery', id: string, name: string, numberOfContents: number } };

export type AddCrmSyncMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  crmSourceId: Scalars['String'];
  requestedCrmName?: InputMaybe<Scalars['String']>;
}>;


export type AddCrmSyncMutation = { __typename?: 'Mutation', addCrmSync?: { __typename?: 'CrmSync', crmUserId?: string | null, crmSource?: { __typename?: 'CrmSource', name: string } | null, owner?: { __typename?: 'Owner', user?: { __typename?: 'User', fullName?: string | null } | null, company?: { __typename?: 'Company', name: string } | null } | null } | null };

export type AddDirectorMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type AddDirectorMutation = { __typename?: 'Mutation', addDirector: boolean };

export type AddEventMutationVariables = Exact<{
  quickSignupUserId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  eventType: Scalars['String'];
  platform?: InputMaybe<Scalars['String']>;
}>;


export type AddEventMutation = { __typename?: 'Mutation', addEvent: boolean };

export type AddEventsMutationVariables = Exact<{
  events: Array<EventData> | EventData;
}>;


export type AddEventsMutation = { __typename?: 'Mutation', addEvents: boolean };

export type AssignAdsToUserMutationVariables = Exact<{
  userId: Scalars['String'];
  adIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type AssignAdsToUserMutation = { __typename?: 'Mutation', assignAdsToUser: boolean };

export type AssistancePagesJaunesMutationVariables = Exact<{
  pagesJaunesId: Scalars['String'];
  phone: Scalars['String'];
  email: Scalars['String'];
  description: Scalars['String'];
}>;


export type AssistancePagesJaunesMutation = { __typename?: 'Mutation', assistancePagesJaunes: boolean };

export type CreateAdMutationVariables = Exact<{
  type: AdTypes;
  propertyType: PropertyTypes;
  propertyState?: InputMaybe<PropertyState>;
  commonAreasState?: InputMaybe<CommonAreasState>;
  propertyPurposeEstimation?: InputMaybe<PropertyPurposeEstimation>;
  propertyResidenceType?: InputMaybe<PropertyResidenceType>;
  userIsOwner?: InputMaybe<Scalars['Boolean']>;
  contactConsent?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<AdStatuses>;
  isHiddingCompleteAddress: Scalars['Boolean'];
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  constructionYear?: InputMaybe<Scalars['Int']>;
  floorPosition?: InputMaybe<Scalars['Int']>;
  livingArea?: InputMaybe<Scalars['Float']>;
  landArea?: InputMaybe<Scalars['Float']>;
  media: Array<InputMaybe<Scalars['Upload']>> | InputMaybe<Scalars['Upload']>;
  tmpUrls?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  bedroomNumber?: InputMaybe<Scalars['Int']>;
  roomNumber?: InputMaybe<Scalars['Int']>;
  floorNumber?: InputMaybe<Scalars['Int']>;
  rooms?: InputMaybe<Scalars['String']>;
  heatType?: InputMaybe<HeatTypes>;
  heatInformations?: InputMaybe<Scalars['String']>;
  consumption?: InputMaybe<Scalars['String']>;
  emissions?: InputMaybe<Scalars['String']>;
  interOffice: Scalars['Boolean'];
  commissionRate?: InputMaybe<Scalars['Float']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  price?: InputMaybe<Scalars['Int']>;
  homadataEvaluation?: InputMaybe<Scalars['String']>;
  furnished?: InputMaybe<Scalars['Boolean']>;
  inclusions?: InputMaybe<Scalars['String']>;
  rent?: InputMaybe<Scalars['Int']>;
  monthlyCharges?: InputMaybe<Scalars['Float']>;
  inventory?: InputMaybe<Scalars['Float']>;
  fees?: InputMaybe<Scalars['Int']>;
  guarantees?: InputMaybe<Scalars['String']>;
  availableDate?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  servicedLand?: InputMaybe<YesNoNaOptions>;
  constructibleLand?: InputMaybe<YesNoNaOptions>;
  newProperty?: InputMaybe<Scalars['Boolean']>;
  surfaceArea?: InputMaybe<Scalars['Float']>;
  numberOfVehicles?: InputMaybe<Scalars['Int']>;
  dimensionLength?: InputMaybe<Scalars['Float']>;
  dimensionWidth?: InputMaybe<Scalars['Float']>;
  dimensionHeight?: InputMaybe<Scalars['Float']>;
  coOwnership?: InputMaybe<Scalars['Boolean']>;
  coOwnershipNumberOfLots?: InputMaybe<Scalars['Int']>;
  coOwnershipOngoing?: InputMaybe<YesNoOptions>;
  coOwnershipYearlyCharge?: InputMaybe<Scalars['Float']>;
  saleFeeType?: InputMaybe<SaleFeeType>;
  showSaleFeeBuyerPrice?: InputMaybe<Scalars['Boolean']>;
  saleFeeBuyerRate?: InputMaybe<Scalars['Float']>;
  priceWithoutSaleFee?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<AddressParam>;
}>;


export type CreateAdMutation = { __typename?: 'Mutation', createAd: { __typename?: 'Ad', id: string } };

export type CreateChatTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateChatTokenMutation = { __typename?: 'Mutation', createChatToken: { __typename?: 'SendbirdToken', token?: string | null, expireAt?: any | null } };

export type CreateCommentMutationVariables = Exact<{
  postId: Scalars['String'];
  content: Scalars['String'];
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'Comment', id: string } };

export type CreateCompanyMutationVariables = Exact<{
  label?: InputMaybe<CompanyLabel>;
  name: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<PhoneParam>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  feeScaleFile?: InputMaybe<Scalars['Upload']>;
  feeScaleFileName?: InputMaybe<Scalars['String']>;
  imageHybridMedium?: InputMaybe<HybridMedium>;
  coverImage?: InputMaybe<Scalars['Upload']>;
  address?: InputMaybe<AddressParam>;
  isPrivate: Scalars['Boolean'];
  siretNumber?: InputMaybe<Scalars['String']>;
  mainActivityId?: InputMaybe<Scalars['String']>;
  mainCategoryId?: InputMaybe<Scalars['String']>;
  customActivity?: InputMaybe<Scalars['String']>;
  pagesJaunesId?: InputMaybe<Scalars['String']>;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'Company', id: string } };

export type CreateGalleryMutationVariables = Exact<{
  name: Scalars['String'];
  isSecret: Scalars['Boolean'];
  companyId?: InputMaybe<Scalars['String']>;
  invitations?: InputMaybe<Array<ClosedGalleryInvitationInput> | ClosedGalleryInvitationInput>;
}>;


export type CreateGalleryMutation = { __typename?: 'Mutation', createGallery: { __typename?: 'Gallery', id: string, name: string } };

export type CreateGalleryInvitationMutationVariables = Exact<{
  galleryId: Scalars['ID'];
  type: GalleryInvitationType;
  role: GalleryRole;
  invitee?: InputMaybe<GalleryInviteeInput>;
}>;


export type CreateGalleryInvitationMutation = { __typename?: 'Mutation', createGalleryInvitation: { __typename?: 'CreateGalleryInvitationResult', success: boolean, invitation?: { __typename?: 'GalleryInvitation', id: string } | null } };

export type CreateGroupInvitationMutationVariables = Exact<{
  groupId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type CreateGroupInvitationMutation = { __typename?: 'Mutation', createGroupInvitation: { __typename?: 'GroupInvitation', id: string } };

export type CreateInvitationMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type CreateInvitationMutation = { __typename?: 'Mutation', createInvitation: { __typename?: 'Invitation', id: string } };

export type CreateJobOfferMutationVariables = Exact<{
  companyId: Scalars['String'];
  companyName: Scalars['String'];
  jobTypeId: Scalars['String'];
  cityId?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
}>;


export type CreateJobOfferMutation = { __typename?: 'Mutation', createJobOffer: { __typename?: 'JobOffer', id: string } };

export type CreateJobOfferApplicationMutationVariables = Exact<{
  jobOfferId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  linkedInProfileLink?: InputMaybe<Scalars['String']>;
  coverLetter: Scalars['String'];
  resumeFileName: Scalars['String'];
  resumeFile: Scalars['Upload'];
}>;


export type CreateJobOfferApplicationMutation = { __typename?: 'Mutation', createJobOfferApplication: { __typename?: 'JobOfferApplication', id: string } };

export type CreateNewsFeedbackMutationVariables = Exact<{
  wantToSeeMoreOrLess: WantToSeeMoreOrLess;
  reasonForLess?: InputMaybe<ReasonForLess>;
  newsPostId: Scalars['String'];
}>;


export type CreateNewsFeedbackMutation = { __typename?: 'Mutation', createNewsFeedback: { __typename?: 'NewsFeedback', id: string, wantToSeeMoreOrLess: WantToSeeMoreOrLess } };

export type CreatePostMutationVariables = Exact<{
  media: Array<InputMaybe<Scalars['Upload']>> | InputMaybe<Scalars['Upload']>;
  message: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  newsPostId?: InputMaybe<Scalars['String']>;
  adId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
}>;


export type CreatePostMutation = { __typename?: 'Mutation', createPost: { __typename?: 'Post', id: string } };

export type CreateProjectMutationVariables = Exact<{
  name: Scalars['String'];
  cityId?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  media: Array<InputMaybe<Scalars['Upload']>> | InputMaybe<Scalars['Upload']>;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string } };

export type CreateQuickSignupAdsMutationVariables = Exact<{
  quickSignupUserId: Scalars['String'];
  userId: Scalars['String'];
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type CreateQuickSignupAdsMutation = { __typename?: 'Mutation', createQuickSignupAds: boolean };

export type CreateRatingMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  value: Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type CreateRatingMutation = { __typename?: 'Mutation', createRating: { __typename?: 'CreateRatingResponse', id: string } };

export type CreateRecommendationMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type CreateRecommendationMutation = { __typename?: 'Mutation', createRecommendation: { __typename?: 'CreateRecommendationResponse', id: string } };

export type CreateSecondaryEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type CreateSecondaryEmailMutation = { __typename?: 'Mutation', createSecondaryEmail?: { __typename?: 'SecondaryEmail', id: string } | null };

export type CreateStoryMutationVariables = Exact<{
  medium: Scalars['Upload'];
  floatingText?: InputMaybe<Scalars['String']>;
  adId?: InputMaybe<Scalars['String']>;
  newsPostId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type CreateStoryMutation = { __typename?: 'Mutation', createStory: { __typename?: 'Story', id: string } };

export type DeclineGalleryInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID'];
}>;


export type DeclineGalleryInvitationMutation = { __typename?: 'Mutation', declineGalleryInvitation: { __typename?: 'DeclineGalleryInvitationResult', success: boolean } };

export type DeleteCommentMutationVariables = Exact<{
  commentId: Scalars['String'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: boolean };

export type DeleteCompanyMutationVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type DeleteCompanyMutation = { __typename?: 'Mutation', deleteCompany: boolean };

export type DeleteGalleryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteGalleryMutation = { __typename?: 'Mutation', deleteGallery: boolean };

export type DeleteGroupInvitationMutationVariables = Exact<{
  groupId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteGroupInvitationMutation = { __typename?: 'Mutation', deleteGroupInvitation: boolean };

export type DeleteInvitationMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteInvitationMutation = { __typename?: 'Mutation', deleteInvitation: boolean };

export type DeleteJobOfferMutationVariables = Exact<{
  jobOfferId: Scalars['String'];
}>;


export type DeleteJobOfferMutation = { __typename?: 'Mutation', softDeleteJobOffer: boolean };

export type DeletePostMutationVariables = Exact<{
  postId: Scalars['String'];
}>;


export type DeletePostMutation = { __typename?: 'Mutation', deletePost: boolean };

export type DeleteProjectMutationVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: boolean };

export type DeleteSavedSearchMutationVariables = Exact<{
  searchId: Scalars['String'];
}>;


export type DeleteSavedSearchMutation = { __typename?: 'Mutation', deleteSavedSearch: boolean };

export type DeleteSecondaryEmailMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSecondaryEmailMutation = { __typename?: 'Mutation', deleteSecondaryEmail: boolean };

export type DeleteStoryMutationVariables = Exact<{
  storyId: Scalars['String'];
}>;


export type DeleteStoryMutation = { __typename?: 'Mutation', deleteStory: boolean };

export type DislikeCommentMutationVariables = Exact<{
  commentId: Scalars['String'];
}>;


export type DislikeCommentMutation = { __typename?: 'Mutation', dislikeComment: boolean };

export type DislikeNewsPostMutationVariables = Exact<{
  newsPostId: Scalars['String'];
}>;


export type DislikeNewsPostMutation = { __typename?: 'Mutation', dislikeNewsPost: boolean };

export type DislikePostMutationVariables = Exact<{
  postId: Scalars['String'];
}>;


export type DislikePostMutation = { __typename?: 'Mutation', dislikePost: boolean };

export type FollowMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type FollowMutation = { __typename?: 'Mutation', follow: number };

export type UnFollowMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type UnFollowMutation = { __typename?: 'Mutation', unfollow: number };

export type HideRatingMutationVariables = Exact<{
  id: Scalars['String'];
  isHidden: Scalars['Boolean'];
}>;


export type HideRatingMutation = { __typename?: 'Mutation', hideRating: boolean };

export type IgnoreAdminRequestMutationVariables = Exact<{
  adminRequestId: Scalars['String'];
}>;


export type IgnoreAdminRequestMutation = { __typename?: 'Mutation', updateAdminRequest: boolean };

export type IncrementStatsContactCountMutationVariables = Exact<{
  statsId: Scalars['String'];
}>;


export type IncrementStatsContactCountMutation = { __typename?: 'Mutation', incrementStatsContactCount: boolean };

export type LikeCommentMutationVariables = Exact<{
  commentId: Scalars['String'];
}>;


export type LikeCommentMutation = { __typename?: 'Mutation', likeComment: boolean };

export type LikeNewsPostMutationVariables = Exact<{
  newsPostId: Scalars['String'];
}>;


export type LikeNewsPostMutation = { __typename?: 'Mutation', likeNewsPost: boolean };

export type LikePostMutationVariables = Exact<{
  postId: Scalars['String'];
}>;


export type LikePostMutation = { __typename?: 'Mutation', likePost: boolean };

export type PatchViewerNotificationSubscriptionsMutationVariables = Exact<{
  subscriptions: Array<PatchNotificationSubscriptionInput> | PatchNotificationSubscriptionInput;
}>;


export type PatchViewerNotificationSubscriptionsMutation = { __typename?: 'Mutation', patchViewerNotificationSubscriptions: Array<{ __typename?: 'NotificationSubscription', subject: NotificationSubscriptionSubject, status: NotificationSubscriptionStatus }> };

export type RecoverUserMutationVariables = Exact<{ [key: string]: never; }>;


export type RecoverUserMutation = { __typename?: 'Mutation', recoverUser: boolean };

export type RefreshBadgeCountMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshBadgeCountMutation = { __typename?: 'Mutation', refreshBadgeCount: boolean };

export type RequestHomadataEvaluationMutationVariables = Exact<{
  adId: Scalars['ID'];
}>;


export type RequestHomadataEvaluationMutation = { __typename?: 'Mutation', requestHomadataEvaluation?: { __typename?: 'HomadataEvaluation', id: string } | null };

export type RemoveAdminMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type RemoveAdminMutation = { __typename?: 'Mutation', removeAdmin: boolean };

export type RemoveCompanyMutationVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type RemoveCompanyMutation = { __typename?: 'Mutation', removeCompany: boolean };

export type RemoveContentFromGalleriesMutationVariables = Exact<{
  isCompanyGallery?: InputMaybe<Scalars['Boolean']>;
  adId?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['String']>;
  newsPostId?: InputMaybe<Scalars['String']>;
}>;


export type RemoveContentFromGalleriesMutation = { __typename?: 'Mutation', removeContentFromGalleries: Array<{ __typename?: 'Gallery', id: string, numberOfContents: number }> };

export type RemoveCrmSyncMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
}>;


export type RemoveCrmSyncMutation = { __typename?: 'Mutation', removeCrmSync: boolean };

export type RemoveDirectorMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type RemoveDirectorMutation = { __typename?: 'Mutation', removeDirector: boolean };

export type RemoveGalleryCollaboratorMutationVariables = Exact<{
  galleryId: Scalars['ID'];
  collaborator: GalleryCollaboratorRefInput;
}>;


export type RemoveGalleryCollaboratorMutation = { __typename?: 'Mutation', removeGalleryCollaborator: { __typename?: 'RemoveGalleryCollaboratorResult', success: boolean } };

export type CancelGalleryInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID'];
}>;


export type CancelGalleryInvitationMutation = { __typename?: 'Mutation', cancelGalleryInvitation: { __typename?: 'CancelGalleryInvitationResult', success: boolean } };

export type RemoveGroupMembershipMutationVariables = Exact<{
  groupId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type RemoveGroupMembershipMutation = { __typename?: 'Mutation', removeGroupMembership: boolean };

export type RemoveMemberMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type RemoveMemberMutation = { __typename?: 'Mutation', removeMember: boolean };

export type RemoveRecommendationMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type RemoveRecommendationMutation = { __typename?: 'Mutation', removeRecommendation: boolean };

export type ReportAdMutationVariables = Exact<{
  adId: Scalars['String'];
  reason: Scalars['String'];
}>;


export type ReportAdMutation = { __typename?: 'Mutation', reportAd: boolean };

export type ReportCommentMutationVariables = Exact<{
  commentId: Scalars['String'];
  reason: Scalars['String'];
}>;


export type ReportCommentMutation = { __typename?: 'Mutation', reportComment: boolean };

export type ReportCompanyMutationVariables = Exact<{
  reason: Scalars['String'];
  companyId: Scalars['String'];
}>;


export type ReportCompanyMutation = { __typename?: 'Mutation', reportCompany: boolean };

export type ReportConversationMutationVariables = Exact<{
  channelUrl: Scalars['String'];
  reason: Scalars['String'];
}>;


export type ReportConversationMutation = { __typename?: 'Mutation', reportConversation: boolean };

export type ReportNewsPostMutationVariables = Exact<{
  newsPostId: Scalars['String'];
  reason: Scalars['String'];
}>;


export type ReportNewsPostMutation = { __typename?: 'Mutation', reportNewsPost: boolean };

export type ReportPostMutationVariables = Exact<{
  postId: Scalars['String'];
  reason: Scalars['String'];
}>;


export type ReportPostMutation = { __typename?: 'Mutation', reportPost: boolean };

export type ReportStoryMutationVariables = Exact<{
  storyId: Scalars['String'];
  reason: Scalars['String'];
}>;


export type ReportStoryMutation = { __typename?: 'Mutation', reportStory: boolean };

export type ReportUserMutationVariables = Exact<{
  userId: Scalars['String'];
  reason: Scalars['String'];
}>;


export type ReportUserMutation = { __typename?: 'Mutation', reportUser: boolean };

export type RequestAdminAccessMutationVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type RequestAdminAccessMutation = { __typename?: 'Mutation', requestAdminAccess: { __typename?: 'RequestAdmin', id: string } };

export type RequestAgentEmailMutationVariables = Exact<{
  estimationId: Scalars['String'];
}>;


export type RequestAgentEmailMutation = { __typename?: 'Mutation', requestAgentEmail: boolean };

export type RequestRecommendationMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type RequestRecommendationMutation = { __typename?: 'Mutation', requestRecommendation: { __typename?: 'RequestRecommendationResponse', id: string } };

export type RequestVerificationCodeMutationVariables = Exact<{
  proId: Scalars['String'];
}>;


export type RequestVerificationCodeMutation = { __typename?: 'Mutation', requestVerificationCode: boolean };

export type SaveNewsCategoriesMutationVariables = Exact<{
  categoryIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type SaveNewsCategoriesMutation = { __typename?: 'Mutation', saveNewsCategories: boolean };

export type SaveSearchByPlaceMutationVariables = Exact<{
  name: Scalars['String'];
  parameters: Scalars['String'];
  place: GeometryInput;
  placeSource?: InputMaybe<GeometrySource>;
  emailNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type SaveSearchByPlaceMutation = { __typename?: 'Mutation', saveSearchByPlace: { __typename?: 'Search', id: string, isFirstSavedAdSearch: boolean } };

export type SendChatNotificationMessageMutationVariables = Exact<{
  notification: ChatNotificationData;
  channelUrl: Scalars['String'];
  requestId?: InputMaybe<Scalars['String']>;
}>;


export type SendChatNotificationMessageMutation = { __typename?: 'Mutation', sendChatNotificationMessage?: { __typename?: 'SendbirdResponse', id: string } | null };

export type SendMailVerificationMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
}>;


export type SendMailVerificationMutation = { __typename?: 'Mutation', sendMailVerification?: boolean | null };

export type SendMessageMutationVariables = Exact<{
  message?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  channelUrl: Scalars['String'];
  requestId?: InputMaybe<Scalars['String']>;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage?: { __typename?: 'SendbirdResponse', id: string } | null };

export type SendSharedContentMessageMutationVariables = Exact<{
  message?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<MessageData>;
  channelUrl: Scalars['String'];
  requestId?: InputMaybe<Scalars['String']>;
}>;


export type SendSharedContentMessageMutation = { __typename?: 'Mutation', sendSharedContentMessage?: { __typename?: 'SendbirdResponse', id: string } | null };

export type SendSharedFileMessageMutationVariables = Exact<{
  message?: InputMaybe<Scalars['String']>;
  files: Array<InputMaybe<Scalars['Upload']>> | InputMaybe<Scalars['Upload']>;
  channelUrl: Scalars['String'];
  requestId?: InputMaybe<Scalars['String']>;
}>;


export type SendSharedFileMessageMutation = { __typename?: 'Mutation', sendSharedFileMessage?: { __typename?: 'SendbirdResponse', id: string, data?: string | null } | null };

export type SetPrimaryEmailMutationVariables = Exact<{
  secondaryEmail: Scalars['String'];
}>;


export type SetPrimaryEmailMutation = { __typename?: 'Mutation', setPrimaryEmail: boolean };

export type SignUpMutationVariables = Exact<{
  hasOptedInToMarketingCommsAt?: InputMaybe<Scalars['Date']>;
  hasOptedInAt?: InputMaybe<Scalars['Date']>;
  quickSignupUserId?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PlatformSource>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: { __typename?: 'User', id: string, email: string } };

export type SignUpStepTwoMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  cityId?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  imageHybridMedium?: InputMaybe<HybridMedium>;
  description?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
}>;


export type SignUpStepTwoMutation = { __typename?: 'Mutation', updatePersonalInfo: { __typename?: 'User', id: string } };

export type SignUpProMutationVariables = Exact<{
  activityId: Scalars['String'];
  customActivity?: InputMaybe<Scalars['String']>;
  hasOptedInToMarketingCommsAt?: InputMaybe<Scalars['Date']>;
  hasOptedInAt?: InputMaybe<Scalars['Date']>;
  quickSignupUserId?: InputMaybe<Scalars['String']>;
  isTheRealEstateOther?: InputMaybe<Scalars['Boolean']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PlatformSource>;
}>;


export type SignUpProMutation = { __typename?: 'Mutation', signUpPro: { __typename?: 'User', id: string, email: string } };

export type SoftDeleteAdMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftDeleteAdMutation = { __typename?: 'Mutation', softDeleteAd: boolean };

export type SoftDeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type SoftDeleteUserMutation = { __typename?: 'Mutation', softDeleteUser: boolean };

export type IncrementStatsViewCountMutationVariables = Exact<{
  adId?: InputMaybe<Scalars['String']>;
  newsPostId?: InputMaybe<Scalars['String']>;
}>;


export type IncrementStatsViewCountMutation = { __typename?: 'Mutation', incrementStatsViewCount: boolean };

export type SubmitInterestMutationVariables = Exact<{
  interest: Scalars['String'];
  userId: Scalars['String'];
}>;


export type SubmitInterestMutation = { __typename?: 'Mutation', submitInterest: boolean };

export type SyncNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncNotificationsMutation = { __typename?: 'Mutation', syncNotifications: boolean };

export type UnsubscribeQuickSignupUserMutationVariables = Exact<{
  quickSignupUserId: Scalars['String'];
}>;


export type UnsubscribeQuickSignupUserMutation = { __typename?: 'Mutation', unsubscribeQuickSignupUser: boolean };

export type UpdateAdMutationVariables = Exact<{
  id: Scalars['String'];
  type: AdTypes;
  propertyType: PropertyTypes;
  isHiddingCompleteAddress: Scalars['Boolean'];
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  propertyState?: InputMaybe<PropertyState>;
  commonAreasState?: InputMaybe<CommonAreasState>;
  propertyPurposeEstimation?: InputMaybe<PropertyPurposeEstimation>;
  propertyResidenceType?: InputMaybe<PropertyResidenceType>;
  userIsOwner?: InputMaybe<Scalars['Boolean']>;
  contactConsent?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<AdStatuses>;
  constructionYear?: InputMaybe<Scalars['Int']>;
  floorPosition?: InputMaybe<Scalars['Int']>;
  livingArea?: InputMaybe<Scalars['Float']>;
  landArea?: InputMaybe<Scalars['Float']>;
  media: Array<InputMaybe<HybridMedium>> | InputMaybe<HybridMedium>;
  bedroomNumber?: InputMaybe<Scalars['Int']>;
  roomNumber?: InputMaybe<Scalars['Int']>;
  floorNumber?: InputMaybe<Scalars['Int']>;
  rooms?: InputMaybe<Scalars['String']>;
  heatType?: InputMaybe<HeatTypes>;
  heatInformations?: InputMaybe<Scalars['String']>;
  consumption?: InputMaybe<Scalars['String']>;
  emissions?: InputMaybe<Scalars['String']>;
  interOffice: Scalars['Boolean'];
  commissionRate?: InputMaybe<Scalars['Float']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  price?: InputMaybe<Scalars['Int']>;
  homadataEvaluation?: InputMaybe<Scalars['String']>;
  furnished?: InputMaybe<Scalars['Boolean']>;
  inclusions?: InputMaybe<Scalars['String']>;
  rent?: InputMaybe<Scalars['Int']>;
  fees?: InputMaybe<Scalars['Int']>;
  monthlyCharges?: InputMaybe<Scalars['Float']>;
  inventory?: InputMaybe<Scalars['Float']>;
  guarantees?: InputMaybe<Scalars['String']>;
  availableDate?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  servicedLand?: InputMaybe<YesNoNaOptions>;
  constructibleLand?: InputMaybe<YesNoNaOptions>;
  newProperty?: InputMaybe<Scalars['Boolean']>;
  surfaceArea?: InputMaybe<Scalars['Float']>;
  numberOfVehicles?: InputMaybe<Scalars['Int']>;
  dimensionLength?: InputMaybe<Scalars['Float']>;
  dimensionWidth?: InputMaybe<Scalars['Float']>;
  dimensionHeight?: InputMaybe<Scalars['Float']>;
  coOwnership?: InputMaybe<Scalars['Boolean']>;
  coOwnershipNumberOfLots?: InputMaybe<Scalars['Int']>;
  coOwnershipOngoing?: InputMaybe<YesNoOptions>;
  coOwnershipYearlyCharge?: InputMaybe<Scalars['Float']>;
  saleFeeType?: InputMaybe<SaleFeeType>;
  saleFeeBuyerRate?: InputMaybe<Scalars['Float']>;
  showSaleFeeBuyerPrice?: InputMaybe<Scalars['Boolean']>;
  priceWithoutSaleFee?: InputMaybe<Scalars['Int']>;
  isInaccurateAddress: Scalars['Boolean'];
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<AddressParam>;
}>;


export type UpdateAdMutation = { __typename?: 'Mutation', updateAd: { __typename?: 'Ad', id: string } };

export type UpdateAdStatusMutationVariables = Exact<{
  id: Scalars['String'];
  status: AdStatuses;
  priceSold?: InputMaybe<Scalars['Int']>;
  reasonWhyAdArchived?: InputMaybe<ReasonWhyAdArchived>;
}>;


export type UpdateAdStatusMutation = { __typename?: 'Mutation', updateAdStatus: boolean };

export type UpdateChannelNameMutationVariables = Exact<{
  channelUrl: Scalars['String'];
  name: Scalars['String'];
}>;


export type UpdateChannelNameMutation = { __typename?: 'Mutation', updateChannelName: string };

export type UpdateChannelToSuperChannelMutationVariables = Exact<{
  channelUrl: Scalars['String'];
}>;


export type UpdateChannelToSuperChannelMutation = { __typename?: 'Mutation', updateChannelToSuperChannel: boolean };

export type UpdateCommentMutationVariables = Exact<{
  commentId: Scalars['String'];
  content: Scalars['String'];
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'Comment', id: string } };

export type UpdateCompanyShowcaseMutationVariables = Exact<{
  companyId: Scalars['String'];
  media: Array<InputMaybe<HybridMedium>> | InputMaybe<HybridMedium>;
}>;


export type UpdateCompanyShowcaseMutation = { __typename?: 'Mutation', updateCompanyShowcase: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> };

export type UpdateCompanyWithNullableAddressMutationVariables = Exact<{
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<PhoneParam>;
  feeScaleFileHybridMedium?: InputMaybe<HybridMedium>;
  feeScaleFileName?: InputMaybe<Scalars['String']>;
  siretNumber?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<AddressParam>;
  showcase?: InputMaybe<Array<InputMaybe<HybridMedium>> | InputMaybe<HybridMedium>>;
  imageHybridMedium?: InputMaybe<HybridMedium>;
  videoHybridMedium?: InputMaybe<HybridMedium>;
  coverImageHybridMedium?: InputMaybe<HybridMedium>;
  contactUserId?: InputMaybe<Scalars['String']>;
  mission?: InputMaybe<Scalars['String']>;
  contactUrl?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<CompanyLabel>;
  mainActivityId?: InputMaybe<Scalars['String']>;
  mainCategoryId?: InputMaybe<Scalars['String']>;
  customActivity?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCompanyWithNullableAddressMutation = { __typename?: 'Mutation', updateCompanyWithNullableAddress: { __typename?: 'Company', id: string } };

export type UpdateContactMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  contactedUserId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact: boolean };

export type UpdateGalleryMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
  isSecret: Scalars['Boolean'];
}>;


export type UpdateGalleryMutation = { __typename?: 'Mutation', updateGallery: { __typename?: 'Gallery', id: string, name: string, isSecret: boolean } };

export type UpdateGroupInvitationMutationVariables = Exact<{
  groupId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<InvitationStatus>;
}>;


export type UpdateGroupInvitationMutation = { __typename?: 'Mutation', updateGroupInvitation: boolean };

export type UpdateInvitationMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<InvitationStatus>;
}>;


export type UpdateInvitationMutation = { __typename?: 'Mutation', updateInvitation: boolean };

export type UpdateJobOfferMutationVariables = Exact<{
  id: Scalars['String'];
  companyName: Scalars['String'];
  jobTypeId: Scalars['String'];
  cityId?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
}>;


export type UpdateJobOfferMutation = { __typename?: 'Mutation', updateJobOffer: { __typename?: 'JobOffer', id: string } };

export type UpdateJobOfferIsHiddenMutationVariables = Exact<{
  id: Scalars['String'];
  isHidden: Scalars['Boolean'];
}>;


export type UpdateJobOfferIsHiddenMutation = { __typename?: 'Mutation', updateJobOfferIsHidden: { __typename?: 'JobOffer', id: string, isHidden: boolean, updatedAt: any } };

export type UpdatePostMutationVariables = Exact<{
  postId: Scalars['String'];
  media: Array<InputMaybe<HybridMedium>> | InputMaybe<HybridMedium>;
  message?: InputMaybe<Scalars['String']>;
  newsPostId?: InputMaybe<Scalars['String']>;
  adId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePostMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'Post', id: string } };

export type UpdateProjectMutationVariables = Exact<{
  projectId: Scalars['String'];
  name: Scalars['String'];
  cityId?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  media: Array<InputMaybe<HybridMedium>> | InputMaybe<HybridMedium>;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string } };

export type UpdateRatingMutationVariables = Exact<{
  id: Scalars['String'];
  value: Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type UpdateRatingMutation = { __typename?: 'Mutation', updateRating: { __typename?: 'updateRatingResponse', numberOfRatings: number, averageRating: number } };

export type UpdateRecommendationMutationVariables = Exact<{
  recommendationId: Scalars['String'];
  status?: InputMaybe<RecommendationStatus>;
}>;


export type UpdateRecommendationMutation = { __typename?: 'Mutation', updateRecommendation: { __typename?: 'Recommendation', id: string } };

export type UpdateSearchByPlaceMutationVariables = Exact<{
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  parameters?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<GeometryInput>;
  placeSource?: InputMaybe<GeometrySource>;
  lastViewedAt?: InputMaybe<Scalars['Date']>;
  emailNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateSearchByPlaceMutation = { __typename?: 'Mutation', updateSearchByPlace: { __typename?: 'Search', id: string, name: string, parameters: string, lastViewedAt: any, isFirstSavedAdSearch: boolean, emailNotificationsEnabled: boolean, placeGeometry?: { __typename?: 'GeometryWithSource', type?: GeometryType | null, coordinates?: any | null, source: GeometrySource } | null } };

export type UpdateShowcaseMutationVariables = Exact<{
  media: Array<InputMaybe<HybridMedium>> | InputMaybe<HybridMedium>;
}>;


export type UpdateShowcaseMutation = { __typename?: 'Mutation', updateShowcase: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> };

export type UpdateUserLocaleMutationVariables = Exact<{
  locale: SupportedLocales;
}>;


export type UpdateUserLocaleMutation = { __typename?: 'Mutation', updateUserLocale: SupportedLocales };

export type UpdateMyProfileImageMutationVariables = Exact<{
  imageHybridMedium?: InputMaybe<HybridMedium>;
}>;


export type UpdateMyProfileImageMutation = { __typename?: 'Mutation', updateMyProfileImage: { __typename?: 'User', id: string, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } };

export type UpdateUserProfileMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  imageHybridMedium?: InputMaybe<HybridMedium>;
  coverImageHybridMedium?: InputMaybe<HybridMedium>;
  cityId?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  certificates?: InputMaybe<Scalars['String']>;
  customActivity?: InputMaybe<Scalars['String']>;
  services?: InputMaybe<Scalars['String']>;
  awards?: InputMaybe<Scalars['String']>;
  feeScaleFileHybridMedium?: InputMaybe<HybridMedium>;
  feeScaleFileName?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updatePersonalInfo: { __typename?: 'User', id: string } };

export type UpdateUserProfileProMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  imageHybridMedium?: InputMaybe<HybridMedium>;
  cityId?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  certificates?: InputMaybe<Scalars['String']>;
  customActivity?: InputMaybe<Scalars['String']>;
  services?: InputMaybe<Scalars['String']>;
  awards?: InputMaybe<Scalars['String']>;
  feeScaleFileHybridMedium?: InputMaybe<HybridMedium>;
  feeScaleFileName?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  companyPhoneNumber?: InputMaybe<PhoneParam>;
  siretNumber?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<AddressParam>;
}>;


export type UpdateUserProfileProMutation = { __typename?: 'Mutation', updatePersonalInfo: { __typename?: 'User', id: string }, updateCompanyWithNullableAddress: { __typename?: 'Company', id: string } };

export type UpdateUserProfileAndCreateCompanyMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  imageHybridMedium?: InputMaybe<HybridMedium>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  cityId?: InputMaybe<Scalars['String']>;
  certificates?: InputMaybe<Scalars['String']>;
  customActivity?: InputMaybe<Scalars['String']>;
  services?: InputMaybe<Scalars['String']>;
  awards?: InputMaybe<Scalars['String']>;
  feeScaleFileHybridMedium?: InputMaybe<HybridMedium>;
  feeScaleFileName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
  companyPhoneNumber?: InputMaybe<PhoneParam>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<AddressParam>;
}>;


export type UpdateUserProfileAndCreateCompanyMutation = { __typename?: 'Mutation', updatePersonalInfo: { __typename?: 'User', id: string }, createCompany: { __typename?: 'Company', id: string } };

export type UploadChannelImageMutationVariables = Exact<{
  image: Scalars['Upload'];
  channelUrl: Scalars['String'];
}>;


export type UploadChannelImageMutation = { __typename?: 'Mutation', uploadChannelImage: string };

export type UploadMediaMutationVariables = Exact<{
  media: Array<Scalars['Upload']> | Scalars['Upload'];
}>;


export type UploadMediaMutation = { __typename?: 'Mutation', uploadMedia: Array<string> };

export type ValidateVerificationCodeMutationVariables = Exact<{
  proId: Scalars['String'];
  code: Scalars['String'];
}>;


export type ValidateVerificationCodeMutation = { __typename?: 'Mutation', validateVerificationCode: ValidateVerificationCodeResponse };

export type ViewNotificationMutationVariables = Exact<{
  notificationId: Scalars['String'];
}>;


export type ViewNotificationMutation = { __typename?: 'Mutation', viewNotification: boolean };

export type ViewStoryMutationVariables = Exact<{
  storyId: Scalars['String'];
}>;


export type ViewStoryMutation = { __typename?: 'Mutation', viewStory: boolean };

export type SetEmailVerifiedMutationVariables = Exact<{
  isEmailVerified: Scalars['Boolean'];
}>;


export type SetEmailVerifiedMutation = { __typename?: 'Mutation', setEmailVerified: boolean };

export type ActivitiesQueryVariables = Exact<{
  displayOneOtherOnSignUp?: InputMaybe<Scalars['Boolean']>;
  companyLabel?: InputMaybe<CompanyLabel>;
}>;


export type ActivitiesQuery = { __typename?: 'Query', activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string, featuredOrder?: number | null, activityCategories: Array<{ __typename?: 'ActivityCategory', id: string, labelKey: string, parentActivityCategory?: { __typename?: 'ActivityCategory', id: string, labelKey: string } | null } | null> }> | null };

export type ActivityCategoriesQueryVariables = Exact<{
  onlyCrafts?: InputMaybe<Scalars['Boolean']>;
  includeOther?: InputMaybe<Scalars['Boolean']>;
}>;


export type ActivityCategoriesQuery = { __typename?: 'Query', activityCategories?: Array<{ __typename?: 'ActivityCategory', id: string, labelKey: string, parentActivityCategoryId?: string | null, parentActivityCategory?: { __typename?: 'ActivityCategory', id: string, labelKey: string } | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string, featuredOrder?: number | null }> | null }> | null };

export type ActivityCategorySubcategoriesQueryVariables = Exact<{
  parentCategoryId?: InputMaybe<Scalars['String']>;
}>;


export type ActivityCategorySubcategoriesQuery = { __typename?: 'Query', activityCategorySubcategories?: Array<{ __typename?: 'ActivityCategory', id: string, labelKey: string, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string, featuredOrder?: number | null }> | null }> | null };

export type AdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdQuery = { __typename?: 'Query', ad?: { __typename?: 'Ad', id: string, createdAt: any, isUserFavorite: boolean, isUserAffiliatedCompanyFavorite: boolean, title?: string | null, description?: string | null, livingArea?: number | null, surfaceArea?: number | null, landArea?: number | null, price?: number | null, status?: AdStatuses | null, bedroomNumber?: number | null, roomNumber?: number | null, proxyLng: number, proxyLat: number, floorNumber?: number | null, constructionYear?: number | null, floorPosition?: number | null, consumption?: string | null, showSaleFeeBuyerPrice?: boolean | null, saleFeeBuyerPrice?: number | null, emissions?: string | null, heatType?: HeatTypes | null, heatInformations?: string | null, interOffice: boolean, commissionRate?: number | null, rooms?: string | null, isNew: boolean, isPriceDecreasing: boolean, type: AdTypes, propertyType: string, propertyState?: PropertyState | null, commonAreasState?: CommonAreasState | null, propertyPurposeEstimation?: PropertyPurposeEstimation | null, propertyResidenceType?: PropertyResidenceType | null, userIsOwner?: boolean | null, isHiddingCompleteAddress: boolean, numberOfVehicles?: number | null, constructibleLand?: YesNoNaOptions | null, servicedLand?: YesNoNaOptions | null, dimensionLength?: number | null, dimensionWidth?: number | null, dimensionHeight?: number | null, coOwnership?: boolean | null, coOwnershipNumberOfLots?: number | null, coOwnershipOngoing?: YesNoOptions | null, coOwnershipYearlyCharge?: number | null, saleFeeType?: SaleFeeType | null, saleFeeBuyerRate?: number | null, priceWithoutSaleFee?: number | null, assets?: Array<string | null> | null, totalPublisher?: number | null, furnished?: boolean | null, inclusions?: string | null, rent?: number | null, monthlyCharges?: number | null, isRentChargesIncluded?: boolean | null, inventory?: number | null, fees?: number | null, guarantees?: string | null, availableDate?: number | null, isInaccurateAddress: boolean, standardLoanAmount?: { __typename?: 'LoanAmount', monthlyPayment: number } | null, assignedTo?: { __typename?: 'User', fullName?: string | null, initials?: string | null, id: string, sendbirdUserId?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType, isTranscoding?: boolean | null } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, number: string, phoneCode: string } | null } | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType, isTranscoding?: boolean | null } | null>, homadataEvaluation?: { __typename?: 'HomadataEvaluation', id: string, requestDate?: string | null, confidenceMin: number, confidenceMax: number, predictedPrice?: number | null, confidenceIndex?: number | null } | null, address: { __typename?: 'Address', id: string, placeId?: string | null, description: string, zipCode?: string | null, cityName?: string | null, country?: string | null }, owner?: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType, isTranscoding?: boolean | null } | null, company?: { __typename?: 'Company', id: string, name: string, website?: string | null, label?: CompanyLabel | null, customActivity?: string | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null, address?: { __typename?: 'Address', id: string, zipCode?: string | null, description: string, cityName?: string | null } | null, contactUser?: { __typename?: 'User', id: string, sendbirdUserId?: string | null } | null } | null, user?: { __typename?: 'User', id: string, sendbirdUserId?: string | null, isProfessionnal: boolean, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, number: string, phoneCode: string } | null } | null, mainPublisher?: { __typename?: 'Publisher', id: string, createdAt: any, url: string, name: string } | null, stats: { __typename?: 'Stats', id: string, impressionCount: number, viewCount: number, favoriteCount: number, contactCount: number } } | null };

export type AdLightQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdLightQuery = { __typename?: 'Query', ad?: { __typename?: 'Ad', id: string, title?: string | null, createdAt: any, livingArea?: number | null, surfaceArea?: number | null, status?: AdStatuses | null, bedroomNumber?: number | null, roomNumber?: number | null, isNew: boolean, isPriceDecreasing: boolean, price?: number | null, rent?: number | null, proxyLat: number, proxyLng: number, type: AdTypes, isHiddingCompleteAddress: boolean, isInaccurateAddress: boolean, isUserFavorite: boolean, propertyType: string, homadataEvaluation?: { __typename?: 'HomadataEvaluation', confidenceMin: number, confidenceMax: number } | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType, isTranscoding?: boolean | null } | null>, address: { __typename?: 'Address', id: string, zipCode?: string | null, cityName?: string | null }, owner?: { __typename?: 'Owner', id: string, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType, isTranscoding?: boolean | null } | null, user?: { __typename?: 'User', id: string } | null, company?: { __typename?: 'Company', id: string, label?: CompanyLabel | null, customActivity?: string | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null } | null } | null, mainPublisher?: { __typename?: 'Publisher', id: string, createdAt: any, name: string, url: string } | null, stats: { __typename?: 'Stats', id: string } } | null };

export type AdsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  minPrice?: InputMaybe<Scalars['Int']>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  minLandArea?: InputMaybe<Scalars['Int']>;
  maxLandArea?: InputMaybe<Scalars['Int']>;
  minLivingArea?: InputMaybe<Scalars['Int']>;
  maxLivingArea?: InputMaybe<Scalars['Int']>;
  rooms?: InputMaybe<Scalars['Int']>;
  bedrooms?: InputMaybe<Scalars['Int']>;
  house?: InputMaybe<Scalars['Boolean']>;
  apartment?: InputMaybe<Scalars['Boolean']>;
  loft?: InputMaybe<Scalars['Boolean']>;
  parking?: InputMaybe<Scalars['Boolean']>;
  terrain?: InputMaybe<Scalars['Boolean']>;
  newProperty?: InputMaybe<Scalars['Boolean']>;
  oldProperty?: InputMaybe<Scalars['Boolean']>;
  interOffice?: InputMaybe<Scalars['Boolean']>;
  furnished?: InputMaybe<Array<FurnishedStatus> | FurnishedStatus>;
  type?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  isPrivateAdvertiser?: InputMaybe<Scalars['Boolean']>;
  realEstateTradesAdvertiser?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<InputMaybe<AdStatuses>> | InputMaybe<AdStatuses>>;
  withoutAssignation?: InputMaybe<Scalars['Boolean']>;
  assignatedToUserId?: InputMaybe<Scalars['String']>;
  places?: InputMaybe<Array<InputMaybe<GeometryInput>> | InputMaybe<GeometryInput>>;
}>;


export type AdsQuery = { __typename?: 'Query', ads?: { __typename?: 'AdsSearch', totalCount?: number | null, items?: Array<{ __typename?: 'Ad', id: string, type: AdTypes, title?: string | null, livingArea?: number | null, landArea?: number | null, surfaceArea?: number | null, price?: number | null, rent?: number | null, bedroomNumber?: number | null, roomNumber?: number | null, interOffice: boolean, createdAt: any, isNew: boolean, isPriceDecreasing: boolean, isHiddingCompleteAddress: boolean, isInaccurateAddress: boolean, isUserFavorite: boolean, propertyType: string, proxyLat: number, proxyLng: number, status?: AdStatuses | null, assignedTo?: { __typename?: 'User', fullName?: string | null, initials?: string | null, id: string, image?: { __typename?: 'Medium', id: string, aspectRatio?: number | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, media: Array<{ __typename?: 'Medium', id: string, aspectRatio?: number | null, url: string, type: MediumType } | null>, homadataEvaluation?: { __typename?: 'HomadataEvaluation', id: string, confidenceMin: number, confidenceMax: number } | null, address: { __typename?: 'Address', id: string, cityName?: string | null, zipCode?: string | null }, owner?: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, image?: { __typename?: 'Medium', id: string, aspectRatio?: number | null, url: string, type: MediumType } | null, company?: { __typename?: 'Company', id: string, name: string, customActivity?: string | null, label?: CompanyLabel | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null } | null, user?: { __typename?: 'User', id: string, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null } | null, mainPublisher?: { __typename?: 'Publisher', id: string, name: string, url: string } | null }> | null } | null };

export type UserAdsSearchQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  minPrice?: InputMaybe<Scalars['Int']>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  rooms?: InputMaybe<Scalars['Int']>;
  house?: InputMaybe<Scalars['Boolean']>;
  apartment?: InputMaybe<Scalars['Boolean']>;
  loft?: InputMaybe<Scalars['Boolean']>;
  parking?: InputMaybe<Scalars['Boolean']>;
  terrain?: InputMaybe<Scalars['Boolean']>;
  newProperty?: InputMaybe<Scalars['Boolean']>;
  oldProperty?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<AdStatuses>> | InputMaybe<AdStatuses>>;
  places?: InputMaybe<Array<InputMaybe<GeometryInput>> | InputMaybe<GeometryInput>>;
  userId?: InputMaybe<Scalars['String']>;
}>;


export type UserAdsSearchQuery = { __typename?: 'Query', ads?: { __typename?: 'AdsSearch', totalCount?: number | null, items?: Array<{ __typename?: 'Ad', id: string, type: AdTypes, isUserFavorite: boolean, isUserAffiliatedCompanyFavorite: boolean, title?: string | null, livingArea?: number | null, landArea?: number | null, surfaceArea?: number | null, price?: number | null, bedroomNumber?: number | null, roomNumber?: number | null, interOffice: boolean, createdAt: any, isNew: boolean, isPriceDecreasing: boolean, propertyType: string, proxyLat: number, proxyLng: number, status?: AdStatuses | null, rent?: number | null, media: Array<{ __typename?: 'Medium', id: string, aspectRatio?: number | null, url: string, type: MediumType } | null>, homadataEvaluation?: { __typename?: 'HomadataEvaluation', id: string, requestDate?: string | null, confidenceMin: number, confidenceMax: number } | null, address: { __typename?: 'Address', id: string, zipCode?: string | null, cityName?: string | null }, owner?: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, createdAt: any, image?: { __typename?: 'Medium', id: string, aspectRatio?: number | null, url: string, type: MediumType } | null, company?: { __typename?: 'Company', id: string, name: string, website?: string | null, label?: CompanyLabel | null } | null, user?: { __typename?: 'User', id: string, isRealEstatesTrades: boolean, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null } | null, mainPublisher?: { __typename?: 'Publisher', id: string, name: string, url: string } | null, stats: { __typename?: 'Stats', id: string, impressionCount: number, viewCount: number, favoriteCount: number, contactCount: number } }> | null } | null };

export type CompanyAdsSearchQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  minPrice?: InputMaybe<Scalars['Int']>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  rooms?: InputMaybe<Scalars['Int']>;
  house?: InputMaybe<Scalars['Boolean']>;
  apartment?: InputMaybe<Scalars['Boolean']>;
  loft?: InputMaybe<Scalars['Boolean']>;
  parking?: InputMaybe<Scalars['Boolean']>;
  terrain?: InputMaybe<Scalars['Boolean']>;
  newProperty?: InputMaybe<Scalars['Boolean']>;
  oldProperty?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<AdStatuses>> | InputMaybe<AdStatuses>>;
  withoutAssignation?: InputMaybe<Scalars['Boolean']>;
  assignatedToUserId?: InputMaybe<Scalars['String']>;
  places?: InputMaybe<Array<InputMaybe<GeometryInput>> | InputMaybe<GeometryInput>>;
}>;


export type CompanyAdsSearchQuery = { __typename?: 'Query', ads?: { __typename?: 'AdsSearch', totalCount?: number | null, items?: Array<{ __typename?: 'Ad', id: string, type: AdTypes, isUserFavorite: boolean, isUserAffiliatedCompanyFavorite: boolean, title?: string | null, livingArea?: number | null, landArea?: number | null, surfaceArea?: number | null, price?: number | null, bedroomNumber?: number | null, roomNumber?: number | null, interOffice: boolean, createdAt: any, isNew: boolean, isPriceDecreasing: boolean, propertyType: string, proxyLat: number, proxyLng: number, status?: AdStatuses | null, rent?: number | null, media: Array<{ __typename?: 'Medium', id: string, aspectRatio?: number | null, url: string, type: MediumType } | null>, assignedTo?: { __typename?: 'User', fullName?: string | null, initials?: string | null, id: string, image?: { __typename?: 'Medium', id: string, aspectRatio?: number | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, homadataEvaluation?: { __typename?: 'HomadataEvaluation', id: string, requestDate?: string | null, confidenceMin: number, confidenceMax: number } | null, address: { __typename?: 'Address', id: string, zipCode?: string | null, cityName?: string | null }, owner?: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, createdAt: any, image?: { __typename?: 'Medium', id: string, aspectRatio?: number | null, url: string, type: MediumType } | null, company?: { __typename?: 'Company', id: string, name: string, website?: string | null, label?: CompanyLabel | null } | null, user?: { __typename?: 'User', id: string, isRealEstatesTrades: boolean, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null } | null, mainPublisher?: { __typename?: 'Publisher', id: string, name: string, url: string } | null, stats: { __typename?: 'Stats', id: string, impressionCount: number, viewCount: number, favoriteCount: number, contactCount: number } }> | null } | null };

export type AdsForMapQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  minPrice?: InputMaybe<Scalars['Int']>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  minLandArea?: InputMaybe<Scalars['Int']>;
  maxLandArea?: InputMaybe<Scalars['Int']>;
  minLivingArea?: InputMaybe<Scalars['Int']>;
  maxLivingArea?: InputMaybe<Scalars['Int']>;
  rooms?: InputMaybe<Scalars['Int']>;
  bedrooms?: InputMaybe<Scalars['Int']>;
  house?: InputMaybe<Scalars['Boolean']>;
  apartment?: InputMaybe<Scalars['Boolean']>;
  loft?: InputMaybe<Scalars['Boolean']>;
  parking?: InputMaybe<Scalars['Boolean']>;
  terrain?: InputMaybe<Scalars['Boolean']>;
  newProperty?: InputMaybe<Scalars['Boolean']>;
  oldProperty?: InputMaybe<Scalars['Boolean']>;
  interOffice?: InputMaybe<Scalars['Boolean']>;
  furnished?: InputMaybe<Array<FurnishedStatus> | FurnishedStatus>;
  type?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  isPrivateAdvertiser?: InputMaybe<Scalars['Boolean']>;
  realEstateTradesAdvertiser?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<InputMaybe<AdStatuses>> | InputMaybe<AdStatuses>>;
  places?: InputMaybe<Array<InputMaybe<GeometryInput>> | InputMaybe<GeometryInput>>;
}>;


export type AdsForMapQuery = { __typename?: 'Query', ads?: { __typename?: 'AdsSearch', totalCount?: number | null, items?: Array<{ __typename?: 'Ad', id: string, price?: number | null, rent?: number | null, proxyLat: number, proxyLng: number, type: AdTypes, isHiddingCompleteAddress: boolean, isInaccurateAddress: boolean }> | null } | null };

export type AdsTotalCountQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  minPrice?: InputMaybe<Scalars['Int']>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  minLandArea?: InputMaybe<Scalars['Int']>;
  maxLandArea?: InputMaybe<Scalars['Int']>;
  minLivingArea?: InputMaybe<Scalars['Int']>;
  maxLivingArea?: InputMaybe<Scalars['Int']>;
  rooms?: InputMaybe<Scalars['Int']>;
  bedrooms?: InputMaybe<Scalars['Int']>;
  house?: InputMaybe<Scalars['Boolean']>;
  apartment?: InputMaybe<Scalars['Boolean']>;
  loft?: InputMaybe<Scalars['Boolean']>;
  parking?: InputMaybe<Scalars['Boolean']>;
  terrain?: InputMaybe<Scalars['Boolean']>;
  newProperty?: InputMaybe<Scalars['Boolean']>;
  oldProperty?: InputMaybe<Scalars['Boolean']>;
  interOffice?: InputMaybe<Scalars['Boolean']>;
  furnished?: InputMaybe<Array<FurnishedStatus> | FurnishedStatus>;
  type?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  isPrivateAdvertiser?: InputMaybe<Scalars['Boolean']>;
  realEstateTradesAdvertiser?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<InputMaybe<AdStatuses>> | InputMaybe<AdStatuses>>;
  places?: InputMaybe<Array<InputMaybe<GeometryInput>> | InputMaybe<GeometryInput>>;
}>;


export type AdsTotalCountQuery = { __typename?: 'Query', ads?: { __typename?: 'AdsSearch', totalCount?: number | null } | null };

export type AdPublishersQueryVariables = Exact<{
  adId: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<AdPublisherSortInput>;
}>;


export type AdPublishersQuery = { __typename?: 'Query', adPublishers: { __typename?: 'PublishersWithTotal', total: number, results: Array<{ __typename?: 'Publisher', id: string, createdAt: any, url: string, name: string, price?: number | null }> } };

export type AdminRequestsQueryVariables = Exact<{
  companyId: Scalars['String'];
  status?: InputMaybe<RequestAdminStatus>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type AdminRequestsQuery = { __typename?: 'Query', adminRequests: { __typename?: 'AdminRequestsResponse', total: number, items: Array<{ __typename?: 'RequestAdmin', id: string, status: RequestAdminStatus, company: { __typename?: 'Company', id: string, name: string }, user: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } }> } };

export type AgentsQueryVariables = Exact<{
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<EsOrderByTypes>;
}>;


export type AgentsQuery = { __typename?: 'Query', agents?: { __typename?: 'UsersResponseWithTotal', total?: number | null, results?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, isProfessionnal: boolean, initials?: string | null, contactStatusV2?: ContactStatus | null, recommendationsReceivedCount: number, mutualContactsCount?: number | null, numberOfRatings: number, averageRating: number, isRealEstatesTrades: boolean, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null> | null } | null };

export type ChatUserQueryVariables = Exact<{
  sendbirdUserId: Scalars['String'];
}>;


export type ChatUserQuery = { __typename?: 'Query', chatUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, email: string, initials?: string | null, contactStatusV2?: ContactStatus | null, customActivity?: string | null, fallbackNameEn?: string | null, fallbackNameFr?: string | null, fallbackInititals?: string | null, isFollowed: boolean, isProfessionnal: boolean, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, companyToDisplay?: { __typename?: 'Company', id: string, name: string, website?: string | null } | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, number: string, phoneCode: string } | null } | null };

export type ChatUserLightQueryVariables = Exact<{
  sendbirdUserId: Scalars['String'];
}>;


export type ChatUserLightQuery = { __typename?: 'Query', chatUser?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, customActivity?: string | null, fallbackInititals?: string | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null };

export type CompanyGalleriesQueryVariables = Exact<{
  companyId: Scalars['String'];
  policy?: InputMaybe<GalleryAccessPolicy>;
  sort?: InputMaybe<GallerySort>;
  pageRequest?: InputMaybe<PageRequest>;
}>;


export type CompanyGalleriesQuery = { __typename?: 'Query', companyProfile: { __typename?: 'Company', galleries: { __typename?: 'GalleryPage', totalCount: number, items: Array<{ __typename?: 'Gallery', id: string, name: string, isSecret: boolean, createdAt: any, numberOfContents: number, contentLastUpdatedAt: any, previewMedia?: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> | null }> } } };

export type CompanyGalleriesWithCollaboratorsQueryVariables = Exact<{
  companyId: Scalars['String'];
  policy?: InputMaybe<GalleryAccessPolicy>;
  sort?: InputMaybe<GallerySort>;
  pageRequest?: InputMaybe<PageRequest>;
  collaboratorPageRequest?: InputMaybe<PageRequest>;
}>;


export type CompanyGalleriesWithCollaboratorsQuery = { __typename?: 'Query', companyProfile: { __typename?: 'Company', galleries: { __typename?: 'GalleryPage', totalCount: number, items: Array<{ __typename?: 'Gallery', id: string, name: string, isSecret: boolean, createdAt: any, numberOfContents: number, contentLastUpdatedAt: any, previewMedia?: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> | null, collaborators: { __typename?: 'GalleryCollaboratorPage', totalCount: number, items: Array<{ __typename?: 'GalleryCollaborator', user?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null, company?: { __typename?: 'Company', id: string, name: string, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null }> } }> } } };

export type CompanyMembersAndPendingInvitationsQueryVariables = Exact<{
  companyId: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  match?: InputMaybe<Match>;
}>;


export type CompanyMembersAndPendingInvitationsQuery = { __typename?: 'Query', companyMembersAndPendingInvitations?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, pendingInvitations?: Array<{ __typename?: 'Invitation', id: string, companyId: string, direction: InvitationDirection } | null> | null }> | null };

export type CompanyMembersWhoAreInMyContactsQueryVariables = Exact<{
  companyId: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  match?: InputMaybe<Match>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type CompanyMembersWhoAreInMyContactsQuery = { __typename?: 'Query', companyMembersWhoAreInMyContacts?: { __typename?: 'UsersResponseWithTotal', total?: number | null, results?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, customActivity?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null> | null } | null };

export type CompanyMembersWithTotalQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  isDirector?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  withRecursive?: InputMaybe<Scalars['Boolean']>;
  onlyWithRecommendations?: InputMaybe<Scalars['Boolean']>;
}>;


export type CompanyMembersWithTotalQuery = { __typename?: 'Query', companyMembersWithTotal?: { __typename?: 'UsersResponseWithTotal', total?: number | null, results?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, contactStatusV2?: ContactStatus | null, recommendationsReceivedCount: number, mutualContactsCount?: number | null, numberOfRatings: number, averageRating: number, customActivity?: string | null, isRealEstatesTrades: boolean, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null> | null } | null };

export type CompanyProfileQueryVariables = Exact<{
  companyId: Scalars['String'];
  showcaseLimit?: InputMaybe<Scalars['Int']>;
}>;


export type CompanyProfileQuery = { __typename?: 'Query', companyProfile: { __typename?: 'Company', id: string, name: string, label?: CompanyLabel | null, initials?: string | null, description?: string | null, website?: string | null, foundationYear?: number | null, feeScaleFile?: string | null, feeScaleFileName?: string | null, mission?: string | null, contactUrl?: string | null, updatedAt?: any | null, invitationStatus?: InvitationStatus | null, currentUserIsAbleToJoin?: boolean | null, currentUserAffiliatedCompanyIsAbleToJoin?: boolean | null, groupInvitationStatus?: InvitationStatus | null, pagesJaunesId?: string | null, pagesJaunesUrl?: string | null, customActivity?: string | null, siretNumber?: string | null, numberOfMembers: number, numberOfProjects: number, numberOfPosts: number, numberOfStories: number, numberOfGalleries: number, numberOfJobOffers: number, numberOfRatings: number, numberOfDisplayedRatings: number, recommendationsReceivedCount: number, membersRecommendationsCount: number, companyAndMembersRecommendationsCount: number, averageRating: number, numberOfFollowers: number, isFollowingCompany: boolean, numberOfMembersRecursively: number, hasUnreadStory: boolean, createdAt: any, numberOfAvailableAds: number, numberOfEndedAds: number, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string, activityCategories: Array<{ __typename?: 'ActivityCategory', id: string, labelKey: string } | null> }> | null, group?: { __typename?: 'Company', id: string, name: string, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null, capabilities?: { __typename?: 'CompanyCapatibilities', allowedContentTypesToManage?: Array<ContentType | null> | null, allowedContentTypesToDisplay?: Array<ContentType | null> | null, allowedLabels?: Array<CompanyLabel | null> | null, isAbleToSyncCrm: boolean, isAbleToHaveDirectors: boolean, isAbleToHaveEstateCompanies: boolean, hasPublicPage: boolean } | null, coverImage?: { __typename?: 'Medium', id: string, url: string, isTranscoding?: boolean | null } | null, recommendationFromMe?: { __typename?: 'Recommendation', id: string, status: RecommendationStatus } | null, adminRequest?: { __typename?: 'RequestAdmin', id: string, status: RequestAdminStatus } | null, ratingGivenByCurrentUser?: { __typename?: 'Rating', id: string, value: number, comment?: string | null, createdAt: any, isHidden: boolean, giver?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, createdAt: any, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null } | null, address?: { __typename?: 'Address', id: string, placeId?: string | null, zipCode?: string | null, description: string, lng: number, lat: number, cityName?: string | null, country?: string | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, video?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, showcase?: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, number: string, phoneCode: string, countryCode: string } | null, contactUser?: { __typename?: 'User', id: string } | null } };

export type CompanyProfileCountsQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type CompanyProfileCountsQuery = { __typename?: 'Query', companyProfile: { __typename?: 'Company', id: string, numberOfMembers: number, numberOfPosts: number, numberOfGalleries: number, numberOfJobOffers: number, numberOfRatings: number, numberOfProjects: number, numberOfDisplayedRatings: number, numberOfFollowers: number, numberOfAdmins: number, numberOfDirectors: number, numberOfAvailableAds: number, numberOfEndedAds: number, capabilities?: { __typename?: 'CompanyCapatibilities', allowedContentTypesToManage?: Array<ContentType | null> | null, allowedContentTypesToDisplay?: Array<ContentType | null> | null, allowedLabels?: Array<CompanyLabel | null> | null, isAbleToSyncCrm: boolean, isAbleToHaveDirectors: boolean, isAbleToHaveEstateCompanies: boolean, hasPublicPage: boolean } | null } };

export type CompanyProjectsQueryVariables = Exact<{
  companyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type CompanyProjectsQuery = { __typename?: 'Query', companyProjects: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, city: { __typename?: 'City', id: string, name: string, googlePlaceId?: string | null, countryShort: string } }> };

export type CountsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountsQuery = { __typename?: 'Query', counts: { __typename?: 'CountsResponse', totalPendingNotifications: number, numberOfPendingRecommendationRequests: number, numberOfPendingAdminRequests: number, numberOfPendingInvitations: number, numberOfReceivedPendingContactInvitations: number, numberOfUnreadNotifications: number, unreadMessages: number, numberOfPendingCompanyMembershipReceivedInvitations: number, numberOfPendingGroupMembershipReceivedInvitations: number, numberOfPendingCompanyMembershipSentInvitations: number, numberOfPendingGroupMembershipSentInvitations: number } };

export type CountsForSitemapQueryVariables = Exact<{ [key: string]: never; }>;


export type CountsForSitemapQuery = { __typename?: 'Query', countsForSitemap: { __typename?: 'CountsForSitemapResponse', ads: number, users: number, companies: number } };

export type CrmSourcesQueryVariables = Exact<{
  withOther?: InputMaybe<Scalars['Boolean']>;
}>;


export type CrmSourcesQuery = { __typename?: 'Query', crmSources?: Array<{ __typename?: 'CrmSource', id: string, name: string, emailAddress?: string | null, requestEmailSubject?: string | null, requestEmailBody?: string | null, isActive?: boolean | null } | null> | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, sendbirdUserId?: string | null, description?: string | null, fullName?: string | null, initials?: string | null, numberOfGalleries: number, numberOfStories: number, feeScaleFile?: string | null, feeScaleFileName?: string | null, customActivity?: string | null, isAdminOfAffiliatedCompany?: boolean | null, createdAt: any, updatedAt: any, deletedAt?: any | null, deletedReason?: DeletedReason | null, isMandatoryAgentTrade: boolean, isProfessionnal: boolean, isRealEstatesTrades: boolean, isCrafts: boolean, isAbleToJoinOrCreateEstateCompany: boolean, isAbleToJoinOrCreateCompany: boolean, isAbleToJoinOrCreateCraftCompany: boolean, privateCompany?: { __typename?: 'Company', id: string, name: string, foundationYear?: number | null, website?: string | null, siretNumber?: string | null, description?: string | null, capabilities?: { __typename?: 'CompanyCapatibilities', allowedContentTypesToManage?: Array<ContentType | null> | null, allowedContentTypesToDisplay?: Array<ContentType | null> | null, allowedLabels?: Array<CompanyLabel | null> | null, isAbleToSyncCrm: boolean, isAbleToHaveDirectors: boolean, isAbleToHaveEstateCompanies: boolean, hasPublicPage: boolean } | null, address?: { __typename?: 'Address', id: string, placeId?: string | null, description: string, lat: number, lng: number, cityName?: string | null, zipCode?: string | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, contactUser?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null } | null, affiliatedCompany?: { __typename?: 'Company', id: string, name: string, label?: CompanyLabel | null, foundationYear?: number | null, website?: string | null, siretNumber?: string | null, numberOfCompanies?: number | null, customActivity?: string | null, numberOfGalleries: number, numberOfStories: number, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null, group?: { __typename?: 'Company', id: string } | null, capabilities?: { __typename?: 'CompanyCapatibilities', allowedContentTypesToManage?: Array<ContentType | null> | null, allowedContentTypesToDisplay?: Array<ContentType | null> | null, allowedLabels?: Array<CompanyLabel | null> | null, isAbleToSyncCrm: boolean, isAbleToHaveDirectors: boolean, isAbleToHaveEstateCompanies: boolean, hasPublicPage: boolean } | null, address?: { __typename?: 'Address', id: string, placeId?: string | null, description: string, lat: number, lng: number, cityName?: string | null, zipCode?: string | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, contactUser?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, customActivity?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, crmSyncs?: Array<{ __typename?: 'CrmSync', crmUserId?: string | null, id: string, crmSource?: { __typename?: 'CrmSource', name: string, isActive?: boolean | null, id: string } | null, polirisUser?: { __typename?: 'PolirisUser', name?: string | null } | null } | null> | null } | null, contactCompany?: { __typename?: 'Company', id: string } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, city?: { __typename?: 'City', id: string, name: string, lat: number, lng: number, zipCodes?: Array<string | null> | null, googlePlaceId?: string | null, country: string, countryShort: string } | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, number: string, countryCode: string, phoneCode: string } | null, coverImage?: { __typename?: 'Medium', id: string, url: string } | null, showcase?: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> | null, newsCategories: Array<{ __typename?: 'NewsCategory', id: string }>, crmSyncs?: Array<{ __typename?: 'CrmSync', crmUserId?: string | null, id: string, crmSource?: { __typename?: 'CrmSource', name: string, isActive?: boolean | null, id: string } | null, polirisUser?: { __typename?: 'PolirisUser', name?: string | null } | null } | null> | null, notificationSubscriptions: Array<{ __typename?: 'NotificationSubscription', subject: NotificationSubscriptionSubject, status: NotificationSubscriptionStatus }> } };

export type CurrentUserPendingInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserPendingInvitationsQuery = { __typename?: 'Query', me: { __typename?: 'User', pendingInvitations?: Array<{ __typename?: 'Invitation', id: string, companyId: string, direction: InvitationDirection, company: { __typename?: 'Company', id: string, name: string, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } } | null> | null } };

export type CurrentUserProfileQueryVariables = Exact<{
  showcaseLimit?: InputMaybe<Scalars['Int']>;
}>;


export type CurrentUserProfileQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, fullName?: string | null, initials?: string | null, description?: string | null, feeScaleFile?: string | null, feeScaleFileName?: string | null, certificates?: string | null, customActivity?: string | null, services?: string | null, awards?: string | null, isProfessionnal: boolean, isCrafts: boolean, isRealEstatesTrades: boolean, isAbleToJoinOrCreateEstateCompany: boolean, isAbleToJoinOrCreateCraftCompany: boolean, isAbleToJoinOrCreateCompany: boolean, isMandatoryAgentTrade: boolean, totalRelations: number, numberOfContacts: number, numberOfFollowers: number, numberOfFollows: number, numberOfPhoneContacts: number, numberOfPosts: number, numberOfStories: number, numberOfRatings: number, numberOfDisplayedRatings: number, numberOfProjects: number, isAdminOfAffiliatedCompany?: boolean | null, createdAt: any, updatedAt: any, numberOfSellAds: number, numberOfRentAds: number, numberOfAvailableAds: number, numberOfEndedAds: number, numberOfArchivedAds: number, acceptedRecommendationsReceivedCount: number, acceptedAndPendingRecommendationsReceivedCount: number, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, coverImage?: { __typename?: 'Medium', id: string, url: string } | null, showcase?: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, city?: { __typename?: 'City', id: string, name: string, zipCodes?: Array<string | null> | null, googlePlaceId?: string | null, country: string, countryShort: string } | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, number: string, phoneCode: string, countryCode: string } | null, privateCompany?: { __typename?: 'Company', id: string, name: string, foundationYear?: number | null, website?: string | null, siretNumber?: string | null, description?: string | null, capabilities?: { __typename?: 'CompanyCapatibilities', allowedContentTypesToManage?: Array<ContentType | null> | null, allowedContentTypesToDisplay?: Array<ContentType | null> | null, allowedLabels?: Array<CompanyLabel | null> | null, isAbleToSyncCrm: boolean, isAbleToHaveDirectors: boolean, isAbleToHaveEstateCompanies: boolean, hasPublicPage: boolean } | null, address?: { __typename?: 'Address', id: string, placeId?: string | null, description: string, zipCode?: string | null, lat: number, lng: number, cityName?: string | null, country?: string | null, city?: { __typename?: 'City', id: string, name: string } | null } | null } | null, affiliatedCompany?: { __typename?: 'Company', id: string, name: string, foundationYear?: number | null, website?: string | null, siretNumber?: string | null, capabilities?: { __typename?: 'CompanyCapatibilities', allowedContentTypesToManage?: Array<ContentType | null> | null, allowedContentTypesToDisplay?: Array<ContentType | null> | null, allowedLabels?: Array<CompanyLabel | null> | null, isAbleToSyncCrm: boolean, isAbleToHaveDirectors: boolean, isAbleToHaveEstateCompanies: boolean, hasPublicPage: boolean } | null, address?: { __typename?: 'Address', id: string, placeId?: string | null, description: string, zipCode?: string | null, lat: number, lng: number, cityName?: string | null, city?: { __typename?: 'City', id: string, name: string } | null } | null } | null } };

export type DataForSitemapQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type DataForSitemapQuery = { __typename?: 'Query', dataForSitemap: { __typename?: 'DataForSitemapResponse', ads: Array<{ __typename?: 'Ad', id: string, updatedAt: any }>, users: Array<{ __typename?: 'User', id: string, updatedAt: any }>, companies: Array<{ __typename?: 'Company', id: string }> } };

export type FollowersQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  match?: InputMaybe<Match>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type FollowersQuery = { __typename?: 'Query', followers: { __typename?: 'FollowsWithTotal', total: number, results: Array<{ __typename?: 'Follow', id: string, followingUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, customActivity?: string | null, isProfessionnal: boolean, isFollowed: boolean, mutualContactsCount?: number | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, number: string } | null } }> } };

export type FollowingQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  match?: InputMaybe<Match>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type FollowingQuery = { __typename?: 'Query', following: { __typename?: 'FollowsWithTotal', total: number, results: Array<{ __typename?: 'Follow', id: string, followedOwner: { __typename?: 'Owner', id: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, customActivity?: string | null, isProfessionnal: boolean, isFollowed: boolean, mutualContactsCount?: number | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, number: string } | null } | null, company?: { __typename?: 'Company', id: string, name: string, initials?: string | null, customActivity?: string | null, isFollowingCompany: boolean, label?: CompanyLabel | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null } }> } };

export type GalleryQueryVariables = Exact<{
  id: Scalars['String'];
  contentItemTypes?: InputMaybe<Array<GalleryContentReferenceType> | GalleryContentReferenceType>;
  contentItemSort?: InputMaybe<GalleryContentItemSort>;
  contentPageRequest?: InputMaybe<PageRequest>;
  collaboratorPageRequest?: InputMaybe<PageRequest>;
}>;


export type GalleryQuery = { __typename?: 'Query', gallery?: { __typename?: 'Gallery', id: string, name: string, isSecret: boolean, numberOfPosts: number, numberOfNewsPosts: number, numberOfAds: number, numberOfContents: number, contentLastUpdatedAt: any, owner?: { __typename?: 'Owner', userId?: string | null, companyId?: string | null } | null, collaborators: { __typename?: 'GalleryCollaboratorPage', totalCount: number, items: Array<{ __typename?: 'GalleryCollaborator', user?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null, company?: { __typename?: 'Company', id: string, initials?: string | null, name: string, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null }> }, contentItems: { __typename?: 'GalleryContentItemPage', totalCount: number }, viewerPermissions: { __typename?: 'GalleryViewerPermissions', canEditContent: boolean, canDelete: boolean, canManage: boolean }, viewerProperties: { __typename?: 'GalleryViewerProperties', userStatus: GalleryUserStatus } } | null };

export type GalleryCollaboratorsQueryVariables = Exact<{
  id: Scalars['String'];
  pageRequest?: InputMaybe<PageRequest>;
  sort?: InputMaybe<GalleryCollaboratorSort>;
}>;


export type GalleryCollaboratorsQuery = { __typename?: 'Query', gallery?: { __typename?: 'Gallery', id: string, collaborators: { __typename?: 'GalleryCollaboratorPage', totalCount: number, items: Array<{ __typename?: 'GalleryCollaborator', user?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null, company?: { __typename?: 'Company', id: string, initials?: string | null, name: string, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null, invitedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null }> } } | null };

export type GalleryClosedInvitationsQueryVariables = Exact<{
  id: Scalars['String'];
  pageRequest?: InputMaybe<PageRequest>;
  statuses?: InputMaybe<Array<GalleryInvitationStatus> | GalleryInvitationStatus>;
  includeExpired?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<GalleryInvitationSort>;
}>;


export type GalleryClosedInvitationsQuery = { __typename?: 'Query', gallery?: { __typename?: 'Gallery', id: string, invitations: { __typename?: 'GalleryInvitationPage', totalCount: number, items: Array<{ __typename?: 'GalleryInvitation', id: string, status: GalleryInvitationStatus, createdBy: { __typename?: 'User', id: string, fullName?: string | null }, invitee?: { __typename?: 'GalleryInvitee', type: GalleryInviteeType, value: { __typename?: 'EmailGalleryInviteeValue', emailAddress: string } | { __typename?: 'UserGalleryInviteeValue', user: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } } } | null }> } } | null };

export type GalleryContentQueryVariables = Exact<{
  id: Scalars['String'];
  contentItemTypes?: InputMaybe<Array<GalleryContentReferenceType> | GalleryContentReferenceType>;
  contentItemSort?: InputMaybe<GalleryContentItemSort>;
  contentPageRequest?: InputMaybe<PageRequest>;
}>;


export type GalleryContentQuery = { __typename?: 'Query', gallery?: { __typename?: 'Gallery', id: string, contentItems: { __typename?: 'GalleryContentItemPage', totalCount: number, items: Array<{ __typename?: 'GalleryContentItem', id: string, reference: { __typename?: 'GalleryContentReference', type: GalleryContentReferenceType, value: { __typename: 'Ad', id: string, type: AdTypes, newProperty?: boolean | null, title?: string | null, isUserFavorite: boolean, isUserAffiliatedCompanyFavorite: boolean, livingArea?: number | null, surfaceArea?: number | null, price?: number | null, bedroomNumber?: number | null, roomNumber?: number | null, interOffice: boolean, createdAt: any, isNew: boolean, isPriceDecreasing: boolean, propertyType: string, status?: AdStatuses | null, rent?: number | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, homadataEvaluation?: { __typename?: 'HomadataEvaluation', id: string, requestDate?: string | null, confidenceMin: number, confidenceMax: number } | null, address: { __typename?: 'Address', id: string, cityName?: string | null }, owner?: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, user?: { __typename?: 'User', id: string, isRealEstatesTrades: boolean, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, company?: { __typename?: 'Company', id: string, name: string, website?: string | null } | null } | null, mainPublisher?: { __typename?: 'Publisher', id: string, name: string, url: string } | null, stats: { __typename?: 'Stats', id: string, viewCount: number, favoriteCount: number } } | { __typename: 'NewsPost', id: string, tags?: string | null, title?: string | null, likedByCurrentUser: boolean, isUserFavorite: boolean, isUserAffiliatedCompanyFavorite: boolean, totalLikes: number, createdAt: any, updatedAt: any, pubDate: any, source?: string | null, newsPostLink?: string | null, featuredCategory?: { __typename?: 'NewsCategory', id: string, nameEn: string, nameFr: string, icon: string } | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, stats: { __typename?: 'Stats', id: string, viewCount: number, favoriteCount: number, contactCount: number } } | { __typename: 'Post', id: string, isUserFavorite: boolean, isUserAffiliatedCompanyFavorite: boolean, message?: string | null, createdAt: any, totalComments?: number | null, totalLikes: number, likedByCurrentUser: boolean, iHaveOwnership: boolean, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, project?: { __typename?: 'Project', id: string, name: string, description?: string | null, city: { __typename?: 'City', id: string, name: string }, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, owner: { __typename?: 'Owner', user?: { __typename?: 'User', id: string } | null } } | null, owner?: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, isFollowed: boolean, isRealEstatesTrades: boolean, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, company?: { __typename?: 'Company', id: string, name: string, website?: string | null } | null } | null } } }> } } | null };

export type GenerateAppLinkQueryVariables = Exact<{
  type: AppLinkType;
  params?: InputMaybe<Array<AppLinkParamsInput> | AppLinkParamsInput>;
}>;


export type GenerateAppLinkQuery = { __typename?: 'Query', generateAppLink?: { __typename?: 'AppLink', type: AppLinkType, fullUrl: string, shortUrl: string } | null };

export type GroupCompaniesQueryVariables = Exact<{
  groupId: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  radiusKm?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  cityId?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  onlyWithRecommendations?: InputMaybe<Scalars['Boolean']>;
}>;


export type GroupCompaniesQuery = { __typename?: 'Query', groupCompanies?: { __typename?: 'GroupCompaniesResponse', total: number, results: Array<{ __typename?: 'Company', id: string, name: string, label?: CompanyLabel | null, numberOfRatings: number, averageRating: number, companyMembersWhoAreInMyContactsCount?: number | null, recommendationsReceivedCount: number, companyAndMembersRecommendationsCount: number, group?: { __typename?: 'Company', id: string, name: string } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, address?: { __typename?: 'Address', id: string, zipCode?: string | null, description: string, cityName?: string | null, city?: { __typename?: 'City', id: string, name: string } | null } | null } | null> } | null };

export type HomadataQueryVariables = Exact<{
  lng: Scalars['Float'];
  lat: Scalars['Float'];
  isOnEstimationFlow?: InputMaybe<Scalars['Boolean']>;
  propertyType: PropertyTypes;
  livingArea: Scalars['Float'];
  landArea?: InputMaybe<Scalars['Float']>;
  roomNumber?: InputMaybe<Scalars['Int']>;
  bedroomNumber?: InputMaybe<Scalars['Int']>;
  floorPosition?: InputMaybe<Scalars['Int']>;
  floorNumber?: InputMaybe<Scalars['Int']>;
  constructionYear?: InputMaybe<Scalars['Int']>;
}>;


export type HomadataQuery = { __typename?: 'Query', homadata?: { __typename?: 'HomadataEstimationResponse', atypical: number, confidenceIndex: number, confidenceMax: number, confidenceMin: number, fai: number, faiRate: number, nego: number, negoRate: number, predictedPrice: number, priceM2: number, priceMax: number, priceMin: number, virtualPrice: number, virtualPriceAdjustment: number, virtualPriceMax: number, virtualPriceMin: number } | null };

export type HomeLoanQueryVariables = Exact<{
  housePrice: Scalars['Float'];
  intakeAmount: Scalars['Float'];
  interestRate: Scalars['Float'];
  yearNumber: Scalars['Int'];
}>;


export type HomeLoanQuery = { __typename?: 'Query', homeLoan?: { __typename?: 'LoanAmount', monthNumber: number, totalLoanAmount: number, monthlyPayment: number, totalInterestAmount: number, totalPrice: number, intakePercent: number, totalInterests: number, totalLoanedAmount: number } | null };

export type InvitationEmailParametersQueryVariables = Exact<{ [key: string]: never; }>;


export type InvitationEmailParametersQuery = { __typename?: 'Query', subject?: string | null, body?: string | null };

export type JobOfferQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type JobOfferQuery = { __typename?: 'Query', jobOffer?: { __typename?: 'JobOffer', id: string, companyName: string, title: string, description?: string | null, profile?: string | null, emailAddress: string, numberOfJobOfferApplications: number, isHidden: boolean, updatedAt: any, city: { __typename?: 'City', id: string, name: string, googlePlaceId?: string | null, countryShort: string }, jobType: { __typename?: 'JobType', id: string, fr?: string | null, en?: string | null }, company: { __typename?: 'Company', id: string, name: string } } | null };

export type JobOffersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
}>;


export type JobOffersQuery = { __typename?: 'Query', jobOffers?: Array<{ __typename?: 'JobOffer', id: string, companyName: string, title: string, description?: string | null, profile?: string | null, emailAddress: string, isHidden: boolean, createdAt: any, updatedAt: any, company: { __typename?: 'Company', id: string, name: string }, jobType: { __typename?: 'JobType', fr?: string | null, en?: string | null }, city: { __typename?: 'City', id: string, name: string, googlePlaceId?: string | null, countryShort: string } }> | null };

export type JobTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type JobTypesQuery = { __typename?: 'Query', jobTypes?: Array<{ __typename?: 'JobType', id: string, fr?: string | null, en?: string | null }> | null };

export type LegalLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type LegalLinksQuery = { __typename?: 'Query', generalConditionsBasic?: string | null, generalConditionsPro?: string | null, legalNotice?: string | null, privacyPolicy?: string | null, cookiePolicy?: string | null, contact?: string | null };

export type LocalPriceEvolutionQueryVariables = Exact<{
  zipCode: Scalars['String'];
  cityName: Scalars['String'];
  propertyType: LocalPriceEvolutionPropertyType;
}>;


export type LocalPriceEvolutionQuery = { __typename?: 'Query', localPriceEvolution?: { __typename?: 'LocalPriceEvolutionResponse', tendency: number, dataPoints: Array<{ __typename?: 'LocalPriceEvolutionDataPoint', year: string, month: string, price: number }> } | null };

export type LocateQueryVariables = Exact<{
  cityName?: InputMaybe<Scalars['String']>;
  fallbackToParis?: InputMaybe<Scalars['Boolean']>;
}>;


export type LocateQuery = { __typename?: 'Query', locate?: { __typename?: 'City', id: string, name: string, lat: number, lng: number } | null };

export type MembersAdsQueryVariables = Exact<{
  companyId: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<InputMaybe<AdStatuses>> | InputMaybe<AdStatuses>>;
}>;


export type MembersAdsQuery = { __typename?: 'Query', membersAds?: Array<{ __typename?: 'Ad', id: string, type: AdTypes, title?: string | null, isUserFavorite: boolean, isUserAffiliatedCompanyFavorite: boolean, livingArea?: number | null, landArea?: number | null, surfaceArea?: number | null, price?: number | null, rent?: number | null, bedroomNumber?: number | null, roomNumber?: number | null, interOffice: boolean, createdAt: any, isNew: boolean, isPriceDecreasing: boolean, propertyType: string, status?: AdStatuses | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, address: { __typename?: 'Address', id: string, cityName?: string | null, zipCode?: string | null }, stats: { __typename?: 'Stats', id: string, impressionCount: number, viewCount: number, favoriteCount: number, contactCount: number } }> | null };

export type MobileStoreLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type MobileStoreLinksQuery = { __typename?: 'Query', googlePlay?: string | null, appleStore?: string | null };

export type MutualContactsQueryVariables = Exact<{
  userId: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  match?: InputMaybe<Match>;
  excludeFromResultsUserId?: InputMaybe<Scalars['String']>;
}>;


export type MutualContactsQuery = { __typename?: 'Query', mutualContacts?: { __typename?: 'UsersResponseWithTotal', total?: number | null, results?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, customActivity?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null> | null } | null };

export type MyContactsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  statuses?: InputMaybe<Array<InputMaybe<ContactStatus>> | InputMaybe<ContactStatus>>;
  match?: InputMaybe<Match>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type MyContactsQuery = { __typename?: 'Query', myContacts?: Array<{ __typename?: 'User', id: string, contactStatusV2?: ContactStatus | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, isProfessionnal: boolean, sendbirdUserId?: string | null, customActivity?: string | null, numberOfRatings: number, averageRating: number, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, number: string, phoneCode: string } | null, companyToDisplay?: { __typename?: 'Company', id: string, name: string } | null }> | null };

export type MyDraftAdQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDraftAdQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, draftAd?: { __typename?: 'Ad', id: string, type: AdTypes, isHiddingCompleteAddress: boolean, propertyType: string, constructionYear?: number | null, title?: string | null, description?: string | null, interOffice: boolean, floorPosition?: number | null, livingArea?: number | null, landArea?: number | null, proxyLng: number, proxyLat: number, bedroomNumber?: number | null, roomNumber?: number | null, floorNumber?: number | null, heatType?: HeatTypes | null, consumption?: string | null, emissions?: string | null, assets?: Array<string | null> | null, surfaceArea?: number | null, propertyState?: PropertyState | null, commonAreasState?: CommonAreasState | null, propertyPurposeEstimation?: PropertyPurposeEstimation | null, propertyResidenceType?: PropertyResidenceType | null, userIsOwner?: boolean | null, contactConsent?: boolean | null, status?: AdStatuses | null, updatedAt: any, availableDate?: number | null, monthlyCharges?: number | null, inventory?: number | null, fees?: number | null, furnished?: boolean | null, guarantees?: string | null, inclusions?: string | null, price?: number | null, commissionRate?: number | null, rent?: number | null, rooms?: string | null, dimensionLength?: number | null, servicedLand?: YesNoNaOptions | null, constructibleLand?: YesNoNaOptions | null, numberOfVehicles?: number | null, dimensionWidth?: number | null, dimensionHeight?: number | null, coOwnership?: boolean | null, coOwnershipNumberOfLots?: number | null, coOwnershipOngoing?: YesNoOptions | null, coOwnershipYearlyCharge?: number | null, saleFeeType?: SaleFeeType | null, saleFeeBuyerRate?: number | null, saleFeeBuyerPrice?: number | null, showSaleFeeBuyerPrice?: boolean | null, priceWithoutSaleFee?: number | null, isInaccurateAddress: boolean, address: { __typename?: 'Address', id: string, placeId?: string | null, lat: number, lng: number, description: string, zipCode?: string | null, cityName?: string | null, country?: string | null }, homadataEvaluation?: { __typename?: 'HomadataEvaluation', confidenceMin: number, confidenceMax: number, predictedPrice?: number | null, confidenceIndex?: number | null, requestDate?: string | null } | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> } | null } };

export type MyPendingClosedGalleryInvitationQueryVariables = Exact<{
  galleryId: Scalars['ID'];
}>;


export type MyPendingClosedGalleryInvitationQuery = { __typename?: 'Query', myPendingClosedGalleryInvitation?: { __typename?: 'GalleryInvitation', id: string, type: GalleryInvitationType, status: GalleryInvitationStatus, role: GalleryRole, createdAt: any, scope: { __typename?: 'GalleryDescriptor', id: string, name: string, isSecret: boolean, statistics: { __typename?: 'GalleryStatistics', contentItemCount: number }, owner: { __typename?: 'Owner', user?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null, company?: { __typename?: 'Company', id: string, name: string, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null } }, createdBy: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } } | null };

export type MyPendingCompanyMembershipInvitationsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  side?: InputMaybe<PendingInvitationSide>;
  type?: InputMaybe<PendingInvitationType>;
}>;


export type MyPendingCompanyMembershipInvitationsQuery = { __typename?: 'Query', myPendingInvitations?: Array<{ __typename: 'GroupInvitation', id: string, status: InvitationStatus, groupInvitationDirection: GroupInvitationDirection, company: { __typename?: 'Company', id: string, name: string, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, capabilities?: { __typename?: 'CompanyCapatibilities', isAbleToHaveEstateCompanies: boolean } | null }, group: { __typename?: 'Company', id: string, name: string, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, capabilities?: { __typename?: 'CompanyCapatibilities', isAbleToHaveEstateCompanies: boolean } | null } } | { __typename: 'Invitation', id: string, status: InvitationStatus, invitationDirection: InvitationDirection, company: { __typename?: 'Company', id: string, name: string, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, capabilities?: { __typename?: 'CompanyCapatibilities', isAbleToHaveEstateCompanies: boolean } | null }, user: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, customActivity?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } }> | null };

export type MyPendingContactsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type MyPendingContactsQuery = { __typename?: 'Query', myPendingContacts?: Array<{ __typename?: 'PendingContact', id: string, status: string, user: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, customActivity?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } }> | null };

export type MyPendingGalleryInvitationsQueryVariables = Exact<{
  pageRequest?: InputMaybe<PageRequest>;
  sort?: InputMaybe<GalleryInvitationSort>;
}>;


export type MyPendingGalleryInvitationsQuery = { __typename?: 'Query', myGalleryInvitations: { __typename?: 'GalleryInvitationPage', totalCount: number, items: Array<{ __typename?: 'GalleryInvitation', id: string, type: GalleryInvitationType, status: GalleryInvitationStatus, role: GalleryRole, createdAt: any, scope: { __typename?: 'GalleryDescriptor', id: string, name: string }, invitee?: { __typename?: 'GalleryInvitee', type: GalleryInviteeType, value: { __typename?: 'EmailGalleryInviteeValue', emailAddress: string } | { __typename?: 'UserGalleryInviteeValue', user: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } } } | null, createdBy: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } }> } };

export type MyRecommandationsCardQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
}>;


export type MyRecommandationsCardQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, recommendationsReceivedCount: number }, recommendations?: Array<{ __typename?: 'Recommendation', id: string, recommendingUser: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } }> | null };

export type NewsCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsCategoriesQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, newsCategories: Array<{ __typename?: 'NewsCategory', id: string }> }, newsCategories: Array<{ __typename?: 'NewsCategory', id: string, icon: string, nameFr: string, nameEn: string, createdAt: any }>, newsCategoriesRecommendations: Array<{ __typename?: 'NewsCategory', id: string, icon: string, nameFr: string, nameEn: string, createdAt: any }> };

export type NewsFeedQueryVariables = Exact<{
  skipPosts?: InputMaybe<Scalars['Int']>;
  skipNewsPosts?: InputMaybe<Scalars['Int']>;
  skipAds?: InputMaybe<Scalars['Int']>;
}>;


export type NewsFeedQuery = { __typename?: 'Query', newsFeed?: { __typename?: 'NewsFeedResponse', hasMore: boolean, postsCount: number, newsPostsCount: number, adsCount: number, results: Array<{ __typename: 'Ad', id: string, title?: string | null, livingArea?: number | null, surfaceArea?: number | null, price?: number | null, status?: AdStatuses | null, bedroomNumber?: number | null, roomNumber?: number | null, createdAt: any, isNew: boolean, isPriceDecreasing: boolean, isUserFavorite: boolean, isUserAffiliatedCompanyFavorite: boolean, iHaveOwnership: boolean, type: AdTypes, propertyType: string, rent?: number | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType, isTranscoding?: boolean | null } | null>, address: { __typename?: 'Address', id: string, zipCode?: string | null, cityName?: string | null }, owner?: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType, isTranscoding?: boolean | null } | null, user?: { __typename?: 'User', id: string } | null, company?: { __typename?: 'Company', id: string, name: string, label?: CompanyLabel | null, customActivity?: string | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null } | null } | null, stats: { __typename?: 'Stats', id: string, viewCount: number, favoriteCount: number, contactCount: number } } | { __typename: 'NewsPost', id: string, tags?: string | null, title?: string | null, description?: string | null, shortDescription?: string | null, pubDate: any, likedByCurrentUser: boolean, isUserFavorite: boolean, isUserAffiliatedCompanyFavorite: boolean, totalLikes: number, createdAt: any, updatedAt: any, source?: string | null, newsPostLink?: string | null, featuredCategory?: { __typename?: 'NewsCategory', id: string, nameEn: string, nameFr: string, icon: string } | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType, isTranscoding?: boolean | null } | null>, stats: { __typename?: 'Stats', id: string, viewCount: number, favoriteCount: number, contactCount: number } } | { __typename: 'Post', id: string, isUserFavorite: boolean, isUserAffiliatedCompanyFavorite: boolean, iHaveOwnership: boolean, message?: string | null, createdAt: any, totalComments?: number | null, totalLikes: number, likedByCurrentUser: boolean, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType, isTranscoding?: boolean | null } | null>, ad?: { __typename?: 'Ad', id: string, livingArea?: number | null, price?: number | null, bedroomNumber?: number | null, roomNumber?: number | null, propertyType: string, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType, isTranscoding?: boolean | null } | null> } | null, newsPost?: { __typename?: 'NewsPost', id: string, title?: string | null, categories?: Array<{ __typename?: 'NewsCategory', id: string, nameEn: string, nameFr: string, icon: string }> | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType, isTranscoding?: boolean | null } | null> } | null, project?: { __typename?: 'Project', id: string, name: string, description?: string | null, city: { __typename?: 'City', id: string, name: string }, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType, isTranscoding?: boolean | null } | null> } | null, owner?: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, isRealEstatesTrades: boolean, isFollowed: boolean, customActivity?: string | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, company?: { __typename?: 'Company', id: string, name: string, website?: string | null, label?: CompanyLabel | null, customActivity?: string | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null, capabilities?: { __typename?: 'CompanyCapatibilities', allowedContentTypesToManage?: Array<ContentType | null> | null } | null } | null } | null }> } | null };

export type NewsPostQueryVariables = Exact<{
  newsPostId: Scalars['String'];
}>;


export type NewsPostQuery = { __typename?: 'Query', newsPost?: { __typename?: 'NewsPost', id: string, tags?: string | null, title?: string | null, shortDescription?: string | null, description?: string | null, pubDate: any, likedByCurrentUser: boolean, isUserFavorite: boolean, isUserAffiliatedCompanyFavorite: boolean, totalLikes: number, createdAt: any, updatedAt: any, source?: string | null, sourceLink?: string | null, newsPostLink?: string | null, nofollow: boolean, featuredCategory?: { __typename?: 'NewsCategory', id: string, nameEn: string, nameFr: string, icon: string } | null, categories?: Array<{ __typename?: 'NewsCategory', id: string, nameEn: string, nameFr: string, icon: string }> | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType, embedSource?: EmbedSource | null, embedId?: string | null } | null>, stats: { __typename?: 'Stats', id: string, viewCount: number, favoriteCount: number, contactCount: number } } | null };

export type NewsPostLikesQueryVariables = Exact<{
  postId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type NewsPostLikesQuery = { __typename?: 'Query', newsPostLikes?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, isProfessionnal: boolean, customActivity?: string | null, isRealEstatesTrades: boolean, isFollowed: boolean, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null> | null };

export type NotificationsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications?: { __typename?: 'NotificationsResponse', total?: number | null, results?: Array<{ __typename?: 'Notification', id: string, createdAt: any, viewed: boolean, link: string, nameToDisplay?: string | null, companyName?: string | null, count?: string | null, type: string, linkedContentId?: string | null, notifyingUser?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, affiliatedCompany?: { __typename?: 'Company', id: string, name: string, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null } | null } | null> | null } | null };

export type PagesJaunesProQueryVariables = Exact<{
  proId: Scalars['String'];
}>;


export type PagesJaunesProQuery = { __typename?: 'Query', pagesJaunesProWithImagesUrls?: { __typename?: 'PagesJaunesPro', proId: string, name: string, activityLabel?: string | null, pagesJaunesProType: PagesJaunesProType, canBeClaimedByCurrentUser: boolean, woopenCompanyId?: string | null, pageUrl?: string | null, ratingsPageUrl?: string | null, description?: string | null, email?: string | null, foundationYear?: string | null, siret?: string | null, averageRating?: number | null, numberOfRatings?: number | null, thumbnailPath?: string | null, imagePath?: string | null, website?: { __typename?: 'PagesJaunesWebsite', url?: string | null, label?: string | null } | null, address?: { __typename?: 'PagesJaunesAddress', cityName?: string | null, street?: string | null, zipCode?: string | null, district?: string | null, country?: string | null, addressDescription?: string | null, lat?: number | null, lng?: number | null } | null, phoneNumber?: { __typename?: 'PagesJaunesPhoneNumber', number: string, countryCode: string, phoneCode: string } | null, images: Array<{ __typename?: 'PagesJaunesImage', id: string, imagePath?: string | null }> } | null };

export type ParsedLinkQueryVariables = Exact<{
  link: Scalars['String'];
}>;


export type ParsedLinkQuery = { __typename?: 'Query', parsedLink?: { __typename?: 'ParsedLinkResponse', publisher?: string | null, title?: string | null, image?: string | null } | null };

export type PendingOpenGalleryInvitationQueryVariables = Exact<{
  invitationId: Scalars['ID'];
  galleryId: Scalars['ID'];
}>;


export type PendingOpenGalleryInvitationQuery = { __typename?: 'Query', pendingOpenGalleryInvitation?: { __typename?: 'GalleryInvitation', id: string, type: GalleryInvitationType, status: GalleryInvitationStatus, role: GalleryRole, createdAt: any, scope: { __typename?: 'GalleryDescriptor', id: string, name: string, isSecret: boolean, statistics: { __typename?: 'GalleryStatistics', contentItemCount: number }, owner: { __typename?: 'Owner', user?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null, company?: { __typename?: 'Company', id: string, name: string, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null } }, createdBy: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } } | null };

export type PhoneContactsSyncQueryVariables = Exact<{ [key: string]: never; }>;


export type PhoneContactsSyncQuery = { __typename?: 'Query', phoneContactsSync?: { __typename?: 'PhoneContactSync', state: PhoneContactSyncState } | null };

export type PhoneContactsWithTotalQueryVariables = Exact<{
  isSynchronized?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  match?: InputMaybe<Match>;
  query?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  onlyWoopenContacts?: InputMaybe<Scalars['Boolean']>;
  onlyNonWoopenContacts?: InputMaybe<Scalars['Boolean']>;
}>;


export type PhoneContactsWithTotalQuery = { __typename?: 'Query', phoneContactsWithTotal?: { __typename?: 'PhoneContactResponse', numberOfPhoneContacts: number, phoneContacts?: Array<{ __typename?: 'PhoneContact', id: string, firstName?: string | null, lastName?: string | null, initials?: string | null, isSynchronized: boolean, localPhoneContactId: string, jsonContact?: any | null, woopenUser?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, contactStatusV2?: ContactStatus | null, isRealEstatesTrades: boolean, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null }> | null } | null };

export type PostQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type PostQuery = { __typename?: 'Query', post?: { __typename?: 'Post', id: string, message?: string | null, createdAt: any, totalComments?: number | null, totalLikes: number, likedByCurrentUser: boolean, iHaveOwnership: boolean, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, newsPost?: { __typename?: 'NewsPost', id: string, title?: string | null, categories?: Array<{ __typename?: 'NewsCategory', id: string, nameEn: string, nameFr: string, icon: string }> | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType, isTranscoding?: boolean | null } | null> } | null, ad?: { __typename?: 'Ad', id: string, livingArea?: number | null, price?: number | null, bedroomNumber?: number | null, roomNumber?: number | null, propertyType: string, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> } | null, project?: { __typename?: 'Project', id: string, name: string, description?: string | null, city: { __typename?: 'City', id: string, name: string }, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, owner: { __typename?: 'Owner', user?: { __typename?: 'User', id: string } | null } } | null, owner?: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, user?: { __typename?: 'User', id: string, isFollowed: boolean, isRealEstatesTrades: boolean, customActivity?: string | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, company?: { __typename?: 'Company', id: string, name: string, website?: string | null, label?: CompanyLabel | null, customActivity?: string | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null } | null } | null } | null };

export type PostCommentsQueryVariables = Exact<{
  postId: Scalars['String'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type PostCommentsQuery = { __typename?: 'Query', comments?: Array<{ __typename?: 'Comment', id: string, content: string, createdAt: any, likedByCurrentUser: boolean, iHaveOwnership: boolean, usersWhoLikes?: Array<{ __typename?: 'User', id: string } | null> | null, owner: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, createdAt: any, userId?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, user?: { __typename?: 'User', id: string, isFollowed: boolean, customActivity?: string | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, company?: { __typename?: 'Company', id: string, name: string } | null } }> | null };

export type PostLikesQueryVariables = Exact<{
  postId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type PostLikesQuery = { __typename?: 'Query', postLikes?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, isProfessionnal: boolean, customActivity?: string | null, isRealEstatesTrades: boolean, isFollowed: boolean, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null> | null };

export type PostsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type PostsQuery = { __typename?: 'Query', posts?: Array<{ __typename?: 'Post', id: string, isUserFavorite: boolean, isUserAffiliatedCompanyFavorite: boolean, message?: string | null, createdAt: any, totalComments?: number | null, totalLikes: number, likedByCurrentUser: boolean, iHaveOwnership: boolean, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, ad?: { __typename?: 'Ad', id: string, livingArea?: number | null, price?: number | null, bedroomNumber?: number | null, roomNumber?: number | null, propertyType: string, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> } | null, newsPost?: { __typename?: 'NewsPost', id: string, title?: string | null, categories?: Array<{ __typename?: 'NewsCategory', id: string, nameEn: string, nameFr: string, icon: string }> | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> } | null, project?: { __typename?: 'Project', id: string, name: string, description?: string | null, city: { __typename?: 'City', id: string, name: string }, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, owner: { __typename?: 'Owner', user?: { __typename?: 'User', id: string } | null } } | null, owner?: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, isBlocked: boolean, isRealEstatesTrades: boolean, isFollowed: boolean, customActivity?: string | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, company?: { __typename?: 'Company', id: string, name: string, website?: string | null, label?: CompanyLabel | null, customActivity?: string | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null } | null } | null }> | null };

export type ProjectQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type ProjectQuery = { __typename?: 'Query', project?: { __typename?: 'ProjectResponse', project?: { __typename?: 'Project', id: string, name: string, description?: string | null, city: { __typename?: 'City', id: string, name: string, googlePlaceId?: string | null, countryShort: string }, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, owner: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, isRealEstatesTrades: boolean, affiliatedCompany?: { __typename?: 'Company', id: string, name: string } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, company?: { __typename?: 'Company', id: string, name: string, website?: string | null } | null } } | null } | null };

export type ProjectsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type ProjectsQuery = { __typename?: 'Query', projects?: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, city: { __typename?: 'City', id: string, name: string, googlePlaceId?: string | null, countryShort: string }, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, owner: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, isRealEstatesTrades: boolean, affiliatedCompany?: { __typename?: 'Company', id: string, name: string } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, company?: { __typename?: 'Company', id: string, name: string, website?: string | null } | null } }> | null };

export type QuickSignupCompanyQueryVariables = Exact<{
  quickSignupCompanyId: Scalars['String'];
}>;


export type QuickSignupCompanyQuery = { __typename?: 'Query', quickSignupCompany: { __typename?: 'QuickSignupCompany', id: string, name: string, description?: string | null, email?: string | null, siretNumber?: string | null, isAgency?: boolean | null, website?: string | null, initials?: string | null, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string, phoneCode: string } | null, address?: { __typename?: 'Address', id: string, description: string, lng: number, lat: number, cityName?: string | null, zipCode?: string | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, activity?: { __typename?: 'Activity', labelKey: string, id: string } | null } };

export type QuickSignupUserQueryVariables = Exact<{
  quickSignupUserId: Scalars['String'];
  isPro?: InputMaybe<Scalars['Boolean']>;
}>;


export type QuickSignupUserQuery = { __typename?: 'Query', quickSignupUser: { __typename?: 'QuickSignupUser', id: string, email: string, name?: string | null, phoneNumber?: string | null, agencyName?: string | null } };

export type RatingsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  withHiddenRatings?: InputMaybe<Scalars['Boolean']>;
  includeCurrentUserRatings?: InputMaybe<Scalars['Boolean']>;
}>;


export type RatingsQuery = { __typename?: 'Query', ratings?: { __typename?: 'RatingsResponse', averageRating?: number | null, numberOfRatings?: number | null, allRatings?: Array<{ __typename?: 'Rating', id: string, value: number, comment?: string | null, createdAt: any, isHidden: boolean, giver?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, createdAt: any, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null } | null> | null } | null };

export type RecommendationsReceivedQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  userId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<RecommendationStatus>> | InputMaybe<RecommendationStatus>>;
}>;


export type RecommendationsReceivedQuery = { __typename?: 'Query', recommendations?: Array<{ __typename?: 'Recommendation', id: string, status: RecommendationStatus, recommendingUser: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, customActivity?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } }> | null };

export type RequestRecommendationsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  recommendingUserId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<RecommendationStatus>> | InputMaybe<RecommendationStatus>>;
}>;


export type RequestRecommendationsQuery = { __typename?: 'Query', recommendations?: Array<{ __typename?: 'Recommendation', id: string, status: RecommendationStatus, createdAt: any, recommendedOwner: { __typename?: 'Owner', id: string, user?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, customActivity?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null } }> | null };

export type RecommendingUsersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<UserType>;
}>;


export type RecommendingUsersQuery = { __typename?: 'Query', recommendingUsers?: { __typename?: 'UsersResponseWithTotal', total?: number | null, results?: Array<{ __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, mutualContactsCount?: number | null, customActivity?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null> | null } | null };

export type SavedSearchesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SavedSearchesQuery = { __typename?: 'Query', savedSearches: { __typename?: 'SavedSearchesResponseWithTotal', total: number, results: Array<{ __typename?: 'Search', parameters: string, isFirstSavedAdSearch: boolean, name: string, lastViewedAt: any, id: string, emailNotificationsEnabled: boolean, placeGeometry?: { __typename?: 'GeometryWithSource', type?: GeometryType | null, coordinates?: any | null, source: GeometrySource } | null }> } };

export type SearchQueryVariables = Exact<{
  searchId: Scalars['String'];
}>;


export type SearchQuery = { __typename?: 'Query', search?: { __typename?: 'Search', id: string, name: string, parameters: string, lastViewedAt: any, isFirstSavedAdSearch: boolean, emailNotificationsEnabled: boolean, placeGeometry?: { __typename?: 'GeometryWithSource', type?: GeometryType | null, coordinates?: any | null, source: GeometrySource } | null } | null };

export type SearchAdsCountSinceLastViewedQueryVariables = Exact<{
  searchId?: InputMaybe<Scalars['String']>;
}>;


export type SearchAdsCountSinceLastViewedQuery = { __typename?: 'Query', searchAdsCountSinceLastViewed?: number | null };

export type SearchAllUsersWithTotalQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SearchAllUsersWithTotalQuery = { __typename?: 'Query', searchAllUsersWithTotal?: { __typename?: 'UsersResponseWithTotal', total?: number | null, results?: Array<{ __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, isProfessionnal: boolean, sendbirdUserId?: string | null, customActivity?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, recommendationToMe?: { __typename?: 'Recommendation', id: string, status: RecommendationStatus } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null> | null } | null };

export type SearchCityQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type SearchCityQuery = { __typename?: 'Query', searchCities?: Array<{ __typename?: 'City', id: string, name: string, lat: number, lng: number, zipCodes?: Array<string | null> | null, country: string, countryShort: string }> | null };

export type SearchCommunityQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  activityId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['String']>;
  cityRadiusKm?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  communityEntityTypes?: InputMaybe<Array<InputMaybe<CommunityEntityType>> | InputMaybe<CommunityEntityType>>;
}>;


export type SearchCommunityQuery = { __typename?: 'Query', searchCommunity?: { __typename?: 'CommunitySearchResponse', total: number, results: Array<{ __typename: 'Company', id: string, name: string, label?: CompanyLabel | null, isFollowingCompany: boolean, customActivity?: string | null, averageRating: number, numberOfRatings: number, companyAndMembersRecommendationsCount: number, companyMembersWhoAreInMyContactsCount?: number | null, capabilities?: { __typename?: 'CompanyCapatibilities', allowedContentTypesToManage?: Array<ContentType | null> | null, allowedContentTypesToDisplay?: Array<ContentType | null> | null, allowedLabels?: Array<CompanyLabel | null> | null, isAbleToSyncCrm: boolean, isAbleToHaveDirectors: boolean, isAbleToHaveEstateCompanies: boolean, hasPublicPage: boolean } | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null, contactUser?: { __typename?: 'User', id: string } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, address?: { __typename?: 'Address', id: string, zipCode?: string | null, cityName?: string | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, showcase?: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> | null } | { __typename: 'PagesJaunesProSearchResult', id: string, woopenCompanyId?: string | null, merchantId: string, merchantName: string, thumbnailPath?: string | null, activityLabel?: string | null, imagePath?: string | null, contactEmail?: string | null, averagePJRating?: number | null, numberOfPJRatings?: number | null, images: Array<{ __typename?: 'PagesJaunesImage', id: string, imagePath?: string | null }>, phoneNumber?: { __typename?: 'PagesJaunesPhoneNumber', number: string, phoneCode: string, countryCode: string } | null, address?: { __typename?: 'PagesJaunesAddress', cityName?: string | null, street?: string | null, zipCode?: string | null, district?: string | null, country?: string | null, addressDescription?: string | null } | null } | { __typename: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, customActivity?: string | null, recommendationsReceivedCount: number, numberOfRatings: number, averageRating: number, isFollowed: boolean, mutualContactsCount?: number | null, contactStatusV2?: ContactStatus | null, isProfessionnal: boolean, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, showcase?: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> | null, city?: { __typename?: 'City', id: string, name: string, zipCodes?: Array<string | null> | null } | null }> } | null };

export type SearchCompaniesForInvitationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
}>;


export type SearchCompaniesForInvitationsQuery = { __typename?: 'Query', searchCompaniesForInvitations?: { __typename?: 'CompaniesResponseWithTotal', total?: number | null, results?: Array<{ __typename?: 'Company', id: string, name: string, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null> | null } | null };

export type SearchCompaniesToJoinQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  shouldIncludePJPros?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchCompaniesToJoinQuery = { __typename?: 'Query', searchCompaniesToJoin?: { __typename?: 'CompanyOrPagesJaunesProSearchResponse', total: number, results: Array<{ __typename: 'Company', id: string, name: string, label?: CompanyLabel | null, isFollowingCompany: boolean, customActivity?: string | null, averageRating: number, numberOfRatings: number, companyAndMembersRecommendationsCount: number, companyMembersWhoAreInMyContactsCount?: number | null, capabilities?: { __typename?: 'CompanyCapatibilities', allowedContentTypesToManage?: Array<ContentType | null> | null, allowedContentTypesToDisplay?: Array<ContentType | null> | null, allowedLabels?: Array<CompanyLabel | null> | null, isAbleToSyncCrm: boolean, isAbleToHaveDirectors: boolean, isAbleToHaveEstateCompanies: boolean, hasPublicPage: boolean } | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null, contactUser?: { __typename?: 'User', id: string } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, address?: { __typename?: 'Address', id: string, zipCode?: string | null, cityName?: string | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, showcase?: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> | null } | { __typename: 'PagesJaunesProSearchResult', id: string, pagesJaunesProType: PagesJaunesProType, woopenCompanyId?: string | null, merchantId: string, merchantName: string, thumbnailPath?: string | null, activityLabel?: string | null, imagePath?: string | null, contactEmail?: string | null, averagePJRating?: number | null, numberOfPJRatings?: number | null, images: Array<{ __typename?: 'PagesJaunesImage', id: string, imagePath?: string | null }>, phoneNumber?: { __typename?: 'PagesJaunesPhoneNumber', number: string, phoneCode: string, countryCode: string } | null, address?: { __typename?: 'PagesJaunesAddress', cityName?: string | null, street?: string | null, zipCode?: string | null, district?: string | null, country?: string | null, addressDescription?: string | null } | null }> } | null };

export type SearchForSiretQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchForSiretQuery = { __typename?: 'Query', searchForSIRET?: Array<{ __typename?: 'SIRETEstablishment', name: string, location: string, activity: string, siret: string }> | null };

export type SearchProjectsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
}>;


export type SearchProjectsQuery = { __typename?: 'Query', searchProjects?: { __typename?: 'SearchProjectsResponseWithTotal', total: number, results: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, createdAt: any, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string } | null>, owner: { __typename?: 'Owner', id: string, user?: { __typename?: 'User', id: string, fullName?: string | null, affiliatedCompany?: { __typename?: 'Company', id: string, name: string } | null } | null }, city: { __typename?: 'City', id: string, name: string } } | null> } | null };

export type SearchRecommendedRealEstateQueryVariables = Exact<{
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type SearchRecommendedRealEstateQuery = { __typename?: 'Query', searchRecommendedRealEstate?: { __typename?: 'SearchRecommendedRealEstateResponseWithTotal', total: number, results: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, isProfessionnal: boolean, initials?: string | null, contactStatusV2?: ContactStatus | null, mutualContactsCount?: number | null, numberOfRatings: number, averageRating: number, customActivity?: string | null, isRealEstatesTrades: boolean, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null> } | null };

export type SearchUsersAndCompaniesWithTotalQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchUsersAndCompaniesWithTotalQuery = { __typename?: 'Query', searchUsersAndCompaniesWithTotal?: { __typename?: 'UsersOrCompaniesResponseWithTotal', total?: number | null, results?: Array<{ __typename?: 'Company', id: string, name: string } | { __typename?: 'User', id: string, fullName?: string | null }> | null } | null };

export type SearchUsersForGalleryQueryVariables = Exact<{
  id: Scalars['String'];
  searchString: Scalars['String'];
  pageRequest?: InputMaybe<PageRequest>;
}>;


export type SearchUsersForGalleryQuery = { __typename?: 'Query', gallery?: { __typename?: 'Gallery', id: string, searchUsers: { __typename?: 'GalleryUserPage', totalCount: number, items: Array<{ __typename?: 'GalleryUser', id: string, status: GalleryUserStatus, user: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, isProfessionnal: boolean, sendbirdUserId?: string | null, customActivity?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, recommendationToMe?: { __typename?: 'Recommendation', id: string, status: RecommendationStatus } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } }> } } | null };

export type SearchUsersForInvitationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchUsersForInvitationsQuery = { __typename?: 'Query', searchUsersForInvitations?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, customActivity?: string | null, isRealEstatesTrades: boolean, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, invitations?: Array<{ __typename?: 'Invitation', id: string, status: InvitationStatus, company: { __typename?: 'Company', id: string } } | null> | null }> | null };

export type SecondaryEmailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SecondaryEmailQuery = { __typename?: 'Query', secondaryEmail?: { __typename?: 'SecondaryEmail', id: string, userId: string, email: string, verified: boolean } | null };

export type SecondaryEmailsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type SecondaryEmailsQuery = { __typename?: 'Query', secondaryEmails?: Array<{ __typename?: 'SecondaryEmail', id: string, userId: string, email: string, verified: boolean }> | null };

export type SharedFilesQueryVariables = Exact<{
  ids: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  channelUrl: Scalars['String'];
}>;


export type SharedFilesQuery = { __typename?: 'Query', sharedFiles?: Array<{ __typename?: 'Medium', id: string, fileName?: string | null, url: string, size: number, type: MediumType, isTranscoding?: boolean | null, width?: number | null, height?: number | null } | null> | null };

export type StoriesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
}>;


export type StoriesQuery = { __typename?: 'Query', stories?: Array<{ __typename?: 'Story', id: string, floatingText?: string | null, createdAt: any, viewed?: boolean | null, numberOfReactions: number, iHaveOwnership: boolean, medium: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType }, ad?: { __typename?: 'Ad', id: string, title?: string | null, propertyType: string, bedroomNumber?: number | null, roomNumber?: number | null, livingArea?: number | null, price?: number | null, rent?: number | null, address: { __typename?: 'Address', id: string, placeId?: string | null, description: string, cityName?: string | null, zipCode?: string | null, city?: { __typename?: 'City', id: string, name: string, zipCodes?: Array<string | null> | null, code: string } | null }, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> } | null, newsPost?: { __typename?: 'NewsPost', id: string, title?: string | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, featuredCategory?: { __typename?: 'NewsCategory', id: string, nameEn: string, nameFr: string, icon: string } | null } | null, owner: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, user?: { __typename?: 'User', id: string, sendbirdUserId?: string | null, isRealEstatesTrades: boolean, customActivity?: string | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, company?: { __typename?: 'Company', id: string, label?: CompanyLabel | null, customActivity?: string | null, name: string, website?: string | null, contactUser?: { __typename?: 'User', id: string, sendbirdUserId?: string | null } | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null } | null } }> | null };

export type StoriesGroupedByOwnersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
}>;


export type StoriesGroupedByOwnersQuery = { __typename?: 'Query', storiesGroupedByOwners?: Array<{ __typename?: 'Owner', id: string, displayName: string, initials?: string | null, hasUnreadStory: boolean, user?: { __typename?: 'User', id: string, customActivity?: string | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, company?: { __typename?: 'Company', id: string, label?: CompanyLabel | null, customActivity?: string | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, hasStoryWithAdLinked?: { __typename?: 'Story', id: string, createdAt: any, medium: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } } | null, lastStory?: { __typename?: 'Story', id: string, createdAt: any, medium: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType }, ad?: { __typename?: 'Ad', id: string, title?: string | null, propertyType: string, price?: number | null, rent?: number | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> } | null, newsPost?: { __typename?: 'NewsPost', id: string, title?: string | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, featuredCategory?: { __typename?: 'NewsCategory', id: string, nameEn: string, nameFr: string, icon: string } | null } | null } | null }> | null };

export type StoryQueryVariables = Exact<{
  storyId: Scalars['String'];
}>;


export type StoryQuery = { __typename?: 'Query', story?: { __typename?: 'Story', id: string, floatingText?: string | null, createdAt: any, viewed?: boolean | null, iHaveOwnership: boolean, numberOfReactions: number, medium: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType }, ad?: { __typename?: 'Ad', id: string, title?: string | null, propertyType: string, price?: number | null, rent?: number | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> } | null, newsPost?: { __typename?: 'NewsPost', id: string, title?: string | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, featuredCategory?: { __typename?: 'NewsCategory', id: string, nameEn: string, nameFr: string, icon: string } | null } | null, owner: { __typename?: 'Owner', id: string, displayName: string, initials?: string | null, user?: { __typename?: 'User', id: string, sendbirdUserId?: string | null, isRealEstatesTrades: boolean, customActivity?: string | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, company?: { __typename?: 'Company', id: string, name: string, website?: string | null, label?: CompanyLabel | null, customActivity?: string | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null, contactUser?: { __typename?: 'User', id: string, sendbirdUserId?: string | null } | null } | null } } | null };

export type StoryReactionsQueryVariables = Exact<{
  storyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type StoryReactionsQuery = { __typename?: 'Query', storyReactions?: Array<{ __typename?: 'StoryReactions', id: string, reaction?: Reaction | null, message?: string | null, sendbirdMessageId?: string | null, user?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, isProfessionnal: boolean, customActivity?: string | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null }> | null };

export type SuggestedUsersAndCompaniesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  includeCompanies?: InputMaybe<Scalars['Boolean']>;
  includeUsers?: InputMaybe<Scalars['Boolean']>;
}>;


export type SuggestedUsersAndCompaniesQuery = { __typename?: 'Query', suggestedUsersAndCompanies?: { __typename?: 'UsersOrCompaniesResponseWithTotal', total?: number | null, results?: Array<{ __typename: 'Company', id: string, name: string, label?: CompanyLabel | null, isFollowingCompany: boolean, averageRating: number, numberOfRatings: number, companyAndMembersRecommendationsCount: number, companyMembersWhoAreInMyContactsCount?: number | null, customActivity?: string | null, contactUser?: { __typename?: 'User', id: string } | null, capabilities?: { __typename?: 'CompanyCapatibilities', allowedContentTypesToManage?: Array<ContentType | null> | null, allowedContentTypesToDisplay?: Array<ContentType | null> | null, allowedLabels?: Array<CompanyLabel | null> | null, isAbleToSyncCrm: boolean, isAbleToHaveDirectors: boolean, isAbleToHaveEstateCompanies: boolean, hasPublicPage: boolean } | null, activities?: Array<{ __typename?: 'Activity', id: string, labelKey: string }> | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, address?: { __typename?: 'Address', id: string, zipCode?: string | null, cityName?: string | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, showcase?: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> | null } | { __typename: 'User', id: string, lastName?: string | null, firstName?: string | null, fullName?: string | null, initials?: string | null, isFollowed: boolean, averageRating: number, numberOfRatings: number, mutualContactsCount?: number | null, recommendationsReceivedCount: number, contactStatusV2?: ContactStatus | null, isProfessionnal: boolean, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, showcase?: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, privateCompany?: { __typename?: 'Company', id: string, address?: { __typename?: 'Address', id: string, zipCode?: string | null, cityName?: string | null, city?: { __typename?: 'City', id: string, name: string } | null } | null } | null, companyToDisplay?: { __typename?: 'Company', id: string, address?: { __typename?: 'Address', id: string, zipCode?: string | null, cityName?: string | null, city?: { __typename?: 'City', id: string, name: string } | null } | null } | null, city?: { __typename?: 'City', id: string, name: string } | null }> | null } | null };

export type UserAdsQueryVariables = Exact<{
  userId: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<AdTypes>;
  statuses?: InputMaybe<Array<InputMaybe<AdStatuses>> | InputMaybe<AdStatuses>>;
}>;


export type UserAdsQuery = { __typename?: 'Query', userAds?: Array<{ __typename?: 'Ad', id: string, type: AdTypes, isUserFavorite: boolean, title?: string | null, isUserAffiliatedCompanyFavorite: boolean, livingArea?: number | null, landArea?: number | null, surfaceArea?: number | null, price?: number | null, rent?: number | null, bedroomNumber?: number | null, roomNumber?: number | null, interOffice: boolean, createdAt: any, isNew: boolean, isPriceDecreasing: boolean, propertyType: string, status?: AdStatuses | null, owner?: { __typename?: 'Owner', company?: { __typename?: 'Company', id: string } | null } | null, assignedTo?: { __typename?: 'User', fullName?: string | null, initials?: string | null, id: string, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, number: string, phoneCode: string } | null } | null, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, address: { __typename?: 'Address', id: string, cityName?: string | null, zipCode?: string | null }, stats: { __typename?: 'Stats', id: string, impressionCount: number, viewCount: number, favoriteCount: number, contactCount: number } }> | null };

export type UserContactsQueryVariables = Exact<{
  userId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['JSON']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  match?: InputMaybe<Match>;
  excludeFromResultsUserId?: InputMaybe<Scalars['String']>;
  onlyMutual?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserContactsQuery = { __typename?: 'Query', userContactsV2?: { __typename?: 'UsersResponseWithTotal', total?: number | null, results?: Array<{ __typename?: 'User', id: string, isProfessionnal: boolean, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, customActivity?: string | null, mutualContactsCount?: number | null, contactStatusV2?: ContactStatus | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null> | null } | null };

export type UserFavoriteNewsPostsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type UserFavoriteNewsPostsQuery = { __typename?: 'Query', userFavoriteNewsPosts?: { __typename?: 'NewsPostsResponseWithTotal', total: number, results: Array<{ __typename?: 'NewsPost', id: string, status: NewsPostStatus, directusId?: number | null, title?: string | null, shortDescription?: string | null, description?: string | null, source?: string | null, sourceLink?: string | null, newsPostLink?: string | null, tags?: string | null, likedByCurrentUser: boolean, totalLikes: number, createdAt: any, updatedAt: any, isUserFavorite: boolean, isUserAffiliatedCompanyFavorite: boolean, media: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null>, categories?: Array<{ __typename?: 'NewsCategory', id: string, nameEn: string, nameFr: string, icon: string, createdAt: any }> | null, stats: { __typename?: 'Stats', id: string, impressionCount: number, viewCount: number, favoriteCount: number, contactCount: number }, featuredCategory?: { __typename?: 'NewsCategory', id: string, nameEn: string, nameFr: string, icon: string, createdAt: any } | null }> } | null };

export type UserGalleriesQueryVariables = Exact<{
  userId: Scalars['String'];
  policy?: InputMaybe<GalleryAccessPolicy>;
  sort?: InputMaybe<GallerySort>;
  pageRequest?: InputMaybe<PageRequest>;
}>;


export type UserGalleriesQuery = { __typename?: 'Query', userProfile?: { __typename?: 'User', id: string, galleries: { __typename?: 'GalleryPage', totalCount: number, items: Array<{ __typename?: 'Gallery', id: string, name: string, isSecret: boolean, createdAt: any, numberOfContents: number, contentLastUpdatedAt: any, previewMedia?: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> | null }> } } | null };

export type UserGalleriesWithCollaboratorsQueryVariables = Exact<{
  userId: Scalars['String'];
  policy?: InputMaybe<GalleryAccessPolicy>;
  sort?: InputMaybe<GallerySort>;
  pageRequest?: InputMaybe<PageRequest>;
  collaboratorPageRequest?: InputMaybe<PageRequest>;
}>;


export type UserGalleriesWithCollaboratorsQuery = { __typename?: 'Query', userProfile?: { __typename?: 'User', id: string, galleries: { __typename?: 'GalleryPage', totalCount: number, items: Array<{ __typename?: 'Gallery', id: string, name: string, isSecret: boolean, createdAt: any, numberOfContents: number, contentLastUpdatedAt: any, previewMedia?: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> | null, collaborators: { __typename?: 'GalleryCollaboratorPage', totalCount: number, items: Array<{ __typename?: 'GalleryCollaborator', user?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null, company?: { __typename?: 'Company', id: string, name: string, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null }> } }> } } | null };

export type UserIdBySendbirdUserIdQueryVariables = Exact<{
  sendbirdUserId: Scalars['String'];
}>;


export type UserIdBySendbirdUserIdQuery = { __typename?: 'Query', chatUser?: { __typename?: 'User', id: string } | null };

export type UserProfileQueryVariables = Exact<{
  id: Scalars['String'];
  showcaseLimit?: InputMaybe<Scalars['Int']>;
}>;


export type UserProfileQuery = { __typename?: 'Query', userProfile?: { __typename?: 'User', id: string, isFollowed: boolean, contactStatusV2?: ContactStatus | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, numberOfContacts: number, mutualContactsCount?: number | null, description?: string | null, feeScaleFile?: string | null, feeScaleFileName?: string | null, hasUnreadStory: boolean, isBlocked: boolean, customActivity?: string | null, isRealEstatesTrades: boolean, createdAt: any, isProfessionnal: boolean, isAbleToJoinOrCreateCompany: boolean, recommendationsReceivedCount: number, numberOfRatings: number, numberOfDisplayedRatings: number, averageRating: number, numberOfProjects: number, numberOfFollowers: number, numberOfFollows: number, numberOfAds: number, numberOfGalleries: number, numberOfPosts: number, numberOfAvailableAds: number, numberOfEndedAds: number, coverImage?: { __typename?: 'Medium', id: string, url: string } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, affiliatedCompany?: { __typename?: 'Company', id: string, group?: { __typename?: 'Company', id: string, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null } | null, showcase?: Array<{ __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null> | null, activity?: { __typename?: 'Activity', id: string, labelKey: string } | null, city?: { __typename?: 'City', id: string, name: string, zipCodes?: Array<string | null> | null } | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, number: string, phoneCode: string, countryCode: string } | null, companyToDisplay?: { __typename?: 'Company', id: string, name: string, website?: string | null, foundationYear?: number | null, numberOfMembers: number, siretNumber?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, number: string, phoneCode: string, countryCode: string } | null, capabilities?: { __typename?: 'CompanyCapatibilities', allowedContentTypesToManage?: Array<ContentType | null> | null, allowedContentTypesToDisplay?: Array<ContentType | null> | null, allowedLabels?: Array<CompanyLabel | null> | null, isAbleToSyncCrm: boolean, isAbleToHaveDirectors: boolean, isAbleToHaveEstateCompanies: boolean, hasPublicPage: boolean } | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null, contactUser?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null, address?: { __typename?: 'Address', id: string, placeId?: string | null, zipCode?: string | null, description: string, cityName?: string | null, city?: { __typename?: 'City', id: string, name: string } | null } | null } | null, recommendationFromMe?: { __typename?: 'Recommendation', id: string, status: RecommendationStatus } | null, ratingGivenByCurrentUser?: { __typename?: 'Rating', id: string, value: number, comment?: string | null, createdAt: any, isHidden: boolean, giver?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, initials?: string | null, createdAt: any, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } | null } | null } | null, recommendations?: Array<{ __typename?: 'Recommendation', id: string, recommendingUser: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, image?: { __typename?: 'Medium', id: string, width?: number | null, height?: number | null, size: number, aspectRatio?: number | null, isTranscoding?: boolean | null, duration: number, rotation?: string | null, url: string, type: MediumType } | null } }> | null };

export type UserProfileForChatQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserProfileForChatQuery = { __typename?: 'Query', userProfile?: { __typename?: 'User', id: string, sendbirdUserId?: string | null } | null };

export type VersionsSupportedQueryVariables = Exact<{ [key: string]: never; }>;


export type VersionsSupportedQuery = { __typename?: 'Query', versionsSupported?: Array<string> | null };

export type WoopenSupportInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type WoopenSupportInfoQuery = { __typename?: 'Query', supportEmail?: string | null, supportPhoneNumber?: string | null };

export type PostLikedByCurrentUserFragment = { __typename?: 'Post', likedByCurrentUser: boolean, totalLikes: number };

export type NewsPostLikedByCurrentUserFragment = { __typename?: 'NewsPost', likedByCurrentUser: boolean, totalLikes: number };

export type PostIsUserFavoriteFragment = { __typename?: 'Post', isUserFavorite: boolean };

export type AdIsUserFavoriteFragment = { __typename?: 'Ad', isUserFavorite: boolean };

export type NewsPostIsUserFavoriteFragment = { __typename?: 'NewsPost', isUserFavorite: boolean };

export type GalleryNumberOfContentFragment = { __typename?: 'Gallery', numberOfContents: number, contentLastUpdatedAt: any };

export type PostTotalCommentsFragment = { __typename?: 'Post', totalComments?: number | null };

export type UserIsFollowedFragment = { __typename?: 'User', isFollowed: boolean };

export type CompanyIsFollowedFragment = { __typename?: 'Company', isFollowingCompany: boolean };

export type UserContactStatusFragment = { __typename?: 'User', contactStatusV2?: ContactStatus | null };

export type GalleryUserStatusFragment = { __typename?: 'GalleryUser', status: GalleryUserStatus };

export const PostLikedByCurrentUserFragmentDoc = gql`
    fragment PostLikedByCurrentUser on Post {
  likedByCurrentUser
  totalLikes
}
    `;
export const NewsPostLikedByCurrentUserFragmentDoc = gql`
    fragment NewsPostLikedByCurrentUser on NewsPost {
  likedByCurrentUser
  totalLikes
}
    `;
export const PostIsUserFavoriteFragmentDoc = gql`
    fragment PostIsUserFavorite on Post {
  isUserFavorite
}
    `;
export const AdIsUserFavoriteFragmentDoc = gql`
    fragment AdIsUserFavorite on Ad {
  isUserFavorite
}
    `;
export const NewsPostIsUserFavoriteFragmentDoc = gql`
    fragment NewsPostIsUserFavorite on NewsPost {
  isUserFavorite
}
    `;
export const GalleryNumberOfContentFragmentDoc = gql`
    fragment GalleryNumberOfContent on Gallery {
  numberOfContents
  contentLastUpdatedAt
}
    `;
export const PostTotalCommentsFragmentDoc = gql`
    fragment PostTotalComments on Post {
  totalComments
}
    `;
export const UserIsFollowedFragmentDoc = gql`
    fragment UserIsFollowed on User {
  isFollowed
}
    `;
export const CompanyIsFollowedFragmentDoc = gql`
    fragment CompanyIsFollowed on Company {
  isFollowingCompany
}
    `;
export const UserContactStatusFragmentDoc = gql`
    fragment UserContactStatus on User {
  contactStatusV2
}
    `;
export const GalleryUserStatusFragmentDoc = gql`
    fragment GalleryUserStatus on GalleryUser {
  status
}
    `;
export const AcceptAdminRequest = gql`
    mutation AcceptAdminRequest($adminRequestId: String!) {
  updateAdminRequest(id: $adminRequestId, status: accepted)
}
    `;
export type AcceptAdminRequestMutationFn = Apollo.MutationFunction<AcceptAdminRequestMutation, AcceptAdminRequestMutationVariables>;
export type AcceptAdminRequestMutationResult = Apollo.MutationResult<AcceptAdminRequestMutation>;
export type AcceptAdminRequestMutationOptions = Apollo.BaseMutationOptions<AcceptAdminRequestMutation, AcceptAdminRequestMutationVariables>;
export const AcceptGalleryInvitation = gql`
    mutation AcceptGalleryInvitation($invitationId: ID!) {
  acceptGalleryInvitation(invitationId: $invitationId) {
    success
  }
}
    `;
export type AcceptGalleryInvitationMutationFn = Apollo.MutationFunction<AcceptGalleryInvitationMutation, AcceptGalleryInvitationMutationVariables>;
export type AcceptGalleryInvitationMutationResult = Apollo.MutationResult<AcceptGalleryInvitationMutation>;
export type AcceptGalleryInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptGalleryInvitationMutation, AcceptGalleryInvitationMutationVariables>;
export const AddAdmin = gql`
    mutation AddAdmin($userId: String!) {
  addAdmin(userId: $userId)
}
    `;
export type AddAdminMutationFn = Apollo.MutationFunction<AddAdminMutation, AddAdminMutationVariables>;
export type AddAdminMutationResult = Apollo.MutationResult<AddAdminMutation>;
export type AddAdminMutationOptions = Apollo.BaseMutationOptions<AddAdminMutation, AddAdminMutationVariables>;
export const AddBlockedUser = gql`
    mutation AddBlockedUser($userId: String!) {
  addBlockedUser(userId: $userId) {
    id
  }
}
    `;
export type AddBlockedUserMutationFn = Apollo.MutationFunction<AddBlockedUserMutation, AddBlockedUserMutationVariables>;
export type AddBlockedUserMutationResult = Apollo.MutationResult<AddBlockedUserMutation>;
export type AddBlockedUserMutationOptions = Apollo.BaseMutationOptions<AddBlockedUserMutation, AddBlockedUserMutationVariables>;
export const RemoveBlockedUser = gql`
    mutation RemoveBlockedUser($userId: String!) {
  removeBlockedUser(userId: $userId)
}
    `;
export type RemoveBlockedUserMutationFn = Apollo.MutationFunction<RemoveBlockedUserMutation, RemoveBlockedUserMutationVariables>;
export type RemoveBlockedUserMutationResult = Apollo.MutationResult<RemoveBlockedUserMutation>;
export type RemoveBlockedUserMutationOptions = Apollo.BaseMutationOptions<RemoveBlockedUserMutation, RemoveBlockedUserMutationVariables>;
export const AddContact = gql`
    mutation AddContact($userId: String!) {
  addContactToUser(userId: $userId) {
    id
  }
}
    `;
export type AddContactMutationFn = Apollo.MutationFunction<AddContactMutation, AddContactMutationVariables>;
export type AddContactMutationResult = Apollo.MutationResult<AddContactMutation>;
export type AddContactMutationOptions = Apollo.BaseMutationOptions<AddContactMutation, AddContactMutationVariables>;
export const RemoveContact = gql`
    mutation RemoveContact($userId: String!) {
  removeContact(userId: $userId)
}
    `;
export type RemoveContactMutationFn = Apollo.MutationFunction<RemoveContactMutation, RemoveContactMutationVariables>;
export type RemoveContactMutationResult = Apollo.MutationResult<RemoveContactMutation>;
export type RemoveContactMutationOptions = Apollo.BaseMutationOptions<RemoveContactMutation, RemoveContactMutationVariables>;
export const AddContentEvent = gql`
    mutation AddContentEvent($newsPostId: String, $postId: String, $adId: String, $storyId: String, $companyId: String, $eventType: String!) {
  addContentEvent(
    newsPostId: $newsPostId
    postId: $postId
    adId: $adId
    storyId: $storyId
    companyId: $companyId
    eventType: $eventType
  )
}
    `;
export type AddContentEventMutationFn = Apollo.MutationFunction<AddContentEventMutation, AddContentEventMutationVariables>;
export type AddContentEventMutationResult = Apollo.MutationResult<AddContentEventMutation>;
export type AddContentEventMutationOptions = Apollo.BaseMutationOptions<AddContentEventMutation, AddContentEventMutationVariables>;
export const AddContentToGallery = gql`
    mutation AddContentToGallery($galleryId: String!, $adId: String, $postId: String, $newsPostId: String) {
  addContentToGallery(
    galleryId: $galleryId
    adId: $adId
    postId: $postId
    newsPostId: $newsPostId
  ) {
    id
    name
    numberOfContents
  }
}
    `;
export type AddContentToGalleryMutationFn = Apollo.MutationFunction<AddContentToGalleryMutation, AddContentToGalleryMutationVariables>;
export type AddContentToGalleryMutationResult = Apollo.MutationResult<AddContentToGalleryMutation>;
export type AddContentToGalleryMutationOptions = Apollo.BaseMutationOptions<AddContentToGalleryMutation, AddContentToGalleryMutationVariables>;
export const AddCrmSync = gql`
    mutation AddCrmSync($companyId: String, $userId: String, $crmSourceId: String!, $requestedCrmName: String) {
  addCrmSync(
    companyId: $companyId
    userId: $userId
    crmSourceId: $crmSourceId
    requestedCrmName: $requestedCrmName
  ) {
    crmSource {
      name
    }
    crmUserId
    owner {
      user {
        fullName
      }
      company {
        name
      }
    }
  }
}
    `;
export type AddCrmSyncMutationFn = Apollo.MutationFunction<AddCrmSyncMutation, AddCrmSyncMutationVariables>;
export type AddCrmSyncMutationResult = Apollo.MutationResult<AddCrmSyncMutation>;
export type AddCrmSyncMutationOptions = Apollo.BaseMutationOptions<AddCrmSyncMutation, AddCrmSyncMutationVariables>;
export const AddDirector = gql`
    mutation AddDirector($userId: String!) {
  addDirector(userId: $userId)
}
    `;
export type AddDirectorMutationFn = Apollo.MutationFunction<AddDirectorMutation, AddDirectorMutationVariables>;
export type AddDirectorMutationResult = Apollo.MutationResult<AddDirectorMutation>;
export type AddDirectorMutationOptions = Apollo.BaseMutationOptions<AddDirectorMutation, AddDirectorMutationVariables>;
export const AddEvent = gql`
    mutation AddEvent($quickSignupUserId: String, $userId: String, $companyId: String, $eventType: String!, $platform: String) {
  addEvent(
    quickSignupUserId: $quickSignupUserId
    userId: $userId
    companyId: $companyId
    eventType: $eventType
    platform: $platform
  )
}
    `;
export type AddEventMutationFn = Apollo.MutationFunction<AddEventMutation, AddEventMutationVariables>;
export type AddEventMutationResult = Apollo.MutationResult<AddEventMutation>;
export type AddEventMutationOptions = Apollo.BaseMutationOptions<AddEventMutation, AddEventMutationVariables>;
export const AddEvents = gql`
    mutation AddEvents($events: [EventData!]!) {
  addEvents(events: $events)
}
    `;
export type AddEventsMutationFn = Apollo.MutationFunction<AddEventsMutation, AddEventsMutationVariables>;
export type AddEventsMutationResult = Apollo.MutationResult<AddEventsMutation>;
export type AddEventsMutationOptions = Apollo.BaseMutationOptions<AddEventsMutation, AddEventsMutationVariables>;
export const AssignAdsToUser = gql`
    mutation AssignAdsToUser($userId: String!, $adIds: [String]) {
  assignAdsToUser(userId: $userId, adIds: $adIds)
}
    `;
export type AssignAdsToUserMutationFn = Apollo.MutationFunction<AssignAdsToUserMutation, AssignAdsToUserMutationVariables>;
export type AssignAdsToUserMutationResult = Apollo.MutationResult<AssignAdsToUserMutation>;
export type AssignAdsToUserMutationOptions = Apollo.BaseMutationOptions<AssignAdsToUserMutation, AssignAdsToUserMutationVariables>;
export const AssistancePagesJaunes = gql`
    mutation AssistancePagesJaunes($pagesJaunesId: String!, $phone: String!, $email: String!, $description: String!) {
  assistancePagesJaunes(
    pagesJaunesId: $pagesJaunesId
    phone: $phone
    email: $email
    description: $description
  )
}
    `;
export type AssistancePagesJaunesMutationFn = Apollo.MutationFunction<AssistancePagesJaunesMutation, AssistancePagesJaunesMutationVariables>;
export type AssistancePagesJaunesMutationResult = Apollo.MutationResult<AssistancePagesJaunesMutation>;
export type AssistancePagesJaunesMutationOptions = Apollo.BaseMutationOptions<AssistancePagesJaunesMutation, AssistancePagesJaunesMutationVariables>;
export const CreateAd = gql`
    mutation CreateAd($type: AdTypes!, $propertyType: PropertyTypes!, $propertyState: PropertyState, $commonAreasState: CommonAreasState, $propertyPurposeEstimation: PropertyPurposeEstimation, $propertyResidenceType: PropertyResidenceType, $userIsOwner: Boolean, $contactConsent: Boolean, $status: AdStatuses, $isHiddingCompleteAddress: Boolean!, $title: String, $description: String, $constructionYear: Int, $floorPosition: Int, $livingArea: Float, $landArea: Float, $media: [Upload]!, $tmpUrls: [String!], $bedroomNumber: Int, $roomNumber: Int, $floorNumber: Int, $rooms: String, $heatType: HeatTypes, $heatInformations: String, $consumption: String, $emissions: String, $interOffice: Boolean!, $commissionRate: Float, $assets: [String], $price: Int, $homadataEvaluation: String, $furnished: Boolean, $inclusions: String, $rent: Int, $monthlyCharges: Float, $inventory: Float, $fees: Int, $guarantees: String, $availableDate: Int, $email: String, $servicedLand: YesNoNAOptions, $constructibleLand: YesNoNAOptions, $newProperty: Boolean, $surfaceArea: Float, $numberOfVehicles: Int, $dimensionLength: Float, $dimensionWidth: Float, $dimensionHeight: Float, $coOwnership: Boolean, $coOwnershipNumberOfLots: Int, $coOwnershipOngoing: YesNoOptions, $coOwnershipYearlyCharge: Float, $saleFeeType: SaleFeeType, $showSaleFeeBuyerPrice: Boolean, $saleFeeBuyerRate: Float, $priceWithoutSaleFee: Int, $userId: String, $companyId: String, $address: AddressParam) {
  createAd(
    type: $type
    propertyType: $propertyType
    propertyState: $propertyState
    commonAreasState: $commonAreasState
    propertyPurposeEstimation: $propertyPurposeEstimation
    propertyResidenceType: $propertyResidenceType
    userIsOwner: $userIsOwner
    contactConsent: $contactConsent
    status: $status
    isHiddingCompleteAddress: $isHiddingCompleteAddress
    title: $title
    description: $description
    constructionYear: $constructionYear
    floorPosition: $floorPosition
    livingArea: $livingArea
    landArea: $landArea
    media: $media
    tmpUrls: $tmpUrls
    bedroomNumber: $bedroomNumber
    roomNumber: $roomNumber
    floorNumber: $floorNumber
    rooms: $rooms
    heatType: $heatType
    heatInformations: $heatInformations
    consumption: $consumption
    emissions: $emissions
    interOffice: $interOffice
    commissionRate: $commissionRate
    assets: $assets
    price: $price
    homadataEvaluation: $homadataEvaluation
    furnished: $furnished
    inclusions: $inclusions
    rent: $rent
    monthlyCharges: $monthlyCharges
    inventory: $inventory
    fees: $fees
    guarantees: $guarantees
    availableDate: $availableDate
    email: $email
    servicedLand: $servicedLand
    constructibleLand: $constructibleLand
    newProperty: $newProperty
    surfaceArea: $surfaceArea
    numberOfVehicles: $numberOfVehicles
    dimensionLength: $dimensionLength
    dimensionWidth: $dimensionWidth
    dimensionHeight: $dimensionHeight
    coOwnership: $coOwnership
    coOwnershipNumberOfLots: $coOwnershipNumberOfLots
    coOwnershipOngoing: $coOwnershipOngoing
    coOwnershipYearlyCharge: $coOwnershipYearlyCharge
    saleFeeType: $saleFeeType
    showSaleFeeBuyerPrice: $showSaleFeeBuyerPrice
    saleFeeBuyerRate: $saleFeeBuyerRate
    priceWithoutSaleFee: $priceWithoutSaleFee
    userId: $userId
    companyId: $companyId
    address: $address
  ) {
    id
  }
}
    `;
export type CreateAdMutationFn = Apollo.MutationFunction<CreateAdMutation, CreateAdMutationVariables>;
export type CreateAdMutationResult = Apollo.MutationResult<CreateAdMutation>;
export type CreateAdMutationOptions = Apollo.BaseMutationOptions<CreateAdMutation, CreateAdMutationVariables>;
export const CreateChatToken = gql`
    mutation CreateChatToken {
  createChatToken {
    token
    expireAt
  }
}
    `;
export type CreateChatTokenMutationFn = Apollo.MutationFunction<CreateChatTokenMutation, CreateChatTokenMutationVariables>;
export type CreateChatTokenMutationResult = Apollo.MutationResult<CreateChatTokenMutation>;
export type CreateChatTokenMutationOptions = Apollo.BaseMutationOptions<CreateChatTokenMutation, CreateChatTokenMutationVariables>;
export const CreateComment = gql`
    mutation CreateComment($postId: String!, $content: String!) {
  createComment(postId: $postId, content: $content) {
    id
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateCompany = gql`
    mutation CreateCompany($label: CompanyLabel, $name: String!, $website: String, $description: String, $phoneNumber: PhoneParam, $foundationYear: Int, $feeScaleFile: Upload, $feeScaleFileName: String, $imageHybridMedium: HybridMedium, $coverImage: Upload, $address: AddressParam, $isPrivate: Boolean!, $siretNumber: String, $mainActivityId: String, $mainCategoryId: String, $customActivity: String, $pagesJaunesId: String) {
  createCompany(
    label: $label
    name: $name
    website: $website
    description: $description
    foundationYear: $foundationYear
    address: $address
    feeScaleFile: $feeScaleFile
    feeScaleFileName: $feeScaleFileName
    imageHybridMedium: $imageHybridMedium
    coverImage: $coverImage
    isPrivate: $isPrivate
    phoneNumber: $phoneNumber
    siretNumber: $siretNumber
    mainActivityId: $mainActivityId
    mainCategoryId: $mainCategoryId
    customActivity: $customActivity
    pagesJaunesId: $pagesJaunesId
  ) {
    id
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const CreateGallery = gql`
    mutation CreateGallery($name: String!, $isSecret: Boolean!, $companyId: String, $invitations: [ClosedGalleryInvitationInput!]) {
  createGallery(
    name: $name
    isSecret: $isSecret
    companyId: $companyId
    invitations: $invitations
  ) {
    id
    name
  }
}
    `;
export type CreateGalleryMutationFn = Apollo.MutationFunction<CreateGalleryMutation, CreateGalleryMutationVariables>;
export type CreateGalleryMutationResult = Apollo.MutationResult<CreateGalleryMutation>;
export type CreateGalleryMutationOptions = Apollo.BaseMutationOptions<CreateGalleryMutation, CreateGalleryMutationVariables>;
export const CreateGalleryInvitation = gql`
    mutation CreateGalleryInvitation($galleryId: ID!, $type: GalleryInvitationType!, $role: GalleryRole!, $invitee: GalleryInviteeInput) {
  createGalleryInvitation(
    galleryId: $galleryId
    type: $type
    role: $role
    invitee: $invitee
  ) {
    success
    invitation {
      id
    }
  }
}
    `;
export type CreateGalleryInvitationMutationFn = Apollo.MutationFunction<CreateGalleryInvitationMutation, CreateGalleryInvitationMutationVariables>;
export type CreateGalleryInvitationMutationResult = Apollo.MutationResult<CreateGalleryInvitationMutation>;
export type CreateGalleryInvitationMutationOptions = Apollo.BaseMutationOptions<CreateGalleryInvitationMutation, CreateGalleryInvitationMutationVariables>;
export const CreateGroupInvitation = gql`
    mutation CreateGroupInvitation($groupId: String, $companyId: String) {
  createGroupInvitation(groupId: $groupId, companyId: $companyId) {
    id
  }
}
    `;
export type CreateGroupInvitationMutationFn = Apollo.MutationFunction<CreateGroupInvitationMutation, CreateGroupInvitationMutationVariables>;
export type CreateGroupInvitationMutationResult = Apollo.MutationResult<CreateGroupInvitationMutation>;
export type CreateGroupInvitationMutationOptions = Apollo.BaseMutationOptions<CreateGroupInvitationMutation, CreateGroupInvitationMutationVariables>;
export const CreateInvitation = gql`
    mutation CreateInvitation($userId: String, $companyId: String) {
  createInvitation(userId: $userId, companyId: $companyId) {
    id
  }
}
    `;
export type CreateInvitationMutationFn = Apollo.MutationFunction<CreateInvitationMutation, CreateInvitationMutationVariables>;
export type CreateInvitationMutationResult = Apollo.MutationResult<CreateInvitationMutation>;
export type CreateInvitationMutationOptions = Apollo.BaseMutationOptions<CreateInvitationMutation, CreateInvitationMutationVariables>;
export const CreateJobOffer = gql`
    mutation CreateJobOffer($companyId: String!, $companyName: String!, $jobTypeId: String!, $cityId: String, $googlePlaceId: String, $title: String!, $description: String, $profile: String, $emailAddress: String!) {
  createJobOffer(
    companyId: $companyId
    companyName: $companyName
    jobTypeId: $jobTypeId
    cityId: $cityId
    googlePlaceId: $googlePlaceId
    title: $title
    description: $description
    profile: $profile
    emailAddress: $emailAddress
  ) {
    id
  }
}
    `;
export type CreateJobOfferMutationFn = Apollo.MutationFunction<CreateJobOfferMutation, CreateJobOfferMutationVariables>;
export type CreateJobOfferMutationResult = Apollo.MutationResult<CreateJobOfferMutation>;
export type CreateJobOfferMutationOptions = Apollo.BaseMutationOptions<CreateJobOfferMutation, CreateJobOfferMutationVariables>;
export const CreateJobOfferApplication = gql`
    mutation CreateJobOfferApplication($jobOfferId: String!, $firstName: String!, $lastName: String!, $email: String!, $phoneNumber: String!, $linkedInProfileLink: String, $coverLetter: String!, $resumeFileName: String!, $resumeFile: Upload!) {
  createJobOfferApplication(
    jobOfferId: $jobOfferId
    firstName: $firstName
    lastName: $lastName
    email: $email
    phoneNumber: $phoneNumber
    linkedInProfileLink: $linkedInProfileLink
    coverLetter: $coverLetter
    resumeFileName: $resumeFileName
    resumeFile: $resumeFile
  ) {
    id
  }
}
    `;
export type CreateJobOfferApplicationMutationFn = Apollo.MutationFunction<CreateJobOfferApplicationMutation, CreateJobOfferApplicationMutationVariables>;
export type CreateJobOfferApplicationMutationResult = Apollo.MutationResult<CreateJobOfferApplicationMutation>;
export type CreateJobOfferApplicationMutationOptions = Apollo.BaseMutationOptions<CreateJobOfferApplicationMutation, CreateJobOfferApplicationMutationVariables>;
export const CreateNewsFeedback = gql`
    mutation CreateNewsFeedback($wantToSeeMoreOrLess: WantToSeeMoreOrLess!, $reasonForLess: ReasonForLess, $newsPostId: String!) {
  createNewsFeedback(
    wantToSeeMoreOrLess: $wantToSeeMoreOrLess
    reasonForLess: $reasonForLess
    newsPostId: $newsPostId
  ) {
    id
    wantToSeeMoreOrLess
  }
}
    `;
export type CreateNewsFeedbackMutationFn = Apollo.MutationFunction<CreateNewsFeedbackMutation, CreateNewsFeedbackMutationVariables>;
export type CreateNewsFeedbackMutationResult = Apollo.MutationResult<CreateNewsFeedbackMutation>;
export type CreateNewsFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateNewsFeedbackMutation, CreateNewsFeedbackMutationVariables>;
export const CreatePost = gql`
    mutation CreatePost($media: [Upload]!, $message: String!, $userId: String, $companyId: String, $newsPostId: String, $adId: String, $projectId: String) {
  createPost(
    media: $media
    message: $message
    userId: $userId
    companyId: $companyId
    newsPostId: $newsPostId
    adId: $adId
    projectId: $projectId
  ) {
    id
  }
}
    `;
export type CreatePostMutationFn = Apollo.MutationFunction<CreatePostMutation, CreatePostMutationVariables>;
export type CreatePostMutationResult = Apollo.MutationResult<CreatePostMutation>;
export type CreatePostMutationOptions = Apollo.BaseMutationOptions<CreatePostMutation, CreatePostMutationVariables>;
export const CreateProject = gql`
    mutation CreateProject($name: String!, $cityId: String, $googlePlaceId: String, $description: String!, $media: [Upload]!) {
  createProject(
    name: $name
    cityId: $cityId
    googlePlaceId: $googlePlaceId
    description: $description
    media: $media
  ) {
    id
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateQuickSignupAds = gql`
    mutation CreateQuickSignupAds($quickSignupUserId: String!, $userId: String!, $companyId: String) {
  createQuickSignupAds(
    quickSignupUserId: $quickSignupUserId
    userId: $userId
    companyId: $companyId
  )
}
    `;
export type CreateQuickSignupAdsMutationFn = Apollo.MutationFunction<CreateQuickSignupAdsMutation, CreateQuickSignupAdsMutationVariables>;
export type CreateQuickSignupAdsMutationResult = Apollo.MutationResult<CreateQuickSignupAdsMutation>;
export type CreateQuickSignupAdsMutationOptions = Apollo.BaseMutationOptions<CreateQuickSignupAdsMutation, CreateQuickSignupAdsMutationVariables>;
export const CreateRating = gql`
    mutation CreateRating($userId: String, $value: Int!, $comment: String) {
  createRating(userId: $userId, value: $value, comment: $comment) {
    id
  }
}
    `;
export type CreateRatingMutationFn = Apollo.MutationFunction<CreateRatingMutation, CreateRatingMutationVariables>;
export type CreateRatingMutationResult = Apollo.MutationResult<CreateRatingMutation>;
export type CreateRatingMutationOptions = Apollo.BaseMutationOptions<CreateRatingMutation, CreateRatingMutationVariables>;
export const CreateRecommendation = gql`
    mutation CreateRecommendation($userId: String, $companyId: String) {
  createRecommendation(userId: $userId, companyId: $companyId) {
    id
  }
}
    `;
export type CreateRecommendationMutationFn = Apollo.MutationFunction<CreateRecommendationMutation, CreateRecommendationMutationVariables>;
export type CreateRecommendationMutationResult = Apollo.MutationResult<CreateRecommendationMutation>;
export type CreateRecommendationMutationOptions = Apollo.BaseMutationOptions<CreateRecommendationMutation, CreateRecommendationMutationVariables>;
export const CreateSecondaryEmail = gql`
    mutation CreateSecondaryEmail($email: String!) {
  createSecondaryEmail(email: $email) {
    id
  }
}
    `;
export type CreateSecondaryEmailMutationFn = Apollo.MutationFunction<CreateSecondaryEmailMutation, CreateSecondaryEmailMutationVariables>;
export type CreateSecondaryEmailMutationResult = Apollo.MutationResult<CreateSecondaryEmailMutation>;
export type CreateSecondaryEmailMutationOptions = Apollo.BaseMutationOptions<CreateSecondaryEmailMutation, CreateSecondaryEmailMutationVariables>;
export const CreateStory = gql`
    mutation CreateStory($medium: Upload!, $floatingText: String, $adId: String, $newsPostId: String, $userId: String, $companyId: String) {
  createStory(
    medium: $medium
    floatingText: $floatingText
    adId: $adId
    newsPostId: $newsPostId
    userId: $userId
    companyId: $companyId
  ) {
    id
  }
}
    `;
export type CreateStoryMutationFn = Apollo.MutationFunction<CreateStoryMutation, CreateStoryMutationVariables>;
export type CreateStoryMutationResult = Apollo.MutationResult<CreateStoryMutation>;
export type CreateStoryMutationOptions = Apollo.BaseMutationOptions<CreateStoryMutation, CreateStoryMutationVariables>;
export const DeclineGalleryInvitation = gql`
    mutation DeclineGalleryInvitation($invitationId: ID!) {
  declineGalleryInvitation(invitationId: $invitationId) {
    success
  }
}
    `;
export type DeclineGalleryInvitationMutationFn = Apollo.MutationFunction<DeclineGalleryInvitationMutation, DeclineGalleryInvitationMutationVariables>;
export type DeclineGalleryInvitationMutationResult = Apollo.MutationResult<DeclineGalleryInvitationMutation>;
export type DeclineGalleryInvitationMutationOptions = Apollo.BaseMutationOptions<DeclineGalleryInvitationMutation, DeclineGalleryInvitationMutationVariables>;
export const DeleteComment = gql`
    mutation DeleteComment($commentId: String!) {
  deleteComment(commentId: $commentId)
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeleteCompany = gql`
    mutation DeleteCompany($companyId: String!) {
  deleteCompany(companyId: $companyId)
}
    `;
export type DeleteCompanyMutationFn = Apollo.MutationFunction<DeleteCompanyMutation, DeleteCompanyMutationVariables>;
export type DeleteCompanyMutationResult = Apollo.MutationResult<DeleteCompanyMutation>;
export type DeleteCompanyMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>;
export const DeleteGallery = gql`
    mutation DeleteGallery($id: String!) {
  deleteGallery(id: $id)
}
    `;
export type DeleteGalleryMutationFn = Apollo.MutationFunction<DeleteGalleryMutation, DeleteGalleryMutationVariables>;
export type DeleteGalleryMutationResult = Apollo.MutationResult<DeleteGalleryMutation>;
export type DeleteGalleryMutationOptions = Apollo.BaseMutationOptions<DeleteGalleryMutation, DeleteGalleryMutationVariables>;
export const DeleteGroupInvitation = gql`
    mutation DeleteGroupInvitation($groupId: String, $companyId: String) {
  deleteGroupInvitation(groupId: $groupId, companyId: $companyId)
}
    `;
export type DeleteGroupInvitationMutationFn = Apollo.MutationFunction<DeleteGroupInvitationMutation, DeleteGroupInvitationMutationVariables>;
export type DeleteGroupInvitationMutationResult = Apollo.MutationResult<DeleteGroupInvitationMutation>;
export type DeleteGroupInvitationMutationOptions = Apollo.BaseMutationOptions<DeleteGroupInvitationMutation, DeleteGroupInvitationMutationVariables>;
export const DeleteInvitation = gql`
    mutation DeleteInvitation($userId: String, $companyId: String) {
  deleteInvitation(userId: $userId, companyId: $companyId)
}
    `;
export type DeleteInvitationMutationFn = Apollo.MutationFunction<DeleteInvitationMutation, DeleteInvitationMutationVariables>;
export type DeleteInvitationMutationResult = Apollo.MutationResult<DeleteInvitationMutation>;
export type DeleteInvitationMutationOptions = Apollo.BaseMutationOptions<DeleteInvitationMutation, DeleteInvitationMutationVariables>;
export const DeleteJobOffer = gql`
    mutation DeleteJobOffer($jobOfferId: String!) {
  softDeleteJobOffer(jobOfferId: $jobOfferId)
}
    `;
export type DeleteJobOfferMutationFn = Apollo.MutationFunction<DeleteJobOfferMutation, DeleteJobOfferMutationVariables>;
export type DeleteJobOfferMutationResult = Apollo.MutationResult<DeleteJobOfferMutation>;
export type DeleteJobOfferMutationOptions = Apollo.BaseMutationOptions<DeleteJobOfferMutation, DeleteJobOfferMutationVariables>;
export const DeletePost = gql`
    mutation DeletePost($postId: String!) {
  deletePost(postId: $postId)
}
    `;
export type DeletePostMutationFn = Apollo.MutationFunction<DeletePostMutation, DeletePostMutationVariables>;
export type DeletePostMutationResult = Apollo.MutationResult<DeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<DeletePostMutation, DeletePostMutationVariables>;
export const DeleteProject = gql`
    mutation DeleteProject($projectId: String!) {
  deleteProject(projectId: $projectId)
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const DeleteSavedSearch = gql`
    mutation DeleteSavedSearch($searchId: String!) {
  deleteSavedSearch(searchId: $searchId)
}
    `;
export type DeleteSavedSearchMutationFn = Apollo.MutationFunction<DeleteSavedSearchMutation, DeleteSavedSearchMutationVariables>;
export type DeleteSavedSearchMutationResult = Apollo.MutationResult<DeleteSavedSearchMutation>;
export type DeleteSavedSearchMutationOptions = Apollo.BaseMutationOptions<DeleteSavedSearchMutation, DeleteSavedSearchMutationVariables>;
export const DeleteSecondaryEmail = gql`
    mutation DeleteSecondaryEmail($id: String!) {
  deleteSecondaryEmail(id: $id)
}
    `;
export type DeleteSecondaryEmailMutationFn = Apollo.MutationFunction<DeleteSecondaryEmailMutation, DeleteSecondaryEmailMutationVariables>;
export type DeleteSecondaryEmailMutationResult = Apollo.MutationResult<DeleteSecondaryEmailMutation>;
export type DeleteSecondaryEmailMutationOptions = Apollo.BaseMutationOptions<DeleteSecondaryEmailMutation, DeleteSecondaryEmailMutationVariables>;
export const DeleteStory = gql`
    mutation DeleteStory($storyId: String!) {
  deleteStory(storyId: $storyId)
}
    `;
export type DeleteStoryMutationFn = Apollo.MutationFunction<DeleteStoryMutation, DeleteStoryMutationVariables>;
export type DeleteStoryMutationResult = Apollo.MutationResult<DeleteStoryMutation>;
export type DeleteStoryMutationOptions = Apollo.BaseMutationOptions<DeleteStoryMutation, DeleteStoryMutationVariables>;
export const DislikeComment = gql`
    mutation DislikeComment($commentId: String!) {
  dislikeComment(commentId: $commentId)
}
    `;
export type DislikeCommentMutationFn = Apollo.MutationFunction<DislikeCommentMutation, DislikeCommentMutationVariables>;
export type DislikeCommentMutationResult = Apollo.MutationResult<DislikeCommentMutation>;
export type DislikeCommentMutationOptions = Apollo.BaseMutationOptions<DislikeCommentMutation, DislikeCommentMutationVariables>;
export const DislikeNewsPost = gql`
    mutation DislikeNewsPost($newsPostId: String!) {
  dislikeNewsPost(newsPostId: $newsPostId)
}
    `;
export type DislikeNewsPostMutationFn = Apollo.MutationFunction<DislikeNewsPostMutation, DislikeNewsPostMutationVariables>;
export type DislikeNewsPostMutationResult = Apollo.MutationResult<DislikeNewsPostMutation>;
export type DislikeNewsPostMutationOptions = Apollo.BaseMutationOptions<DislikeNewsPostMutation, DislikeNewsPostMutationVariables>;
export const DislikePost = gql`
    mutation DislikePost($postId: String!) {
  dislikePost(postId: $postId)
}
    `;
export type DislikePostMutationFn = Apollo.MutationFunction<DislikePostMutation, DislikePostMutationVariables>;
export type DislikePostMutationResult = Apollo.MutationResult<DislikePostMutation>;
export type DislikePostMutationOptions = Apollo.BaseMutationOptions<DislikePostMutation, DislikePostMutationVariables>;
export const Follow = gql`
    mutation Follow($userId: String, $companyId: String) {
  follow(userId: $userId, companyId: $companyId)
}
    `;
export type FollowMutationFn = Apollo.MutationFunction<FollowMutation, FollowMutationVariables>;
export type FollowMutationResult = Apollo.MutationResult<FollowMutation>;
export type FollowMutationOptions = Apollo.BaseMutationOptions<FollowMutation, FollowMutationVariables>;
export const UnFollow = gql`
    mutation UnFollow($userId: String, $companyId: String) {
  unfollow(userId: $userId, companyId: $companyId)
}
    `;
export type UnFollowMutationFn = Apollo.MutationFunction<UnFollowMutation, UnFollowMutationVariables>;
export type UnFollowMutationResult = Apollo.MutationResult<UnFollowMutation>;
export type UnFollowMutationOptions = Apollo.BaseMutationOptions<UnFollowMutation, UnFollowMutationVariables>;
export const HideRating = gql`
    mutation HideRating($id: String!, $isHidden: Boolean!) {
  hideRating(id: $id, isHidden: $isHidden)
}
    `;
export type HideRatingMutationFn = Apollo.MutationFunction<HideRatingMutation, HideRatingMutationVariables>;
export type HideRatingMutationResult = Apollo.MutationResult<HideRatingMutation>;
export type HideRatingMutationOptions = Apollo.BaseMutationOptions<HideRatingMutation, HideRatingMutationVariables>;
export const IgnoreAdminRequest = gql`
    mutation IgnoreAdminRequest($adminRequestId: String!) {
  updateAdminRequest(id: $adminRequestId, status: refused)
}
    `;
export type IgnoreAdminRequestMutationFn = Apollo.MutationFunction<IgnoreAdminRequestMutation, IgnoreAdminRequestMutationVariables>;
export type IgnoreAdminRequestMutationResult = Apollo.MutationResult<IgnoreAdminRequestMutation>;
export type IgnoreAdminRequestMutationOptions = Apollo.BaseMutationOptions<IgnoreAdminRequestMutation, IgnoreAdminRequestMutationVariables>;
export const IncrementStatsContactCount = gql`
    mutation IncrementStatsContactCount($statsId: String!) {
  incrementStatsContactCount(statsId: $statsId)
}
    `;
export type IncrementStatsContactCountMutationFn = Apollo.MutationFunction<IncrementStatsContactCountMutation, IncrementStatsContactCountMutationVariables>;
export type IncrementStatsContactCountMutationResult = Apollo.MutationResult<IncrementStatsContactCountMutation>;
export type IncrementStatsContactCountMutationOptions = Apollo.BaseMutationOptions<IncrementStatsContactCountMutation, IncrementStatsContactCountMutationVariables>;
export const LikeComment = gql`
    mutation LikeComment($commentId: String!) {
  likeComment(commentId: $commentId)
}
    `;
export type LikeCommentMutationFn = Apollo.MutationFunction<LikeCommentMutation, LikeCommentMutationVariables>;
export type LikeCommentMutationResult = Apollo.MutationResult<LikeCommentMutation>;
export type LikeCommentMutationOptions = Apollo.BaseMutationOptions<LikeCommentMutation, LikeCommentMutationVariables>;
export const LikeNewsPost = gql`
    mutation LikeNewsPost($newsPostId: String!) {
  likeNewsPost(newsPostId: $newsPostId)
}
    `;
export type LikeNewsPostMutationFn = Apollo.MutationFunction<LikeNewsPostMutation, LikeNewsPostMutationVariables>;
export type LikeNewsPostMutationResult = Apollo.MutationResult<LikeNewsPostMutation>;
export type LikeNewsPostMutationOptions = Apollo.BaseMutationOptions<LikeNewsPostMutation, LikeNewsPostMutationVariables>;
export const LikePost = gql`
    mutation LikePost($postId: String!) {
  likePost(postId: $postId)
}
    `;
export type LikePostMutationFn = Apollo.MutationFunction<LikePostMutation, LikePostMutationVariables>;
export type LikePostMutationResult = Apollo.MutationResult<LikePostMutation>;
export type LikePostMutationOptions = Apollo.BaseMutationOptions<LikePostMutation, LikePostMutationVariables>;
export const PatchViewerNotificationSubscriptions = gql`
    mutation PatchViewerNotificationSubscriptions($subscriptions: [PatchNotificationSubscriptionInput!]!) {
  patchViewerNotificationSubscriptions(subscriptions: $subscriptions) {
    subject
    status
  }
}
    `;
export type PatchViewerNotificationSubscriptionsMutationFn = Apollo.MutationFunction<PatchViewerNotificationSubscriptionsMutation, PatchViewerNotificationSubscriptionsMutationVariables>;
export type PatchViewerNotificationSubscriptionsMutationResult = Apollo.MutationResult<PatchViewerNotificationSubscriptionsMutation>;
export type PatchViewerNotificationSubscriptionsMutationOptions = Apollo.BaseMutationOptions<PatchViewerNotificationSubscriptionsMutation, PatchViewerNotificationSubscriptionsMutationVariables>;
export const RecoverUser = gql`
    mutation RecoverUser {
  recoverUser
}
    `;
export type RecoverUserMutationFn = Apollo.MutationFunction<RecoverUserMutation, RecoverUserMutationVariables>;
export type RecoverUserMutationResult = Apollo.MutationResult<RecoverUserMutation>;
export type RecoverUserMutationOptions = Apollo.BaseMutationOptions<RecoverUserMutation, RecoverUserMutationVariables>;
export const RefreshBadgeCount = gql`
    mutation RefreshBadgeCount {
  refreshBadgeCount
}
    `;
export type RefreshBadgeCountMutationFn = Apollo.MutationFunction<RefreshBadgeCountMutation, RefreshBadgeCountMutationVariables>;
export type RefreshBadgeCountMutationResult = Apollo.MutationResult<RefreshBadgeCountMutation>;
export type RefreshBadgeCountMutationOptions = Apollo.BaseMutationOptions<RefreshBadgeCountMutation, RefreshBadgeCountMutationVariables>;
export const RequestHomadataEvaluation = gql`
    mutation RequestHomadataEvaluation($adId: ID!) {
  requestHomadataEvaluation(adId: $adId) {
    id
  }
}
    `;
export type RequestHomadataEvaluationMutationFn = Apollo.MutationFunction<RequestHomadataEvaluationMutation, RequestHomadataEvaluationMutationVariables>;
export type RequestHomadataEvaluationMutationResult = Apollo.MutationResult<RequestHomadataEvaluationMutation>;
export type RequestHomadataEvaluationMutationOptions = Apollo.BaseMutationOptions<RequestHomadataEvaluationMutation, RequestHomadataEvaluationMutationVariables>;
export const RemoveAdmin = gql`
    mutation RemoveAdmin($userId: String!) {
  removeAdmin(userId: $userId)
}
    `;
export type RemoveAdminMutationFn = Apollo.MutationFunction<RemoveAdminMutation, RemoveAdminMutationVariables>;
export type RemoveAdminMutationResult = Apollo.MutationResult<RemoveAdminMutation>;
export type RemoveAdminMutationOptions = Apollo.BaseMutationOptions<RemoveAdminMutation, RemoveAdminMutationVariables>;
export const RemoveCompany = gql`
    mutation RemoveCompany($companyId: String!) {
  removeCompany(companyId: $companyId)
}
    `;
export type RemoveCompanyMutationFn = Apollo.MutationFunction<RemoveCompanyMutation, RemoveCompanyMutationVariables>;
export type RemoveCompanyMutationResult = Apollo.MutationResult<RemoveCompanyMutation>;
export type RemoveCompanyMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyMutation, RemoveCompanyMutationVariables>;
export const RemoveContentFromGalleries = gql`
    mutation RemoveContentFromGalleries($isCompanyGallery: Boolean, $adId: String, $postId: String, $newsPostId: String) {
  removeContentFromGalleries(
    isCompanyGallery: $isCompanyGallery
    adId: $adId
    postId: $postId
    newsPostId: $newsPostId
  ) {
    id
    numberOfContents
  }
}
    `;
export type RemoveContentFromGalleriesMutationFn = Apollo.MutationFunction<RemoveContentFromGalleriesMutation, RemoveContentFromGalleriesMutationVariables>;
export type RemoveContentFromGalleriesMutationResult = Apollo.MutationResult<RemoveContentFromGalleriesMutation>;
export type RemoveContentFromGalleriesMutationOptions = Apollo.BaseMutationOptions<RemoveContentFromGalleriesMutation, RemoveContentFromGalleriesMutationVariables>;
export const RemoveCrmSync = gql`
    mutation RemoveCrmSync($companyId: String, $userId: String) {
  removeCrmSync(companyId: $companyId, userId: $userId)
}
    `;
export type RemoveCrmSyncMutationFn = Apollo.MutationFunction<RemoveCrmSyncMutation, RemoveCrmSyncMutationVariables>;
export type RemoveCrmSyncMutationResult = Apollo.MutationResult<RemoveCrmSyncMutation>;
export type RemoveCrmSyncMutationOptions = Apollo.BaseMutationOptions<RemoveCrmSyncMutation, RemoveCrmSyncMutationVariables>;
export const RemoveDirector = gql`
    mutation RemoveDirector($userId: String!) {
  removeDirector(userId: $userId)
}
    `;
export type RemoveDirectorMutationFn = Apollo.MutationFunction<RemoveDirectorMutation, RemoveDirectorMutationVariables>;
export type RemoveDirectorMutationResult = Apollo.MutationResult<RemoveDirectorMutation>;
export type RemoveDirectorMutationOptions = Apollo.BaseMutationOptions<RemoveDirectorMutation, RemoveDirectorMutationVariables>;
export const RemoveGalleryCollaborator = gql`
    mutation RemoveGalleryCollaborator($galleryId: ID!, $collaborator: GalleryCollaboratorRefInput!) {
  removeGalleryCollaborator(galleryId: $galleryId, collaborator: $collaborator) {
    success
  }
}
    `;
export type RemoveGalleryCollaboratorMutationFn = Apollo.MutationFunction<RemoveGalleryCollaboratorMutation, RemoveGalleryCollaboratorMutationVariables>;
export type RemoveGalleryCollaboratorMutationResult = Apollo.MutationResult<RemoveGalleryCollaboratorMutation>;
export type RemoveGalleryCollaboratorMutationOptions = Apollo.BaseMutationOptions<RemoveGalleryCollaboratorMutation, RemoveGalleryCollaboratorMutationVariables>;
export const CancelGalleryInvitation = gql`
    mutation CancelGalleryInvitation($invitationId: ID!) {
  cancelGalleryInvitation(invitationId: $invitationId) {
    success
  }
}
    `;
export type CancelGalleryInvitationMutationFn = Apollo.MutationFunction<CancelGalleryInvitationMutation, CancelGalleryInvitationMutationVariables>;
export type CancelGalleryInvitationMutationResult = Apollo.MutationResult<CancelGalleryInvitationMutation>;
export type CancelGalleryInvitationMutationOptions = Apollo.BaseMutationOptions<CancelGalleryInvitationMutation, CancelGalleryInvitationMutationVariables>;
export const RemoveGroupMembership = gql`
    mutation RemoveGroupMembership($groupId: String, $companyId: String) {
  removeGroupMembership(groupId: $groupId, companyId: $companyId)
}
    `;
export type RemoveGroupMembershipMutationFn = Apollo.MutationFunction<RemoveGroupMembershipMutation, RemoveGroupMembershipMutationVariables>;
export type RemoveGroupMembershipMutationResult = Apollo.MutationResult<RemoveGroupMembershipMutation>;
export type RemoveGroupMembershipMutationOptions = Apollo.BaseMutationOptions<RemoveGroupMembershipMutation, RemoveGroupMembershipMutationVariables>;
export const RemoveMember = gql`
    mutation RemoveMember($userId: String!) {
  removeMember(userId: $userId)
}
    `;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const RemoveRecommendation = gql`
    mutation RemoveRecommendation($userId: String, $companyId: String) {
  removeRecommendation(userId: $userId, companyId: $companyId)
}
    `;
export type RemoveRecommendationMutationFn = Apollo.MutationFunction<RemoveRecommendationMutation, RemoveRecommendationMutationVariables>;
export type RemoveRecommendationMutationResult = Apollo.MutationResult<RemoveRecommendationMutation>;
export type RemoveRecommendationMutationOptions = Apollo.BaseMutationOptions<RemoveRecommendationMutation, RemoveRecommendationMutationVariables>;
export const ReportAd = gql`
    mutation ReportAd($adId: String!, $reason: String!) {
  reportAd(adId: $adId, reason: $reason)
}
    `;
export type ReportAdMutationFn = Apollo.MutationFunction<ReportAdMutation, ReportAdMutationVariables>;
export type ReportAdMutationResult = Apollo.MutationResult<ReportAdMutation>;
export type ReportAdMutationOptions = Apollo.BaseMutationOptions<ReportAdMutation, ReportAdMutationVariables>;
export const ReportComment = gql`
    mutation ReportComment($commentId: String!, $reason: String!) {
  reportComment(commentId: $commentId, reason: $reason)
}
    `;
export type ReportCommentMutationFn = Apollo.MutationFunction<ReportCommentMutation, ReportCommentMutationVariables>;
export type ReportCommentMutationResult = Apollo.MutationResult<ReportCommentMutation>;
export type ReportCommentMutationOptions = Apollo.BaseMutationOptions<ReportCommentMutation, ReportCommentMutationVariables>;
export const ReportCompany = gql`
    mutation ReportCompany($reason: String!, $companyId: String!) {
  reportCompany(reason: $reason, companyId: $companyId)
}
    `;
export type ReportCompanyMutationFn = Apollo.MutationFunction<ReportCompanyMutation, ReportCompanyMutationVariables>;
export type ReportCompanyMutationResult = Apollo.MutationResult<ReportCompanyMutation>;
export type ReportCompanyMutationOptions = Apollo.BaseMutationOptions<ReportCompanyMutation, ReportCompanyMutationVariables>;
export const ReportConversation = gql`
    mutation ReportConversation($channelUrl: String!, $reason: String!) {
  reportConversation(channelUrl: $channelUrl, reason: $reason)
}
    `;
export type ReportConversationMutationFn = Apollo.MutationFunction<ReportConversationMutation, ReportConversationMutationVariables>;
export type ReportConversationMutationResult = Apollo.MutationResult<ReportConversationMutation>;
export type ReportConversationMutationOptions = Apollo.BaseMutationOptions<ReportConversationMutation, ReportConversationMutationVariables>;
export const ReportNewsPost = gql`
    mutation ReportNewsPost($newsPostId: String!, $reason: String!) {
  reportNewsPost(newsPostId: $newsPostId, reason: $reason)
}
    `;
export type ReportNewsPostMutationFn = Apollo.MutationFunction<ReportNewsPostMutation, ReportNewsPostMutationVariables>;
export type ReportNewsPostMutationResult = Apollo.MutationResult<ReportNewsPostMutation>;
export type ReportNewsPostMutationOptions = Apollo.BaseMutationOptions<ReportNewsPostMutation, ReportNewsPostMutationVariables>;
export const ReportPost = gql`
    mutation ReportPost($postId: String!, $reason: String!) {
  reportPost(postId: $postId, reason: $reason)
}
    `;
export type ReportPostMutationFn = Apollo.MutationFunction<ReportPostMutation, ReportPostMutationVariables>;
export type ReportPostMutationResult = Apollo.MutationResult<ReportPostMutation>;
export type ReportPostMutationOptions = Apollo.BaseMutationOptions<ReportPostMutation, ReportPostMutationVariables>;
export const ReportStory = gql`
    mutation ReportStory($storyId: String!, $reason: String!) {
  reportStory(storyId: $storyId, reason: $reason)
}
    `;
export type ReportStoryMutationFn = Apollo.MutationFunction<ReportStoryMutation, ReportStoryMutationVariables>;
export type ReportStoryMutationResult = Apollo.MutationResult<ReportStoryMutation>;
export type ReportStoryMutationOptions = Apollo.BaseMutationOptions<ReportStoryMutation, ReportStoryMutationVariables>;
export const ReportUser = gql`
    mutation ReportUser($userId: String!, $reason: String!) {
  reportUser(userId: $userId, reason: $reason)
}
    `;
export type ReportUserMutationFn = Apollo.MutationFunction<ReportUserMutation, ReportUserMutationVariables>;
export type ReportUserMutationResult = Apollo.MutationResult<ReportUserMutation>;
export type ReportUserMutationOptions = Apollo.BaseMutationOptions<ReportUserMutation, ReportUserMutationVariables>;
export const RequestAdminAccess = gql`
    mutation RequestAdminAccess($companyId: String!) {
  requestAdminAccess(companyId: $companyId) {
    id
  }
}
    `;
export type RequestAdminAccessMutationFn = Apollo.MutationFunction<RequestAdminAccessMutation, RequestAdminAccessMutationVariables>;
export type RequestAdminAccessMutationResult = Apollo.MutationResult<RequestAdminAccessMutation>;
export type RequestAdminAccessMutationOptions = Apollo.BaseMutationOptions<RequestAdminAccessMutation, RequestAdminAccessMutationVariables>;
export const RequestAgentEmail = gql`
    mutation RequestAgentEmail($estimationId: String!) {
  requestAgentEmail(estimationId: $estimationId)
}
    `;
export type RequestAgentEmailMutationFn = Apollo.MutationFunction<RequestAgentEmailMutation, RequestAgentEmailMutationVariables>;
export type RequestAgentEmailMutationResult = Apollo.MutationResult<RequestAgentEmailMutation>;
export type RequestAgentEmailMutationOptions = Apollo.BaseMutationOptions<RequestAgentEmailMutation, RequestAgentEmailMutationVariables>;
export const RequestRecommendation = gql`
    mutation RequestRecommendation($userId: String!) {
  requestRecommendation(userId: $userId) {
    id
  }
}
    `;
export type RequestRecommendationMutationFn = Apollo.MutationFunction<RequestRecommendationMutation, RequestRecommendationMutationVariables>;
export type RequestRecommendationMutationResult = Apollo.MutationResult<RequestRecommendationMutation>;
export type RequestRecommendationMutationOptions = Apollo.BaseMutationOptions<RequestRecommendationMutation, RequestRecommendationMutationVariables>;
export const RequestVerificationCode = gql`
    mutation RequestVerificationCode($proId: String!) {
  requestVerificationCode(proId: $proId)
}
    `;
export type RequestVerificationCodeMutationFn = Apollo.MutationFunction<RequestVerificationCodeMutation, RequestVerificationCodeMutationVariables>;
export type RequestVerificationCodeMutationResult = Apollo.MutationResult<RequestVerificationCodeMutation>;
export type RequestVerificationCodeMutationOptions = Apollo.BaseMutationOptions<RequestVerificationCodeMutation, RequestVerificationCodeMutationVariables>;
export const SaveNewsCategories = gql`
    mutation SaveNewsCategories($categoryIds: [String!]!) {
  saveNewsCategories(categoryIds: $categoryIds)
}
    `;
export type SaveNewsCategoriesMutationFn = Apollo.MutationFunction<SaveNewsCategoriesMutation, SaveNewsCategoriesMutationVariables>;
export type SaveNewsCategoriesMutationResult = Apollo.MutationResult<SaveNewsCategoriesMutation>;
export type SaveNewsCategoriesMutationOptions = Apollo.BaseMutationOptions<SaveNewsCategoriesMutation, SaveNewsCategoriesMutationVariables>;
export const SaveSearchByPlace = gql`
    mutation SaveSearchByPlace($name: String!, $parameters: String!, $place: GeometryInput!, $placeSource: GeometrySource, $emailNotificationsEnabled: Boolean) {
  saveSearchByPlace(
    name: $name
    parameters: $parameters
    place: $place
    placeSource: $placeSource
    emailNotificationsEnabled: $emailNotificationsEnabled
  ) {
    id
    isFirstSavedAdSearch
  }
}
    `;
export type SaveSearchByPlaceMutationFn = Apollo.MutationFunction<SaveSearchByPlaceMutation, SaveSearchByPlaceMutationVariables>;
export type SaveSearchByPlaceMutationResult = Apollo.MutationResult<SaveSearchByPlaceMutation>;
export type SaveSearchByPlaceMutationOptions = Apollo.BaseMutationOptions<SaveSearchByPlaceMutation, SaveSearchByPlaceMutationVariables>;
export const SendChatNotificationMessage = gql`
    mutation SendChatNotificationMessage($notification: ChatNotificationData!, $channelUrl: String!, $requestId: String) {
  sendChatNotificationMessage(
    notification: $notification
    channelUrl: $channelUrl
    requestId: $requestId
  ) {
    id
  }
}
    `;
export type SendChatNotificationMessageMutationFn = Apollo.MutationFunction<SendChatNotificationMessageMutation, SendChatNotificationMessageMutationVariables>;
export type SendChatNotificationMessageMutationResult = Apollo.MutationResult<SendChatNotificationMessageMutation>;
export type SendChatNotificationMessageMutationOptions = Apollo.BaseMutationOptions<SendChatNotificationMessageMutation, SendChatNotificationMessageMutationVariables>;
export const SendMailVerification = gql`
    mutation SendMailVerification($email: String, $id: String) {
  sendMailVerification(email: $email, id: $id)
}
    `;
export type SendMailVerificationMutationFn = Apollo.MutationFunction<SendMailVerificationMutation, SendMailVerificationMutationVariables>;
export type SendMailVerificationMutationResult = Apollo.MutationResult<SendMailVerificationMutation>;
export type SendMailVerificationMutationOptions = Apollo.BaseMutationOptions<SendMailVerificationMutation, SendMailVerificationMutationVariables>;
export const SendMessage = gql`
    mutation SendMessage($message: String, $data: String, $channelUrl: String!, $requestId: String) {
  sendMessage(
    message: $message
    channelUrl: $channelUrl
    data: $data
    requestId: $requestId
  ) {
    id
  }
}
    `;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const SendSharedContentMessage = gql`
    mutation SendSharedContentMessage($message: String, $data: MessageData, $channelUrl: String!, $requestId: String) {
  sendSharedContentMessage(
    message: $message
    channelUrl: $channelUrl
    data: $data
    requestId: $requestId
  ) {
    id
  }
}
    `;
export type SendSharedContentMessageMutationFn = Apollo.MutationFunction<SendSharedContentMessageMutation, SendSharedContentMessageMutationVariables>;
export type SendSharedContentMessageMutationResult = Apollo.MutationResult<SendSharedContentMessageMutation>;
export type SendSharedContentMessageMutationOptions = Apollo.BaseMutationOptions<SendSharedContentMessageMutation, SendSharedContentMessageMutationVariables>;
export const SendSharedFileMessage = gql`
    mutation SendSharedFileMessage($message: String, $files: [Upload]!, $channelUrl: String!, $requestId: String) {
  sendSharedFileMessage(
    message: $message
    files: $files
    channelUrl: $channelUrl
    requestId: $requestId
  ) {
    id
    data
  }
}
    `;
export type SendSharedFileMessageMutationFn = Apollo.MutationFunction<SendSharedFileMessageMutation, SendSharedFileMessageMutationVariables>;
export type SendSharedFileMessageMutationResult = Apollo.MutationResult<SendSharedFileMessageMutation>;
export type SendSharedFileMessageMutationOptions = Apollo.BaseMutationOptions<SendSharedFileMessageMutation, SendSharedFileMessageMutationVariables>;
export const SetPrimaryEmail = gql`
    mutation SetPrimaryEmail($secondaryEmail: String!) {
  setPrimaryEmail(secondaryEmail: $secondaryEmail)
}
    `;
export type SetPrimaryEmailMutationFn = Apollo.MutationFunction<SetPrimaryEmailMutation, SetPrimaryEmailMutationVariables>;
export type SetPrimaryEmailMutationResult = Apollo.MutationResult<SetPrimaryEmailMutation>;
export type SetPrimaryEmailMutationOptions = Apollo.BaseMutationOptions<SetPrimaryEmailMutation, SetPrimaryEmailMutationVariables>;
export const SignUp = gql`
    mutation SignUp($hasOptedInToMarketingCommsAt: Date, $hasOptedInAt: Date, $quickSignupUserId: String, $ipAddress: String, $platform: PlatformSource, $firstName: String, $lastName: String) {
  signUp(
    hasOptedInToMarketingCommsAt: $hasOptedInToMarketingCommsAt
    hasOptedInAt: $hasOptedInAt
    quickSignupUserId: $quickSignupUserId
    ipAddress: $ipAddress
    platform: $platform
    firstName: $firstName
    lastName: $lastName
  ) {
    id
    email
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const SignUpStepTwo = gql`
    mutation SignUpStepTwo($firstName: String!, $lastName: String!, $cityId: String, $googlePlaceId: String, $imageHybridMedium: HybridMedium, $description: String, $phoneNumber: String) {
  updatePersonalInfo(
    firstName: $firstName
    lastName: $lastName
    cityId: $cityId
    googlePlaceId: $googlePlaceId
    imageHybridMedium: $imageHybridMedium
    description: $description
    phoneNumber: $phoneNumber
  ) {
    id
  }
}
    `;
export type SignUpStepTwoMutationFn = Apollo.MutationFunction<SignUpStepTwoMutation, SignUpStepTwoMutationVariables>;
export type SignUpStepTwoMutationResult = Apollo.MutationResult<SignUpStepTwoMutation>;
export type SignUpStepTwoMutationOptions = Apollo.BaseMutationOptions<SignUpStepTwoMutation, SignUpStepTwoMutationVariables>;
export const SignUpPro = gql`
    mutation SignUpPro($activityId: String!, $customActivity: String, $hasOptedInToMarketingCommsAt: Date, $hasOptedInAt: Date, $quickSignupUserId: String, $isTheRealEstateOther: Boolean, $ipAddress: String, $platform: PlatformSource) {
  signUpPro(
    activityId: $activityId
    customActivity: $customActivity
    hasOptedInToMarketingCommsAt: $hasOptedInToMarketingCommsAt
    hasOptedInAt: $hasOptedInAt
    quickSignupUserId: $quickSignupUserId
    isTheRealEstateOther: $isTheRealEstateOther
    ipAddress: $ipAddress
    platform: $platform
  ) {
    id
    email
  }
}
    `;
export type SignUpProMutationFn = Apollo.MutationFunction<SignUpProMutation, SignUpProMutationVariables>;
export type SignUpProMutationResult = Apollo.MutationResult<SignUpProMutation>;
export type SignUpProMutationOptions = Apollo.BaseMutationOptions<SignUpProMutation, SignUpProMutationVariables>;
export const SoftDeleteAd = gql`
    mutation SoftDeleteAd($id: String!) {
  softDeleteAd(id: $id)
}
    `;
export type SoftDeleteAdMutationFn = Apollo.MutationFunction<SoftDeleteAdMutation, SoftDeleteAdMutationVariables>;
export type SoftDeleteAdMutationResult = Apollo.MutationResult<SoftDeleteAdMutation>;
export type SoftDeleteAdMutationOptions = Apollo.BaseMutationOptions<SoftDeleteAdMutation, SoftDeleteAdMutationVariables>;
export const SoftDeleteUser = gql`
    mutation SoftDeleteUser {
  softDeleteUser
}
    `;
export type SoftDeleteUserMutationFn = Apollo.MutationFunction<SoftDeleteUserMutation, SoftDeleteUserMutationVariables>;
export type SoftDeleteUserMutationResult = Apollo.MutationResult<SoftDeleteUserMutation>;
export type SoftDeleteUserMutationOptions = Apollo.BaseMutationOptions<SoftDeleteUserMutation, SoftDeleteUserMutationVariables>;
export const IncrementStatsViewCount = gql`
    mutation IncrementStatsViewCount($adId: String, $newsPostId: String) {
  incrementStatsViewCount(adId: $adId, newsPostId: $newsPostId)
}
    `;
export type IncrementStatsViewCountMutationFn = Apollo.MutationFunction<IncrementStatsViewCountMutation, IncrementStatsViewCountMutationVariables>;
export type IncrementStatsViewCountMutationResult = Apollo.MutationResult<IncrementStatsViewCountMutation>;
export type IncrementStatsViewCountMutationOptions = Apollo.BaseMutationOptions<IncrementStatsViewCountMutation, IncrementStatsViewCountMutationVariables>;
export const SubmitInterest = gql`
    mutation SubmitInterest($interest: String!, $userId: String!) {
  submitInterest(interest: $interest, userId: $userId)
}
    `;
export type SubmitInterestMutationFn = Apollo.MutationFunction<SubmitInterestMutation, SubmitInterestMutationVariables>;
export type SubmitInterestMutationResult = Apollo.MutationResult<SubmitInterestMutation>;
export type SubmitInterestMutationOptions = Apollo.BaseMutationOptions<SubmitInterestMutation, SubmitInterestMutationVariables>;
export const SyncNotifications = gql`
    mutation SyncNotifications {
  syncNotifications
}
    `;
export type SyncNotificationsMutationFn = Apollo.MutationFunction<SyncNotificationsMutation, SyncNotificationsMutationVariables>;
export type SyncNotificationsMutationResult = Apollo.MutationResult<SyncNotificationsMutation>;
export type SyncNotificationsMutationOptions = Apollo.BaseMutationOptions<SyncNotificationsMutation, SyncNotificationsMutationVariables>;
export const UnsubscribeQuickSignupUser = gql`
    mutation UnsubscribeQuickSignupUser($quickSignupUserId: String!) {
  unsubscribeQuickSignupUser(quickSignupUserId: $quickSignupUserId)
}
    `;
export type UnsubscribeQuickSignupUserMutationFn = Apollo.MutationFunction<UnsubscribeQuickSignupUserMutation, UnsubscribeQuickSignupUserMutationVariables>;
export type UnsubscribeQuickSignupUserMutationResult = Apollo.MutationResult<UnsubscribeQuickSignupUserMutation>;
export type UnsubscribeQuickSignupUserMutationOptions = Apollo.BaseMutationOptions<UnsubscribeQuickSignupUserMutation, UnsubscribeQuickSignupUserMutationVariables>;
export const UpdateAd = gql`
    mutation UpdateAd($id: String!, $type: AdTypes!, $propertyType: PropertyTypes!, $isHiddingCompleteAddress: Boolean!, $title: String, $description: String, $propertyState: PropertyState, $commonAreasState: CommonAreasState, $propertyPurposeEstimation: PropertyPurposeEstimation, $propertyResidenceType: PropertyResidenceType, $userIsOwner: Boolean, $contactConsent: Boolean, $status: AdStatuses, $constructionYear: Int, $floorPosition: Int, $livingArea: Float, $landArea: Float, $media: [HybridMedium]!, $bedroomNumber: Int, $roomNumber: Int, $floorNumber: Int, $rooms: String, $heatType: HeatTypes, $heatInformations: String, $consumption: String, $emissions: String, $interOffice: Boolean!, $commissionRate: Float, $assets: [String], $price: Int, $homadataEvaluation: String, $furnished: Boolean, $inclusions: String, $rent: Int, $fees: Int, $monthlyCharges: Float, $inventory: Float, $guarantees: String, $availableDate: Int, $email: String, $servicedLand: YesNoNAOptions, $constructibleLand: YesNoNAOptions, $newProperty: Boolean, $surfaceArea: Float, $numberOfVehicles: Int, $dimensionLength: Float, $dimensionWidth: Float, $dimensionHeight: Float, $coOwnership: Boolean, $coOwnershipNumberOfLots: Int, $coOwnershipOngoing: YesNoOptions, $coOwnershipYearlyCharge: Float, $saleFeeType: SaleFeeType, $saleFeeBuyerRate: Float, $showSaleFeeBuyerPrice: Boolean, $priceWithoutSaleFee: Int, $isInaccurateAddress: Boolean!, $userId: String, $companyId: String, $address: AddressParam) {
  updateAd(
    id: $id
    type: $type
    propertyType: $propertyType
    isHiddingCompleteAddress: $isHiddingCompleteAddress
    title: $title
    description: $description
    propertyState: $propertyState
    commonAreasState: $commonAreasState
    propertyPurposeEstimation: $propertyPurposeEstimation
    propertyResidenceType: $propertyResidenceType
    userIsOwner: $userIsOwner
    contactConsent: $contactConsent
    status: $status
    constructionYear: $constructionYear
    floorPosition: $floorPosition
    livingArea: $livingArea
    landArea: $landArea
    media: $media
    bedroomNumber: $bedroomNumber
    roomNumber: $roomNumber
    floorNumber: $floorNumber
    rooms: $rooms
    heatType: $heatType
    heatInformations: $heatInformations
    consumption: $consumption
    emissions: $emissions
    interOffice: $interOffice
    commissionRate: $commissionRate
    assets: $assets
    price: $price
    homadataEvaluation: $homadataEvaluation
    furnished: $furnished
    inclusions: $inclusions
    rent: $rent
    monthlyCharges: $monthlyCharges
    inventory: $inventory
    fees: $fees
    guarantees: $guarantees
    availableDate: $availableDate
    email: $email
    servicedLand: $servicedLand
    constructibleLand: $constructibleLand
    newProperty: $newProperty
    surfaceArea: $surfaceArea
    numberOfVehicles: $numberOfVehicles
    dimensionLength: $dimensionLength
    dimensionWidth: $dimensionWidth
    dimensionHeight: $dimensionHeight
    coOwnership: $coOwnership
    coOwnershipNumberOfLots: $coOwnershipNumberOfLots
    coOwnershipOngoing: $coOwnershipOngoing
    coOwnershipYearlyCharge: $coOwnershipYearlyCharge
    saleFeeType: $saleFeeType
    saleFeeBuyerRate: $saleFeeBuyerRate
    showSaleFeeBuyerPrice: $showSaleFeeBuyerPrice
    priceWithoutSaleFee: $priceWithoutSaleFee
    isInaccurateAddress: $isInaccurateAddress
    userId: $userId
    companyId: $companyId
    address: $address
  ) {
    id
  }
}
    `;
export type UpdateAdMutationFn = Apollo.MutationFunction<UpdateAdMutation, UpdateAdMutationVariables>;
export type UpdateAdMutationResult = Apollo.MutationResult<UpdateAdMutation>;
export type UpdateAdMutationOptions = Apollo.BaseMutationOptions<UpdateAdMutation, UpdateAdMutationVariables>;
export const UpdateAdStatus = gql`
    mutation UpdateAdStatus($id: String!, $status: AdStatuses!, $priceSold: Int, $reasonWhyAdArchived: ReasonWhyAdArchived) {
  updateAdStatus(
    id: $id
    status: $status
    priceSold: $priceSold
    reasonWhyAdArchived: $reasonWhyAdArchived
  )
}
    `;
export type UpdateAdStatusMutationFn = Apollo.MutationFunction<UpdateAdStatusMutation, UpdateAdStatusMutationVariables>;
export type UpdateAdStatusMutationResult = Apollo.MutationResult<UpdateAdStatusMutation>;
export type UpdateAdStatusMutationOptions = Apollo.BaseMutationOptions<UpdateAdStatusMutation, UpdateAdStatusMutationVariables>;
export const UpdateChannelName = gql`
    mutation UpdateChannelName($channelUrl: String!, $name: String!) {
  updateChannelName(channelUrl: $channelUrl, name: $name)
}
    `;
export type UpdateChannelNameMutationFn = Apollo.MutationFunction<UpdateChannelNameMutation, UpdateChannelNameMutationVariables>;
export type UpdateChannelNameMutationResult = Apollo.MutationResult<UpdateChannelNameMutation>;
export type UpdateChannelNameMutationOptions = Apollo.BaseMutationOptions<UpdateChannelNameMutation, UpdateChannelNameMutationVariables>;
export const UpdateChannelToSuperChannel = gql`
    mutation UpdateChannelToSuperChannel($channelUrl: String!) {
  updateChannelToSuperChannel(channelUrl: $channelUrl)
}
    `;
export type UpdateChannelToSuperChannelMutationFn = Apollo.MutationFunction<UpdateChannelToSuperChannelMutation, UpdateChannelToSuperChannelMutationVariables>;
export type UpdateChannelToSuperChannelMutationResult = Apollo.MutationResult<UpdateChannelToSuperChannelMutation>;
export type UpdateChannelToSuperChannelMutationOptions = Apollo.BaseMutationOptions<UpdateChannelToSuperChannelMutation, UpdateChannelToSuperChannelMutationVariables>;
export const UpdateComment = gql`
    mutation UpdateComment($commentId: String!, $content: String!) {
  updateComment(commentId: $commentId, content: $content) {
    id
  }
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const UpdateCompanyShowcase = gql`
    mutation UpdateCompanyShowcase($companyId: String!, $media: [HybridMedium]!) {
  updateCompanyShowcase(companyId: $companyId, media: $media) {
    id
    width
    height
    size
    aspectRatio
    duration
    rotation
    url
    type
  }
}
    `;
export type UpdateCompanyShowcaseMutationFn = Apollo.MutationFunction<UpdateCompanyShowcaseMutation, UpdateCompanyShowcaseMutationVariables>;
export type UpdateCompanyShowcaseMutationResult = Apollo.MutationResult<UpdateCompanyShowcaseMutation>;
export type UpdateCompanyShowcaseMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyShowcaseMutation, UpdateCompanyShowcaseMutationVariables>;
export const UpdateCompanyWithNullableAddress = gql`
    mutation UpdateCompanyWithNullableAddress($id: String!, $name: String, $description: String, $phoneNumber: PhoneParam, $feeScaleFileHybridMedium: HybridMedium, $feeScaleFileName: String, $siretNumber: String, $website: String, $foundationYear: Int, $address: AddressParam, $showcase: [HybridMedium], $imageHybridMedium: HybridMedium, $videoHybridMedium: HybridMedium, $coverImageHybridMedium: HybridMedium, $contactUserId: String, $mission: String, $contactUrl: String, $label: CompanyLabel, $mainActivityId: String, $mainCategoryId: String, $customActivity: String) {
  updateCompanyWithNullableAddress(
    id: $id
    name: $name
    description: $description
    phoneNumber: $phoneNumber
    feeScaleFileHybridMedium: $feeScaleFileHybridMedium
    feeScaleFileName: $feeScaleFileName
    siretNumber: $siretNumber
    website: $website
    foundationYear: $foundationYear
    address: $address
    showcase: $showcase
    imageHybridMedium: $imageHybridMedium
    videoHybridMedium: $videoHybridMedium
    coverImageHybridMedium: $coverImageHybridMedium
    contactUserId: $contactUserId
    mission: $mission
    contactUrl: $contactUrl
    label: $label
    mainActivityId: $mainActivityId
    mainCategoryId: $mainCategoryId
    customActivity: $customActivity
  ) {
    id
  }
}
    `;
export type UpdateCompanyWithNullableAddressMutationFn = Apollo.MutationFunction<UpdateCompanyWithNullableAddressMutation, UpdateCompanyWithNullableAddressMutationVariables>;
export type UpdateCompanyWithNullableAddressMutationResult = Apollo.MutationResult<UpdateCompanyWithNullableAddressMutation>;
export type UpdateCompanyWithNullableAddressMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyWithNullableAddressMutation, UpdateCompanyWithNullableAddressMutationVariables>;
export const UpdateContact = gql`
    mutation UpdateContact($id: String, $userId: String, $contactedUserId: String, $status: String!) {
  updateContact(
    id: $id
    userId: $userId
    contactedUserId: $contactedUserId
    status: $status
  )
}
    `;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const UpdateGallery = gql`
    mutation UpdateGallery($id: String!, $name: String!, $isSecret: Boolean!) {
  updateGallery(id: $id, name: $name, isSecret: $isSecret) {
    id
    name
    isSecret
  }
}
    `;
export type UpdateGalleryMutationFn = Apollo.MutationFunction<UpdateGalleryMutation, UpdateGalleryMutationVariables>;
export type UpdateGalleryMutationResult = Apollo.MutationResult<UpdateGalleryMutation>;
export type UpdateGalleryMutationOptions = Apollo.BaseMutationOptions<UpdateGalleryMutation, UpdateGalleryMutationVariables>;
export const UpdateGroupInvitation = gql`
    mutation UpdateGroupInvitation($groupId: String, $companyId: String, $status: InvitationStatus) {
  updateGroupInvitation(groupId: $groupId, companyId: $companyId, status: $status)
}
    `;
export type UpdateGroupInvitationMutationFn = Apollo.MutationFunction<UpdateGroupInvitationMutation, UpdateGroupInvitationMutationVariables>;
export type UpdateGroupInvitationMutationResult = Apollo.MutationResult<UpdateGroupInvitationMutation>;
export type UpdateGroupInvitationMutationOptions = Apollo.BaseMutationOptions<UpdateGroupInvitationMutation, UpdateGroupInvitationMutationVariables>;
export const UpdateInvitation = gql`
    mutation UpdateInvitation($userId: String, $companyId: String, $status: InvitationStatus) {
  updateInvitation(userId: $userId, companyId: $companyId, status: $status)
}
    `;
export type UpdateInvitationMutationFn = Apollo.MutationFunction<UpdateInvitationMutation, UpdateInvitationMutationVariables>;
export type UpdateInvitationMutationResult = Apollo.MutationResult<UpdateInvitationMutation>;
export type UpdateInvitationMutationOptions = Apollo.BaseMutationOptions<UpdateInvitationMutation, UpdateInvitationMutationVariables>;
export const UpdateJobOffer = gql`
    mutation UpdateJobOffer($id: String!, $companyName: String!, $jobTypeId: String!, $cityId: String, $googlePlaceId: String, $title: String!, $description: String, $profile: String, $emailAddress: String!) {
  updateJobOffer(
    id: $id
    companyName: $companyName
    jobTypeId: $jobTypeId
    cityId: $cityId
    googlePlaceId: $googlePlaceId
    title: $title
    description: $description
    profile: $profile
    emailAddress: $emailAddress
  ) {
    id
  }
}
    `;
export type UpdateJobOfferMutationFn = Apollo.MutationFunction<UpdateJobOfferMutation, UpdateJobOfferMutationVariables>;
export type UpdateJobOfferMutationResult = Apollo.MutationResult<UpdateJobOfferMutation>;
export type UpdateJobOfferMutationOptions = Apollo.BaseMutationOptions<UpdateJobOfferMutation, UpdateJobOfferMutationVariables>;
export const UpdateJobOfferIsHidden = gql`
    mutation UpdateJobOfferIsHidden($id: String!, $isHidden: Boolean!) {
  updateJobOfferIsHidden(id: $id, isHidden: $isHidden) {
    id
    isHidden
    updatedAt
  }
}
    `;
export type UpdateJobOfferIsHiddenMutationFn = Apollo.MutationFunction<UpdateJobOfferIsHiddenMutation, UpdateJobOfferIsHiddenMutationVariables>;
export type UpdateJobOfferIsHiddenMutationResult = Apollo.MutationResult<UpdateJobOfferIsHiddenMutation>;
export type UpdateJobOfferIsHiddenMutationOptions = Apollo.BaseMutationOptions<UpdateJobOfferIsHiddenMutation, UpdateJobOfferIsHiddenMutationVariables>;
export const UpdatePost = gql`
    mutation UpdatePost($postId: String!, $media: [HybridMedium]!, $message: String, $newsPostId: String, $adId: String, $projectId: String) {
  updatePost(
    id: $postId
    media: $media
    message: $message
    newsPostId: $newsPostId
    adId: $adId
    projectId: $projectId
  ) {
    id
  }
}
    `;
export type UpdatePostMutationFn = Apollo.MutationFunction<UpdatePostMutation, UpdatePostMutationVariables>;
export type UpdatePostMutationResult = Apollo.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationOptions = Apollo.BaseMutationOptions<UpdatePostMutation, UpdatePostMutationVariables>;
export const UpdateProject = gql`
    mutation UpdateProject($projectId: String!, $name: String!, $cityId: String, $googlePlaceId: String, $description: String!, $media: [HybridMedium]!) {
  updateProject(
    projectId: $projectId
    name: $name
    cityId: $cityId
    googlePlaceId: $googlePlaceId
    description: $description
    media: $media
  ) {
    id
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateRating = gql`
    mutation UpdateRating($id: String!, $value: Int!, $comment: String) {
  updateRating(id: $id, value: $value, comment: $comment) {
    numberOfRatings
    averageRating
  }
}
    `;
export type UpdateRatingMutationFn = Apollo.MutationFunction<UpdateRatingMutation, UpdateRatingMutationVariables>;
export type UpdateRatingMutationResult = Apollo.MutationResult<UpdateRatingMutation>;
export type UpdateRatingMutationOptions = Apollo.BaseMutationOptions<UpdateRatingMutation, UpdateRatingMutationVariables>;
export const UpdateRecommendation = gql`
    mutation UpdateRecommendation($recommendationId: String!, $status: RecommendationStatus) {
  updateRecommendation(recommendationId: $recommendationId, status: $status) {
    id
  }
}
    `;
export type UpdateRecommendationMutationFn = Apollo.MutationFunction<UpdateRecommendationMutation, UpdateRecommendationMutationVariables>;
export type UpdateRecommendationMutationResult = Apollo.MutationResult<UpdateRecommendationMutation>;
export type UpdateRecommendationMutationOptions = Apollo.BaseMutationOptions<UpdateRecommendationMutation, UpdateRecommendationMutationVariables>;
export const UpdateSearchByPlace = gql`
    mutation UpdateSearchByPlace($id: String!, $name: String, $parameters: String, $place: GeometryInput, $placeSource: GeometrySource, $lastViewedAt: Date, $emailNotificationsEnabled: Boolean) {
  updateSearchByPlace(
    id: $id
    name: $name
    parameters: $parameters
    place: $place
    placeSource: $placeSource
    lastViewedAt: $lastViewedAt
    emailNotificationsEnabled: $emailNotificationsEnabled
  ) {
    id
    name
    parameters
    lastViewedAt
    isFirstSavedAdSearch
    placeGeometry {
      type
      coordinates
      source
    }
    emailNotificationsEnabled
  }
}
    `;
export type UpdateSearchByPlaceMutationFn = Apollo.MutationFunction<UpdateSearchByPlaceMutation, UpdateSearchByPlaceMutationVariables>;
export type UpdateSearchByPlaceMutationResult = Apollo.MutationResult<UpdateSearchByPlaceMutation>;
export type UpdateSearchByPlaceMutationOptions = Apollo.BaseMutationOptions<UpdateSearchByPlaceMutation, UpdateSearchByPlaceMutationVariables>;
export const UpdateShowcase = gql`
    mutation UpdateShowcase($media: [HybridMedium]!) {
  updateShowcase(media: $media) {
    id
    width
    height
    size
    aspectRatio
    duration
    rotation
    url
    type
  }
}
    `;
export type UpdateShowcaseMutationFn = Apollo.MutationFunction<UpdateShowcaseMutation, UpdateShowcaseMutationVariables>;
export type UpdateShowcaseMutationResult = Apollo.MutationResult<UpdateShowcaseMutation>;
export type UpdateShowcaseMutationOptions = Apollo.BaseMutationOptions<UpdateShowcaseMutation, UpdateShowcaseMutationVariables>;
export const UpdateUserLocale = gql`
    mutation UpdateUserLocale($locale: SupportedLocales!) {
  updateUserLocale(locale: $locale)
}
    `;
export type UpdateUserLocaleMutationFn = Apollo.MutationFunction<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>;
export type UpdateUserLocaleMutationResult = Apollo.MutationResult<UpdateUserLocaleMutation>;
export type UpdateUserLocaleMutationOptions = Apollo.BaseMutationOptions<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>;
export const UpdateMyProfileImage = gql`
    mutation UpdateMyProfileImage($imageHybridMedium: HybridMedium) {
  updateMyProfileImage(imageHybridMedium: $imageHybridMedium) {
    id
    image {
      id
      width
      height
      size
      aspectRatio
      duration
      rotation
      url
      type
    }
  }
}
    `;
export type UpdateMyProfileImageMutationFn = Apollo.MutationFunction<UpdateMyProfileImageMutation, UpdateMyProfileImageMutationVariables>;
export type UpdateMyProfileImageMutationResult = Apollo.MutationResult<UpdateMyProfileImageMutation>;
export type UpdateMyProfileImageMutationOptions = Apollo.BaseMutationOptions<UpdateMyProfileImageMutation, UpdateMyProfileImageMutationVariables>;
export const UpdateUserProfile = gql`
    mutation UpdateUserProfile($firstName: String, $lastName: String, $imageHybridMedium: HybridMedium, $coverImageHybridMedium: HybridMedium, $cityId: String, $googlePlaceId: String, $description: String, $phoneNumber: String, $certificates: String, $customActivity: String, $services: String, $awards: String, $feeScaleFileHybridMedium: HybridMedium, $feeScaleFileName: String) {
  updatePersonalInfo(
    firstName: $firstName
    lastName: $lastName
    imageHybridMedium: $imageHybridMedium
    coverImageHybridMedium: $coverImageHybridMedium
    cityId: $cityId
    googlePlaceId: $googlePlaceId
    description: $description
    phoneNumber: $phoneNumber
    certificates: $certificates
    customActivity: $customActivity
    services: $services
    awards: $awards
    feeScaleFileHybridMedium: $feeScaleFileHybridMedium
    feeScaleFileName: $feeScaleFileName
  ) {
    id
  }
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const UpdateUserProfilePro = gql`
    mutation UpdateUserProfilePro($firstName: String, $lastName: String, $imageHybridMedium: HybridMedium, $cityId: String, $googlePlaceId: String, $phoneNumber: String, $description: String, $certificates: String, $customActivity: String, $services: String, $awards: String, $feeScaleFileHybridMedium: HybridMedium, $feeScaleFileName: String, $companyId: String!, $name: String, $companyPhoneNumber: PhoneParam, $siretNumber: String, $website: String, $foundationYear: Int, $address: AddressParam) {
  updatePersonalInfo(
    firstName: $firstName
    lastName: $lastName
    imageHybridMedium: $imageHybridMedium
    cityId: $cityId
    googlePlaceId: $googlePlaceId
    description: $description
    phoneNumber: $phoneNumber
    certificates: $certificates
    customActivity: $customActivity
    services: $services
    awards: $awards
    feeScaleFileHybridMedium: $feeScaleFileHybridMedium
    feeScaleFileName: $feeScaleFileName
  ) {
    id
  }
  updateCompanyWithNullableAddress(
    id: $companyId
    name: $name
    description: $description
    phoneNumber: $companyPhoneNumber
    feeScaleFileHybridMedium: $feeScaleFileHybridMedium
    feeScaleFileName: $feeScaleFileName
    siretNumber: $siretNumber
    website: $website
    foundationYear: $foundationYear
    address: $address
    imageHybridMedium: $imageHybridMedium
  ) {
    id
  }
}
    `;
export type UpdateUserProfileProMutationFn = Apollo.MutationFunction<UpdateUserProfileProMutation, UpdateUserProfileProMutationVariables>;
export type UpdateUserProfileProMutationResult = Apollo.MutationResult<UpdateUserProfileProMutation>;
export type UpdateUserProfileProMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileProMutation, UpdateUserProfileProMutationVariables>;
export const UpdateUserProfileAndCreateCompany = gql`
    mutation UpdateUserProfileAndCreateCompany($firstName: String, $lastName: String, $imageHybridMedium: HybridMedium, $googlePlaceId: String, $phoneNumber: String!, $cityId: String, $certificates: String, $customActivity: String, $services: String, $awards: String, $feeScaleFileHybridMedium: HybridMedium, $feeScaleFileName: String, $name: String!, $website: String, $companyPhoneNumber: PhoneParam, $foundationYear: Int, $address: AddressParam) {
  updatePersonalInfo(
    firstName: $firstName
    lastName: $lastName
    imageHybridMedium: $imageHybridMedium
    cityId: $cityId
    googlePlaceId: $googlePlaceId
    phoneNumber: $phoneNumber
    certificates: $certificates
    customActivity: $customActivity
    services: $services
    awards: $awards
    feeScaleFileHybridMedium: $feeScaleFileHybridMedium
    feeScaleFileName: $feeScaleFileName
  ) {
    id
  }
  createCompany(
    name: $name
    website: $website
    foundationYear: $foundationYear
    address: $address
    isPrivate: true
    phoneNumber: $companyPhoneNumber
  ) {
    id
  }
}
    `;
export type UpdateUserProfileAndCreateCompanyMutationFn = Apollo.MutationFunction<UpdateUserProfileAndCreateCompanyMutation, UpdateUserProfileAndCreateCompanyMutationVariables>;
export type UpdateUserProfileAndCreateCompanyMutationResult = Apollo.MutationResult<UpdateUserProfileAndCreateCompanyMutation>;
export type UpdateUserProfileAndCreateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileAndCreateCompanyMutation, UpdateUserProfileAndCreateCompanyMutationVariables>;
export const UploadChannelImage = gql`
    mutation UploadChannelImage($image: Upload!, $channelUrl: String!) {
  uploadChannelImage(image: $image, channelUrl: $channelUrl)
}
    `;
export type UploadChannelImageMutationFn = Apollo.MutationFunction<UploadChannelImageMutation, UploadChannelImageMutationVariables>;
export type UploadChannelImageMutationResult = Apollo.MutationResult<UploadChannelImageMutation>;
export type UploadChannelImageMutationOptions = Apollo.BaseMutationOptions<UploadChannelImageMutation, UploadChannelImageMutationVariables>;
export const UploadMedia = gql`
    mutation UploadMedia($media: [Upload!]!) {
  uploadMedia(media: $media)
}
    `;
export type UploadMediaMutationFn = Apollo.MutationFunction<UploadMediaMutation, UploadMediaMutationVariables>;
export type UploadMediaMutationResult = Apollo.MutationResult<UploadMediaMutation>;
export type UploadMediaMutationOptions = Apollo.BaseMutationOptions<UploadMediaMutation, UploadMediaMutationVariables>;
export const ValidateVerificationCode = gql`
    mutation ValidateVerificationCode($proId: String!, $code: String!) {
  validateVerificationCode(proId: $proId, code: $code)
}
    `;
export type ValidateVerificationCodeMutationFn = Apollo.MutationFunction<ValidateVerificationCodeMutation, ValidateVerificationCodeMutationVariables>;
export type ValidateVerificationCodeMutationResult = Apollo.MutationResult<ValidateVerificationCodeMutation>;
export type ValidateVerificationCodeMutationOptions = Apollo.BaseMutationOptions<ValidateVerificationCodeMutation, ValidateVerificationCodeMutationVariables>;
export const ViewNotification = gql`
    mutation ViewNotification($notificationId: String!) {
  viewNotification(id: $notificationId)
}
    `;
export type ViewNotificationMutationFn = Apollo.MutationFunction<ViewNotificationMutation, ViewNotificationMutationVariables>;
export type ViewNotificationMutationResult = Apollo.MutationResult<ViewNotificationMutation>;
export type ViewNotificationMutationOptions = Apollo.BaseMutationOptions<ViewNotificationMutation, ViewNotificationMutationVariables>;
export const ViewStory = gql`
    mutation ViewStory($storyId: String!) {
  viewStory(storyId: $storyId)
}
    `;
export type ViewStoryMutationFn = Apollo.MutationFunction<ViewStoryMutation, ViewStoryMutationVariables>;
export type ViewStoryMutationResult = Apollo.MutationResult<ViewStoryMutation>;
export type ViewStoryMutationOptions = Apollo.BaseMutationOptions<ViewStoryMutation, ViewStoryMutationVariables>;
export const SetEmailVerified = gql`
    mutation SetEmailVerified($isEmailVerified: Boolean!) {
  setEmailVerified(isEmailVerified: $isEmailVerified)
}
    `;
export type SetEmailVerifiedMutationFn = Apollo.MutationFunction<SetEmailVerifiedMutation, SetEmailVerifiedMutationVariables>;
export type SetEmailVerifiedMutationResult = Apollo.MutationResult<SetEmailVerifiedMutation>;
export type SetEmailVerifiedMutationOptions = Apollo.BaseMutationOptions<SetEmailVerifiedMutation, SetEmailVerifiedMutationVariables>;
export const Activities = gql`
    query Activities($displayOneOtherOnSignUp: Boolean, $companyLabel: CompanyLabel) {
  activities(
    displayOneOtherOnSignUp: $displayOneOtherOnSignUp
    companyLabel: $companyLabel
  ) {
    id
    labelKey
    featuredOrder
    activityCategories {
      id
      labelKey
      parentActivityCategory {
        id
        labelKey
      }
    }
  }
}
    `;
export type ActivitiesQueryResult = Apollo.QueryResult<ActivitiesQuery, ActivitiesQueryVariables>;
export const ActivityCategories = gql`
    query ActivityCategories($onlyCrafts: Boolean, $includeOther: Boolean) {
  activityCategories(onlyCrafts: $onlyCrafts, includeOther: $includeOther) {
    id
    labelKey
    parentActivityCategoryId
    parentActivityCategory {
      id
      labelKey
    }
    activities {
      id
      labelKey
      featuredOrder
    }
  }
}
    `;
export type ActivityCategoriesQueryResult = Apollo.QueryResult<ActivityCategoriesQuery, ActivityCategoriesQueryVariables>;
export const ActivityCategorySubcategories = gql`
    query ActivityCategorySubcategories($parentCategoryId: String) {
  activityCategorySubcategories(parentCategoryId: $parentCategoryId) {
    id
    labelKey
    activities {
      id
      labelKey
      featuredOrder
    }
  }
}
    `;
export type ActivityCategorySubcategoriesQueryResult = Apollo.QueryResult<ActivityCategorySubcategoriesQuery, ActivityCategorySubcategoriesQueryVariables>;
export const Ad = gql`
    query Ad($id: String!) {
  ad(id: $id) {
    id
    createdAt
    isUserFavorite
    isUserAffiliatedCompanyFavorite
    title
    description
    livingArea
    surfaceArea
    landArea
    price
    status
    standardLoanAmount {
      monthlyPayment
    }
    bedroomNumber
    roomNumber
    proxyLng
    proxyLat
    floorNumber
    constructionYear
    floorPosition
    consumption
    showSaleFeeBuyerPrice
    saleFeeBuyerPrice
    emissions
    heatType
    heatInformations
    interOffice
    assignedTo {
      image {
        id
        width
        height
        size
        aspectRatio
        duration
        rotation
        url
        type
        isTranscoding
      }
      fullName
      initials
      id
      activity {
        id
        labelKey
      }
      sendbirdUserId
      phoneNumber {
        id
        number
        phoneCode
      }
    }
    commissionRate
    rooms
    isNew
    isPriceDecreasing
    media {
      id
      width
      height
      size
      aspectRatio
      duration
      rotation
      url
      type
      isTranscoding
    }
    type
    propertyType
    propertyState
    commonAreasState
    propertyPurposeEstimation
    propertyResidenceType
    userIsOwner
    isHiddingCompleteAddress
    numberOfVehicles
    constructibleLand
    servicedLand
    dimensionLength
    dimensionWidth
    dimensionHeight
    coOwnership
    coOwnershipNumberOfLots
    coOwnershipOngoing
    coOwnershipYearlyCharge
    saleFeeType
    saleFeeBuyerRate
    priceWithoutSaleFee
    homadataEvaluation {
      id
      requestDate
      confidenceMin
      confidenceMax
      predictedPrice
      confidenceIndex
    }
    address {
      id
      placeId
      description
      zipCode
      cityName
      country
    }
    assets
    owner {
      id
      displayName
      initials
      image {
        id
        width
        height
        size
        aspectRatio
        duration
        rotation
        url
        type
        isTranscoding
      }
      company {
        id
        name
        website
        label
        customActivity
        activities {
          id
          labelKey
        }
        address {
          id
          zipCode
          description
          cityName
        }
        contactUser {
          id
          sendbirdUserId
        }
      }
      user {
        id
        sendbirdUserId
        isProfessionnal
        activity {
          id
          labelKey
        }
      }
      phoneNumber {
        id
        number
        phoneCode
      }
    }
    mainPublisher {
      id
      createdAt
      url
      name
    }
    totalPublisher
    furnished
    inclusions
    rent
    monthlyCharges
    isRentChargesIncluded
    inventory
    fees
    guarantees
    availableDate
    stats {
      id
      impressionCount
      viewCount
      favoriteCount
      contactCount
    }
    isInaccurateAddress
  }
}
    `;
export type AdQueryResult = Apollo.QueryResult<AdQuery, AdQueryVariables>;
export const AdLight = gql`
    query AdLight($id: String!) {
  ad(id: $id) {
    id
    title
    createdAt
    livingArea
    surfaceArea
    status
    bedroomNumber
    roomNumber
    isNew
    isPriceDecreasing
    price
    rent
    proxyLat
    proxyLng
    type
    homadataEvaluation {
      confidenceMin
      confidenceMax
    }
    isHiddingCompleteAddress
    isInaccurateAddress
    isUserFavorite
    media {
      id
      width
      height
      size
      aspectRatio
      duration
      rotation
      url
      type
      isTranscoding
    }
    propertyType
    address {
      id
      zipCode
      cityName
    }
    owner {
      id
      image {
        id
        width
        height
        size
        aspectRatio
        duration
        rotation
        url
        type
        isTranscoding
      }
      user {
        id
      }
      company {
        id
        label
        customActivity
        activities {
          id
          labelKey
        }
      }
    }
    mainPublisher {
      id
      createdAt
      name
      url
    }
    stats {
      id
    }
  }
}
    `;
export type AdLightQueryResult = Apollo.QueryResult<AdLightQuery, AdLightQueryVariables>;
export const Ads = gql`
    query Ads($offset: Int, $limit: Int, $orderBy: JSON, $minPrice: Int, $maxPrice: Int, $minLandArea: Int, $maxLandArea: Int, $minLivingArea: Int, $maxLivingArea: Int, $rooms: Int, $bedrooms: Int, $house: Boolean, $apartment: Boolean, $loft: Boolean, $parking: Boolean, $terrain: Boolean, $newProperty: Boolean, $oldProperty: Boolean, $interOffice: Boolean, $furnished: [FurnishedStatus!], $type: String, $assets: [String], $isPrivateAdvertiser: Boolean, $realEstateTradesAdvertiser: Boolean, $statuses: [AdStatuses], $withoutAssignation: Boolean, $assignatedToUserId: String, $places: [GeometryInput]) {
  ads(
    offset: $offset
    limit: $limit
    orderBy: $orderBy
    minPrice: $minPrice
    maxPrice: $maxPrice
    minLandArea: $minLandArea
    maxLandArea: $maxLandArea
    minLivingArea: $minLivingArea
    maxLivingArea: $maxLivingArea
    rooms: $rooms
    bedrooms: $bedrooms
    house: $house
    apartment: $apartment
    loft: $loft
    parking: $parking
    terrain: $terrain
    newProperty: $newProperty
    oldProperty: $oldProperty
    interOffice: $interOffice
    furnished: $furnished
    type: $type
    assets: $assets
    isPrivateAdvertiser: $isPrivateAdvertiser
    realEstateTradesAdvertiser: $realEstateTradesAdvertiser
    statuses: $statuses
    withoutAssignation: $withoutAssignation
    assignatedToUserId: $assignatedToUserId
    places: $places
  ) {
    items {
      id
      type
      title
      livingArea
      landArea
      surfaceArea
      price
      rent
      bedroomNumber
      roomNumber
      interOffice
      createdAt
      isNew
      isPriceDecreasing
      isHiddingCompleteAddress
      isInaccurateAddress
      isUserFavorite
      assignedTo {
        image {
          id
          aspectRatio
          url
          type
        }
        activity {
          id
          labelKey
        }
        fullName
        initials
        id
      }
      media {
        id
        aspectRatio
        url
        type
      }
      propertyType
      proxyLat
      proxyLng
      status
      homadataEvaluation {
        id
        confidenceMin
        confidenceMax
      }
      address {
        id
        cityName
        zipCode
      }
      owner {
        id
        displayName
        initials
        image {
          id
          aspectRatio
          url
          type
        }
        company {
          id
          name
          customActivity
          label
          activities {
            id
            labelKey
          }
        }
        user {
          id
          activity {
            id
            labelKey
          }
        }
      }
      mainPublisher {
        id
        name
        url
      }
    }
    totalCount
  }
}
    `;
export type AdsQueryResult = Apollo.QueryResult<AdsQuery, AdsQueryVariables>;
export const UserAdsSearch = gql`
    query UserAdsSearch($offset: Int, $limit: Int, $orderBy: JSON, $minPrice: Int, $maxPrice: Int, $rooms: Int, $house: Boolean, $apartment: Boolean, $loft: Boolean, $parking: Boolean, $terrain: Boolean, $newProperty: Boolean, $oldProperty: Boolean, $type: String, $statuses: [AdStatuses], $places: [GeometryInput], $userId: String) {
  ads(
    offset: $offset
    limit: $limit
    orderBy: $orderBy
    minPrice: $minPrice
    maxPrice: $maxPrice
    rooms: $rooms
    house: $house
    apartment: $apartment
    loft: $loft
    parking: $parking
    terrain: $terrain
    newProperty: $newProperty
    oldProperty: $oldProperty
    type: $type
    statuses: $statuses
    places: $places
    userId: $userId
  ) {
    items {
      id
      type
      isUserFavorite
      isUserAffiliatedCompanyFavorite
      title
      livingArea
      landArea
      surfaceArea
      price
      bedroomNumber
      roomNumber
      interOffice
      createdAt
      isNew
      isPriceDecreasing
      media {
        id
        aspectRatio
        url
        type
      }
      propertyType
      proxyLat
      proxyLng
      status
      homadataEvaluation {
        id
        requestDate
        confidenceMin
        confidenceMax
      }
      address {
        id
        zipCode
        cityName
      }
      owner {
        id
        displayName
        initials
        image {
          id
          aspectRatio
          url
          type
        }
        company {
          id
          name
          website
          label
        }
        user {
          id
          isRealEstatesTrades
          activity {
            id
            labelKey
          }
        }
        createdAt
      }
      mainPublisher {
        id
        name
        url
      }
      rent
      stats {
        id
        impressionCount
        viewCount
        favoriteCount
        contactCount
      }
    }
    totalCount
  }
}
    `;
export type UserAdsSearchQueryResult = Apollo.QueryResult<UserAdsSearchQuery, UserAdsSearchQueryVariables>;
export const CompanyAdsSearch = gql`
    query CompanyAdsSearch($offset: Int, $limit: Int, $orderBy: JSON, $minPrice: Int, $maxPrice: Int, $rooms: Int, $house: Boolean, $apartment: Boolean, $loft: Boolean, $parking: Boolean, $terrain: Boolean, $newProperty: Boolean, $oldProperty: Boolean, $type: String, $companyId: String, $statuses: [AdStatuses], $withoutAssignation: Boolean, $assignatedToUserId: String, $places: [GeometryInput]) {
  ads(
    offset: $offset
    limit: $limit
    orderBy: $orderBy
    minPrice: $minPrice
    maxPrice: $maxPrice
    rooms: $rooms
    house: $house
    apartment: $apartment
    loft: $loft
    parking: $parking
    terrain: $terrain
    newProperty: $newProperty
    oldProperty: $oldProperty
    type: $type
    companyId: $companyId
    statuses: $statuses
    withoutAssignation: $withoutAssignation
    assignatedToUserId: $assignatedToUserId
    places: $places
  ) {
    items {
      id
      type
      isUserFavorite
      isUserAffiliatedCompanyFavorite
      title
      livingArea
      landArea
      surfaceArea
      price
      bedroomNumber
      roomNumber
      interOffice
      createdAt
      isNew
      isPriceDecreasing
      media {
        id
        aspectRatio
        url
        type
      }
      assignedTo {
        image {
          id
          aspectRatio
          url
          type
        }
        activity {
          id
          labelKey
        }
        fullName
        initials
        id
      }
      propertyType
      proxyLat
      proxyLng
      status
      homadataEvaluation {
        id
        requestDate
        confidenceMin
        confidenceMax
      }
      address {
        id
        zipCode
        cityName
      }
      owner {
        id
        displayName
        initials
        image {
          id
          aspectRatio
          url
          type
        }
        company {
          id
          name
          website
          label
        }
        user {
          id
          isRealEstatesTrades
          activity {
            id
            labelKey
          }
        }
        createdAt
      }
      mainPublisher {
        id
        name
        url
      }
      rent
      stats {
        id
        impressionCount
        viewCount
        favoriteCount
        contactCount
      }
    }
    totalCount
  }
}
    `;
export type CompanyAdsSearchQueryResult = Apollo.QueryResult<CompanyAdsSearchQuery, CompanyAdsSearchQueryVariables>;
export const AdsForMap = gql`
    query AdsForMap($offset: Int, $limit: Int, $orderBy: JSON, $minPrice: Int, $maxPrice: Int, $minLandArea: Int, $maxLandArea: Int, $minLivingArea: Int, $maxLivingArea: Int, $rooms: Int, $bedrooms: Int, $house: Boolean, $apartment: Boolean, $loft: Boolean, $parking: Boolean, $terrain: Boolean, $newProperty: Boolean, $oldProperty: Boolean, $interOffice: Boolean, $furnished: [FurnishedStatus!], $type: String, $assets: [String], $isPrivateAdvertiser: Boolean, $realEstateTradesAdvertiser: Boolean, $statuses: [AdStatuses], $places: [GeometryInput]) {
  ads(
    offset: $offset
    limit: $limit
    orderBy: $orderBy
    minPrice: $minPrice
    maxPrice: $maxPrice
    minLandArea: $minLandArea
    maxLandArea: $maxLandArea
    minLivingArea: $minLivingArea
    maxLivingArea: $maxLivingArea
    rooms: $rooms
    bedrooms: $bedrooms
    house: $house
    apartment: $apartment
    loft: $loft
    parking: $parking
    terrain: $terrain
    newProperty: $newProperty
    oldProperty: $oldProperty
    interOffice: $interOffice
    furnished: $furnished
    type: $type
    assets: $assets
    isPrivateAdvertiser: $isPrivateAdvertiser
    realEstateTradesAdvertiser: $realEstateTradesAdvertiser
    statuses: $statuses
    places: $places
  ) {
    items {
      id
      price
      rent
      proxyLat
      proxyLng
      type
      isHiddingCompleteAddress
      isInaccurateAddress
    }
    totalCount
  }
}
    `;
export type AdsForMapQueryResult = Apollo.QueryResult<AdsForMapQuery, AdsForMapQueryVariables>;
export const AdsTotalCount = gql`
    query AdsTotalCount($offset: Int, $limit: Int, $orderBy: JSON, $minPrice: Int, $maxPrice: Int, $minLandArea: Int, $maxLandArea: Int, $minLivingArea: Int, $maxLivingArea: Int, $rooms: Int, $bedrooms: Int, $house: Boolean, $apartment: Boolean, $loft: Boolean, $parking: Boolean, $terrain: Boolean, $newProperty: Boolean, $oldProperty: Boolean, $interOffice: Boolean, $furnished: [FurnishedStatus!], $type: String, $assets: [String], $isPrivateAdvertiser: Boolean, $realEstateTradesAdvertiser: Boolean, $statuses: [AdStatuses], $places: [GeometryInput]) {
  ads(
    offset: $offset
    limit: $limit
    orderBy: $orderBy
    minPrice: $minPrice
    maxPrice: $maxPrice
    minLandArea: $minLandArea
    maxLandArea: $maxLandArea
    minLivingArea: $minLivingArea
    maxLivingArea: $maxLivingArea
    rooms: $rooms
    bedrooms: $bedrooms
    house: $house
    apartment: $apartment
    loft: $loft
    parking: $parking
    terrain: $terrain
    newProperty: $newProperty
    oldProperty: $oldProperty
    interOffice: $interOffice
    furnished: $furnished
    type: $type
    assets: $assets
    isPrivateAdvertiser: $isPrivateAdvertiser
    realEstateTradesAdvertiser: $realEstateTradesAdvertiser
    statuses: $statuses
    places: $places
  ) {
    totalCount
  }
}
    `;
export type AdsTotalCountQueryResult = Apollo.QueryResult<AdsTotalCountQuery, AdsTotalCountQueryVariables>;
export const AdPublishers = gql`
    query AdPublishers($adId: String!, $offset: Int, $limit: Int, $sort: AdPublisherSortInput) {
  adPublishers(adId: $adId, offset: $offset, limit: $limit, sort: $sort) {
    results {
      id
      createdAt
      url
      name
      price
    }
    total
  }
}
    `;
export type AdPublishersQueryResult = Apollo.QueryResult<AdPublishersQuery, AdPublishersQueryVariables>;
export const AdminRequests = gql`
    query AdminRequests($companyId: String!, $status: RequestAdminStatus, $skip: Int, $take: Int) {
  adminRequests(companyId: $companyId, status: $status, skip: $skip, take: $take) {
    items {
      id
      status
      company {
        id
        name
      }
      user {
        id
        fullName
        initials
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        activity {
          id
          labelKey
        }
      }
    }
    total
  }
}
    `;
export type AdminRequestsQueryResult = Apollo.QueryResult<AdminRequestsQuery, AdminRequestsQueryVariables>;
export const Agents = gql`
    query Agents($lat: Float!, $lng: Float!, $skip: Int, $take: Int, $orderBy: ESOrderByTypes) {
  agents(lat: $lat, lng: $lng, skip: $skip, take: $take, orderBy: $orderBy) {
    total
    results {
      id
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      firstName
      lastName
      fullName
      isProfessionnal
      initials
      contactStatusV2
      recommendationsReceivedCount
      mutualContactsCount
      numberOfRatings
      averageRating
      isRealEstatesTrades
      activity {
        id
        labelKey
      }
      city {
        id
        name
      }
    }
  }
}
    `;
export type AgentsQueryResult = Apollo.QueryResult<AgentsQuery, AgentsQueryVariables>;
export const ChatUser = gql`
    query ChatUser($sendbirdUserId: String!) {
  chatUser(sendbirdUserId: $sendbirdUserId) {
    id
    firstName
    lastName
    fullName
    email
    initials
    contactStatusV2
    customActivity
    activity {
      id
      labelKey
    }
    image {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    fallbackNameEn
    fallbackNameFr
    fallbackInititals
    companyToDisplay {
      id
      name
      website
    }
    isFollowed
    isProfessionnal
    phoneNumber {
      id
      number
      phoneCode
    }
  }
}
    `;
export type ChatUserQueryResult = Apollo.QueryResult<ChatUserQuery, ChatUserQueryVariables>;
export const ChatUserLight = gql`
    query ChatUserLight($sendbirdUserId: String!) {
  chatUser(sendbirdUserId: $sendbirdUserId) {
    id
    fullName
    initials
    customActivity
    activity {
      id
      labelKey
    }
    image {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    fallbackInititals
  }
}
    `;
export type ChatUserLightQueryResult = Apollo.QueryResult<ChatUserLightQuery, ChatUserLightQueryVariables>;
export const CompanyGalleries = gql`
    query CompanyGalleries($companyId: String!, $policy: GalleryAccessPolicy, $sort: GallerySort, $pageRequest: PageRequest) {
  companyProfile(companyId: $companyId) {
    galleries(policy: $policy, sort: $sort, pageRequest: $pageRequest) {
      items {
        id
        name
        isSecret
        createdAt
        numberOfContents
        contentLastUpdatedAt
        previewMedia {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
      }
      totalCount
    }
  }
}
    `;
export type CompanyGalleriesQueryResult = Apollo.QueryResult<CompanyGalleriesQuery, CompanyGalleriesQueryVariables>;
export const CompanyGalleriesWithCollaborators = gql`
    query CompanyGalleriesWithCollaborators($companyId: String!, $policy: GalleryAccessPolicy, $sort: GallerySort, $pageRequest: PageRequest, $collaboratorPageRequest: PageRequest) {
  companyProfile(companyId: $companyId) {
    galleries(policy: $policy, sort: $sort, pageRequest: $pageRequest) {
      items {
        id
        name
        isSecret
        createdAt
        numberOfContents
        contentLastUpdatedAt
        previewMedia {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        collaborators(pageRequest: $collaboratorPageRequest) {
          totalCount
          items {
            user {
              id
              fullName
              initials
              image {
                id
                width
                height
                size
                aspectRatio
                duration
                rotation
                url
                type
              }
            }
            company {
              id
              name
              initials
              image {
                id
                width
                height
                size
                aspectRatio
                duration
                rotation
                url
                type
              }
            }
          }
        }
      }
      totalCount
    }
  }
}
    `;
export type CompanyGalleriesWithCollaboratorsQueryResult = Apollo.QueryResult<CompanyGalleriesWithCollaboratorsQuery, CompanyGalleriesWithCollaboratorsQueryVariables>;
export const CompanyMembersAndPendingInvitations = gql`
    query CompanyMembersAndPendingInvitations($companyId: String!, $take: Int, $skip: Int, $orderBy: JSON, $query: String, $searchFields: [String], $match: Match) {
  companyMembersAndPendingInvitations(
    companyId: $companyId
    take: $take
    skip: $skip
    orderBy: $orderBy
    query: $query
    searchFields: $searchFields
    match: $match
  ) {
    id
    firstName
    lastName
    fullName
    initials
    image {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    activity {
      id
      labelKey
    }
    pendingInvitations {
      id
      companyId
      direction
    }
  }
}
    `;
export type CompanyMembersAndPendingInvitationsQueryResult = Apollo.QueryResult<CompanyMembersAndPendingInvitationsQuery, CompanyMembersAndPendingInvitationsQueryVariables>;
export const CompanyMembersWhoAreInMyContacts = gql`
    query CompanyMembersWhoAreInMyContacts($companyId: String!, $query: String, $skip: Int, $take: Int, $orderBy: JSON, $searchFields: [String], $match: Match, $activityIds: [String]) {
  companyMembersWhoAreInMyContacts(
    companyId: $companyId
    query: $query
    skip: $skip
    take: $take
    orderBy: $orderBy
    searchFields: $searchFields
    match: $match
    activityIds: $activityIds
  ) {
    total
    results {
      id
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      firstName
      lastName
      fullName
      initials
      customActivity
      activity {
        id
        labelKey
      }
      city {
        id
        name
      }
    }
  }
}
    `;
export type CompanyMembersWhoAreInMyContactsQueryResult = Apollo.QueryResult<CompanyMembersWhoAreInMyContactsQuery, CompanyMembersWhoAreInMyContactsQueryVariables>;
export const CompanyMembersWithTotal = gql`
    query CompanyMembersWithTotal($companyId: String, $offset: Int, $limit: Int, $orderBy: JSON, $query: String, $isDirector: Boolean, $isAdmin: Boolean, $withRecursive: Boolean, $onlyWithRecommendations: Boolean) {
  companyMembersWithTotal(
    companyId: $companyId
    offset: $offset
    limit: $limit
    orderBy: $orderBy
    query: $query
    isDirector: $isDirector
    isAdmin: $isAdmin
    withRecursive: $withRecursive
    onlyWithRecommendations: $onlyWithRecommendations
  ) {
    total
    results {
      id
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      firstName
      lastName
      fullName
      initials
      contactStatusV2
      recommendationsReceivedCount
      mutualContactsCount
      numberOfRatings
      averageRating
      customActivity
      isRealEstatesTrades
      activity {
        id
        labelKey
      }
    }
  }
}
    `;
export type CompanyMembersWithTotalQueryResult = Apollo.QueryResult<CompanyMembersWithTotalQuery, CompanyMembersWithTotalQueryVariables>;
export const CompanyProfile = gql`
    query CompanyProfile($companyId: String!, $showcaseLimit: Int) {
  companyProfile(companyId: $companyId) {
    id
    name
    label
    initials
    description
    website
    foundationYear
    feeScaleFile
    feeScaleFileName
    mission
    contactUrl
    updatedAt
    invitationStatus
    currentUserIsAbleToJoin
    currentUserAffiliatedCompanyIsAbleToJoin
    groupInvitationStatus
    pagesJaunesId
    pagesJaunesUrl
    activities {
      id
      labelKey
      activityCategories {
        id
        labelKey
      }
    }
    customActivity
    group {
      id
      name
      initials
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
    }
    capabilities {
      allowedContentTypesToManage
      allowedContentTypesToDisplay
      allowedLabels
      isAbleToSyncCrm
      isAbleToHaveDirectors
      isAbleToHaveEstateCompanies
      hasPublicPage
    }
    coverImage {
      id
      url
      isTranscoding
    }
    siretNumber
    numberOfMembers
    numberOfAvailableAds: numberOfAds(statuses: available)
    numberOfEndedAds: numberOfAds(statuses: ended)
    numberOfProjects
    numberOfPosts
    numberOfStories
    numberOfGalleries
    numberOfJobOffers
    numberOfRatings
    numberOfDisplayedRatings
    recommendationsReceivedCount
    membersRecommendationsCount
    companyAndMembersRecommendationsCount
    recommendationFromMe {
      id
      status
    }
    averageRating
    numberOfFollowers
    isFollowingCompany
    numberOfMembersRecursively
    hasUnreadStory
    adminRequest {
      id
      status
    }
    createdAt
    ratingGivenByCurrentUser {
      id
      value
      comment
      createdAt
      isHidden
      giver {
        id
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        firstName
        lastName
        fullName
        initials
        createdAt
      }
    }
    address {
      id
      placeId
      zipCode
      description
      lng
      lat
      cityName
      country
      city {
        id
        name
      }
    }
    image {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    video {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    showcase(limit: $showcaseLimit) {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    phoneNumber {
      id
      number
      phoneCode
      countryCode
    }
    contactUser {
      id
    }
  }
}
    `;
export type CompanyProfileQueryResult = Apollo.QueryResult<CompanyProfileQuery, CompanyProfileQueryVariables>;
export const CompanyProfileCounts = gql`
    query CompanyProfileCounts($companyId: String!) {
  companyProfile(companyId: $companyId) {
    id
    numberOfMembers
    numberOfAdmins: numberOfMembers(isAdmin: true)
    numberOfDirectors: numberOfMembers(isDirector: true)
    capabilities {
      allowedContentTypesToManage
      allowedContentTypesToDisplay
      allowedLabels
      isAbleToSyncCrm
      isAbleToHaveDirectors
      isAbleToHaveEstateCompanies
      hasPublicPage
    }
    numberOfAvailableAds: numberOfAds(statuses: available)
    numberOfEndedAds: numberOfAds(statuses: ended)
    numberOfPosts
    numberOfGalleries
    numberOfJobOffers
    numberOfRatings
    numberOfProjects
    numberOfDisplayedRatings
    numberOfFollowers
  }
}
    `;
export type CompanyProfileCountsQueryResult = Apollo.QueryResult<CompanyProfileCountsQuery, CompanyProfileCountsQueryVariables>;
export const CompanyProjects = gql`
    query CompanyProjects($companyId: String!, $skip: Int, $take: Int) {
  companyProjects(companyId: $companyId, skip: $skip, take: $take) {
    id
    media {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    city {
      id
      name
      googlePlaceId
      countryShort
    }
    name
    description
  }
}
    `;
export type CompanyProjectsQueryResult = Apollo.QueryResult<CompanyProjectsQuery, CompanyProjectsQueryVariables>;
export const Counts = gql`
    query Counts {
  counts {
    totalPendingNotifications
    numberOfPendingRecommendationRequests
    numberOfPendingAdminRequests
    numberOfPendingInvitations
    numberOfPendingCompanyMembershipReceivedInvitations: numberOfPendingInvitations(
      side: received
      type: companyMembership
    )
    numberOfPendingGroupMembershipReceivedInvitations: numberOfPendingInvitations(
      side: received
      type: groupMembership
    )
    numberOfPendingCompanyMembershipSentInvitations: numberOfPendingInvitations(
      side: sent
      type: companyMembership
    )
    numberOfPendingGroupMembershipSentInvitations: numberOfPendingInvitations(
      side: sent
      type: groupMembership
    )
    numberOfReceivedPendingContactInvitations
    numberOfUnreadNotifications
    unreadMessages
  }
}
    `;
export type CountsQueryResult = Apollo.QueryResult<CountsQuery, CountsQueryVariables>;
export const CountsForSitemap = gql`
    query CountsForSitemap {
  countsForSitemap {
    ads
    users
    companies
  }
}
    `;
export type CountsForSitemapQueryResult = Apollo.QueryResult<CountsForSitemapQuery, CountsForSitemapQueryVariables>;
export const CrmSources = gql`
    query CrmSources($withOther: Boolean) {
  crmSources(withOther: $withOther) {
    id
    name
    emailAddress
    requestEmailSubject
    requestEmailBody
    isActive
  }
}
    `;
export type CrmSourcesQueryResult = Apollo.QueryResult<CrmSourcesQuery, CrmSourcesQueryVariables>;
export const CurrentUser = gql`
    query CurrentUser {
  me {
    id
    email
    firstName
    lastName
    sendbirdUserId
    description
    fullName
    initials
    numberOfGalleries
    numberOfStories
    feeScaleFile
    feeScaleFileName
    customActivity
    privateCompany {
      id
      name
      foundationYear
      website
      siretNumber
      capabilities {
        allowedContentTypesToManage
        allowedContentTypesToDisplay
        allowedLabels
        isAbleToSyncCrm
        isAbleToHaveDirectors
        isAbleToHaveEstateCompanies
        hasPublicPage
      }
      description
      address {
        id
        placeId
        description
        lat
        lng
        cityName
        city {
          id
          name
        }
        zipCode
      }
      contactUser {
        id
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        fullName
        initials
        activity {
          id
          labelKey
        }
      }
    }
    affiliatedCompany {
      id
      name
      label
      foundationYear
      website
      siretNumber
      numberOfCompanies
      customActivity
      activities {
        id
        labelKey
      }
      group {
        id
      }
      capabilities {
        allowedContentTypesToManage
        allowedContentTypesToDisplay
        allowedLabels
        isAbleToSyncCrm
        isAbleToHaveDirectors
        isAbleToHaveEstateCompanies
        hasPublicPage
      }
      numberOfGalleries
      numberOfStories
      address {
        id
        placeId
        description
        lat
        lng
        cityName
        city {
          id
          name
        }
        zipCode
      }
      contactUser {
        id
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        fullName
        initials
        customActivity
        activity {
          id
          labelKey
        }
      }
      crmSyncs {
        crmUserId
        id
        crmSource {
          name
          isActive
          id
        }
        polirisUser {
          name
        }
      }
    }
    contactCompany {
      id
    }
    isAdminOfAffiliatedCompany
    image {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    activity {
      id
      labelKey
    }
    city {
      id
      name
      lat
      lng
      zipCodes
      googlePlaceId
      country
      countryShort
    }
    phoneNumber {
      id
      number
      countryCode
      phoneCode
    }
    activity {
      id
      labelKey
    }
    coverImage {
      id
      url
    }
    showcase {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    newsCategories {
      id
    }
    createdAt
    updatedAt
    deletedAt
    deletedReason
    isMandatoryAgentTrade
    isProfessionnal
    isRealEstatesTrades
    isCrafts
    isAbleToJoinOrCreateEstateCompany
    isAbleToJoinOrCreateCompany
    isAbleToJoinOrCreateCraftCompany
    crmSyncs {
      crmUserId
      id
      crmSource {
        name
        isActive
        id
      }
      polirisUser {
        name
      }
    }
    notificationSubscriptions {
      subject
      status
    }
  }
}
    `;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const CurrentUserPendingInvitations = gql`
    query CurrentUserPendingInvitations {
  me {
    pendingInvitations {
      id
      companyId
      direction
      company {
        id
        name
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
      }
    }
  }
}
    `;
export type CurrentUserPendingInvitationsQueryResult = Apollo.QueryResult<CurrentUserPendingInvitationsQuery, CurrentUserPendingInvitationsQueryVariables>;
export const CurrentUserProfile = gql`
    query CurrentUserProfile($showcaseLimit: Int) {
  me {
    id
    firstName
    lastName
    image {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    email
    coverImage {
      id
      url
    }
    fullName
    initials
    description
    feeScaleFile
    feeScaleFileName
    description
    certificates
    customActivity
    services
    awards
    isProfessionnal
    isCrafts
    isRealEstatesTrades
    isAbleToJoinOrCreateEstateCompany
    isAbleToJoinOrCreateCraftCompany
    isAbleToJoinOrCreateCompany
    isMandatoryAgentTrade
    showcase(limit: $showcaseLimit) {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    totalRelations
    numberOfContacts
    numberOfFollowers
    numberOfFollows
    numberOfPhoneContacts
    numberOfPosts
    numberOfStories
    numberOfSellAds: numberOfAds(statuses: available, type: sell)
    numberOfRentAds: numberOfAds(statuses: available, type: rent)
    numberOfAvailableAds: numberOfAds(statuses: available)
    numberOfEndedAds: numberOfAds(statuses: ended)
    numberOfArchivedAds: numberOfAds(statuses: archived)
    numberOfRatings
    numberOfDisplayedRatings
    numberOfProjects
    acceptedRecommendationsReceivedCount: recommendationsReceivedCount(
      statuses: [accepted]
    )
    acceptedAndPendingRecommendationsReceivedCount: recommendationsReceivedCount(
      statuses: [accepted, pending]
    )
    activity {
      id
      labelKey
    }
    city {
      id
      name
      zipCodes
      googlePlaceId
      country
      countryShort
    }
    phoneNumber {
      id
      number
      phoneCode
      countryCode
    }
    privateCompany {
      id
      name
      foundationYear
      website
      siretNumber
      capabilities {
        allowedContentTypesToManage
        allowedContentTypesToDisplay
        allowedLabels
        isAbleToSyncCrm
        isAbleToHaveDirectors
        isAbleToHaveEstateCompanies
        hasPublicPage
      }
      description
      address {
        id
        placeId
        description
        zipCode
        lat
        lng
        cityName
        country
        city {
          id
          name
        }
      }
    }
    affiliatedCompany {
      id
      name
      foundationYear
      website
      siretNumber
      capabilities {
        allowedContentTypesToManage
        allowedContentTypesToDisplay
        allowedLabels
        isAbleToSyncCrm
        isAbleToHaveDirectors
        isAbleToHaveEstateCompanies
        hasPublicPage
      }
      address {
        id
        placeId
        description
        zipCode
        lat
        lng
        cityName
        city {
          id
          name
        }
      }
    }
    isAdminOfAffiliatedCompany
    createdAt
    updatedAt
  }
}
    `;
export type CurrentUserProfileQueryResult = Apollo.QueryResult<CurrentUserProfileQuery, CurrentUserProfileQueryVariables>;
export const DataForSitemap = gql`
    query DataForSitemap($offset: Int, $limit: Int) {
  dataForSitemap(offset: $offset, limit: $limit) {
    ads {
      id
      updatedAt
    }
    users {
      id
      updatedAt
    }
    companies {
      id
    }
  }
}
    `;
export type DataForSitemapQueryResult = Apollo.QueryResult<DataForSitemapQuery, DataForSitemapQueryVariables>;
export const Followers = gql`
    query Followers($userId: String, $offset: Int, $limit: Int, $orderBy: JSON, $match: Match, $activityIds: [String], $query: String, $searchFields: [String], $companyId: String) {
  followers(
    userId: $userId
    offset: $offset
    limit: $limit
    orderBy: $orderBy
    match: $match
    activityIds: $activityIds
    query: $query
    searchFields: $searchFields
    companyId: $companyId
  ) {
    total
    results {
      id
      followingUser {
        id
        firstName
        lastName
        fullName
        initials
        image {
          id
          width
          height
          size
          aspectRatio
          duration
          rotation
          url
          type
        }
        activity {
          id
          labelKey
        }
        phoneNumber {
          id
          number
        }
        customActivity
        isProfessionnal
        isFollowed
        mutualContactsCount
      }
    }
  }
}
    `;
export type FollowersQueryResult = Apollo.QueryResult<FollowersQuery, FollowersQueryVariables>;
export const Following = gql`
    query Following($userId: String, $offset: Int, $limit: Int, $orderBy: JSON, $match: Match, $activityIds: [String], $query: String, $searchFields: [String]) {
  following(
    userId: $userId
    offset: $offset
    limit: $limit
    orderBy: $orderBy
    match: $match
    activityIds: $activityIds
    query: $query
    searchFields: $searchFields
  ) {
    total
    results {
      id
      followedOwner {
        id
        user {
          id
          firstName
          lastName
          fullName
          initials
          image {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
          }
          activity {
            id
            labelKey
          }
          phoneNumber {
            id
            number
          }
          customActivity
          isProfessionnal
          isFollowed
          mutualContactsCount
        }
        company {
          id
          name
          initials
          customActivity
          isFollowingCompany
          label
          activities {
            id
            labelKey
          }
          image {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
          }
        }
      }
    }
  }
}
    `;
export type FollowingQueryResult = Apollo.QueryResult<FollowingQuery, FollowingQueryVariables>;
export const Gallery = gql`
    query Gallery($id: String!, $contentItemTypes: [GalleryContentReferenceType!], $contentItemSort: GalleryContentItemSort, $contentPageRequest: PageRequest, $collaboratorPageRequest: PageRequest) {
  gallery(id: $id) {
    id
    owner {
      userId
      companyId
    }
    name
    isSecret
    numberOfPosts
    numberOfNewsPosts
    numberOfAds
    numberOfContents
    contentLastUpdatedAt
    collaborators(pageRequest: $collaboratorPageRequest) {
      totalCount
      items {
        user {
          id
          fullName
          initials
          image {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
          }
        }
        company {
          id
          initials
          name
          image {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
          }
        }
      }
    }
    contentItems(
      types: $contentItemTypes
      sort: $contentItemSort
      pageRequest: $contentPageRequest
    ) {
      totalCount
    }
    viewerPermissions {
      canEditContent
      canDelete
      canManage
    }
    viewerProperties {
      userStatus
    }
  }
}
    `;
export type GalleryQueryResult = Apollo.QueryResult<GalleryQuery, GalleryQueryVariables>;
export const GalleryCollaborators = gql`
    query GalleryCollaborators($id: String!, $pageRequest: PageRequest, $sort: GalleryCollaboratorSort) {
  gallery(id: $id) {
    id
    collaborators(pageRequest: $pageRequest, sort: $sort) {
      totalCount
      items {
        user {
          id
          fullName
          initials
          image {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
          }
        }
        company {
          id
          initials
          name
          image {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
          }
        }
        invitedBy {
          id
          fullName
        }
      }
    }
  }
}
    `;
export type GalleryCollaboratorsQueryResult = Apollo.QueryResult<GalleryCollaboratorsQuery, GalleryCollaboratorsQueryVariables>;
export const GalleryClosedInvitations = gql`
    query GalleryClosedInvitations($id: String!, $pageRequest: PageRequest, $statuses: [GalleryInvitationStatus!], $includeExpired: Boolean, $sort: GalleryInvitationSort) {
  gallery(id: $id) {
    id
    invitations(
      types: [closed]
      pageRequest: $pageRequest
      statuses: $statuses
      includeExpired: $includeExpired
      sort: $sort
    ) {
      totalCount
      items {
        id
        status
        createdBy {
          id
          fullName
        }
        invitee {
          type
          value {
            ... on UserGalleryInviteeValue {
              user {
                id
                fullName
                initials
                image {
                  id
                  width
                  height
                  size
                  aspectRatio
                  duration
                  rotation
                  url
                  type
                }
              }
            }
            ... on EmailGalleryInviteeValue {
              emailAddress
            }
          }
        }
      }
    }
  }
}
    `;
export type GalleryClosedInvitationsQueryResult = Apollo.QueryResult<GalleryClosedInvitationsQuery, GalleryClosedInvitationsQueryVariables>;
export const GalleryContent = gql`
    query GalleryContent($id: String!, $contentItemTypes: [GalleryContentReferenceType!], $contentItemSort: GalleryContentItemSort, $contentPageRequest: PageRequest) {
  gallery(id: $id) {
    id
    contentItems(
      types: $contentItemTypes
      sort: $contentItemSort
      pageRequest: $contentPageRequest
    ) {
      totalCount
      items {
        id
        reference {
          type
          value {
            __typename
            ... on Post {
              id
              media {
                id
                width
                height
                size
                aspectRatio
                isTranscoding
                duration
                rotation
                url
                type
              }
              isUserFavorite
              isUserAffiliatedCompanyFavorite
              message
              createdAt
              totalComments
              totalLikes
              likedByCurrentUser
              iHaveOwnership
              project {
                id
                name
                description
                city {
                  id
                  name
                }
                media {
                  id
                  width
                  height
                  size
                  aspectRatio
                  isTranscoding
                  duration
                  rotation
                  url
                  type
                }
                owner {
                  user {
                    id
                  }
                }
              }
              owner {
                id
                displayName
                initials
                user {
                  id
                  firstName
                  isFollowed
                  isRealEstatesTrades
                  activity {
                    id
                    labelKey
                  }
                }
                image {
                  id
                  width
                  height
                  size
                  aspectRatio
                  isTranscoding
                  duration
                  rotation
                  url
                  type
                }
                company {
                  id
                  name
                  website
                }
              }
            }
            ... on NewsPost {
              id
              tags
              title
              likedByCurrentUser
              isUserFavorite
              isUserAffiliatedCompanyFavorite
              totalLikes
              createdAt
              updatedAt
              pubDate
              source
              newsPostLink
              featuredCategory {
                id
                nameEn
                nameFr
                icon
              }
              media {
                id
                width
                height
                size
                aspectRatio
                isTranscoding
                duration
                rotation
                url
                type
              }
              stats {
                id
                viewCount
                favoriteCount
                contactCount
              }
            }
            ... on Ad {
              id
              type
              newProperty
              title
              isUserFavorite
              isUserAffiliatedCompanyFavorite
              livingArea
              surfaceArea
              price
              bedroomNumber
              roomNumber
              interOffice
              createdAt
              isNew
              isPriceDecreasing
              propertyType
              media {
                id
                width
                height
                size
                aspectRatio
                isTranscoding
                duration
                rotation
                url
                type
              }
              status
              homadataEvaluation {
                id
                requestDate
                confidenceMin
                confidenceMax
              }
              address {
                id
                cityName
              }
              owner {
                id
                displayName
                initials
                image {
                  id
                  width
                  height
                  size
                  aspectRatio
                  isTranscoding
                  duration
                  rotation
                  url
                  type
                }
                user {
                  id
                  isRealEstatesTrades
                  activity {
                    id
                    labelKey
                  }
                }
                company {
                  id
                  name
                  website
                }
              }
              mainPublisher {
                id
                name
                url
              }
              rent
              stats {
                id
                viewCount
                favoriteCount
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type GalleryContentQueryResult = Apollo.QueryResult<GalleryContentQuery, GalleryContentQueryVariables>;
export const GenerateAppLink = gql`
    query GenerateAppLink($type: AppLinkType!, $params: [AppLinkParamsInput!]) {
  generateAppLink(type: $type, params: $params) {
    type
    fullUrl
    shortUrl
  }
}
    `;
export type GenerateAppLinkQueryResult = Apollo.QueryResult<GenerateAppLinkQuery, GenerateAppLinkQueryVariables>;
export const GroupCompanies = gql`
    query GroupCompanies($groupId: String!, $offset: Int, $search: String, $limit: Int, $radiusKm: Int, $orderBy: JSON, $cityId: String, $lat: Float, $lng: Float, $onlyWithRecommendations: Boolean) {
  groupCompanies(
    groupId: $groupId
    offset: $offset
    search: $search
    orderBy: $orderBy
    limit: $limit
    lat: $lat
    lng: $lng
    radiusKm: $radiusKm
    cityId: $cityId
    onlyWithRecommendations: $onlyWithRecommendations
  ) {
    total
    results {
      id
      name
      label
      group {
        id
        name
      }
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      address {
        id
        zipCode
        description
        cityName
        city {
          id
          name
        }
      }
      numberOfRatings
      averageRating
      companyMembersWhoAreInMyContactsCount
      recommendationsReceivedCount
      companyAndMembersRecommendationsCount
    }
  }
}
    `;
export type GroupCompaniesQueryResult = Apollo.QueryResult<GroupCompaniesQuery, GroupCompaniesQueryVariables>;
export const Homadata = gql`
    query Homadata($lng: Float!, $lat: Float!, $isOnEstimationFlow: Boolean, $propertyType: PropertyTypes!, $livingArea: Float!, $landArea: Float, $roomNumber: Int, $bedroomNumber: Int, $floorPosition: Int, $floorNumber: Int, $constructionYear: Int) {
  homadata(
    lng: $lng
    lat: $lat
    isOnEstimationFlow: $isOnEstimationFlow
    propertyType: $propertyType
    livingArea: $livingArea
    landArea: $landArea
    roomNumber: $roomNumber
    bedroomNumber: $bedroomNumber
    floorPosition: $floorPosition
    floorNumber: $floorNumber
    constructionYear: $constructionYear
  ) {
    atypical
    confidenceIndex
    confidenceMax
    confidenceMin
    fai
    faiRate
    nego
    negoRate
    predictedPrice
    priceM2
    priceMax
    priceMin
    virtualPrice
    virtualPriceAdjustment
    virtualPriceMax
    virtualPriceMin
  }
}
    `;
export type HomadataQueryResult = Apollo.QueryResult<HomadataQuery, HomadataQueryVariables>;
export const HomeLoan = gql`
    query HomeLoan($housePrice: Float!, $intakeAmount: Float!, $interestRate: Float!, $yearNumber: Int!) {
  homeLoan(
    housePrice: $housePrice
    intakeAmount: $intakeAmount
    interestRate: $interestRate
    yearNumber: $yearNumber
  ) {
    monthNumber
    totalLoanAmount
    monthlyPayment
    totalInterestAmount
    totalPrice
    intakePercent
    totalInterests
    totalLoanedAmount
  }
}
    `;
export type HomeLoanQueryResult = Apollo.QueryResult<HomeLoanQuery, HomeLoanQueryVariables>;
export const InvitationEmailParameters = gql`
    query InvitationEmailParameters {
  subject: woopenParameter(key: "woopen_invite_email_subject")
  body: woopenParameter(key: "woopen_invite_email_body")
}
    `;
export type InvitationEmailParametersQueryResult = Apollo.QueryResult<InvitationEmailParametersQuery, InvitationEmailParametersQueryVariables>;
export const JobOffer = gql`
    query JobOffer($id: String!) {
  jobOffer(id: $id) {
    id
    companyName
    title
    description
    profile
    emailAddress
    numberOfJobOfferApplications
    city {
      id
      name
      googlePlaceId
      countryShort
    }
    jobType {
      id
      fr
      en
    }
    company {
      id
      name
    }
    isHidden
    updatedAt
  }
}
    `;
export type JobOfferQueryResult = Apollo.QueryResult<JobOfferQuery, JobOfferQueryVariables>;
export const JobOffers = gql`
    query JobOffers($companyId: String, $skip: Int, $take: Int, $includeHidden: Boolean) {
  jobOffers(
    companyId: $companyId
    skip: $skip
    take: $take
    includeHidden: $includeHidden
  ) {
    id
    company {
      id
      name
    }
    companyName
    jobType {
      fr
      en
    }
    city {
      id
      name
      googlePlaceId
      countryShort
    }
    title
    description
    profile
    emailAddress
    isHidden
    createdAt
    updatedAt
  }
}
    `;
export type JobOffersQueryResult = Apollo.QueryResult<JobOffersQuery, JobOffersQueryVariables>;
export const JobTypes = gql`
    query JobTypes {
  jobTypes {
    id
    fr
    en
  }
}
    `;
export type JobTypesQueryResult = Apollo.QueryResult<JobTypesQuery, JobTypesQueryVariables>;
export const LegalLinks = gql`
    query LegalLinks {
  generalConditionsBasic: woopenParameter(
    key: "woopen_legal_general_conditions_basic"
  )
  generalConditionsPro: woopenParameter(
    key: "woopen_legal_general_conditions_pro"
  )
  legalNotice: woopenParameter(key: "woopen_legal_legal_notice")
  privacyPolicy: woopenParameter(key: "woopen_legal_privacy_policy")
  cookiePolicy: woopenParameter(key: "woopen_cookie_policy")
  contact: woopenParameter(key: "woopen_contact")
}
    `;
export type LegalLinksQueryResult = Apollo.QueryResult<LegalLinksQuery, LegalLinksQueryVariables>;
export const LocalPriceEvolution = gql`
    query LocalPriceEvolution($zipCode: String!, $cityName: String!, $propertyType: LocalPriceEvolutionPropertyType!) {
  localPriceEvolution(
    zipCode: $zipCode
    cityName: $cityName
    propertyType: $propertyType
  ) {
    tendency
    dataPoints {
      year
      month
      price
    }
  }
}
    `;
export type LocalPriceEvolutionQueryResult = Apollo.QueryResult<LocalPriceEvolutionQuery, LocalPriceEvolutionQueryVariables>;
export const Locate = gql`
    query Locate($cityName: String, $fallbackToParis: Boolean) {
  locate(cityName: $cityName, fallbackToParis: $fallbackToParis) {
    id
    name
    lat
    lng
  }
}
    `;
export type LocateQueryResult = Apollo.QueryResult<LocateQuery, LocateQueryVariables>;
export const MembersAds = gql`
    query MembersAds($companyId: String!, $offset: Int, $limit: Int, $statuses: [AdStatuses]) {
  membersAds(
    companyId: $companyId
    offset: $offset
    limit: $limit
    statuses: $statuses
  ) {
    id
    type
    title
    isUserFavorite
    isUserAffiliatedCompanyFavorite
    livingArea
    landArea
    surfaceArea
    price
    rent
    bedroomNumber
    roomNumber
    interOffice
    createdAt
    isNew
    isPriceDecreasing
    media {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    propertyType
    status
    address {
      id
      cityName
      zipCode
    }
    stats {
      id
      impressionCount
      viewCount
      favoriteCount
      contactCount
    }
  }
}
    `;
export type MembersAdsQueryResult = Apollo.QueryResult<MembersAdsQuery, MembersAdsQueryVariables>;
export const MobileStoreLinks = gql`
    query MobileStoreLinks {
  googlePlay: woopenParameter(key: "woopen_google_play_link")
  appleStore: woopenParameter(key: "woopen_apple_store_link")
}
    `;
export type MobileStoreLinksQueryResult = Apollo.QueryResult<MobileStoreLinksQuery, MobileStoreLinksQueryVariables>;
export const MutualContacts = gql`
    query MutualContacts($userId: String!, $query: String, $skip: Int, $take: Int, $orderBy: JSON, $searchFields: [String], $match: Match, $excludeFromResultsUserId: String) {
  mutualContacts(
    userId: $userId
    query: $query
    skip: $skip
    take: $take
    orderBy: $orderBy
    searchFields: $searchFields
    match: $match
    excludeFromResultsUserId: $excludeFromResultsUserId
  ) {
    total
    results {
      id
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      firstName
      lastName
      fullName
      initials
      customActivity
      activity {
        id
        labelKey
      }
      city {
        id
        name
      }
    }
  }
}
    `;
export type MutualContactsQueryResult = Apollo.QueryResult<MutualContactsQuery, MutualContactsQueryVariables>;
export const MyContacts = gql`
    query MyContacts($offset: Int, $limit: Int, $orderBy: JSON, $statuses: [ContactStatus], $match: Match, $activityIds: [String], $query: String, $searchFields: [String]) {
  myContacts(
    offset: $offset
    limit: $limit
    orderBy: $orderBy
    statuses: $statuses
    match: $match
    activityIds: $activityIds
    query: $query
    searchFields: $searchFields
  ) {
    id
    contactStatusV2
    firstName
    lastName
    fullName
    initials
    isProfessionnal
    sendbirdUserId
    image {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    customActivity
    activity {
      id
      labelKey
    }
    phoneNumber {
      id
      number
      phoneCode
    }
    numberOfRatings
    averageRating
    companyToDisplay {
      id
      name
    }
  }
}
    `;
export type MyContactsQueryResult = Apollo.QueryResult<MyContactsQuery, MyContactsQueryVariables>;
export const MyDraftAd = gql`
    query MyDraftAd {
  me {
    id
    draftAd {
      id
      type
      isHiddingCompleteAddress
      propertyType
      constructionYear
      title
      description
      interOffice
      floorPosition
      livingArea
      landArea
      address {
        id
        placeId
        lat
        lng
        description
        zipCode
        cityName
        country
      }
      proxyLng
      proxyLat
      bedroomNumber
      roomNumber
      floorNumber
      heatType
      consumption
      emissions
      assets
      surfaceArea
      homadataEvaluation {
        confidenceMin
        confidenceMax
        predictedPrice
        confidenceIndex
        requestDate
      }
      propertyState
      commonAreasState
      propertyPurposeEstimation
      propertyResidenceType
      userIsOwner
      contactConsent
      status
      updatedAt
      availableDate
      monthlyCharges
      inventory
      fees
      furnished
      guarantees
      inclusions
      price
      commissionRate
      rent
      rooms
      media {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      dimensionLength
      servicedLand
      constructibleLand
      numberOfVehicles
      dimensionLength
      dimensionWidth
      dimensionHeight
      coOwnership
      coOwnershipNumberOfLots
      coOwnershipOngoing
      coOwnershipOngoing
      coOwnershipYearlyCharge
      coOwnershipYearlyCharge
      saleFeeType
      saleFeeBuyerRate
      saleFeeBuyerPrice
      showSaleFeeBuyerPrice
      priceWithoutSaleFee
      isInaccurateAddress
    }
  }
}
    `;
export type MyDraftAdQueryResult = Apollo.QueryResult<MyDraftAdQuery, MyDraftAdQueryVariables>;
export const MyPendingClosedGalleryInvitation = gql`
    query MyPendingClosedGalleryInvitation($galleryId: ID!) {
  myPendingClosedGalleryInvitation(galleryId: $galleryId) {
    id
    type
    status
    role
    scope {
      id
      name
      isSecret
      statistics {
        contentItemCount
      }
      owner {
        user {
          id
          fullName
          initials
          image {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
          }
        }
        company {
          id
          name
          initials
          image {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
          }
        }
      }
    }
    createdAt
    createdBy {
      id
      fullName
      initials
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
    }
  }
}
    `;
export type MyPendingClosedGalleryInvitationQueryResult = Apollo.QueryResult<MyPendingClosedGalleryInvitationQuery, MyPendingClosedGalleryInvitationQueryVariables>;
export const MyPendingCompanyMembershipInvitations = gql`
    query MyPendingCompanyMembershipInvitations($skip: Int, $take: Int, $side: PendingInvitationSide, $type: PendingInvitationType) {
  myPendingInvitations(skip: $skip, take: $take, side: $side, type: $type) {
    __typename
    ... on Invitation {
      id
      status
      invitationDirection: direction
      company {
        id
        name
        initials
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        capabilities {
          isAbleToHaveEstateCompanies
        }
      }
      user {
        id
        fullName
        initials
        customActivity
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        activity {
          id
          labelKey
        }
      }
    }
    ... on GroupInvitation {
      id
      status
      groupInvitationDirection: direction
      company {
        id
        name
        initials
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        capabilities {
          isAbleToHaveEstateCompanies
        }
      }
      group {
        id
        name
        initials
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        capabilities {
          isAbleToHaveEstateCompanies
        }
      }
    }
  }
}
    `;
export type MyPendingCompanyMembershipInvitationsQueryResult = Apollo.QueryResult<MyPendingCompanyMembershipInvitationsQuery, MyPendingCompanyMembershipInvitationsQueryVariables>;
export const MyPendingContacts = gql`
    query MyPendingContacts($skip: Int, $take: Int) {
  myPendingContacts(skip: $skip, take: $take) {
    id
    status
    user {
      id
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      fullName
      initials
      customActivity
      activity {
        id
        labelKey
      }
    }
  }
}
    `;
export type MyPendingContactsQueryResult = Apollo.QueryResult<MyPendingContactsQuery, MyPendingContactsQueryVariables>;
export const MyPendingGalleryInvitations = gql`
    query MyPendingGalleryInvitations($pageRequest: PageRequest, $sort: GalleryInvitationSort) {
  myGalleryInvitations(
    statuses: [pending]
    includeExpired: false
    pageRequest: $pageRequest
    sort: $sort
  ) {
    totalCount
    items {
      id
      type
      status
      role
      scope {
        id
        name
      }
      invitee {
        type
        value {
          ... on UserGalleryInviteeValue {
            user {
              id
              fullName
              initials
              image {
                id
                width
                height
                size
                aspectRatio
                duration
                rotation
                url
                type
              }
            }
          }
          ... on EmailGalleryInviteeValue {
            emailAddress
          }
        }
      }
      createdAt
      createdBy {
        id
        fullName
        initials
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
      }
    }
  }
}
    `;
export type MyPendingGalleryInvitationsQueryResult = Apollo.QueryResult<MyPendingGalleryInvitationsQuery, MyPendingGalleryInvitationsQueryVariables>;
export const MyRecommandationsCard = gql`
    query MyRecommandationsCard($userId: String) {
  me {
    id
    recommendationsReceivedCount
  }
  recommendations(offset: 0, limit: 2, userId: $userId, statuses: [accepted]) {
    id
    recommendingUser {
      id
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      fullName
      initials
      activity {
        id
        labelKey
      }
    }
  }
}
    `;
export type MyRecommandationsCardQueryResult = Apollo.QueryResult<MyRecommandationsCardQuery, MyRecommandationsCardQueryVariables>;
export const NewsCategories = gql`
    query NewsCategories {
  me {
    id
    newsCategories {
      id
    }
  }
  newsCategories {
    id
    icon
    nameFr
    nameEn
    createdAt
  }
  newsCategoriesRecommendations {
    id
    icon
    nameFr
    nameEn
    createdAt
  }
}
    `;
export type NewsCategoriesQueryResult = Apollo.QueryResult<NewsCategoriesQuery, NewsCategoriesQueryVariables>;
export const NewsFeed = gql`
    query NewsFeed($skipPosts: Int, $skipNewsPosts: Int, $skipAds: Int) {
  newsFeed(
    skipPosts: $skipPosts
    skipNewsPosts: $skipNewsPosts
    skipAds: $skipAds
  ) {
    hasMore
    postsCount
    newsPostsCount
    adsCount
    results {
      __typename
      ... on Post {
        id
        media {
          id
          width
          height
          size
          aspectRatio
          duration
          rotation
          url
          type
          isTranscoding
        }
        isUserFavorite
        isUserAffiliatedCompanyFavorite
        iHaveOwnership
        message
        createdAt
        totalComments
        totalLikes
        likedByCurrentUser
        ad {
          id
          livingArea
          price
          bedroomNumber
          roomNumber
          media {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
            isTranscoding
          }
          propertyType
        }
        newsPost {
          id
          title
          categories {
            id
            nameEn
            nameFr
            icon
          }
          media {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
            isTranscoding
          }
        }
        project {
          id
          name
          description
          city {
            id
            name
          }
          media {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
            isTranscoding
          }
        }
        owner {
          id
          displayName
          initials
          user {
            id
            firstName
            isRealEstatesTrades
            isFollowed
            activity {
              id
              labelKey
            }
            customActivity
          }
          image {
            id
            width
            height
            size
            aspectRatio
            isTranscoding
            duration
            rotation
            url
            type
          }
          company {
            id
            name
            website
            label
            customActivity
            activities {
              id
              labelKey
            }
            capabilities {
              allowedContentTypesToManage
            }
          }
        }
      }
      ... on NewsPost {
        id
        tags
        title
        description
        shortDescription
        pubDate
        likedByCurrentUser
        isUserFavorite
        isUserAffiliatedCompanyFavorite
        totalLikes
        createdAt
        updatedAt
        source
        newsPostLink
        featuredCategory {
          id
          nameEn
          nameFr
          icon
        }
        media {
          id
          width
          height
          size
          aspectRatio
          duration
          rotation
          url
          type
          isTranscoding
        }
        stats {
          id
          viewCount
          favoriteCount
          contactCount
        }
      }
      ... on Ad {
        id
        title
        livingArea
        surfaceArea
        price
        status
        bedroomNumber
        roomNumber
        createdAt
        isNew
        isPriceDecreasing
        isUserFavorite
        isUserAffiliatedCompanyFavorite
        iHaveOwnership
        media {
          id
          width
          height
          size
          aspectRatio
          duration
          rotation
          url
          type
          isTranscoding
        }
        type
        propertyType
        rent
        address {
          id
          zipCode
          cityName
        }
        owner {
          id
          displayName
          initials
          image {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
            isTranscoding
          }
          user {
            id
          }
          company {
            id
            name
            label
            customActivity
            activities {
              id
              labelKey
            }
          }
        }
        stats {
          id
          viewCount
          favoriteCount
          contactCount
        }
      }
    }
  }
}
    `;
export type NewsFeedQueryResult = Apollo.QueryResult<NewsFeedQuery, NewsFeedQueryVariables>;
export const NewsPost = gql`
    query NewsPost($newsPostId: String!) {
  newsPost(newsPostId: $newsPostId) {
    id
    tags
    title
    shortDescription
    description
    pubDate
    likedByCurrentUser
    isUserFavorite
    isUserAffiliatedCompanyFavorite
    totalLikes
    createdAt
    updatedAt
    source
    sourceLink
    newsPostLink
    nofollow
    featuredCategory {
      id
      nameEn
      nameFr
      icon
    }
    categories {
      id
      nameEn
      nameFr
      icon
    }
    media {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
      embedSource
      embedId
    }
    stats {
      id
      viewCount
      favoriteCount
      contactCount
    }
  }
}
    `;
export type NewsPostQueryResult = Apollo.QueryResult<NewsPostQuery, NewsPostQueryVariables>;
export const NewsPostLikes = gql`
    query NewsPostLikes($postId: String!, $skip: Int, $take: Int) {
  newsPostLikes(postId: $postId, skip: $skip, take: $take) {
    id
    firstName
    lastName
    fullName
    initials
    isProfessionnal
    customActivity
    image {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    isRealEstatesTrades
    activity {
      id
      labelKey
    }
    isFollowed
  }
}
    `;
export type NewsPostLikesQueryResult = Apollo.QueryResult<NewsPostLikesQuery, NewsPostLikesQueryVariables>;
export const Notifications = gql`
    query Notifications($skip: Int, $take: Int) {
  notifications(skip: $skip, take: $take) {
    results {
      id
      createdAt
      viewed
      link
      nameToDisplay
      companyName
      count
      type
      linkedContentId
      notifyingUser {
        id
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        fullName
        initials
        affiliatedCompany {
          id
          name
          initials
          image {
            id
            width
            height
            size
            aspectRatio
            isTranscoding
            duration
            rotation
            url
            type
          }
        }
      }
    }
    total
  }
}
    `;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const PagesJaunesPro = gql`
    query PagesJaunesPro($proId: String!) {
  pagesJaunesProWithImagesUrls(proId: $proId) {
    proId
    name
    activityLabel
    pagesJaunesProType
    canBeClaimedByCurrentUser
    woopenCompanyId
    pageUrl
    ratingsPageUrl
    website {
      url
      label
    }
    address {
      cityName
      street
      zipCode
      district
      country
      addressDescription
      lat
      lng
    }
    description
    phoneNumber {
      number
      countryCode
      phoneCode
    }
    email
    foundationYear
    siret
    averageRating
    numberOfRatings
    thumbnailPath
    imagePath
    images {
      id
      imagePath
    }
  }
}
    `;
export type PagesJaunesProQueryResult = Apollo.QueryResult<PagesJaunesProQuery, PagesJaunesProQueryVariables>;
export const ParsedLink = gql`
    query ParsedLink($link: String!) {
  parsedLink(link: $link) {
    publisher
    title
    image
  }
}
    `;
export type ParsedLinkQueryResult = Apollo.QueryResult<ParsedLinkQuery, ParsedLinkQueryVariables>;
export const PendingOpenGalleryInvitation = gql`
    query PendingOpenGalleryInvitation($invitationId: ID!, $galleryId: ID!) {
  pendingOpenGalleryInvitation(invitationId: $invitationId, galleryId: $galleryId) {
    id
    type
    status
    role
    scope {
      id
      name
      isSecret
      statistics {
        contentItemCount
      }
      owner {
        user {
          id
          fullName
          initials
          image {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
          }
        }
        company {
          id
          name
          initials
          image {
            id
            width
            height
            size
            aspectRatio
            duration
            rotation
            url
            type
          }
        }
      }
    }
    createdAt
    createdBy {
      id
      fullName
      initials
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
    }
  }
}
    `;
export type PendingOpenGalleryInvitationQueryResult = Apollo.QueryResult<PendingOpenGalleryInvitationQuery, PendingOpenGalleryInvitationQueryVariables>;
export const PhoneContactsSync = gql`
    query PhoneContactsSync {
  phoneContactsSync {
    state
  }
}
    `;
export type PhoneContactsSyncQueryResult = Apollo.QueryResult<PhoneContactsSyncQuery, PhoneContactsSyncQueryVariables>;
export const PhoneContactsWithTotal = gql`
    query PhoneContactsWithTotal($isSynchronized: Boolean, $offset: Int, $limit: Int, $orderBy: JSON, $match: Match, $query: String, $searchFields: [String], $onlyWoopenContacts: Boolean, $onlyNonWoopenContacts: Boolean) {
  phoneContactsWithTotal(
    isSynchronized: $isSynchronized
    offset: $offset
    limit: $limit
    orderBy: $orderBy
    match: $match
    query: $query
    searchFields: $searchFields
    onlyWoopenContacts: $onlyWoopenContacts
    onlyNonWoopenContacts: $onlyNonWoopenContacts
  ) {
    numberOfPhoneContacts
    phoneContacts {
      id
      firstName
      lastName
      initials
      isSynchronized
      localPhoneContactId
      jsonContact
      woopenUser {
        id
        fullName
        initials
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        contactStatusV2
        isRealEstatesTrades
        activity {
          id
          labelKey
        }
      }
    }
  }
}
    `;
export type PhoneContactsWithTotalQueryResult = Apollo.QueryResult<PhoneContactsWithTotalQuery, PhoneContactsWithTotalQueryVariables>;
export const Post = gql`
    query Post($postId: String!) {
  post(postId: $postId) {
    id
    media {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    newsPost {
      id
      title
      categories {
        id
        nameEn
        nameFr
        icon
      }
      media {
        id
        width
        height
        size
        aspectRatio
        duration
        rotation
        url
        type
        isTranscoding
      }
    }
    ad {
      id
      livingArea
      price
      bedroomNumber
      roomNumber
      media {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      propertyType
    }
    message
    createdAt
    totalComments
    totalLikes
    likedByCurrentUser
    iHaveOwnership
    project {
      id
      name
      description
      city {
        id
        name
      }
      media {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      owner {
        user {
          id
        }
      }
    }
    owner {
      id
      displayName
      initials
      user {
        id
        isFollowed
        isRealEstatesTrades
        activity {
          id
          labelKey
        }
        customActivity
      }
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      company {
        id
        name
        website
        label
        customActivity
        activities {
          id
          labelKey
        }
      }
    }
  }
}
    `;
export type PostQueryResult = Apollo.QueryResult<PostQuery, PostQueryVariables>;
export const PostComments = gql`
    query PostComments($postId: String!, $skip: Int!, $take: Int!) {
  comments(postId: $postId, skip: $skip, take: $take) {
    id
    content
    createdAt
    likedByCurrentUser
    iHaveOwnership
    usersWhoLikes {
      id
    }
    owner {
      id
      displayName
      initials
      createdAt
      userId
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      user {
        id
        isFollowed
        customActivity
        activity {
          id
          labelKey
        }
      }
      company {
        id
        name
      }
    }
  }
}
    `;
export type PostCommentsQueryResult = Apollo.QueryResult<PostCommentsQuery, PostCommentsQueryVariables>;
export const PostLikes = gql`
    query PostLikes($postId: String!, $skip: Int, $take: Int) {
  postLikes(postId: $postId, skip: $skip, take: $take) {
    id
    firstName
    lastName
    fullName
    initials
    isProfessionnal
    customActivity
    image {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    isRealEstatesTrades
    activity {
      id
      labelKey
    }
    isFollowed
  }
}
    `;
export type PostLikesQueryResult = Apollo.QueryResult<PostLikesQuery, PostLikesQueryVariables>;
export const Posts = gql`
    query Posts($skip: Int, $take: Int, $userId: String, $companyId: String) {
  posts(skip: $skip, take: $take, userId: $userId, companyId: $companyId) {
    id
    media {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    isUserFavorite
    isUserAffiliatedCompanyFavorite
    message
    createdAt
    totalComments
    totalLikes
    likedByCurrentUser
    iHaveOwnership
    ad {
      id
      livingArea
      price
      bedroomNumber
      roomNumber
      media {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      propertyType
    }
    newsPost {
      id
      title
      categories {
        id
        nameEn
        nameFr
        icon
      }
      media {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
    }
    project {
      id
      name
      description
      city {
        id
        name
      }
      media {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      owner {
        user {
          id
        }
      }
    }
    owner {
      id
      displayName
      initials
      user {
        id
        firstName
        isBlocked
        isRealEstatesTrades
        activity {
          id
          labelKey
        }
        isFollowed
        customActivity
      }
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      company {
        id
        name
        website
        label
        customActivity
        activities {
          id
          labelKey
        }
      }
    }
  }
}
    `;
export type PostsQueryResult = Apollo.QueryResult<PostsQuery, PostsQueryVariables>;
export const Project = gql`
    query Project($projectId: String!) {
  project(projectId: $projectId) {
    project {
      id
      name
      description
      city {
        id
        name
        googlePlaceId
        countryShort
      }
      media {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      owner {
        id
        displayName
        initials
        user {
          id
          firstName
          lastName
          fullName
          affiliatedCompany {
            id
            name
          }
          isRealEstatesTrades
          activity {
            id
            labelKey
          }
        }
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        company {
          id
          name
          website
        }
      }
    }
  }
}
    `;
export type ProjectQueryResult = Apollo.QueryResult<ProjectQuery, ProjectQueryVariables>;
export const Projects = gql`
    query Projects($userId: String, $skip: Int, $take: Int) {
  projects(userId: $userId, skip: $skip, take: $take) {
    id
    name
    description
    city {
      id
      name
      googlePlaceId
      countryShort
    }
    media {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    owner {
      id
      displayName
      initials
      user {
        id
        firstName
        lastName
        affiliatedCompany {
          id
          name
        }
        isRealEstatesTrades
        activity {
          id
          labelKey
        }
      }
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      company {
        id
        name
        website
      }
    }
  }
}
    `;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const QuickSignupCompany = gql`
    query QuickSignupCompany($quickSignupCompanyId: String!) {
  quickSignupCompany(quickSignupCompanyId: $quickSignupCompanyId) {
    id
    name
    description
    email
    siretNumber
    isAgency
    website
    initials
    phone {
      number
      countryCode
      phoneCode
    }
    address {
      id
      description
      lng
      lat
      cityName
      city {
        id
        name
      }
      zipCode
    }
    activity {
      labelKey
      id
    }
  }
}
    `;
export type QuickSignupCompanyQueryResult = Apollo.QueryResult<QuickSignupCompanyQuery, QuickSignupCompanyQueryVariables>;
export const QuickSignupUser = gql`
    query QuickSignupUser($quickSignupUserId: String!, $isPro: Boolean) {
  quickSignupUser(quickSignupUserId: $quickSignupUserId, isPro: $isPro) {
    id
    email
    name
    phoneNumber
    agencyName
  }
}
    `;
export type QuickSignupUserQueryResult = Apollo.QueryResult<QuickSignupUserQuery, QuickSignupUserQueryVariables>;
export const Ratings = gql`
    query Ratings($userId: String, $companyId: String, $skip: Int, $take: Int, $withHiddenRatings: Boolean, $includeCurrentUserRatings: Boolean) {
  ratings(
    userId: $userId
    companyId: $companyId
    skip: $skip
    take: $take
    withHiddenRatings: $withHiddenRatings
    includeCurrentUserRatings: $includeCurrentUserRatings
  ) {
    averageRating
    numberOfRatings
    allRatings {
      id
      value
      comment
      createdAt
      isHidden
      giver {
        id
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        firstName
        lastName
        fullName
        initials
        createdAt
      }
    }
  }
}
    `;
export type RatingsQueryResult = Apollo.QueryResult<RatingsQuery, RatingsQueryVariables>;
export const RecommendationsReceived = gql`
    query RecommendationsReceived($offset: Int, $limit: Int, $query: String, $orderBy: JSON, $userId: String, $statuses: [RecommendationStatus]) {
  recommendations(
    offset: $offset
    limit: $limit
    query: $query
    orderBy: $orderBy
    userId: $userId
    statuses: $statuses
  ) {
    id
    status
    recommendingUser {
      id
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      fullName
      initials
      customActivity
      activity {
        id
        labelKey
      }
    }
  }
}
    `;
export type RecommendationsReceivedQueryResult = Apollo.QueryResult<RecommendationsReceivedQuery, RecommendationsReceivedQueryVariables>;
export const RequestRecommendations = gql`
    query RequestRecommendations($offset: Int, $limit: Int, $query: String, $recommendingUserId: String, $statuses: [RecommendationStatus]) {
  recommendations(
    offset: $offset
    limit: $limit
    query: $query
    recommendingUserId: $recommendingUserId
    statuses: $statuses
  ) {
    id
    status
    createdAt
    recommendedOwner {
      id
      user {
        id
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        fullName
        initials
        customActivity
        activity {
          id
          labelKey
        }
      }
    }
  }
}
    `;
export type RequestRecommendationsQueryResult = Apollo.QueryResult<RequestRecommendationsQuery, RequestRecommendationsQueryVariables>;
export const RecommendingUsers = gql`
    query RecommendingUsers($companyId: String, $offset: Int, $limit: Int, $userId: String, $orderBy: JSON, $query: String, $userType: UserType) {
  recommendingUsers(
    companyId: $companyId
    offset: $offset
    limit: $limit
    userId: $userId
    orderBy: $orderBy
    query: $query
    userType: $userType
  ) {
    total
    results {
      id
      fullName
      initials
      mutualContactsCount
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      customActivity
      activity {
        id
        labelKey
      }
    }
  }
}
    `;
export type RecommendingUsersQueryResult = Apollo.QueryResult<RecommendingUsersQuery, RecommendingUsersQueryVariables>;
export const SavedSearches = gql`
    query SavedSearches($offset: Int, $limit: Int) {
  savedSearches(offset: $offset, limit: $limit) {
    results {
      parameters
      isFirstSavedAdSearch
      name
      lastViewedAt
      id
      placeGeometry {
        type
        coordinates
        source
      }
      emailNotificationsEnabled
    }
    total
  }
}
    `;
export type SavedSearchesQueryResult = Apollo.QueryResult<SavedSearchesQuery, SavedSearchesQueryVariables>;
export const Search = gql`
    query Search($searchId: String!) {
  search(searchId: $searchId) {
    id
    name
    parameters
    lastViewedAt
    isFirstSavedAdSearch
    placeGeometry {
      type
      coordinates
      source
    }
    emailNotificationsEnabled
  }
}
    `;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const SearchAdsCountSinceLastViewed = gql`
    query SearchAdsCountSinceLastViewed($searchId: String) {
  searchAdsCountSinceLastViewed(searchId: $searchId)
}
    `;
export type SearchAdsCountSinceLastViewedQueryResult = Apollo.QueryResult<SearchAdsCountSinceLastViewedQuery, SearchAdsCountSinceLastViewedQueryVariables>;
export const SearchAllUsersWithTotal = gql`
    query SearchAllUsersWithTotal($search: String, $limit: Int, $offset: Int) {
  searchAllUsersWithTotal(search: $search, limit: $limit, offset: $offset) {
    total
    results {
      id
      fullName
      initials
      isProfessionnal
      sendbirdUserId
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      recommendationToMe {
        id
        status
      }
      customActivity
      activity {
        id
        labelKey
      }
    }
  }
}
    `;
export type SearchAllUsersWithTotalQueryResult = Apollo.QueryResult<SearchAllUsersWithTotalQuery, SearchAllUsersWithTotalQueryVariables>;
export const SearchCity = gql`
    query SearchCity($search: String!) {
  searchCities(search: $search) {
    id
    name
    lat
    lng
    zipCodes
    country
    countryShort
  }
}
    `;
export type SearchCityQueryResult = Apollo.QueryResult<SearchCityQuery, SearchCityQueryVariables>;
export const SearchCommunity = gql`
    query SearchCommunity($offset: Int, $limit: Int, $search: String, $activityId: String, $categoryId: String, $cityId: String, $cityRadiusKm: Int, $orderBy: JSON, $communityEntityTypes: [CommunityEntityType]) {
  searchCommunity(
    offset: $offset
    limit: $limit
    search: $search
    activityId: $activityId
    categoryId: $categoryId
    cityId: $cityId
    cityRadiusKm: $cityRadiusKm
    orderBy: $orderBy
    communityEntityTypes: $communityEntityTypes
  ) {
    total
    results {
      __typename
      ... on User {
        id
        firstName
        lastName
        fullName
        initials
        customActivity
        activity {
          id
          labelKey
        }
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        showcase(limit: 3) {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        city {
          id
          name
          zipCodes
        }
        recommendationsReceivedCount
        numberOfRatings
        averageRating
        isFollowed
        mutualContactsCount
        contactStatusV2
        isProfessionnal
      }
      ... on Company {
        id
        name
        label
        isFollowingCompany
        capabilities {
          allowedContentTypesToManage
          allowedContentTypesToDisplay
          allowedLabels
          isAbleToSyncCrm
          isAbleToHaveDirectors
          isAbleToHaveEstateCompanies
          hasPublicPage
        }
        customActivity
        activities {
          id
          labelKey
        }
        contactUser {
          id
        }
        averageRating
        numberOfRatings
        companyAndMembersRecommendationsCount
        companyMembersWhoAreInMyContactsCount
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        address {
          id
          zipCode
          cityName
          city {
            id
            name
          }
        }
        showcase(limit: 3) {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
      }
      ... on PagesJaunesProSearchResult {
        id
        woopenCompanyId
        merchantId
        merchantName
        thumbnailPath
        activityLabel
        imagePath
        images {
          id
          imagePath
        }
        phoneNumber {
          number
          phoneCode
          countryCode
        }
        contactEmail
        averagePJRating
        numberOfPJRatings
        address {
          cityName
          street
          zipCode
          district
          country
          addressDescription
        }
      }
    }
  }
}
    `;
export type SearchCommunityQueryResult = Apollo.QueryResult<SearchCommunityQuery, SearchCommunityQueryVariables>;
export const SearchCompaniesForInvitations = gql`
    query SearchCompaniesForInvitations($search: String, $offset: Int, $limit: Int, $orderBy: JSON) {
  searchCompaniesForInvitations(
    search: $search
    offset: $offset
    limit: $limit
    orderBy: $orderBy
  ) {
    total
    results {
      id
      name
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
    }
  }
}
    `;
export type SearchCompaniesForInvitationsQueryResult = Apollo.QueryResult<SearchCompaniesForInvitationsQuery, SearchCompaniesForInvitationsQueryVariables>;
export const SearchCompaniesToJoin = gql`
    query SearchCompaniesToJoin($search: String, $offset: Int, $limit: Int, $orderBy: JSON, $shouldIncludePJPros: Boolean) {
  searchCompaniesToJoin(
    search: $search
    offset: $offset
    limit: $limit
    orderBy: $orderBy
    shouldIncludePJPros: $shouldIncludePJPros
  ) {
    total
    results {
      __typename
      ... on Company {
        id
        name
        label
        isFollowingCompany
        capabilities {
          allowedContentTypesToManage
          allowedContentTypesToDisplay
          allowedLabels
          isAbleToSyncCrm
          isAbleToHaveDirectors
          isAbleToHaveEstateCompanies
          hasPublicPage
        }
        customActivity
        activities {
          id
          labelKey
        }
        contactUser {
          id
        }
        averageRating
        numberOfRatings
        companyAndMembersRecommendationsCount
        companyMembersWhoAreInMyContactsCount
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        address {
          id
          zipCode
          cityName
          city {
            id
            name
          }
        }
        showcase(limit: 3) {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
      }
      ... on PagesJaunesProSearchResult {
        id
        pagesJaunesProType
        woopenCompanyId
        merchantId
        merchantName
        thumbnailPath
        activityLabel
        imagePath
        images {
          id
          imagePath
        }
        phoneNumber {
          number
          phoneCode
          countryCode
        }
        contactEmail
        averagePJRating
        numberOfPJRatings
        address {
          cityName
          street
          zipCode
          district
          country
          addressDescription
        }
      }
    }
  }
}
    `;
export type SearchCompaniesToJoinQueryResult = Apollo.QueryResult<SearchCompaniesToJoinQuery, SearchCompaniesToJoinQueryVariables>;
export const SearchForSiret = gql`
    query SearchForSiret($query: String!) {
  searchForSIRET(query: $query) {
    name
    location
    activity
    siret
  }
}
    `;
export type SearchForSiretQueryResult = Apollo.QueryResult<SearchForSiretQuery, SearchForSiretQueryVariables>;
export const SearchProjects = gql`
    query SearchProjects($search: String, $offset: Int, $limit: Int, $userId: String, $companyId: String, $orderBy: JSON) {
  searchProjects(
    search: $search
    offset: $offset
    limit: $limit
    userId: $userId
    companyId: $companyId
    orderBy: $orderBy
  ) {
    total
    results {
      id
      media {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
      }
      name
      description
      owner {
        id
        user {
          id
          fullName
          affiliatedCompany {
            id
            name
          }
        }
      }
      city {
        id
        name
      }
      createdAt
    }
  }
}
    `;
export type SearchProjectsQueryResult = Apollo.QueryResult<SearchProjectsQuery, SearchProjectsQueryVariables>;
export const SearchRecommendedRealEstate = gql`
    query SearchRecommendedRealEstate($lat: Float!, $lng: Float!, $offset: Int, $limit: Int, $search: String) {
  searchRecommendedRealEstate(
    lat: $lat
    lng: $lng
    offset: $offset
    limit: $limit
    search: $search
  ) {
    total
    results {
      id
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      firstName
      lastName
      fullName
      isProfessionnal
      initials
      contactStatusV2
      mutualContactsCount
      numberOfRatings
      averageRating
      customActivity
      isRealEstatesTrades
      activity {
        id
        labelKey
      }
      city {
        id
        name
      }
    }
  }
}
    `;
export type SearchRecommendedRealEstateQueryResult = Apollo.QueryResult<SearchRecommendedRealEstateQuery, SearchRecommendedRealEstateQueryVariables>;
export const SearchUsersAndCompaniesWithTotal = gql`
    query SearchUsersAndCompaniesWithTotal($search: String, $offset: Int, $limit: Int) {
  searchUsersAndCompaniesWithTotal(
    search: $search
    limit: $limit
    offset: $offset
  ) {
    total
    results {
      ... on User {
        id
        fullName
      }
      ... on Company {
        id
        name
      }
    }
  }
}
    `;
export type SearchUsersAndCompaniesWithTotalQueryResult = Apollo.QueryResult<SearchUsersAndCompaniesWithTotalQuery, SearchUsersAndCompaniesWithTotalQueryVariables>;
export const SearchUsersForGallery = gql`
    query SearchUsersForGallery($id: String!, $searchString: String!, $pageRequest: PageRequest) {
  gallery(id: $id) {
    id
    searchUsers(searchString: $searchString, pageRequest: $pageRequest) {
      totalCount
      items {
        id
        status
        user {
          id
          fullName
          initials
          isProfessionnal
          sendbirdUserId
          image {
            id
            width
            height
            size
            aspectRatio
            isTranscoding
            duration
            rotation
            url
            type
          }
          recommendationToMe {
            id
            status
          }
          customActivity
          activity {
            id
            labelKey
          }
        }
      }
    }
  }
}
    `;
export type SearchUsersForGalleryQueryResult = Apollo.QueryResult<SearchUsersForGalleryQuery, SearchUsersForGalleryQueryVariables>;
export const SearchUsersForInvitations = gql`
    query SearchUsersForInvitations($search: String, $offset: Int, $limit: Int) {
  searchUsersForInvitations(
    search: $search
    offset: $offset
    limit: $limit
    filterOutUsersWithPendingInvitations: true
  ) {
    id
    firstName
    lastName
    fullName
    initials
    customActivity
    image {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    isRealEstatesTrades
    activity {
      id
      labelKey
    }
    invitations {
      id
      status
      company {
        id
      }
    }
  }
}
    `;
export type SearchUsersForInvitationsQueryResult = Apollo.QueryResult<SearchUsersForInvitationsQuery, SearchUsersForInvitationsQueryVariables>;
export const SecondaryEmail = gql`
    query SecondaryEmail($id: String!) {
  secondaryEmail(id: $id) {
    id
    userId
    email
    verified
  }
}
    `;
export type SecondaryEmailQueryResult = Apollo.QueryResult<SecondaryEmailQuery, SecondaryEmailQueryVariables>;
export const SecondaryEmails = gql`
    query SecondaryEmails($skip: Int, $take: Int) {
  secondaryEmails(skip: $skip, take: $take) {
    id
    userId
    email
    verified
  }
}
    `;
export type SecondaryEmailsQueryResult = Apollo.QueryResult<SecondaryEmailsQuery, SecondaryEmailsQueryVariables>;
export const SharedFiles = gql`
    query SharedFiles($ids: [String]!, $channelUrl: String!) {
  sharedFiles(ids: $ids, channelUrl: $channelUrl) {
    id
    fileName
    url
    size
    type
    isTranscoding
    width
    height
  }
}
    `;
export type SharedFilesQueryResult = Apollo.QueryResult<SharedFilesQuery, SharedFilesQueryVariables>;
export const Stories = gql`
    query Stories($userId: String, $companyId: String, $offset: Int, $limit: Int, $orderBy: JSON) {
  stories(
    userId: $userId
    companyId: $companyId
    offset: $offset
    limit: $limit
    orderBy: $orderBy
  ) {
    id
    medium {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    floatingText
    createdAt
    viewed
    numberOfReactions
    ad {
      id
      title
      propertyType
      bedroomNumber
      roomNumber
      livingArea
      address {
        id
        placeId
        description
        cityName
        zipCode
        city {
          id
          name
          zipCodes
          code
        }
      }
      media {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      price
      rent
    }
    newsPost {
      id
      title
      media {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      featuredCategory {
        id
        nameEn
        nameFr
        icon
      }
    }
    iHaveOwnership
    owner {
      id
      displayName
      initials
      user {
        id
        sendbirdUserId
        isRealEstatesTrades
        customActivity
        activity {
          id
          labelKey
        }
      }
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      company {
        id
        contactUser {
          id
          sendbirdUserId
        }
        label
        customActivity
        activities {
          id
          labelKey
        }
        name
        website
      }
    }
  }
}
    `;
export type StoriesQueryResult = Apollo.QueryResult<StoriesQuery, StoriesQueryVariables>;
export const StoriesGroupedByOwners = gql`
    query StoriesGroupedByOwners($offset: Int, $limit: Int, $lat: Float, $lng: Float) {
  storiesGroupedByOwners(offset: $offset, limit: $limit, lat: $lat, lng: $lng) {
    id
    user {
      id
      customActivity
      activity {
        id
        labelKey
      }
    }
    company {
      id
      label
      customActivity
      activities {
        id
        labelKey
      }
    }
    displayName
    initials
    image {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    hasUnreadStory
    hasStoryWithAdLinked {
      id
      createdAt
      medium {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
    }
    lastStory {
      id
      createdAt
      medium {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      ad {
        id
        title
        propertyType
        media {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        price
        rent
      }
      newsPost {
        id
        title
        media {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        featuredCategory {
          id
          nameEn
          nameFr
          icon
        }
      }
    }
  }
}
    `;
export type StoriesGroupedByOwnersQueryResult = Apollo.QueryResult<StoriesGroupedByOwnersQuery, StoriesGroupedByOwnersQueryVariables>;
export const Story = gql`
    query Story($storyId: String!) {
  story(storyId: $storyId) {
    id
    medium {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    floatingText
    createdAt
    viewed
    ad {
      id
      title
      propertyType
      media {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      price
      rent
    }
    newsPost {
      id
      title
      media {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      featuredCategory {
        id
        nameEn
        nameFr
        icon
      }
    }
    iHaveOwnership
    numberOfReactions
    owner {
      id
      displayName
      initials
      user {
        id
        sendbirdUserId
        isRealEstatesTrades
        customActivity
        activity {
          id
          labelKey
        }
      }
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      company {
        id
        name
        website
        label
        activities {
          id
          labelKey
        }
        customActivity
        contactUser {
          id
          sendbirdUserId
        }
      }
    }
  }
}
    `;
export type StoryQueryResult = Apollo.QueryResult<StoryQuery, StoryQueryVariables>;
export const StoryReactions = gql`
    query StoryReactions($storyId: String!, $skip: Int, $take: Int) {
  storyReactions(storyId: $storyId, skip: $skip, take: $take) {
    id
    user {
      id
      fullName
      initials
      isProfessionnal
      customActivity
      activity {
        id
        labelKey
      }
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
    }
    reaction
    message
    sendbirdMessageId
  }
}
    `;
export type StoryReactionsQueryResult = Apollo.QueryResult<StoryReactionsQuery, StoryReactionsQueryVariables>;
export const SuggestedUsersAndCompanies = gql`
    query SuggestedUsersAndCompanies($limit: Int, $offset: Int, $includeCompanies: Boolean, $includeUsers: Boolean) {
  suggestedUsersAndCompanies(
    limit: $limit
    offset: $offset
    includeCompanies: $includeCompanies
    includeUsers: $includeUsers
  ) {
    total
    results {
      __typename
      ... on User {
        id
        lastName
        firstName
        fullName
        initials
        isFollowed
        averageRating
        numberOfRatings
        mutualContactsCount
        recommendationsReceivedCount
        isFollowed
        contactStatusV2
        isProfessionnal
        activity {
          id
          labelKey
        }
        showcase {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        privateCompany {
          id
          address {
            id
            zipCode
            cityName
            city {
              id
              name
            }
          }
        }
        companyToDisplay {
          id
          address {
            id
            zipCode
            cityName
            city {
              id
              name
            }
          }
        }
        city {
          id
          name
        }
      }
      ... on Company {
        id
        name
        label
        isFollowingCompany
        contactUser {
          id
        }
        capabilities {
          allowedContentTypesToManage
          allowedContentTypesToDisplay
          allowedLabels
          isAbleToSyncCrm
          isAbleToHaveDirectors
          isAbleToHaveEstateCompanies
          hasPublicPage
        }
        averageRating
        numberOfRatings
        companyAndMembersRecommendationsCount
        companyMembersWhoAreInMyContactsCount
        customActivity
        activities {
          id
          labelKey
        }
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        address {
          id
          zipCode
          cityName
          city {
            id
            name
          }
        }
        showcase {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
      }
    }
  }
}
    `;
export type SuggestedUsersAndCompaniesQueryResult = Apollo.QueryResult<SuggestedUsersAndCompaniesQuery, SuggestedUsersAndCompaniesQueryVariables>;
export const UserAds = gql`
    query UserAds($userId: String!, $offset: Int, $limit: Int, $type: AdTypes, $statuses: [AdStatuses]) {
  userAds(
    userId: $userId
    offset: $offset
    limit: $limit
    type: $type
    statuses: $statuses
  ) {
    id
    type
    isUserFavorite
    title
    isUserAffiliatedCompanyFavorite
    livingArea
    landArea
    surfaceArea
    price
    rent
    bedroomNumber
    roomNumber
    interOffice
    createdAt
    isNew
    owner {
      company {
        id
      }
    }
    assignedTo {
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      fullName
      initials
      id
      phoneNumber {
        id
        number
        phoneCode
      }
    }
    isPriceDecreasing
    media {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    propertyType
    status
    address {
      id
      cityName
      zipCode
    }
    stats {
      id
      impressionCount
      viewCount
      favoriteCount
      contactCount
    }
  }
}
    `;
export type UserAdsQueryResult = Apollo.QueryResult<UserAdsQuery, UserAdsQueryVariables>;
export const UserContacts = gql`
    query UserContacts($userId: String!, $skip: Int, $take: Int, $query: String, $orderBy: JSON, $searchFields: [String], $match: Match, $excludeFromResultsUserId: String, $onlyMutual: Boolean) {
  userContactsV2(
    userId: $userId
    skip: $skip
    take: $take
    query: $query
    orderBy: $orderBy
    searchFields: $searchFields
    match: $match
    excludeFromResultsUserId: $excludeFromResultsUserId
    onlyMutual: $onlyMutual
  ) {
    total
    results {
      id
      image {
        id
        width
        height
        size
        aspectRatio
        duration
        rotation
        url
        type
      }
      isProfessionnal
      firstName
      lastName
      fullName
      initials
      customActivity
      mutualContactsCount
      contactStatusV2
      activity {
        id
        labelKey
      }
      city {
        id
        name
      }
    }
  }
}
    `;
export type UserContactsQueryResult = Apollo.QueryResult<UserContactsQuery, UserContactsQueryVariables>;
export const UserFavoriteNewsPosts = gql`
    query UserFavoriteNewsPosts($companyId: String, $offset: Int, $limit: Int) {
  userFavoriteNewsPosts(companyId: $companyId, offset: $offset, limit: $limit) {
    total
    results {
      id
      status
      directusId
      media {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      title
      shortDescription
      description
      categories {
        id
        nameEn
        nameFr
        icon
        createdAt
      }
      source
      sourceLink
      newsPostLink
      tags
      likedByCurrentUser
      totalLikes
      stats {
        id
        impressionCount
        viewCount
        favoriteCount
        contactCount
      }
      featuredCategory {
        id
        nameEn
        nameFr
        icon
        createdAt
      }
      createdAt
      updatedAt
      isUserFavorite
      isUserAffiliatedCompanyFavorite
    }
  }
}
    `;
export type UserFavoriteNewsPostsQueryResult = Apollo.QueryResult<UserFavoriteNewsPostsQuery, UserFavoriteNewsPostsQueryVariables>;
export const UserGalleries = gql`
    query UserGalleries($userId: String!, $policy: GalleryAccessPolicy, $sort: GallerySort, $pageRequest: PageRequest) {
  userProfile(id: $userId) {
    id
    galleries(policy: $policy, sort: $sort, pageRequest: $pageRequest) {
      items {
        id
        name
        isSecret
        createdAt
        numberOfContents
        contentLastUpdatedAt
        previewMedia {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
      }
      totalCount
    }
  }
}
    `;
export type UserGalleriesQueryResult = Apollo.QueryResult<UserGalleriesQuery, UserGalleriesQueryVariables>;
export const UserGalleriesWithCollaborators = gql`
    query UserGalleriesWithCollaborators($userId: String!, $policy: GalleryAccessPolicy, $sort: GallerySort, $pageRequest: PageRequest, $collaboratorPageRequest: PageRequest) {
  userProfile(id: $userId) {
    id
    galleries(policy: $policy, sort: $sort, pageRequest: $pageRequest) {
      items {
        id
        name
        isSecret
        createdAt
        numberOfContents
        contentLastUpdatedAt
        previewMedia {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        collaborators(pageRequest: $collaboratorPageRequest) {
          totalCount
          items {
            user {
              id
              fullName
              initials
              image {
                id
                width
                height
                size
                aspectRatio
                duration
                rotation
                url
                type
              }
            }
            company {
              id
              name
              initials
              image {
                id
                width
                height
                size
                aspectRatio
                duration
                rotation
                url
                type
              }
            }
          }
        }
      }
      totalCount
    }
  }
}
    `;
export type UserGalleriesWithCollaboratorsQueryResult = Apollo.QueryResult<UserGalleriesWithCollaboratorsQuery, UserGalleriesWithCollaboratorsQueryVariables>;
export const UserIdBySendbirdUserId = gql`
    query UserIdBySendbirdUserId($sendbirdUserId: String!) {
  chatUser(sendbirdUserId: $sendbirdUserId) {
    id
  }
}
    `;
export type UserIdBySendbirdUserIdQueryResult = Apollo.QueryResult<UserIdBySendbirdUserIdQuery, UserIdBySendbirdUserIdQueryVariables>;
export const UserProfile = gql`
    query UserProfile($id: String!, $showcaseLimit: Int) {
  userProfile(id: $id) {
    id
    isFollowed
    contactStatusV2
    firstName
    lastName
    fullName
    initials
    numberOfContacts
    mutualContactsCount
    coverImage {
      id
      url
    }
    mutualContactsCount
    description
    feeScaleFile
    feeScaleFileName
    hasUnreadStory
    isBlocked
    image {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    affiliatedCompany {
      id
      group {
        id
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
      }
    }
    showcase(limit: $showcaseLimit) {
      id
      width
      height
      size
      aspectRatio
      isTranscoding
      duration
      rotation
      url
      type
    }
    customActivity
    isRealEstatesTrades
    activity {
      id
      labelKey
    }
    city {
      id
      name
      zipCodes
    }
    phoneNumber {
      id
      number
      phoneCode
      countryCode
    }
    companyToDisplay {
      id
      name
      phoneNumber {
        id
        number
        phoneCode
        countryCode
      }
      website
      foundationYear
      numberOfMembers
      capabilities {
        allowedContentTypesToManage
        allowedContentTypesToDisplay
        allowedLabels
        isAbleToSyncCrm
        isAbleToHaveDirectors
        isAbleToHaveEstateCompanies
        hasPublicPage
      }
      siretNumber
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      contactUser {
        id
        fullName
        initials
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
      }
      address {
        id
        placeId
        zipCode
        description
        cityName
        city {
          id
          name
        }
      }
    }
    createdAt
    isProfessionnal
    isRealEstatesTrades
    isAbleToJoinOrCreateCompany
    recommendationsReceivedCount
    recommendationFromMe {
      id
      status
    }
    numberOfRatings
    numberOfDisplayedRatings
    averageRating
    numberOfProjects
    numberOfFollowers
    numberOfFollows
    numberOfAds
    numberOfAvailableAds: numberOfAds(statuses: available)
    numberOfEndedAds: numberOfAds(statuses: ended)
    numberOfGalleries
    numberOfPosts
    ratingGivenByCurrentUser {
      id
      value
      comment
      createdAt
      isHidden
      giver {
        id
        image {
          id
          width
          height
          size
          aspectRatio
          isTranscoding
          duration
          rotation
          url
          type
        }
        firstName
        lastName
        fullName
        initials
        createdAt
      }
    }
  }
  recommendations(offset: 0, limit: 2, userId: $id, statuses: [accepted]) {
    id
    recommendingUser {
      id
      image {
        id
        width
        height
        size
        aspectRatio
        isTranscoding
        duration
        rotation
        url
        type
      }
      fullName
      initials
    }
  }
}
    `;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const UserProfileForChat = gql`
    query UserProfileForChat($id: String!) {
  userProfile(id: $id) {
    id
    sendbirdUserId
  }
}
    `;
export type UserProfileForChatQueryResult = Apollo.QueryResult<UserProfileForChatQuery, UserProfileForChatQueryVariables>;
export const VersionsSupported = gql`
    query VersionsSupported {
  versionsSupported
}
    `;
export type VersionsSupportedQueryResult = Apollo.QueryResult<VersionsSupportedQuery, VersionsSupportedQueryVariables>;
export const WoopenSupportInfo = gql`
    query WoopenSupportInfo {
  supportEmail: woopenParameter(key: "woopen_support_email")
  supportPhoneNumber: woopenParameter(key: "woopen_support_phone_number")
}
    `;
export type WoopenSupportInfoQueryResult = Apollo.QueryResult<WoopenSupportInfoQuery, WoopenSupportInfoQueryVariables>;